;/*! showdown v 3.0.0-rc2 - 05-07-2026 */
(function(){
// noinspection HtmlRequiredLangAttribute

/**
 * Created by Tivie on 13-07-2015.
 */

// eslint-disable-next-line no-unused-vars -- called from sibling src files via the shared concat scope (see scripts/concat.mjs)
function getDefaultOpts (simple) {
  'use strict';

  let defaultOptions = {
    omitExtraWLInCodeBlocks: {
      defaultValue: false,
      describe: 'Omit the default extra whiteline added to code blocks',
      type: 'boolean'
    },
    headerIds: {
      defaultValue: {},
      describe: 'Controls the id attribute generated on headings. Accepts either `false` (no ids) or an object `{prefix, raw}`. `{}` (the default) generates github-compatible ids with no prefix. `prefix` (string) is prepended to every id. `raw: true` uses minimal sanitization (only spaces, \', ", > and < become dashes, including in any prefix) instead of the default github-compatible sanitization. WARNING: raw ids might be malformed',
      type: 'object'
    },
    headerLevelStart: {
      defaultValue: 1,
      describe: 'The header blocks level start',
      type: 'number'
    },
    parseImgDimensions: {
      defaultValue: false,
      describe: 'Turn on/off image dimension parsing',
      type: 'boolean'
    },
    simplifiedAutoLink: {
      defaultValue: false,
      describe: 'Turn on/off GFM autolink style',
      type: 'boolean'
    },
    httpsAutoLinks: {
      defaultValue: false,
      describe: 'Use \'https://\' for auto-generated links',
      type: 'boolean'
    },
    literalMidWordUnderscores: {
      defaultValue: false,
      describe: 'Parse midword underscores as literal underscores',
      type: 'boolean'
    },
    strikethrough: {
      defaultValue: true,
      describe: 'Turn on/off strikethrough support',
      type: 'boolean'
    },
    tables: {
      defaultValue: false,
      describe: 'Turn on/off tables support',
      type: 'boolean'
    },
    tablesHeaderId: {
      defaultValue: false,
      describe: 'Add an id to table headers',
      type: 'boolean'
    },
    ghCodeBlocks: {
      defaultValue: true,
      describe: 'Turn on/off GFM fenced code blocks support',
      type: 'boolean'
    },
    tasklists: {
      defaultValue: false,
      describe: 'Turn on/off GFM tasklist support',
      type: 'boolean'
    },
    footnotes: {
      defaultValue: false,
      describe: 'Turn on/off GFM footnotes support',
      type: 'boolean'
    },
    smartIndentationFix: {
      defaultValue: false,
      describe: 'Tries to smartly fix indentation in es6 strings',
      type: 'boolean'
    },
    disableForced4SpacesIndentedSublists: {
      defaultValue: false,
      describe: 'Disables the requirement of indenting nested sublists by 4 spaces',
      type: 'boolean'
    },
    simpleLineBreaks: {
      defaultValue: false,
      describe: 'Parses simple line breaks as <br>',
      type: 'boolean'
    },
    requireSpaceBeforeHeadingText: {
      defaultValue: false,
      describe: 'Makes adding a space between `#` and the header text mandatory (GFM Style)',
      type: 'boolean'
    },
    ghMentions: {
      defaultValue: false,
      describe: 'Enables github @mentions',
      type: 'boolean'
    },
    ghMentionsLink: {
      defaultValue: 'https://github.com/{u}',
      describe: 'Changes the link generated by @mentions. Only applies if ghMentions option is enabled.',
      type: 'string'
    },
    encodeEmails: {
      defaultValue: true,
      describe: 'Encode e-mail addresses through the use of Character Entities, transforming ASCII e-mail addresses into its equivalent decimal entities',
      type: 'boolean'
    },
    backslashEscapesHTMLTags: {
      defaultValue: false,
      describe: 'Support for HTML Tag escaping. ex: \\<div>foo\\</div>',
      type: 'boolean'
    },
    emoji: {
      defaultValue: false,
      describe: 'Enable emoji support. Ex: `this is a :smile: emoji`',
      type: 'boolean'
    },
    underline: {
      defaultValue: false,
      describe: 'Enable support for underline. Syntax is double or triple underscores: `__underline word__`. With this option enabled, underscores no longer parses into `<em>` and `<strong>`',
      type: 'boolean'
    },
    ellipsis: {
      defaultValue: true,
      describe: 'Replaces three dots with the ellipsis unicode character',
      type: 'boolean'
    },
    completeHTMLDocument: {
      defaultValue: false,
      describe: 'Outputs a complete html document, including `<html>`, `<head>` and `<body>` tags',
      type: 'boolean'
    },
    metadata: {
      defaultValue: false,
      describe: 'Enable support for document metadata (defined at the top of the document between `«««` and `»»»` or between `---` and `---`).',
      type: 'boolean'
    },
    splitAdjacentBlockquotes: {
      defaultValue: false,
      describe: 'Split adjacent blockquote blocks',
      type: 'boolean'
    },
    moreStyling: {
      defaultValue: false,
      describe: 'Adds some useful styling css classes in the generated html',
      type: 'boolean'
    },
    relativePathBaseUrl: {
      defaultValue: '',
      describe: 'Prepends a base URL to relative paths',
      type: 'string'
    },
    decodeEntities: {
      defaultValue: false,
      describe: 'Resolve HTML5 named and numeric character references to their characters (CommonMark behavior)',
      type: 'boolean'
    },
    cmSpec: {
      defaultValue: false,
      describe: 'Enable CommonMark spec compliance: parse blocks (lists, block quotes, HTML blocks, containers, tabs) and inlines (emphasis, links, images, autolinks, raw HTML) per the CommonMark spec instead of Showdown\'s legacy matching',
      type: 'boolean'
    },
    disallowRawHTML: {
      defaultValue: false,
      describe: 'Filter the GFM "disallowed raw HTML" tags (title, textarea, style, xmp, iframe, noembed, noframes, script, plaintext) by escaping their leading < to &lt; in the output',
      type: 'boolean'
    },
    safeMode: {
      defaultValue: false,
      describe: 'Defense-in-depth hardening for untrusted Markdown: (1) block dangerous URL schemes (javascript:, vbscript:, data: except data:image for image src) in generated links/images, and (2) escape ALL raw HTML tags so embedded <script>/<img onerror>/event handlers cannot execute. NOTE: this is not a full HTML sanitizer — for fully untrusted input still run the output through a dedicated sanitizer (e.g. DOMPurify) and serve a Content-Security-Policy',
      type: 'boolean'
    },
  };
  if (simple === false) {
    return JSON.parse(JSON.stringify(defaultOptions));
  }
  let ret = {};
  for (let opt in defaultOptions) {
    if (Object.prototype.hasOwnProperty.call(defaultOptions, opt)) {
      ret[opt] = defaultOptions[opt].defaultValue;
    }
  }
  return ret;
}

/**
 * Created by Tivie on 06-01-2015.
 */
// Private properties
let showdown = {},
    parsers = {},
    extensions = {},
    globalOptions = getDefaultOpts(true),
    setFlavor = 'vanilla',
    flavor = {
      commonmark: {
        headerIds:                            false,
        requireSpaceBeforeHeadingText:        true,
        decodeEntities:                       true,
        cmSpec:                               true,
        strikethrough:                        false,
        encodeEmails:                         false
      },
      gfm: {
        headerIds:                            false,
        requireSpaceBeforeHeadingText:        true,
        decodeEntities:                       true,
        cmSpec:                               true,
        strikethrough:                        true,
        encodeEmails:                         false,
        ghCodeBlocks:                         true,
        tables:                               true,
        tasklists:                            true,
        footnotes:                            true,
        ghMentions:                           true,
        simplifiedAutoLink:                   true,
        emoji:                                true,
        omitExtraWLInCodeBlocks:              true,

        disallowRawHTML:                      true, // GFM tagfilter extension (spec §6.11)

        //literalMidWordUnderscores:            true,
        //disableForced4SpacesIndentedSublists: true,
        //backslashEscapesHTMLTags:             true,
      },
      original: {
        headerIds:                            false,
        ghCodeBlocks:                         false,
        strikethrough:                        false
      },
      vanilla: getDefaultOpts(true)
    };

// alias github to gfm for backwards compatibility
flavor.github = flavor.gfm;

/**
 * helper namespace
 * @type {{}}
 */
showdown.helper = {};

/**
 * Set a global option
 * @static
 * @param {string} key
 * @param {*} value
 * @returns {showdown}
 */
showdown.setOption = function (key, value) {
  'use strict';
  globalOptions[key] = value;
  return this;
};

/**
 * Get a global option
 * @static
 * @param {string} key
 * @returns {*}
 */
showdown.getOption = function (key) {
  'use strict';
  return globalOptions[key];
};

/**
 * Get the global options
 * @static
 * @returns {{}}
 */
showdown.getOptions = function () {
  'use strict';
  return globalOptions;
};

/**
 * Reset global options to the default values
 * @static
 */
showdown.resetOptions = function () {
  'use strict';
  globalOptions = getDefaultOpts(true);
};

/**
 * Set the flavor showdown should use as default
 * @param {string} name
 */
showdown.setFlavor = function (name) {
  'use strict';
  if (!Object.prototype.hasOwnProperty.call(flavor, name)) {
    throw Error(name + ' flavor was not found');
  }
  showdown.resetOptions();
  let preset = flavor[name];
  setFlavor = name;
  for (let option in preset) {
    if (Object.prototype.hasOwnProperty.call(preset, option)) {
      globalOptions[option] = preset[option];
    }
  }
};

/**
 * Get the currently set flavor
 * @returns {string}
 */
showdown.getFlavor = function () {
  'use strict';
  return setFlavor;
};

/**
 * Get the options of a specified flavor. Returns undefined if the flavor was not found
 * @param {string} name Name of the flavor
 * @returns {{}|undefined}
 */
showdown.getFlavorOptions = function (name) {
  'use strict';
  if (Object.prototype.hasOwnProperty.call(flavor, name)) {
    return flavor[name];
  }
};

/**
 * Get the list of available flavor names
 * @static
 * @returns {string[]}
 */
showdown.getFlavors = function () {
  'use strict';
  return Object.keys(flavor);
};

/**
 * Get the default options
 * @static
 * @param {boolean} [simple=true]
 * @returns {{}}
 */
showdown.getDefaultOptions = function (simple) {
  'use strict';
  return getDefaultOpts(simple);
};

/**
 * Get or set a subParser
 *
 * subParser(name)       - Get a registered subParser
 * subParser(name, func) - Register a subParser
 * @static
 * @param {string} name
 * @param {function} [func]
 * @returns {*}
 */
showdown.subParser = function (name, func) {
  'use strict';
  if (showdown.helper.isString(name)) {
    if (typeof func !== 'undefined') {
      parsers[name] = func;
    } else {
      if (Object.prototype.hasOwnProperty.call(parsers, name)) {
        return parsers[name];
      } else {
        throw Error('SubParser named ' + name + ' not registered!');
      }
    }
  } else {
    throw Error('showdown.subParser function first argument must be a string (the name of the subparser)');
  }
};

/**
 *
 * @returns {{}}
 */
showdown.getSubParserList = function () {
  return parsers;
};

/**
 * Gets or registers an extension
 * @static
 * @param {string} name
 * @param {object|object[]|function=} ext
 * @returns {*}
 */
showdown.extension = function (name, ext) {
  'use strict';

  if (!showdown.helper.isString(name)) {
    throw Error('Extension \'name\' must be a string');
  }

  name = showdown.helper.stdExtName(name);

  // Getter
  if (showdown.helper.isUndefined(ext)) {
    if (!Object.prototype.hasOwnProperty.call(extensions, name)) {
      throw Error('Extension named ' + name + ' is not registered!');
    }
    return extensions[name];

    // Setter
  } else {
    // Expand extension if it's wrapped in a function
    if (typeof ext === 'function') {
      ext = ext();
    }

    // Ensure extension is an array
    if (!showdown.helper.isArray(ext)) {
      ext = [ext];
    }

    let validExtension = validate(ext, name);

    if (validExtension.valid) {
      extensions[name] = ext;
    } else {
      throw Error(validExtension.error);
    }
  }
};

/**
 * Gets all extensions registered
 * @returns {{}}
 */
showdown.getAllExtensions = function () {
  'use strict';
  return extensions;
};

/**
 * Remove an extension
 * @param {string} name
 */
showdown.removeExtension = function (name) {
  'use strict';
  delete extensions[name];
};

/**
 * Removes all extensions
 */
showdown.resetExtensions = function () {
  'use strict';
  extensions = {};
};

/**
 * Validate extension
 * @param {array} extension
 * @param {string} name
 * @returns {{valid: boolean, error: string}}
 */
function validate (extension, name) {
  'use strict';

  let errMsg = (name) ? 'Error in ' + name + ' extension->' : 'Error in unnamed extension',
      ret = {
        valid: true,
        error: ''
      };

  if (!showdown.helper.isArray(extension)) {
    extension = [extension];
  }

  for (let i = 0; i < extension.length; ++i) {
    let baseMsg = errMsg + ' sub-extension ' + i + ': ',
        ext = extension[i];
    if (typeof ext !== 'object') {
      ret.valid = false;
      ret.error = baseMsg + 'must be an object, but ' + typeof ext + ' given';
      return ret;
    }

    if (!showdown.helper.isString(ext.type)) {
      ret.valid = false;
      ret.error = baseMsg + 'property "type" must be a string, but ' + typeof ext.type + ' given';
      return ret;
    }

    let type = ext.type = ext.type.toLowerCase();

    // normalize extension type
    if (type === 'language') {
      type = ext.type = 'lang';
    }

    if (type === 'html') {
      type = ext.type = 'output';
    }

    if (type !== 'lang' && type !== 'output' && type !== 'listener') {
      ret.valid = false;
      ret.error = baseMsg + 'type ' + type + ' is not recognized. Valid values: "lang/language", "output/html" or "listener"';
      return ret;
    }

    if (type === 'listener') {
      if (showdown.helper.isUndefined(ext.listeners)) {
        ret.valid = false;
        ret.error = baseMsg + '. Extensions of type "listener" must have a property called "listeners"';
        return ret;
      }
    } else {
      if (showdown.helper.isUndefined(ext.filter) && showdown.helper.isUndefined(ext.regex)) {
        ret.valid = false;
        ret.error = baseMsg + type + ' extensions must define either a "regex" property or a "filter" method';
        return ret;
      }
    }

    if (ext.listeners) {
      if (typeof ext.listeners !== 'object') {
        ret.valid = false;
        ret.error = baseMsg + '"listeners" property must be an object but ' + typeof ext.listeners + ' given';
        return ret;
      }
      for (let ln in ext.listeners) {
        if (Object.prototype.hasOwnProperty.call(ext.listeners, ln)) {
          if (typeof ext.listeners[ln] !== 'function') {
            ret.valid = false;
            ret.error = baseMsg + '"listeners" property must be an hash of [event name]: [callback]. listeners.' + ln +
              ' must be a function but ' + typeof ext.listeners[ln] + ' given';
            return ret;
          }
        }
      }
    }

    if (ext.filter) {
      if (typeof ext.filter !== 'function') {
        ret.valid = false;
        ret.error = baseMsg + '"filter" must be a function, but ' + typeof ext.filter + ' given';
        return ret;
      }
    } else if (ext.regex) {
      if (showdown.helper.isString(ext.regex)) {
        ext.regex = new RegExp(ext.regex, 'g');
      }
      if (!(ext.regex instanceof RegExp)) {
        ret.valid = false;
        ret.error = baseMsg + '"regex" property must either be a string or a RegExp object, but ' + typeof ext.regex + ' given';
        return ret;
      }
      if (showdown.helper.isUndefined(ext.replace)) {
        ret.valid = false;
        ret.error = baseMsg + '"regex" extensions must implement a replace string or function';
        return ret;
      }
    }
  }
  return ret;
}

/**
 * Validate extension
 * @param {object} ext
 * @returns {boolean}
 */
showdown.validateExtension = function (ext) {
  'use strict';

  let validateExtension = validate(ext, null);
  if (!validateExtension.valid) {
    console.warn(validateExtension.error);
    return false;
  }
  return true;
};

// noinspection HtmlDeprecatedAttribute,CheckImageSize

/**
 * showdownjs helper functions
 */

if (!Object.prototype.hasOwnProperty.call(showdown, 'helper')) {
  showdown.helper = {};
}

// makeMarkdown needs a DOM to parse the input HTML. Resolution is lazy (first access of
// `showdown.helper.document`) so Node users that only call makeHtml never pay the cost of
// loading happy-dom; in environments with an ambient window/document (browsers, DOM test
// environments) the require branch is never reached, so happy-dom never ends up in bundles.
let lazyDocument = null;
Object.defineProperty(showdown.helper, 'document', {
  get: function () {
    'use strict';
    if (lazyDocument === null) {
      if (typeof window !== 'undefined' && window.document) {
        lazyDocument = window.document;
      } else if (typeof document !== 'undefined') {
        lazyDocument = document;
      } else if (typeof require === 'function') {
        let happyDom = require('happy-dom');
        lazyDocument = new happyDom.Window().document;
      } else {
        throw new Error('makeMarkdown requires a DOM: provide a global window/document, ' +
          'or run in Node (CommonJS) with happy-dom installed.');
      }
    }
    return lazyDocument;
  }
});

/**
 * Parse an untrusted HTML string into a detached <div> and return it, for
 * makeMarkdown to walk. The HTML is parsed inside an *inert* document (one with
 * no browsing context, obtained via document.implementation.createHTMLDocument)
 * whenever the host DOM supports it. In an inert document, assigning to innerHTML
 * never executes <script> and never triggers resource loads or fires on* handlers
 * such as `<img onerror>` / `<svg onload>` — so parsing attacker HTML client-side
 * cannot run script. happy-dom (Node) is already inert; using the same path keeps
 * behavior uniform.
 * @param {string} html
 * @returns {Object} a detached div element whose innerHTML is the parsed html
 */
let lazyInertDocument = null;
showdown.helper.parseHTML = function (html) {
  'use strict';
  let ownerDoc = showdown.helper.document;
  if (ownerDoc.implementation && typeof ownerDoc.implementation.createHTMLDocument === 'function') {
    if (lazyInertDocument === null) {
      lazyInertDocument = ownerDoc.implementation.createHTMLDocument('');
    }
    ownerDoc = lazyInertDocument;
  }
  let div = ownerDoc.createElement('div');
  div.innerHTML = html;
  return div;
};

/**
 * Check if var is string
 * @static
 * @param {*} a
 * @returns {boolean}
 */
showdown.helper.isString = function (a) {
  'use strict';
  return (typeof a === 'string' || a instanceof String);
};

/**
 * Check if var is a number
 * @static
 * @param {*} a
 * @returns {boolean}
 */
showdown.helper.isNumber = function (a) {
  return !isNaN(a);
};

/**
 * Check if var is a function
 * @static
 * @param {*} a
 * @returns {boolean}
 */
showdown.helper.isFunction = function (a) {
  'use strict';
  let getType = {};
  return a && getType.toString.call(a) === '[object Function]';
};

/**
 * isArray helper function
 * @static
 * @param {*} a
 * @returns {boolean}
 */
showdown.helper.isArray = function (a) {
  'use strict';
  let isArray;
  if (!Array.isArray) {
    isArray = function (arg) {
      return Object.prototype.toString.call(arg) === '[object Array]';
    };
  } else {
    isArray = Array.isArray;
  }
  return isArray(a);
};

/**
 * Check if value is undefined
 * @static
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 */
showdown.helper.isUndefined = function (value) {
  'use strict';
  return typeof value === 'undefined';
};

/**
 * Check if value is an object (excluding arrays)
 * @param {*} value
 * @returns {boolean}
 */
showdown.helper.isObject = function (value) {
  'use strict';
  return (
    typeof value === 'object' &&
    !Array.isArray(value) &&
    value !== null
  );
};

/**
 * ForEach helper function
 * Iterates over Arrays and Objects (own properties only)
 * @static
 * @param {*} obj
 * @param {function} callback Accepts 3 params: 1. value, 2. key, 3. the original array/object
 */
showdown.helper.forEach = function (obj, callback) {
  'use strict';
  // check if obj is defined
  if (showdown.helper.isUndefined(obj)) {
    throw new Error('obj param is required');
  }

  if (showdown.helper.isUndefined(callback)) {
    throw new Error('callback param is required');
  }

  if (!showdown.helper.isFunction(callback)) {
    throw new Error('callback param must be a function/closure');
  }

  if (typeof obj.forEach === 'function') {
    obj.forEach(callback);
  } else if (showdown.helper.isArray(obj)) {
    for (let i = 0; i < obj.length; i++) {
      callback(obj[i], i, obj);
    }
  } else if (typeof (obj) === 'object') {
    for (let prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        callback(obj[prop], prop, obj);
      }
    }
  } else {
    throw new Error('obj does not seem to be an array or an iterable object');
  }
};

/**
 * Standardize extension name
 * @static
 * @param {string} s extension name
 * @returns {string}
 */
showdown.helper.stdExtName = function (s) {
  'use strict';
  return s.replace(/[_?*+/\\.^-]/g, '').replace(/\s/g, '').toLowerCase();
};

function escapeCharactersCallback (wholeMatch, m1) {
  'use strict';
  let charCodeToEscape = m1.charCodeAt(0);
  return '¨E' + charCodeToEscape + 'E';
}

/**
 * Callback used to escape characters when passing through String.replace
 * @static
 * @param {string} wholeMatch
 * @param {string} m1
 * @returns {string}
 */
showdown.helper.escapeCharactersCallback = escapeCharactersCallback;

/**
 * Escape characters in a string
 * @static
 * @param {string} text
 * @param {string} charsToEscape
 * @param {boolean} afterBackslash
 * @returns {string|void|*}
 */
showdown.helper.escapeCharacters = function (text, charsToEscape, afterBackslash) {
  'use strict';
  // First we have to escape the escape characters so that
  // we can build a character class out of them
  let regexString = '([' + charsToEscape.replace(/([[\]\\])/g, '\\$1') + '])';

  if (afterBackslash) {
    regexString = '\\\\' + regexString;
  }

  let regex = new RegExp(regexString, 'g');
  text = text.replace(regex, escapeCharactersCallback);

  return text;
};

let rgxFindMatchPos = function (str, left, right, flags) {
  'use strict';
  let f = flags || '',
      g = f.indexOf('g') > -1,
      x = new RegExp(left + '|' + right, 'g' + f.replace(/g/g, '')),
      l = new RegExp(left, f.replace(/g/g, '')),
      pos = [],
      t, s, m, start, end;

  do {
    t = 0;
    while ((m = x.exec(str))) {
      if (l.test(m[0])) {
        if (!(t++)) {
          s = x.lastIndex;
          start = s - m[0].length;
        }
      } else if (t) {
        if (!--t) {
          end = m.index + m[0].length;
          let obj = {
            left: {start: start, end: s},
            match: {start: s, end: m.index},
            right: {start: m.index, end: end},
            wholeMatch: {start: start, end: end}
          };
          pos.push(obj);
          if (!g) {
            return pos;
          }
        }
      }
    }
  } while (t && (x.lastIndex = s));

  return pos;
};

/**
 * matchRecursiveRegExp
 *
 * (c) 2007 Steven Levithan <stevenlevithan.com>
 * MIT License
 *
 * Accepts a string to search, a left and right format delimiter
 * as regex patterns, and optional regex flags. Returns an array
 * of matches, allowing nested instances of left/right delimiters.
 * Use the "g" flag to return all matches, otherwise only the
 * first is returned. Be careful to ensure that the left and
 * right format delimiters produce mutually exclusive matches.
 * Backreferences are not supported within the right delimiter
 * due to how it is internally combined with the left delimiter.
 * When matching strings whose format delimiters are unbalanced
 * to the left or right, the output is intentionally as a
 * conventional regex library with recursion support would
 * produce, e.g. "<<x>" and "<x>>" both produce ["x"] when using
 * "<" and ">" as the delimiters (both strings contain a single,
 * balanced instance of "<x>").
 *
 * examples:
 * matchRecursiveRegExp("test", "\\(", "\\)")
 * returns: []
 * matchRecursiveRegExp("<t<<e>><s>>t<>", "<", ">", "g")
 * returns: ["t<<e>><s>", ""]
 * matchRecursiveRegExp("<div id=\"x\">test</div>", "<div\\b[^>]*>", "</div>", "gi")
 * returns: ["test"]
 */
showdown.helper.matchRecursiveRegExp = function (str, left, right, flags) {
  'use strict';

  let matchPos = rgxFindMatchPos (str, left, right, flags),
      results = [];

  for (let i = 0; i < matchPos.length; ++i) {
    results.push([
      str.slice(matchPos[i].wholeMatch.start, matchPos[i].wholeMatch.end),
      str.slice(matchPos[i].match.start, matchPos[i].match.end),
      str.slice(matchPos[i].left.start, matchPos[i].left.end),
      str.slice(matchPos[i].right.start, matchPos[i].right.end)
    ]);
  }
  return results;
};

/**
 *
 * @param {string} str
 * @param {string|function} replacement
 * @param {string} left
 * @param {string} right
 * @param {string} flags
 * @returns {string}
 */
showdown.helper.replaceRecursiveRegExp = function (str, replacement, left, right, flags) {
  'use strict';

  if (!showdown.helper.isFunction(replacement)) {
    let repStr = replacement;
    replacement = function () {
      return repStr;
    };
  }

  let matchPos = rgxFindMatchPos(str, left, right, flags),
      finalStr = str,
      lng = matchPos.length;

  if (lng > 0) {
    let bits = [];
    if (matchPos[0].wholeMatch.start !== 0) {
      bits.push(str.slice(0, matchPos[0].wholeMatch.start));
    }
    for (let i = 0; i < lng; ++i) {
      bits.push(
        replacement(
          str.slice(matchPos[i].wholeMatch.start, matchPos[i].wholeMatch.end),
          str.slice(matchPos[i].match.start, matchPos[i].match.end),
          str.slice(matchPos[i].left.start, matchPos[i].left.end),
          str.slice(matchPos[i].right.start, matchPos[i].right.end)
        )
      );
      if (i < lng - 1) {
        bits.push(str.slice(matchPos[i].wholeMatch.end, matchPos[i + 1].wholeMatch.start));
      }
    }
    if (matchPos[lng - 1].wholeMatch.end < str.length) {
      bits.push(str.slice(matchPos[lng - 1].wholeMatch.end));
    }
    finalStr = bits.join('');
  }
  return finalStr;
};

/**
 * Returns the index within the passed String object of the first occurrence of the specified regex,
 * starting the search at fromIndex. Returns -1 if the value is not found.
 *
 * @param {string} str string to search
 * @param {RegExp} regex Regular expression to search
 * @param {int} [fromIndex = 0] Index to start the search
 * @returns {Number}
 * @throws InvalidArgumentError
 */
showdown.helper.regexIndexOf = function (str, regex, fromIndex) {
  'use strict';
  if (!showdown.helper.isString(str)) {
    throw 'InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string';
  }
  if (!(regex instanceof RegExp)) {
    throw 'InvalidArgumentError: second parameter of showdown.helper.regexIndexOf function must be an instance of RegExp';
  }
  let indexOf = str.substring(fromIndex || 0).search(regex);
  return (indexOf >= 0) ? (indexOf + (fromIndex || 0)) : indexOf;
};

/**
 * Splits the passed string object at the defined index, and returns an array composed of the two substrings
 * @param {string} str string to split
 * @param {int} index index to split string at
 * @returns {[string,string]}
 * @throws InvalidArgumentError
 */
showdown.helper.splitAtIndex = function (str, index) {
  'use strict';
  if (!showdown.helper.isString(str)) {
    throw 'InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string';
  }
  return [str.substring(0, index), str.substring(index)];
};


/**
 * MurmurHash3's mixing function
 * https://stackoverflow.com/questions/521295/seeding-the-random-number-generator-in-javascript/47593316#47593316
 *
 * @param {string} string
 * @returns {Number}
 */
/*jshint bitwise: false*/
function xmur3 (str) {
  let h;
  for (let i = 0, h = 1779033703 ^ str.length; i < str.length; i++) {
    h = Math.imul(h ^ str.charCodeAt(i), 3432918353);
    h = h << 13 | h >>> 19;
  }
  return function () {
    h = Math.imul(h ^ h >>> 16, 2246822507);
    h = Math.imul(h ^ h >>> 13, 3266489909);
    return (h ^= h >>> 16) >>> 0;
  };
}

/**
 * Random Number Generator
 * https://stackoverflow.com/questions/521295/seeding-the-random-number-generator-in-javascript/47593316#47593316
 *
 * @param {Number} seed
 * @returns {Number}
 */
/*jshint bitwise: false*/
function mulberry32 (a) {
  return function () {
    let t = a += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
  };
}

/**
 * Obfuscate an e-mail address through the use of Character Entities,
 * transforming ASCII characters into their equivalent decimal or hex entities.
 *
 *
 * @param {string} mail
 * @returns {string}
 */
showdown.helper.encodeEmailAddress = function (mail) {
  'use strict';
  let encode = [
    function (ch) {
      return '&#' + ch.charCodeAt(0) + ';';
    },
    function (ch) {
      return '&#x' + ch.charCodeAt(0).toString(16) + ';';
    },
    function (ch) {
      return ch;
    }
  ];

  // RNG seeded with mail, so that we can get determined results for each email.
  let rand = mulberry32(xmur3(mail));

  mail = mail.replace(/./g, function (ch) {
    if (ch === '@') {
      // this *must* be encoded. I insist.
      ch = encode[Math.floor(rand() * 2)](ch);
    } else {
      let r = rand();
      // roughly 10% raw, 45% hex, 45% dec
      ch = (
        r > 0.9 ? encode[2](ch) : r > 0.45 ? encode[1](ch) : encode[0](ch)
      );
    }
    return ch;
  });

  return mail;
};

/**
 * String.prototype.repeat polyfill
 *
 * @param {string} str
 * @param {int} count
 * @returns {string}
 */
showdown.helper.repeat = function (str, count) {
  'use strict';
  // use built-in method if it's available
  if (!showdown.helper.isUndefined(String.prototype.repeat)) {
    return str.repeat(count);
  }
  str = '' + str;
  if (count < 0) {
    throw new RangeError('repeat count must be non-negative');
  }
  if (count === Infinity) {
    throw new RangeError('repeat count must be less than infinity');
  }
  count = Math.floor(count);
  if (str.length === 0 || count === 0) {
    return '';
  }
  // Ensuring count is a 31-bit integer allows us to heavily optimize the
  // main part. But anyway, most current (August 2014) browsers can't handle
  // strings 1 << 28 chars or longer, so:
  /*jshint bitwise: false*/
  if (str.length * count >= 1 << 28) {
    throw new RangeError('repeat count must not overflow maximum string size');
  }
  /*jshint bitwise: true*/
  let maxCount = str.length * count;
  count = Math.floor(Math.log(count) / Math.log(2));
  while (count) {
    str += str;
    count--;
  }
  str += str.substring(0, maxCount - str.length);
  return str;
};

/**
 * String.prototype.padEnd polyfill
 *
 * @param {string} str
 * @param {int} targetLength
 * @param {string} [padString]
 * @returns {string}
 */
showdown.helper.padEnd = function padEnd (str, targetLength, padString) {
  'use strict';
  // eslint-disable-next-line @stylistic/space-infix-ops
  targetLength = targetLength>>0; //floor if number or convert non-number to 0;
  padString = String(padString || ' ');
  if (str.length > targetLength) {
    return String(str);
  } else {
    targetLength = targetLength - str.length;
    if (targetLength > padString.length) {
      padString += showdown.helper.repeat(padString, targetLength / padString.length); //append to original to ensure we are longer than needed
    }
    return String(str) + padString.slice(0,targetLength);
  }
};

/**
 * Unescape HTML entities
 * @param txt
 * @returns {string}
 */
showdown.helper.unescapeHTMLEntities = function (txt) {
  'use strict';

  return txt
    .replace(/&quot;/g, '"')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&');
};

showdown.helper._hashHTMLSpan = function (html, globals) {
  return '¨C' + (globals.gHtmlSpans.push(html) - 1) + 'C';
};

/**
 * Prepends a base URL to relative paths.
 *
 * @param {string} baseUrl the base URL to prepend to a relative path
 * @param {string} url the path to modify, which may be relative
 * @returns {string} the full URL
 */
showdown.helper.applyBaseUrl = function (baseUrl, url) {
  // Only prepend if given a base URL and the path is not absolute.
  if (baseUrl && baseUrl !== '' && !showdown.helper.isAbsolutePath(url)) {
    let urlResolve = new showdown.helper.URLUtils(url, baseUrl);
    url = urlResolve.href;
  }

  return url;
};

/**
 * Checks if the given path is absolute.
 *
 * @param {string} path the path to test for absolution
 * @returns {boolean} `true` if the given path is absolute, else `false`
 */
showdown.helper.isAbsolutePath = function (path) {
  // Absolute paths begin with '[protocol:]//' or '#' (anchors)
  return /(^([a-z]+:)?\/\/)|(^#)/i.test(path);
};

// URL schemes allowed by safeMode. Relative URLs, fragments (#...) and
// protocol-relative URLs (//host) carry no scheme and are always allowed.
showdown.helper.safeUrlSchemes = ['http', 'https', 'ftp', 'ftps', 'mailto', 'tel', 'sms'];

/**
 * safeMode URL guard: decide whether a link/image destination is safe to emit.
 * Rejects dangerous schemes (javascript:, vbscript:, data:text/html, ...). The
 * scheme is resolved after decoding character references and stripping the
 * characters browsers ignore when parsing a scheme (whitespace and control
 * chars), so evasions like `java&#115;cript:` or `java\tscript:` are caught.
 * `data:` is only permitted when opts.allowDataImage is set and the payload is a
 * `data:image/...` URL (so inline base64 images keep working under safeMode).
 * @param {string} url
 * @param {{allowDataImage?: boolean}} [opts]
 * @returns {boolean}
 */
showdown.helper.isSafeUrl = function (url, opts) {
  'use strict';
  let allowDataImage = !!(opts && opts.allowDataImage);
  // resolve character references (numeric + named) that could hide the scheme
  let decoded = showdown.helper.cmDecodeEntities(String(url));
  // restore showdown's internal escape placeholders (¨E<code>E) to their chars
  decoded = decoded.replace(/¨E(\d+)E/g, function (wm, code) {
    return String.fromCharCode(+code);
  });
  // remove whitespace/control chars browsers ignore while resolving the scheme
  // eslint-disable-next-line no-control-regex -- intentionally stripping ASCII control chars used to obfuscate schemes
  let stripped = decoded.replace(/[\u0000-\u0020\u00a0]+/g, '');
  let m = /^([a-zA-Z][a-zA-Z0-9+.-]*):/.exec(stripped);
  if (!m) {
    // no scheme: relative path, fragment (#...) or protocol-relative (//host)
    return true;
  }
  let scheme = m[1].toLowerCase();
  if (scheme === 'data') {
    return allowDataImage && /^data:image\//i.test(stripped);
  }
  return showdown.helper.safeUrlSchemes.indexOf(scheme) !== -1;
};


/**
 * Polyfill method for trimStart
 * @param {string} text
 * @returns {string}
 */
showdown.helper.trimStart = function (text) {
  return (!String.prototype.trimStart) ?
    // eslint-disable-next-line no-control-regex -- Unicode whitespace class (incl. \x09-\x0D) in trim polyfill
    text.replace(/^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/, '') :
    text.trimStart();
};

/**
 * Polyfill method for trimEnd
 * @param {string} text
 * @returns {string}
 */
showdown.helper.trimEnd = function (text) {
  return (!String.prototype.trimEnd) ?
    // eslint-disable-next-line no-control-regex -- Unicode whitespace class (incl. \x09-\x0D) in trim polyfill
    text.replace(/[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/, '') :
    text.trimEnd();
};



showdown.helper.URLUtils = function (url, baseURL) {
  const pattern2 = /^([^:/?#]+:)?(?:\/\/(?:([^:@/?#]*)(?::([^:@/?#]*))?@)?(([^:/?#]*)(?::(\d*))?))?([^?#]*)(\?[^#]*)?(#[\s\S]*)?/;

  let m = String(url)
    .trim()
    .match(pattern2);
  if (!m) {
    throw new RangeError();
  }
  let protocol = m[1] || '';
  let username = m[2] || '';
  let password = m[3] || '';
  let host = m[4] || '';
  let hostname = m[5] || '';
  let port = m[6] || '';
  let pathname = m[7] || '';
  let search = m[8] || '';
  let hash = m[9] || '';
  if (baseURL !== undefined) {
    let base = new showdown.helper.URLUtils(baseURL);
    let flag = protocol === '' && host === '' && username === '';
    if (flag && pathname === '' && search === '') {
      search = base.search;
    }
    if (flag && pathname.charAt(0) !== '/') {
      pathname = (pathname !== '' ? (((base.host !== '' || base.username !== '') && base.pathname === '' ? '/' : '') + base.pathname.slice(0, base.pathname.lastIndexOf('/') + 1) + pathname) : base.pathname);
    }
    // dot segments removal
    let output = [];
    pathname.replace(/^(\.\.?(\/|$))+/, '')
      .replace(/\/(\.(\/|$))+/g, '/')
      .replace(/\/\.\.$/, '/../')
      .replace(/\/?[^/]*/g, function (p) {
        if (p === '/..') {
          output.pop();
        } else {
          output.push(p);
        }
      });
    pathname = output.join('').replace(/^\//, pathname.charAt(0) === '/' ? '/' : '');
    if (flag) {
      port = base.port;
      hostname = base.hostname;
      host = base.host;
      password = base.password;
      username = base.username;
    }
    if (protocol === '') {
      protocol = base.protocol;
    }
  }
  this.origin = protocol + (protocol !== '' || host !== '' ? '//' : '') + host;
  this.href = protocol + (protocol !== '' || host !== '' ? '//' : '') + (username !== '' ? username + (password !== '' ? ':' + password : '') + '@' : '') + host + pathname + search + hash;
  this.protocol = protocol;
  this.username = username;
  this.password = password;
  this.host = host;
  this.hostname = hostname;
  this.port = port;
  this.pathname = pathname;
  this.search = search;
  this.hash = hash;
};

/**
 *
 * @param {string} url
 * @returns {string}
 */
showdown.helper.urlASCIIEncoding = function (url) {
  url = url
    .replace(/\\/g, '%5C')
    .replace(/ /g, '%20');

  return url;
};

/**
 * Resolve HTML5 named (`&ouml;`), decimal (`&#246;`) and hexadecimal (`&#xf6;`)
 * character references to their corresponding characters (CommonMark behavior).
 * Unlike makehtml.decodeEntities, this returns the raw decoded characters (no
 * HTML re-escaping) so the result can be percent-encoded for a URL or further
 * processed. Invalid references are left verbatim.
 * @param {string} str
 * @returns {string}
 */
showdown.helper.cmDecodeEntities = function (str) {
  let entities = showdown.helper.htmlEntities || {};
  function fromCodePoint (cp) {
    if (cp === 0 || cp > 0x10FFFF || (cp >= 0xD800 && cp <= 0xDFFF)) {
      return '�';
    }
    try {
      return String.fromCodePoint(cp);
    } catch {
      return '�';
    }
  }
  return str.replace(/&([#0-9a-zA-Z]+);/g, function (wholeMatch, body) {
    let m;
    if ((m = /^#([0-9]{1,7})$/.exec(body))) {
      return fromCodePoint(parseInt(m[1], 10));
    }
    if ((m = /^#[xX]([0-9a-fA-F]{1,6})$/.exec(body))) {
      return fromCodePoint(parseInt(m[1], 16));
    }
    if (/^[a-zA-Z][a-zA-Z0-9]*$/.test(body) && Object.prototype.hasOwnProperty.call(entities, body)) {
      return entities[body];
    }
    return wholeMatch;
  });
};

/**
 * CommonMark URL percent-encoding: percent-encode every character outside the
 * "safe" set, while preserving sequences that are already percent-encoded.
 * Mirrors mdurl.encode's default behavior.
 * @param {string} uri
 * @returns {string}
 */
showdown.helper.cmEncodeURI = function (uri) {
  const safe = ';/?:@&=+$,-_.!~*\'()#';
  let out = '';
  for (let i = 0; i < uri.length; ++i) {
    let ch = uri.charAt(i),
        code = uri.charCodeAt(i);
    if (ch === '%' && /^[0-9a-fA-F]{2}$/.test(uri.slice(i + 1, i + 3))) {
      out += uri.slice(i, i + 3);
      i += 2;
    } else if ((code >= 48 && code <= 57) || (code >= 65 && code <= 90) ||
               (code >= 97 && code <= 122) || safe.indexOf(ch) !== -1) {
      out += ch;
    } else {
      out += encodeURIComponent(ch);
    }
  }
  return out;
};

/**
 * Full CommonMark URL normalization for a link/image destination:
 * 1. restore showdown's `¨E<code>E` backslash-escape placeholders to their literal
 *    characters (so escaped punctuation is treated literally, not re-processed);
 * 2. resolve raw backslash escapes of ASCII punctuation (`\*` -> `*`); a backslash
 *    before a non-punctuation character stays literal (and is later percent-encoded);
 * 3. resolve HTML character references (`&ouml;` -> `ö`);
 * 4. percent-encode the result;
 * 5. HTML-escape any residual bare `&` so the href stays valid HTML.
 * @param {string} url
 * @returns {string}
 */
showdown.helper.cmNormalizeURL = function (url) {
  url = url.replace(/¨E(\d+)E/g, function (wholeMatch, code) {
    return String.fromCharCode(parseInt(code, 10));
  });
  url = url.replace(/\\([!-/:-@[-`{-~])/g, '$1');
  url = showdown.helper.cmDecodeEntities(url);
  url = showdown.helper.cmEncodeURI(url);
  return url.replace(/&(?![a-zA-Z#0-9]+;)/g, '&amp;');
};

/**
 * HTML-escape the characters that are significant in element and (double-quoted)
 * attribute contexts: `&`, `<`, `>`, `"`. Ampersand is escaped unconditionally,
 * so callers must pass a decoded/plain string (not one that already contains
 * entities they wish to preserve). Used to harden values that are concatenated
 * straight into generated markup (e.g. document metadata).
 * @param {string} str
 * @returns {string}
 */
showdown.helper.escapeHTMLEntities = function (str) {
  'use strict';
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
};

/**
 * makeMarkdown emitters: backslash-escape the characters that would otherwise let
 * an attribute value break out of the generated Markdown syntax and inject new
 * constructs when the Markdown is re-rendered (round-trip injection).
 *
 * - Destination: emitted inside `<...>`, so `\`, `<` and `>` must be escaped.
 * - Title: emitted inside `"..."`, so `\` and `"` must be escaped.
 * - Text (link/image alt): emitted inside `[...]`, so `\`, `[` and `]` must be escaped.
 */
showdown.helper.escapeMarkdownDestination = function (url) {
  'use strict';
  return String(url).replace(/([\\<>])/g, '\\$1');
};
showdown.helper.escapeMarkdownTitle = function (title) {
  'use strict';
  return String(title).replace(/([\\"])/g, '\\$1');
};
showdown.helper.escapeMarkdownText = function (text) {
  'use strict';
  return String(text).replace(/([\\[\]])/g, '\\$1');
};

/**
 * CommonMark link/image title processing: resolve character references, then
 * HTML-escape the significant characters so the title attribute is valid HTML.
 * @param {string} title
 * @returns {string}
 */
showdown.helper.cmEscapeTitle = function (title) {
  return showdown.helper.cmDecodeEntities(title)
    .replace(/&(?![a-zA-Z#0-9]+;)/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
};

/**
 * Normalize a CommonMark link label for reference matching: resolve backslash
 * escapes (both raw `\x` and showdown's `¨E<code>E` placeholders), collapse
 * internal whitespace runs to a single space, trim and case-fold. The same
 * normalization must be applied to both the definition label and the use label
 * so that they compare equal.
 * @param {string} label
 * @returns {string}
 */
showdown.helper.cmNormalizeLabel = function (label) {
  // CommonMark matches labels by case-fold + whitespace collapse only; backslash
  // escapes are NOT resolved (so `[foo\!]` does not match a `[foo!]` definition).
  return showdown.helper.caseFold(label
    .replace(/¨E(\d+)E/g, function (wholeMatch, code) {
      return String.fromCharCode(parseInt(code, 10));
    })
    .replace(/\s+/g, ' ')
    .trim());
};

/**
 * Unicode case folding for case-insensitive matching of link reference labels.
 * Uses `toLowerCase().toUpperCase()` (the round-trip used by commonmark.js) so that
 * characters like `ß`, `ẞ` and `SS` all fold together - which plain `toLowerCase`
 * does not (`ẞ` -> `ß`, not `ss`).
 * @param {string} str
 * @returns {string}
 */
showdown.helper.caseFold = function (str) {
  return str.toLowerCase().toUpperCase();
};

/**
 * Scan a CommonMark link destination starting at index `j`. Handles both
 * `<...>` destinations (no raw newline or unescaped `<`) and bare destinations
 * with balanced parentheses. Returns `{url, end, angle}` (url may be empty for
 * `<>`) or `null` when the destination is malformed.
 * @param {string} str
 * @param {number} j
 * @returns {{url: string, end: number, angle: boolean}|null}
 */
showdown.helper.cmScanDestination = function (str, j) {
  let n = str.length;
  if (str.charAt(j) === '<') {
    j++;
    let buf = '';
    while (j < n && str.charAt(j) !== '>') {
      let c = str.charAt(j);
      if (c === '\n' || c === '<') { return null; }
      if (c === '\\' && j + 1 < n) { buf += c + str.charAt(j + 1); j += 2; continue; }
      buf += c; j++;
    }
    if (j >= n || str.charAt(j) !== '>') { return null; }
    return {url: buf, end: j + 1, angle: true};
  }
  let depth = 0, buf = '';
  while (j < n) {
    let c = str.charAt(j),
        code = str.charCodeAt(j);
    if (c === '\\' && j + 1 < n) { buf += c + str.charAt(j + 1); j += 2; continue; }
    if (c === ' ' || c === '\t' || c === '\n') { break; }
    if (code < 0x20 || code === 0x7f) { break; }
    if (c === '(') { depth++; buf += c; j++; continue; }
    if (c === ')') {
      if (depth === 0) { break; }
      depth--; buf += c; j++; continue;
    }
    buf += c; j++;
  }
  if (depth !== 0) { return null; }
  return {url: buf, end: j, angle: false};
};

/**
 * Scan a CommonMark link title starting at index `j` (which must point at the
 * opening delimiter `"`, `'` or `(`). The title may span multiple lines but not
 * contain a blank line. Returns `{title, end}` or `null` if malformed.
 * @param {string} str
 * @param {number} j
 * @returns {{title: string, end: number}|null}
 */
showdown.helper.cmScanTitle = function (str, j) {
  let n = str.length,
      open = str.charAt(j),
      close = (open === '(') ? ')' : open;
  if (open !== '"' && open !== '\'' && open !== '(') { return null; }
  j++;
  let buf = '';
  while (j < n) {
    let c = str.charAt(j);
    if (c === '\\' && j + 1 < n) { buf += c + str.charAt(j + 1); j += 2; continue; }
    if (open === '(' && c === '(') { return null; }
    if (c === close) {
      if (/\n[ \t]*\n/.test(buf)) { return null; }
      return {title: buf, end: j + 1};
    }
    buf += c; j++;
  }
  return null;
};

/**
 * Clones an object . If the second parameter is true, it deep clones the object.
 * Note: It should not be used in other contexts than showdown, since this algorithm might fail for
 * cyclic references, and dataypes such as Dates, RegExps, Typed Arrays, etc...
 * @param {{}} obj Object to clone
 * @param {boolean} [deep] [optional] If it should deep clone the object. Default is false
 */
showdown.helper.cloneObject = function (obj, deep) {
  deep = !!deep;
  if (obj === null || typeof (obj) !== 'object') {
    return obj;
  }

  if (obj instanceof Date) {
    return new Date(obj);
  }

  if (!deep) {
    let newObj = {};
    for (let key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        newObj[key] = obj[key];
      }
    }
    return newObj;
  }

  if (typeof structuredClone === 'function') {
    return structuredClone(obj);
  } else {
    // note: This is not a real deep clone, and might work in weird ways if used in a dif
    //this is costly and should be used sparsly
    return JSON.parse(JSON.stringify(obj));
  }
};

/**
 * Populate attributes in output text
 * @param {{}} attributes
 * @returns {string}
 */
showdown.helper._populateAttributes = function (attributes) {
  let text = '';
  if (!attributes || !showdown.helper.isObject(attributes)) {
    return text;
  }

  for (let attr in attributes) {
    if (Object.prototype.hasOwnProperty.call(attributes, attr)) {
      let key = attr,
          val;

      // since class is a javascript reserved word we use classes
      if (attr === 'classes') {
        key = 'class';
      }
      if (attributes[attr] === null || showdown.helper.isUndefined(attributes[attr])) {
        val = null;
      } else if (showdown.helper.isArray(attributes[attr])) {
        val = attributes[attr].join(' ');
        if (val === '') {
          val = null;
        }
      } else if (showdown.helper.isString(attributes[attr])) {
        val = attributes[attr];
      } else if (showdown.helper.isNumber(attributes[attr])) {
        val = String(attributes[attr]);
      } else {
        throw new TypeError('Attribute "' + attr + '" must be either an array or string but ' + typeof attributes[attr] + ' given');
      }
      // special attributes
      switch (attr) {
        // these attributes don't expect a value. If they are false, they should be removed. If they are true,
        // they should be present but without any value
        case 'checked':
        case 'disabled':
          if (val === true || val === 'true' || val === attr) {
            text += ' ' + key;
          }
          // if falsy, they are just ignored
          break;

        // default behavior for all other attributes types
        default:
          // Encode any literal double-quote so an attribute value cannot break out of
          // the quoted attribute. Core callers already pre-escape their values (so this
          // is a no-op for them); this closes the hole for values injected via an
          // extension/listener through the setAttributes() event API.
          text += (val === null) ? '' : ' ' + key + '="' + String(val).replace(/"/g, '&quot;') + '"';
          break;
      }
    }
  }

  return text;
};

showdown.helper.normalizeLeadingTabs = function (text) {
  // 1. (1 to 3 spaces followed by a tab at the start of the line) becomes (1 tab)
  text = text.replace(/^ {1,3}\t/gm, '\t');

  // 2.
  return text;
};

/**
 * CommonMark tab expansion: tabs are expanded to spaces using 4-column tab stops,
 * but only in the part of a line that defines block structure - the leading
 * whitespace plus an optional single list/block-quote marker and the whitespace
 * after it. Tabs in content (after that prefix) are preserved. Lines without a tab
 * in their prefix are returned unchanged.
 * @param {string} text
 * @returns {string}
 */
showdown.helper.expandCmTabs = function (text) {
  if (text.indexOf('\t') === -1) {
    return text;
  }
  const prefixRgx = /^[ \t]*(?:(?:[-+*]|\d{1,9}[.)]|>)[ \t]*)?/;
  const thematicBreakRgx = /^ {0,3}([-*_])(?:[ \t]*\1){2,}[ \t]*$/;
  return text.split('\n').map(function (line) {
    // a thematic break (e.g. `*\t*\t*`) is not a list item: do not let the marker
    // branch of the prefix expansion mangle it
    if (thematicBreakRgx.test(line)) {
      return line;
    }
    let prefix = prefixRgx.exec(line)[0];
    if (prefix.indexOf('\t') === -1) {
      return line;
    }
    let out = '',
        col = 0;
    for (let k = 0; k < prefix.length; ++k) {
      let ch = prefix.charAt(k);
      if (ch === '\t') {
        let adv = 4 - (col % 4);
        out += new Array(adv + 1).join(' ');
        col += adv;
      } else {
        out += ch;
        col++;
      }
    }
    return out + line.slice(prefix.length);
  }).join('\n');
};

/**
 * Remove one level of line-leading tabs or spaces
 * @param {string} text
 * @returns {string}
 */
showdown.helper.outdent = function (text) {
  'use strict';
  if (!showdown.helper.isString(text)) {
    return text;
  }
  return text.replace(/^(\t| {1,4})/gm, '');
};

/**
 * Validate options
 * @param {{}} options
 * @returns {{}}
 */
showdown.helper.validateOptions = function (options) {
  if (!showdown.helper.isObject(options)) {
    throw new TypeError('Options must be an object, but ' + typeof options + ' given');
  }

  let defaultOptions = getDefaultOpts(false);

  for (let opt in defaultOptions) {
    if (!Object.prototype.hasOwnProperty.call(defaultOptions, opt)) {
      continue;
    }

    if (!Object.prototype.hasOwnProperty.call(options, opt)) {
      options[opt] = defaultOptions[opt].defaultValue;
    }

    switch (opt) {
      case 'headerIds':
        // accepts `false` (or any boolean) or a plain object {prefix, raw}
        if (typeof options[opt] !== 'boolean' && !showdown.helper.isObject(options[opt])) {
          throw new TypeError('Option headerIds must be `false` or an object but ' + typeof options[opt] + ' given');
        }
        break;
      default:
        if (typeof options[opt] !== defaultOptions[opt].type) {
          throw new TypeError('Option ' + opt + ' must be of type ' + defaultOptions[opt].type + ' but ' + typeof options[opt] + ' given');
        }
    }
  }
  //options.headerLevelStart = (isNaN(parseInt(options.headerLevelStart))) ? 1 : parseInt(options.headerLevelStart);
  return options;
};

/**
 * POLYFILLS
 */
// use this instead of builtin is undefined for IE8 compatibility
if (typeof (console) === 'undefined') {
  // noinspection JSValidateTypes
  // eslint-disable-next-line no-global-assign -- deliberate polyfill for environments without console
  console = {
    warn: function (msg) {
      'use strict';
      alert(msg);
    },
    log: function (msg) {
      'use strict';
      alert(msg);
    },
    error: function (msg) {
      'use strict';
      throw msg;
    }
  };
}

// Math.imul() polyfill
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/imul
if (!Math.imul) {
  Math.imul = function (opA, opB) {
    opB |= 0; // ensure that opB is an integer. opA will automatically be coerced.
    // floating points give us 53 bits of precision to work with plus 1 sign bit
    // automatically handled for our convienence:
    // 1. 0x003fffff /*opA & 0x000fffff*/ * 0x7fffffff /*opB*/ = 0x1fffff7fc00001
    //    0x1fffff7fc00001 < Number.MAX_SAFE_INTEGER /*0x1fffffffffffff*/
    let result = (opA & 0x003fffff) * opB;
    // 2. We can remove an integer coersion from the statement above because:
    //    0x1fffff7fc00001 + 0xffc00000 = 0x1fffffff800001
    //    0x1fffffff800001 < Number.MAX_SAFE_INTEGER /*0x1fffffffffffff*/
    if (opA & 0xffc00000 /*!== 0*/) {
      result += (opA & 0xffc00000) * opB | 0;
    }
    return result | 0;
  };
}

/**
 * Common regexes.
 * We declare some common regexes to improve performance
 */
// CommonMark inline raw-HTML grammar (mirrors commonmark.js' HTMLTAG): an open tag,
// close tag, HTML comment, processing instruction, declaration or CDATA section.
let cmAttributeName = '[a-zA-Z_:][a-zA-Z0-9:._-]*',
    cmAttributeValue = '(?:[^"\'=<>`\\x00-\\x20]+|\'[^\']*\'|"[^"]*")',
    cmAttribute = '(?:\\s+' + cmAttributeName + '(?:\\s*=\\s*' + cmAttributeValue + ')?)',
    cmOpenTag = '<[A-Za-z][A-Za-z0-9\\-]*' + cmAttribute + '*\\s*/?>',
    cmCloseTag = '</[A-Za-z][A-Za-z0-9\\-]*\\s*>',
    cmHTMLComment = '<!-->|<!--->|<!--(?:[^-]|-[^-]|--[^>])*-->',
    cmProcessingInstruction = '<[?][\\s\\S]*?[?]>',
    cmDeclaration = '<![A-Za-z]+[^>]*>',
    cmCDATA = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';

showdown.helper.regexes = {
  asteriskDashTildeAndColon: /([*_:~])/g,
  asteriskDashAndTilde:      /([*_~])/g,
  // Source string (not a RegExp) for the CommonMark inline raw-HTML grammar.
  // hashHTMLSpans builds a *fresh* global RegExp from this per call, because that
  // subparser runs re-entrantly and a shared stateful /g regex would corrupt its
  // lastIndex between nested invocations.
  cmHTMLTagSource:           '(?:' + cmOpenTag + '|' + cmCloseTag + '|' + cmHTMLComment +
                               '|' + cmProcessingInstruction + '|' + cmDeclaration + '|' + cmCDATA + ')',
  // Open and close tag sources on their own, used for the CommonMark "type 7" HTML
  // block start condition (a complete tag that fills the line).
  cmOpenTagSource:           cmOpenTag,
  cmCloseTagSource:          cmCloseTag
};

/**
 * EMOJIS LIST
 */
showdown.helper.emojis = {
  '100': '\ud83d\udcaf',
  '1234': '\ud83d\udd22',
  '+1': '\ud83d\udc4d',
  '-1': '\ud83d\udc4e',
  '1st_place_medal': '\ud83e\udd47',
  '2nd_place_medal': '\ud83e\udd48',
  '3rd_place_medal': '\ud83e\udd49',
  '8ball': '\ud83c\udfb1',
  'a': '\ud83c\udd70\ufe0f',
  'ab': '\ud83c\udd8e',
  'abacus': '\ud83e\uddee',
  'abc': '\ud83d\udd24',
  'abcd': '\ud83d\udd21',
  'accept': '\ud83c\ude51',
  'adhesive_bandage': '\ud83e\ude79',
  'adult': '\ud83e\uddd1',
  'aerial_tramway': '\ud83d\udea1',
  'afghanistan': '\ud83c\udde6\ud83c\uddeb',
  'airplane': '\u2708\ufe0f',
  'aland_islands': '\ud83c\udde6\ud83c\uddfd',
  'alarm_clock': '\u23f0',
  'albania': '\ud83c\udde6\ud83c\uddf1',
  'alembic': '\u2697\ufe0f',
  'algeria': '\ud83c\udde9\ud83c\uddff',
  'alien': '\ud83d\udc7d',
  'ambulance': '\ud83d\ude91',
  'american_samoa': '\ud83c\udde6\ud83c\uddf8',
  'amphora': '\ud83c\udffa',
  'anchor': '\u2693',
  'andorra': '\ud83c\udde6\ud83c\udde9',
  'angel': '\ud83d\udc7c',
  'anger': '\ud83d\udca2',
  'angola': '\ud83c\udde6\ud83c\uddf4',
  'angry': '\ud83d\ude20',
  'anguilla': '\ud83c\udde6\ud83c\uddee',
  'anguished': '\ud83d\ude27',
  'ant': '\ud83d\udc1c',
  'antarctica': '\ud83c\udde6\ud83c\uddf6',
  'antigua_barbuda': '\ud83c\udde6\ud83c\uddec',
  'apple': '\ud83c\udf4e',
  'aquarius': '\u2652',
  'argentina': '\ud83c\udde6\ud83c\uddf7',
  'aries': '\u2648',
  'armenia': '\ud83c\udde6\ud83c\uddf2',
  'arrow_backward': '\u25c0\ufe0f',
  'arrow_double_down': '\u23ec',
  'arrow_double_up': '\u23eb',
  'arrow_down': '\u2b07\ufe0f',
  'arrow_down_small': '\ud83d\udd3d',
  'arrow_forward': '\u25b6\ufe0f',
  'arrow_heading_down': '\u2935\ufe0f',
  'arrow_heading_up': '\u2934\ufe0f',
  'arrow_left': '\u2b05\ufe0f',
  'arrow_lower_left': '\u2199\ufe0f',
  'arrow_lower_right': '\u2198\ufe0f',
  'arrow_right': '\u27a1\ufe0f',
  'arrow_right_hook': '\u21aa\ufe0f',
  'arrow_up': '\u2b06\ufe0f',
  'arrow_up_down': '\u2195\ufe0f',
  'arrow_up_small': '\ud83d\udd3c',
  'arrow_upper_left': '\u2196\ufe0f',
  'arrow_upper_right': '\u2197\ufe0f',
  'arrows_clockwise': '\ud83d\udd03',
  'arrows_counterclockwise': '\ud83d\udd04',
  'art': '\ud83c\udfa8',
  'articulated_lorry': '\ud83d\ude9b',
  'artificial_satellite': '\ud83d\udef0\ufe0f',
  'artist': '\ud83e\uddd1\u200d\ud83c\udfa8',
  'aruba': '\ud83c\udde6\ud83c\uddfc',
  'ascension_island': '\ud83c\udde6\ud83c\udde8',
  'asterisk': '*\ufe0f\u20e3',
  'astonished': '\ud83d\ude32',
  'astronaut': '\ud83e\uddd1\u200d\ud83d\ude80',
  'athletic_shoe': '\ud83d\udc5f',
  'atm': '\ud83c\udfe7',
  'atom_symbol': '\u269b\ufe0f',
  'australia': '\ud83c\udde6\ud83c\uddfa',
  'austria': '\ud83c\udde6\ud83c\uddf9',
  'auto_rickshaw': '\ud83d\udefa',
  'avocado': '\ud83e\udd51',
  'axe': '\ud83e\ude93',
  'azerbaijan': '\ud83c\udde6\ud83c\uddff',
  'b': '\ud83c\udd71\ufe0f',
  'baby': '\ud83d\udc76',
  'baby_bottle': '\ud83c\udf7c',
  'baby_chick': '\ud83d\udc24',
  'baby_symbol': '\ud83d\udebc',
  'back': '\ud83d\udd19',
  'bacon': '\ud83e\udd53',
  'badger': '\ud83e\udda1',
  'badminton': '\ud83c\udff8',
  'bagel': '\ud83e\udd6f',
  'baggage_claim': '\ud83d\udec4',
  'baguette_bread': '\ud83e\udd56',
  'bahamas': '\ud83c\udde7\ud83c\uddf8',
  'bahrain': '\ud83c\udde7\ud83c\udded',
  'balance_scale': '\u2696\ufe0f',
  'bald_man': '\ud83d\udc68\u200d\ud83e\uddb2',
  'bald_woman': '\ud83d\udc69\u200d\ud83e\uddb2',
  'ballet_shoes': '\ud83e\ude70',
  'balloon': '\ud83c\udf88',
  'ballot_box': '\ud83d\uddf3\ufe0f',
  'ballot_box_with_check': '\u2611\ufe0f',
  'bamboo': '\ud83c\udf8d',
  'banana': '\ud83c\udf4c',
  'bangbang': '\u203c\ufe0f',
  'bangladesh': '\ud83c\udde7\ud83c\udde9',
  'banjo': '\ud83e\ude95',
  'bank': '\ud83c\udfe6',
  'bar_chart': '\ud83d\udcca',
  'barbados': '\ud83c\udde7\ud83c\udde7',
  'barber': '\ud83d\udc88',
  'baseball': '\u26be',
  'basket': '\ud83e\uddfa',
  'basketball': '\ud83c\udfc0',
  'basketball_man': '\u26f9\ufe0f\u200d\u2642\ufe0f',
  'basketball_woman': '\u26f9\ufe0f\u200d\u2640\ufe0f',
  'bat': '\ud83e\udd87',
  'bath': '\ud83d\udec0',
  'bathtub': '\ud83d\udec1',
  'battery': '\ud83d\udd0b',
  'beach_umbrella': '\ud83c\udfd6\ufe0f',
  'bear': '\ud83d\udc3b',
  'bearded_person': '\ud83e\uddd4',
  'bed': '\ud83d\udecf\ufe0f',
  'bee': '\ud83d\udc1d',
  'beer': '\ud83c\udf7a',
  'beers': '\ud83c\udf7b',
  'beetle': '\ud83d\udc1e',
  'beginner': '\ud83d\udd30',
  'belarus': '\ud83c\udde7\ud83c\uddfe',
  'belgium': '\ud83c\udde7\ud83c\uddea',
  'belize': '\ud83c\udde7\ud83c\uddff',
  'bell': '\ud83d\udd14',
  'bellhop_bell': '\ud83d\udece\ufe0f',
  'benin': '\ud83c\udde7\ud83c\uddef',
  'bento': '\ud83c\udf71',
  'bermuda': '\ud83c\udde7\ud83c\uddf2',
  'beverage_box': '\ud83e\uddc3',
  'bhutan': '\ud83c\udde7\ud83c\uddf9',
  'bicyclist': '\ud83d\udeb4',
  'bike': '\ud83d\udeb2',
  'biking_man': '\ud83d\udeb4\u200d\u2642\ufe0f',
  'biking_woman': '\ud83d\udeb4\u200d\u2640\ufe0f',
  'bikini': '\ud83d\udc59',
  'billed_cap': '\ud83e\udde2',
  'biohazard': '\u2623\ufe0f',
  'bird': '\ud83d\udc26',
  'birthday': '\ud83c\udf82',
  'black_circle': '\u26ab',
  'black_flag': '\ud83c\udff4',
  'black_heart': '\ud83d\udda4',
  'black_joker': '\ud83c\udccf',
  'black_large_square': '\u2b1b',
  'black_medium_small_square': '\u25fe',
  'black_medium_square': '\u25fc\ufe0f',
  'black_nib': '\u2712\ufe0f',
  'black_small_square': '\u25aa\ufe0f',
  'black_square_button': '\ud83d\udd32',
  'blond_haired_man': '\ud83d\udc71\u200d\u2642\ufe0f',
  'blond_haired_person': '\ud83d\udc71',
  'blond_haired_woman': '\ud83d\udc71\u200d\u2640\ufe0f',
  'blonde_woman': '\ud83d\udc71\u200d\u2640\ufe0f',
  'blossom': '\ud83c\udf3c',
  'blowfish': '\ud83d\udc21',
  'blue_book': '\ud83d\udcd8',
  'blue_car': '\ud83d\ude99',
  'blue_heart': '\ud83d\udc99',
  'blue_square': '\ud83d\udfe6',
  'blush': '\ud83d\ude0a',
  'boar': '\ud83d\udc17',
  'boat': '\u26f5',
  'bolivia': '\ud83c\udde7\ud83c\uddf4',
  'bomb': '\ud83d\udca3',
  'bone': '\ud83e\uddb4',
  'book': '\ud83d\udcd6',
  'bookmark': '\ud83d\udd16',
  'bookmark_tabs': '\ud83d\udcd1',
  'books': '\ud83d\udcda',
  'boom': '\ud83d\udca5',
  'boot': '\ud83d\udc62',
  'bosnia_herzegovina': '\ud83c\udde7\ud83c\udde6',
  'botswana': '\ud83c\udde7\ud83c\uddfc',
  'bouncing_ball_man': '\u26f9\ufe0f\u200d\u2642\ufe0f',
  'bouncing_ball_person': '\u26f9\ufe0f',
  'bouncing_ball_woman': '\u26f9\ufe0f\u200d\u2640\ufe0f',
  'bouquet': '\ud83d\udc90',
  'bouvet_island': '\ud83c\udde7\ud83c\uddfb',
  'bow': '\ud83d\ude47',
  'bow_and_arrow': '\ud83c\udff9',
  'bowing_man': '\ud83d\ude47\u200d\u2642\ufe0f',
  'bowing_woman': '\ud83d\ude47\u200d\u2640\ufe0f',
  'bowl_with_spoon': '\ud83e\udd63',
  'bowling': '\ud83c\udfb3',
  'boxing_glove': '\ud83e\udd4a',
  'boy': '\ud83d\udc66',
  'brain': '\ud83e\udde0',
  'brazil': '\ud83c\udde7\ud83c\uddf7',
  'bread': '\ud83c\udf5e',
  'breast_feeding': '\ud83e\udd31',
  'bricks': '\ud83e\uddf1',
  'bride_with_veil': '\ud83d\udc70',
  'bridge_at_night': '\ud83c\udf09',
  'briefcase': '\ud83d\udcbc',
  'british_indian_ocean_territory': '\ud83c\uddee\ud83c\uddf4',
  'british_virgin_islands': '\ud83c\uddfb\ud83c\uddec',
  'broccoli': '\ud83e\udd66',
  'broken_heart': '\ud83d\udc94',
  'broom': '\ud83e\uddf9',
  'brown_circle': '\ud83d\udfe4',
  'brown_heart': '\ud83e\udd0e',
  'brown_square': '\ud83d\udfeb',
  'brunei': '\ud83c\udde7\ud83c\uddf3',
  'bug': '\ud83d\udc1b',
  'building_construction': '\ud83c\udfd7\ufe0f',
  'bulb': '\ud83d\udca1',
  'bulgaria': '\ud83c\udde7\ud83c\uddec',
  'bullettrain_front': '\ud83d\ude85',
  'bullettrain_side': '\ud83d\ude84',
  'burkina_faso': '\ud83c\udde7\ud83c\uddeb',
  'burrito': '\ud83c\udf2f',
  'burundi': '\ud83c\udde7\ud83c\uddee',
  'bus': '\ud83d\ude8c',
  'business_suit_levitating': '\ud83d\udd74\ufe0f',
  'busstop': '\ud83d\ude8f',
  'bust_in_silhouette': '\ud83d\udc64',
  'busts_in_silhouette': '\ud83d\udc65',
  'butter': '\ud83e\uddc8',
  'butterfly': '\ud83e\udd8b',
  'cactus': '\ud83c\udf35',
  'cake': '\ud83c\udf70',
  'calendar': '\ud83d\udcc6',
  'call_me_hand': '\ud83e\udd19',
  'calling': '\ud83d\udcf2',
  'cambodia': '\ud83c\uddf0\ud83c\udded',
  'camel': '\ud83d\udc2b',
  'camera': '\ud83d\udcf7',
  'camera_flash': '\ud83d\udcf8',
  'cameroon': '\ud83c\udde8\ud83c\uddf2',
  'camping': '\ud83c\udfd5\ufe0f',
  'canada': '\ud83c\udde8\ud83c\udde6',
  'canary_islands': '\ud83c\uddee\ud83c\udde8',
  'cancer': '\u264b',
  'candle': '\ud83d\udd6f\ufe0f',
  'candy': '\ud83c\udf6c',
  'canned_food': '\ud83e\udd6b',
  'canoe': '\ud83d\udef6',
  'cape_verde': '\ud83c\udde8\ud83c\uddfb',
  'capital_abcd': '\ud83d\udd20',
  'capricorn': '\u2651',
  'car': '\ud83d\ude97',
  'card_file_box': '\ud83d\uddc3\ufe0f',
  'card_index': '\ud83d\udcc7',
  'card_index_dividers': '\ud83d\uddc2\ufe0f',
  'caribbean_netherlands': '\ud83c\udde7\ud83c\uddf6',
  'carousel_horse': '\ud83c\udfa0',
  'carrot': '\ud83e\udd55',
  'cartwheeling': '\ud83e\udd38',
  'cat': '\ud83d\udc31',
  'cat2': '\ud83d\udc08',
  'cayman_islands': '\ud83c\uddf0\ud83c\uddfe',
  'cd': '\ud83d\udcbf',
  'central_african_republic': '\ud83c\udde8\ud83c\uddeb',
  'ceuta_melilla': '\ud83c\uddea\ud83c\udde6',
  'chad': '\ud83c\uddf9\ud83c\udde9',
  'chains': '\u26d3\ufe0f',
  'chair': '\ud83e\ude91',
  'champagne': '\ud83c\udf7e',
  'chart': '\ud83d\udcb9',
  'chart_with_downwards_trend': '\ud83d\udcc9',
  'chart_with_upwards_trend': '\ud83d\udcc8',
  'checkered_flag': '\ud83c\udfc1',
  'cheese': '\ud83e\uddc0',
  'cherries': '\ud83c\udf52',
  'cherry_blossom': '\ud83c\udf38',
  'chess_pawn': '\u265f\ufe0f',
  'chestnut': '\ud83c\udf30',
  'chicken': '\ud83d\udc14',
  'child': '\ud83e\uddd2',
  'children_crossing': '\ud83d\udeb8',
  'chile': '\ud83c\udde8\ud83c\uddf1',
  'chipmunk': '\ud83d\udc3f\ufe0f',
  'chocolate_bar': '\ud83c\udf6b',
  'chopsticks': '\ud83e\udd62',
  'christmas_island': '\ud83c\udde8\ud83c\uddfd',
  'christmas_tree': '\ud83c\udf84',
  'church': '\u26ea',
  'cinema': '\ud83c\udfa6',
  'circus_tent': '\ud83c\udfaa',
  'city_sunrise': '\ud83c\udf07',
  'city_sunset': '\ud83c\udf06',
  'cityscape': '\ud83c\udfd9\ufe0f',
  'cl': '\ud83c\udd91',
  'clamp': '\ud83d\udddc\ufe0f',
  'clap': '\ud83d\udc4f',
  'clapper': '\ud83c\udfac',
  'classical_building': '\ud83c\udfdb\ufe0f',
  'climbing': '\ud83e\uddd7',
  'climbing_man': '\ud83e\uddd7\u200d\u2642\ufe0f',
  'climbing_woman': '\ud83e\uddd7\u200d\u2640\ufe0f',
  'clinking_glasses': '\ud83e\udd42',
  'clipboard': '\ud83d\udccb',
  'clipperton_island': '\ud83c\udde8\ud83c\uddf5',
  'clock1': '\ud83d\udd50',
  'clock10': '\ud83d\udd59',
  'clock1030': '\ud83d\udd65',
  'clock11': '\ud83d\udd5a',
  'clock1130': '\ud83d\udd66',
  'clock12': '\ud83d\udd5b',
  'clock1230': '\ud83d\udd67',
  'clock130': '\ud83d\udd5c',
  'clock2': '\ud83d\udd51',
  'clock230': '\ud83d\udd5d',
  'clock3': '\ud83d\udd52',
  'clock330': '\ud83d\udd5e',
  'clock4': '\ud83d\udd53',
  'clock430': '\ud83d\udd5f',
  'clock5': '\ud83d\udd54',
  'clock530': '\ud83d\udd60',
  'clock6': '\ud83d\udd55',
  'clock630': '\ud83d\udd61',
  'clock7': '\ud83d\udd56',
  'clock730': '\ud83d\udd62',
  'clock8': '\ud83d\udd57',
  'clock830': '\ud83d\udd63',
  'clock9': '\ud83d\udd58',
  'clock930': '\ud83d\udd64',
  'closed_book': '\ud83d\udcd5',
  'closed_lock_with_key': '\ud83d\udd10',
  'closed_umbrella': '\ud83c\udf02',
  'cloud': '\u2601\ufe0f',
  'cloud_with_lightning': '\ud83c\udf29\ufe0f',
  'cloud_with_lightning_and_rain': '\u26c8\ufe0f',
  'cloud_with_rain': '\ud83c\udf27\ufe0f',
  'cloud_with_snow': '\ud83c\udf28\ufe0f',
  'clown_face': '\ud83e\udd21',
  'clubs': '\u2663\ufe0f',
  'cn': '\ud83c\udde8\ud83c\uddf3',
  'coat': '\ud83e\udde5',
  'cocktail': '\ud83c\udf78',
  'coconut': '\ud83e\udd65',
  'cocos_islands': '\ud83c\udde8\ud83c\udde8',
  'coffee': '\u2615',
  'coffin': '\u26b0\ufe0f',
  'cold_face': '\ud83e\udd76',
  'cold_sweat': '\ud83d\ude30',
  'collision': '\ud83d\udca5',
  'colombia': '\ud83c\udde8\ud83c\uddf4',
  'comet': '\u2604\ufe0f',
  'comoros': '\ud83c\uddf0\ud83c\uddf2',
  'compass': '\ud83e\udded',
  'computer': '\ud83d\udcbb',
  'computer_mouse': '\ud83d\uddb1\ufe0f',
  'confetti_ball': '\ud83c\udf8a',
  'confounded': '\ud83d\ude16',
  'confused': '\ud83d\ude15',
  'congo_brazzaville': '\ud83c\udde8\ud83c\uddec',
  'congo_kinshasa': '\ud83c\udde8\ud83c\udde9',
  'congratulations': '\u3297\ufe0f',
  'construction': '\ud83d\udea7',
  'construction_worker': '\ud83d\udc77',
  'construction_worker_man': '\ud83d\udc77\u200d\u2642\ufe0f',
  'construction_worker_woman': '\ud83d\udc77\u200d\u2640\ufe0f',
  'control_knobs': '\ud83c\udf9b\ufe0f',
  'convenience_store': '\ud83c\udfea',
  'cook': '\ud83e\uddd1\u200d\ud83c\udf73',
  'cook_islands': '\ud83c\udde8\ud83c\uddf0',
  'cookie': '\ud83c\udf6a',
  'cool': '\ud83c\udd92',
  'cop': '\ud83d\udc6e',
  'copyright': '\u00a9\ufe0f',
  'corn': '\ud83c\udf3d',
  'costa_rica': '\ud83c\udde8\ud83c\uddf7',
  'cote_divoire': '\ud83c\udde8\ud83c\uddee',
  'couch_and_lamp': '\ud83d\udecb\ufe0f',
  'couple': '\ud83d\udc6b',
  'couple_with_heart': '\ud83d\udc91',
  'couple_with_heart_man_man': '\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc68',
  'couple_with_heart_woman_man': '\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc68',
  'couple_with_heart_woman_woman': '\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc69',
  'couplekiss': '\ud83d\udc8f',
  'couplekiss_man_man': '\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68',
  'couplekiss_man_woman': '\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68',
  'couplekiss_woman_woman': '\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69',
  'cow': '\ud83d\udc2e',
  'cow2': '\ud83d\udc04',
  'cowboy_hat_face': '\ud83e\udd20',
  'crab': '\ud83e\udd80',
  'crayon': '\ud83d\udd8d\ufe0f',
  'credit_card': '\ud83d\udcb3',
  'crescent_moon': '\ud83c\udf19',
  'cricket': '\ud83e\udd97',
  'cricket_game': '\ud83c\udfcf',
  'croatia': '\ud83c\udded\ud83c\uddf7',
  'crocodile': '\ud83d\udc0a',
  'croissant': '\ud83e\udd50',
  'crossed_fingers': '\ud83e\udd1e',
  'crossed_flags': '\ud83c\udf8c',
  'crossed_swords': '\u2694\ufe0f',
  'crown': '\ud83d\udc51',
  'cry': '\ud83d\ude22',
  'crying_cat_face': '\ud83d\ude3f',
  'crystal_ball': '\ud83d\udd2e',
  'cuba': '\ud83c\udde8\ud83c\uddfa',
  'cucumber': '\ud83e\udd52',
  'cup_with_straw': '\ud83e\udd64',
  'cupcake': '\ud83e\uddc1',
  'cupid': '\ud83d\udc98',
  'curacao': '\ud83c\udde8\ud83c\uddfc',
  'curling_stone': '\ud83e\udd4c',
  'curly_haired_man': '\ud83d\udc68\u200d\ud83e\uddb1',
  'curly_haired_woman': '\ud83d\udc69\u200d\ud83e\uddb1',
  'curly_loop': '\u27b0',
  'currency_exchange': '\ud83d\udcb1',
  'curry': '\ud83c\udf5b',
  'cursing_face': '\ud83e\udd2c',
  'custard': '\ud83c\udf6e',
  'customs': '\ud83d\udec3',
  'cut_of_meat': '\ud83e\udd69',
  'cyclone': '\ud83c\udf00',
  'cyprus': '\ud83c\udde8\ud83c\uddfe',
  'czech_republic': '\ud83c\udde8\ud83c\uddff',
  'dagger': '\ud83d\udde1\ufe0f',
  'dancer': '\ud83d\udc83',
  'dancers': '\ud83d\udc6f',
  'dancing_men': '\ud83d\udc6f\u200d\u2642\ufe0f',
  'dancing_women': '\ud83d\udc6f\u200d\u2640\ufe0f',
  'dango': '\ud83c\udf61',
  'dark_sunglasses': '\ud83d\udd76\ufe0f',
  'dart': '\ud83c\udfaf',
  'dash': '\ud83d\udca8',
  'date': '\ud83d\udcc5',
  'de': '\ud83c\udde9\ud83c\uddea',
  'deaf_man': '\ud83e\uddcf\u200d\u2642\ufe0f',
  'deaf_person': '\ud83e\uddcf',
  'deaf_woman': '\ud83e\uddcf\u200d\u2640\ufe0f',
  'deciduous_tree': '\ud83c\udf33',
  'deer': '\ud83e\udd8c',
  'denmark': '\ud83c\udde9\ud83c\uddf0',
  'department_store': '\ud83c\udfec',
  'derelict_house': '\ud83c\udfda\ufe0f',
  'desert': '\ud83c\udfdc\ufe0f',
  'desert_island': '\ud83c\udfdd\ufe0f',
  'desktop_computer': '\ud83d\udda5\ufe0f',
  'detective': '\ud83d\udd75\ufe0f',
  'diamond_shape_with_a_dot_inside': '\ud83d\udca0',
  'diamonds': '\u2666\ufe0f',
  'diego_garcia': '\ud83c\udde9\ud83c\uddec',
  'disappointed': '\ud83d\ude1e',
  'disappointed_relieved': '\ud83d\ude25',
  'diving_mask': '\ud83e\udd3f',
  'diya_lamp': '\ud83e\ude94',
  'dizzy': '\ud83d\udcab',
  'dizzy_face': '\ud83d\ude35',
  'djibouti': '\ud83c\udde9\ud83c\uddef',
  'dna': '\ud83e\uddec',
  'do_not_litter': '\ud83d\udeaf',
  'dog': '\ud83d\udc36',
  'dog2': '\ud83d\udc15',
  'dollar': '\ud83d\udcb5',
  'dolls': '\ud83c\udf8e',
  'dolphin': '\ud83d\udc2c',
  'dominica': '\ud83c\udde9\ud83c\uddf2',
  'dominican_republic': '\ud83c\udde9\ud83c\uddf4',
  'door': '\ud83d\udeaa',
  'doughnut': '\ud83c\udf69',
  'dove': '\ud83d\udd4a\ufe0f',
  'dragon': '\ud83d\udc09',
  'dragon_face': '\ud83d\udc32',
  'dress': '\ud83d\udc57',
  'dromedary_camel': '\ud83d\udc2a',
  'drooling_face': '\ud83e\udd24',
  'drop_of_blood': '\ud83e\ude78',
  'droplet': '\ud83d\udca7',
  'drum': '\ud83e\udd41',
  'duck': '\ud83e\udd86',
  'dumpling': '\ud83e\udd5f',
  'dvd': '\ud83d\udcc0',
  'e-mail': '\ud83d\udce7',
  'eagle': '\ud83e\udd85',
  'ear': '\ud83d\udc42',
  'ear_of_rice': '\ud83c\udf3e',
  'ear_with_hearing_aid': '\ud83e\uddbb',
  'earth_africa': '\ud83c\udf0d',
  'earth_americas': '\ud83c\udf0e',
  'earth_asia': '\ud83c\udf0f',
  'ecuador': '\ud83c\uddea\ud83c\udde8',
  'egg': '\ud83e\udd5a',
  'eggplant': '\ud83c\udf46',
  'egypt': '\ud83c\uddea\ud83c\uddec',
  'eight': '8\ufe0f\u20e3',
  'eight_pointed_black_star': '\u2734\ufe0f',
  'eight_spoked_asterisk': '\u2733\ufe0f',
  'eject_button': '\u23cf\ufe0f',
  'el_salvador': '\ud83c\uddf8\ud83c\uddfb',
  'electric_plug': '\ud83d\udd0c',
  'elephant': '\ud83d\udc18',
  'elf': '\ud83e\udddd',
  'elf_man': '\ud83e\udddd\u200d\u2642\ufe0f',
  'elf_woman': '\ud83e\udddd\u200d\u2640\ufe0f',
  'email': '\u2709\ufe0f',
  'end': '\ud83d\udd1a',
  'england': '\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc65\udb40\udc6e\udb40\udc67\udb40\udc7f',
  'envelope': '\u2709\ufe0f',
  'envelope_with_arrow': '\ud83d\udce9',
  'equatorial_guinea': '\ud83c\uddec\ud83c\uddf6',
  'eritrea': '\ud83c\uddea\ud83c\uddf7',
  'es': '\ud83c\uddea\ud83c\uddf8',
  'estonia': '\ud83c\uddea\ud83c\uddea',
  'ethiopia': '\ud83c\uddea\ud83c\uddf9',
  'eu': '\ud83c\uddea\ud83c\uddfa',
  'euro': '\ud83d\udcb6',
  'european_castle': '\ud83c\udff0',
  'european_post_office': '\ud83c\udfe4',
  'european_union': '\ud83c\uddea\ud83c\uddfa',
  'evergreen_tree': '\ud83c\udf32',
  'exclamation': '\u2757',
  'exploding_head': '\ud83e\udd2f',
  'expressionless': '\ud83d\ude11',
  'eye': '\ud83d\udc41\ufe0f',
  'eye_speech_bubble': '\ud83d\udc41\ufe0f\u200d\ud83d\udde8\ufe0f',
  'eyeglasses': '\ud83d\udc53',
  'eyes': '\ud83d\udc40',
  'face_with_head_bandage': '\ud83e\udd15',
  'face_with_thermometer': '\ud83e\udd12',
  'facepalm': '\ud83e\udd26',
  'facepunch': '\ud83d\udc4a',
  'factory': '\ud83c\udfed',
  'factory_worker': '\ud83e\uddd1\u200d\ud83c\udfed',
  'fairy': '\ud83e\uddda',
  'fairy_man': '\ud83e\uddda\u200d\u2642\ufe0f',
  'fairy_woman': '\ud83e\uddda\u200d\u2640\ufe0f',
  'falafel': '\ud83e\uddc6',
  'falkland_islands': '\ud83c\uddeb\ud83c\uddf0',
  'fallen_leaf': '\ud83c\udf42',
  'family': '\ud83d\udc6a',
  'family_man_boy': '\ud83d\udc68\u200d\ud83d\udc66',
  'family_man_boy_boy': '\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66',
  'family_man_girl': '\ud83d\udc68\u200d\ud83d\udc67',
  'family_man_girl_boy': '\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d\udc66',
  'family_man_girl_girl': '\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d\udc67',
  'family_man_man_boy': '\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc66',
  'family_man_man_boy_boy': '\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66',
  'family_man_man_girl': '\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc67',
  'family_man_man_girl_boy': '\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d\udc66',
  'family_man_man_girl_girl': '\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d\udc67',
  'family_man_woman_boy': '\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc66',
  'family_man_woman_boy_boy': '\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66',
  'family_man_woman_girl': '\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc67',
  'family_man_woman_girl_boy': '\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d\udc66',
  'family_man_woman_girl_girl': '\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d\udc67',
  'family_woman_boy': '\ud83d\udc69\u200d\ud83d\udc66',
  'family_woman_boy_boy': '\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66',
  'family_woman_girl': '\ud83d\udc69\u200d\ud83d\udc67',
  'family_woman_girl_boy': '\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d\udc66',
  'family_woman_girl_girl': '\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d\udc67',
  'family_woman_woman_boy': '\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc66',
  'family_woman_woman_boy_boy': '\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66',
  'family_woman_woman_girl': '\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc67',
  'family_woman_woman_girl_boy': '\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d\udc66',
  'family_woman_woman_girl_girl': '\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d\udc67',
  'farmer': '\ud83e\uddd1\u200d\ud83c\udf3e',
  'faroe_islands': '\ud83c\uddeb\ud83c\uddf4',
  'fast_forward': '\u23e9',
  'fax': '\ud83d\udce0',
  'fearful': '\ud83d\ude28',
  'feet': '\ud83d\udc3e',
  'female_detective': '\ud83d\udd75\ufe0f\u200d\u2640\ufe0f',
  'female_sign': '\u2640\ufe0f',
  'ferris_wheel': '\ud83c\udfa1',
  'ferry': '\u26f4\ufe0f',
  'field_hockey': '\ud83c\udfd1',
  'fiji': '\ud83c\uddeb\ud83c\uddef',
  'file_cabinet': '\ud83d\uddc4\ufe0f',
  'file_folder': '\ud83d\udcc1',
  'film_projector': '\ud83d\udcfd\ufe0f',
  'film_strip': '\ud83c\udf9e\ufe0f',
  'finland': '\ud83c\uddeb\ud83c\uddee',
  'fire': '\ud83d\udd25',
  'fire_engine': '\ud83d\ude92',
  'fire_extinguisher': '\ud83e\uddef',
  'firecracker': '\ud83e\udde8',
  'firefighter': '\ud83e\uddd1\u200d\ud83d\ude92',
  'fireworks': '\ud83c\udf86',
  'first_quarter_moon': '\ud83c\udf13',
  'first_quarter_moon_with_face': '\ud83c\udf1b',
  'fish': '\ud83d\udc1f',
  'fish_cake': '\ud83c\udf65',
  'fishing_pole_and_fish': '\ud83c\udfa3',
  'fist': '\u270a',
  'fist_left': '\ud83e\udd1b',
  'fist_oncoming': '\ud83d\udc4a',
  'fist_raised': '\u270a',
  'fist_right': '\ud83e\udd1c',
  'five': '5\ufe0f\u20e3',
  'flags': '\ud83c\udf8f',
  'flamingo': '\ud83e\udda9',
  'flashlight': '\ud83d\udd26',
  'flat_shoe': '\ud83e\udd7f',
  'fleur_de_lis': '\u269c\ufe0f',
  'flight_arrival': '\ud83d\udeec',
  'flight_departure': '\ud83d\udeeb',
  'flipper': '\ud83d\udc2c',
  'floppy_disk': '\ud83d\udcbe',
  'flower_playing_cards': '\ud83c\udfb4',
  'flushed': '\ud83d\ude33',
  'flying_disc': '\ud83e\udd4f',
  'flying_saucer': '\ud83d\udef8',
  'fog': '\ud83c\udf2b\ufe0f',
  'foggy': '\ud83c\udf01',
  'foot': '\ud83e\uddb6',
  'football': '\ud83c\udfc8',
  'footprints': '\ud83d\udc63',
  'fork_and_knife': '\ud83c\udf74',
  'fortune_cookie': '\ud83e\udd60',
  'fountain': '\u26f2',
  'fountain_pen': '\ud83d\udd8b\ufe0f',
  'four': '4\ufe0f\u20e3',
  'four_leaf_clover': '\ud83c\udf40',
  'fox_face': '\ud83e\udd8a',
  'fr': '\ud83c\uddeb\ud83c\uddf7',
  'framed_picture': '\ud83d\uddbc\ufe0f',
  'free': '\ud83c\udd93',
  'french_guiana': '\ud83c\uddec\ud83c\uddeb',
  'french_polynesia': '\ud83c\uddf5\ud83c\uddeb',
  'french_southern_territories': '\ud83c\uddf9\ud83c\uddeb',
  'fried_egg': '\ud83c\udf73',
  'fried_shrimp': '\ud83c\udf64',
  'fries': '\ud83c\udf5f',
  'frog': '\ud83d\udc38',
  'frowning': '\ud83d\ude26',
  'frowning_face': '\u2639\ufe0f',
  'frowning_man': '\ud83d\ude4d\u200d\u2642\ufe0f',
  'frowning_person': '\ud83d\ude4d',
  'frowning_woman': '\ud83d\ude4d\u200d\u2640\ufe0f',
  'fu': '\ud83d\udd95',
  'fuelpump': '\u26fd',
  'full_moon': '\ud83c\udf15',
  'full_moon_with_face': '\ud83c\udf1d',
  'funeral_urn': '\u26b1\ufe0f',
  'gabon': '\ud83c\uddec\ud83c\udde6',
  'gambia': '\ud83c\uddec\ud83c\uddf2',
  'game_die': '\ud83c\udfb2',
  'garlic': '\ud83e\uddc4',
  'gb': '\ud83c\uddec\ud83c\udde7',
  'gear': '\u2699\ufe0f',
  'gem': '\ud83d\udc8e',
  'gemini': '\u264a',
  'genie': '\ud83e\uddde',
  'genie_man': '\ud83e\uddde\u200d\u2642\ufe0f',
  'genie_woman': '\ud83e\uddde\u200d\u2640\ufe0f',
  'georgia': '\ud83c\uddec\ud83c\uddea',
  'ghana': '\ud83c\uddec\ud83c\udded',
  'ghost': '\ud83d\udc7b',
  'gibraltar': '\ud83c\uddec\ud83c\uddee',
  'gift': '\ud83c\udf81',
  'gift_heart': '\ud83d\udc9d',
  'giraffe': '\ud83e\udd92',
  'girl': '\ud83d\udc67',
  'globe_with_meridians': '\ud83c\udf10',
  'gloves': '\ud83e\udde4',
  'goal_net': '\ud83e\udd45',
  'goat': '\ud83d\udc10',
  'goggles': '\ud83e\udd7d',
  'golf': '\u26f3',
  'golfing': '\ud83c\udfcc\ufe0f',
  'golfing_man': '\ud83c\udfcc\ufe0f\u200d\u2642\ufe0f',
  'golfing_woman': '\ud83c\udfcc\ufe0f\u200d\u2640\ufe0f',
  'gorilla': '\ud83e\udd8d',
  'grapes': '\ud83c\udf47',
  'greece': '\ud83c\uddec\ud83c\uddf7',
  'green_apple': '\ud83c\udf4f',
  'green_book': '\ud83d\udcd7',
  'green_circle': '\ud83d\udfe2',
  'green_heart': '\ud83d\udc9a',
  'green_salad': '\ud83e\udd57',
  'green_square': '\ud83d\udfe9',
  'greenland': '\ud83c\uddec\ud83c\uddf1',
  'grenada': '\ud83c\uddec\ud83c\udde9',
  'grey_exclamation': '\u2755',
  'grey_question': '\u2754',
  'grimacing': '\ud83d\ude2c',
  'grin': '\ud83d\ude01',
  'grinning': '\ud83d\ude00',
  'guadeloupe': '\ud83c\uddec\ud83c\uddf5',
  'guam': '\ud83c\uddec\ud83c\uddfa',
  'guard': '\ud83d\udc82',
  'guardsman': '\ud83d\udc82\u200d\u2642\ufe0f',
  'guardswoman': '\ud83d\udc82\u200d\u2640\ufe0f',
  'guatemala': '\ud83c\uddec\ud83c\uddf9',
  'guernsey': '\ud83c\uddec\ud83c\uddec',
  'guide_dog': '\ud83e\uddae',
  'guinea': '\ud83c\uddec\ud83c\uddf3',
  'guinea_bissau': '\ud83c\uddec\ud83c\uddfc',
  'guitar': '\ud83c\udfb8',
  'gun': '\ud83d\udd2b',
  'guyana': '\ud83c\uddec\ud83c\uddfe',
  'haircut': '\ud83d\udc87',
  'haircut_man': '\ud83d\udc87\u200d\u2642\ufe0f',
  'haircut_woman': '\ud83d\udc87\u200d\u2640\ufe0f',
  'haiti': '\ud83c\udded\ud83c\uddf9',
  'hamburger': '\ud83c\udf54',
  'hammer': '\ud83d\udd28',
  'hammer_and_pick': '\u2692\ufe0f',
  'hammer_and_wrench': '\ud83d\udee0\ufe0f',
  'hamster': '\ud83d\udc39',
  'hand': '\u270b',
  'hand_over_mouth': '\ud83e\udd2d',
  'handbag': '\ud83d\udc5c',
  'handball_person': '\ud83e\udd3e',
  'handshake': '\ud83e\udd1d',
  'hankey': '\ud83d\udca9',
  'hash': '#\ufe0f\u20e3',
  'hatched_chick': '\ud83d\udc25',
  'hatching_chick': '\ud83d\udc23',
  'headphones': '\ud83c\udfa7',
  'health_worker': '\ud83e\uddd1\u200d\u2695\ufe0f',
  'hear_no_evil': '\ud83d\ude49',
  'heard_mcdonald_islands': '\ud83c\udded\ud83c\uddf2',
  'heart': '\u2764\ufe0f',
  'heart_decoration': '\ud83d\udc9f',
  'heart_eyes': '\ud83d\ude0d',
  'heart_eyes_cat': '\ud83d\ude3b',
  'heartbeat': '\ud83d\udc93',
  'heartpulse': '\ud83d\udc97',
  'hearts': '\u2665\ufe0f',
  'heavy_check_mark': '\u2714\ufe0f',
  'heavy_division_sign': '\u2797',
  'heavy_dollar_sign': '\ud83d\udcb2',
  'heavy_exclamation_mark': '\u2757',
  'heavy_heart_exclamation': '\u2763\ufe0f',
  'heavy_minus_sign': '\u2796',
  'heavy_multiplication_x': '\u2716\ufe0f',
  'heavy_plus_sign': '\u2795',
  'hedgehog': '\ud83e\udd94',
  'helicopter': '\ud83d\ude81',
  'herb': '\ud83c\udf3f',
  'hibiscus': '\ud83c\udf3a',
  'high_brightness': '\ud83d\udd06',
  'high_heel': '\ud83d\udc60',
  'hiking_boot': '\ud83e\udd7e',
  'hindu_temple': '\ud83d\uded5',
  'hippopotamus': '\ud83e\udd9b',
  'hocho': '\ud83d\udd2a',
  'hole': '\ud83d\udd73\ufe0f',
  'honduras': '\ud83c\udded\ud83c\uddf3',
  'honey_pot': '\ud83c\udf6f',
  'honeybee': '\ud83d\udc1d',
  'hong_kong': '\ud83c\udded\ud83c\uddf0',
  'horse': '\ud83d\udc34',
  'horse_racing': '\ud83c\udfc7',
  'hospital': '\ud83c\udfe5',
  'hot_face': '\ud83e\udd75',
  'hot_pepper': '\ud83c\udf36\ufe0f',
  'hotdog': '\ud83c\udf2d',
  'hotel': '\ud83c\udfe8',
  'hotsprings': '\u2668\ufe0f',
  'hourglass': '\u231b',
  'hourglass_flowing_sand': '\u23f3',
  'house': '\ud83c\udfe0',
  'house_with_garden': '\ud83c\udfe1',
  'houses': '\ud83c\udfd8\ufe0f',
  'hugs': '\ud83e\udd17',
  'hungary': '\ud83c\udded\ud83c\uddfa',
  'hushed': '\ud83d\ude2f',
  'ice_cream': '\ud83c\udf68',
  'ice_cube': '\ud83e\uddca',
  'ice_hockey': '\ud83c\udfd2',
  'ice_skate': '\u26f8\ufe0f',
  'icecream': '\ud83c\udf66',
  'iceland': '\ud83c\uddee\ud83c\uddf8',
  'id': '\ud83c\udd94',
  'ideograph_advantage': '\ud83c\ude50',
  'imp': '\ud83d\udc7f',
  'inbox_tray': '\ud83d\udce5',
  'incoming_envelope': '\ud83d\udce8',
  'india': '\ud83c\uddee\ud83c\uddf3',
  'indonesia': '\ud83c\uddee\ud83c\udde9',
  'infinity': '\u267e\ufe0f',
  'information_desk_person': '\ud83d\udc81',
  'information_source': '\u2139\ufe0f',
  'innocent': '\ud83d\ude07',
  'interrobang': '\u2049\ufe0f',
  'iphone': '\ud83d\udcf1',
  'iran': '\ud83c\uddee\ud83c\uddf7',
  'iraq': '\ud83c\uddee\ud83c\uddf6',
  'ireland': '\ud83c\uddee\ud83c\uddea',
  'isle_of_man': '\ud83c\uddee\ud83c\uddf2',
  'israel': '\ud83c\uddee\ud83c\uddf1',
  'it': '\ud83c\uddee\ud83c\uddf9',
  'izakaya_lantern': '\ud83c\udfee',
  'jack_o_lantern': '\ud83c\udf83',
  'jamaica': '\ud83c\uddef\ud83c\uddf2',
  'japan': '\ud83d\uddfe',
  'japanese_castle': '\ud83c\udfef',
  'japanese_goblin': '\ud83d\udc7a',
  'japanese_ogre': '\ud83d\udc79',
  'jeans': '\ud83d\udc56',
  'jersey': '\ud83c\uddef\ud83c\uddea',
  'jigsaw': '\ud83e\udde9',
  'jordan': '\ud83c\uddef\ud83c\uddf4',
  'joy': '\ud83d\ude02',
  'joy_cat': '\ud83d\ude39',
  'joystick': '\ud83d\udd79\ufe0f',
  'jp': '\ud83c\uddef\ud83c\uddf5',
  'judge': '\ud83e\uddd1\u200d\u2696\ufe0f',
  'juggling_person': '\ud83e\udd39',
  'kaaba': '\ud83d\udd4b',
  'kangaroo': '\ud83e\udd98',
  'kazakhstan': '\ud83c\uddf0\ud83c\uddff',
  'kenya': '\ud83c\uddf0\ud83c\uddea',
  'key': '\ud83d\udd11',
  'keyboard': '\u2328\ufe0f',
  'keycap_ten': '\ud83d\udd1f',
  'kick_scooter': '\ud83d\udef4',
  'kimono': '\ud83d\udc58',
  'kiribati': '\ud83c\uddf0\ud83c\uddee',
  'kiss': '\ud83d\udc8b',
  'kissing': '\ud83d\ude17',
  'kissing_cat': '\ud83d\ude3d',
  'kissing_closed_eyes': '\ud83d\ude1a',
  'kissing_heart': '\ud83d\ude18',
  'kissing_smiling_eyes': '\ud83d\ude19',
  'kite': '\ud83e\ude81',
  'kiwi_fruit': '\ud83e\udd5d',
  'kneeling_man': '\ud83e\uddce\u200d\u2642\ufe0f',
  'kneeling_person': '\ud83e\uddce',
  'kneeling_woman': '\ud83e\uddce\u200d\u2640\ufe0f',
  'knife': '\ud83d\udd2a',
  'koala': '\ud83d\udc28',
  'koko': '\ud83c\ude01',
  'kosovo': '\ud83c\uddfd\ud83c\uddf0',
  'kr': '\ud83c\uddf0\ud83c\uddf7',
  'kuwait': '\ud83c\uddf0\ud83c\uddfc',
  'kyrgyzstan': '\ud83c\uddf0\ud83c\uddec',
  'lab_coat': '\ud83e\udd7c',
  'label': '\ud83c\udff7\ufe0f',
  'lacrosse': '\ud83e\udd4d',
  'lantern': '\ud83c\udfee',
  'laos': '\ud83c\uddf1\ud83c\udde6',
  'large_blue_circle': '\ud83d\udd35',
  'large_blue_diamond': '\ud83d\udd37',
  'large_orange_diamond': '\ud83d\udd36',
  'last_quarter_moon': '\ud83c\udf17',
  'last_quarter_moon_with_face': '\ud83c\udf1c',
  'latin_cross': '\u271d\ufe0f',
  'latvia': '\ud83c\uddf1\ud83c\uddfb',
  'laughing': '\ud83d\ude06',
  'leafy_green': '\ud83e\udd6c',
  'leaves': '\ud83c\udf43',
  'lebanon': '\ud83c\uddf1\ud83c\udde7',
  'ledger': '\ud83d\udcd2',
  'left_luggage': '\ud83d\udec5',
  'left_right_arrow': '\u2194\ufe0f',
  'left_speech_bubble': '\ud83d\udde8\ufe0f',
  'leftwards_arrow_with_hook': '\u21a9\ufe0f',
  'leg': '\ud83e\uddb5',
  'lemon': '\ud83c\udf4b',
  'leo': '\u264c',
  'leopard': '\ud83d\udc06',
  'lesotho': '\ud83c\uddf1\ud83c\uddf8',
  'level_slider': '\ud83c\udf9a\ufe0f',
  'liberia': '\ud83c\uddf1\ud83c\uddf7',
  'libra': '\u264e',
  'libya': '\ud83c\uddf1\ud83c\uddfe',
  'liechtenstein': '\ud83c\uddf1\ud83c\uddee',
  'light_rail': '\ud83d\ude88',
  'link': '\ud83d\udd17',
  'lion': '\ud83e\udd81',
  'lips': '\ud83d\udc44',
  'lipstick': '\ud83d\udc84',
  'lithuania': '\ud83c\uddf1\ud83c\uddf9',
  'lizard': '\ud83e\udd8e',
  'llama': '\ud83e\udd99',
  'lobster': '\ud83e\udd9e',
  'lock': '\ud83d\udd12',
  'lock_with_ink_pen': '\ud83d\udd0f',
  'lollipop': '\ud83c\udf6d',
  'loop': '\u27bf',
  'lotion_bottle': '\ud83e\uddf4',
  'lotus_position': '\ud83e\uddd8',
  'lotus_position_man': '\ud83e\uddd8\u200d\u2642\ufe0f',
  'lotus_position_woman': '\ud83e\uddd8\u200d\u2640\ufe0f',
  'loud_sound': '\ud83d\udd0a',
  'loudspeaker': '\ud83d\udce2',
  'love_hotel': '\ud83c\udfe9',
  'love_letter': '\ud83d\udc8c',
  'love_you_gesture': '\ud83e\udd1f',
  'low_brightness': '\ud83d\udd05',
  'luggage': '\ud83e\uddf3',
  'luxembourg': '\ud83c\uddf1\ud83c\uddfa',
  'lying_face': '\ud83e\udd25',
  'm': '\u24c2\ufe0f',
  'macau': '\ud83c\uddf2\ud83c\uddf4',
  'macedonia': '\ud83c\uddf2\ud83c\uddf0',
  'madagascar': '\ud83c\uddf2\ud83c\uddec',
  'mag': '\ud83d\udd0d',
  'mag_right': '\ud83d\udd0e',
  'mage': '\ud83e\uddd9',
  'mage_man': '\ud83e\uddd9\u200d\u2642\ufe0f',
  'mage_woman': '\ud83e\uddd9\u200d\u2640\ufe0f',
  'magnet': '\ud83e\uddf2',
  'mahjong': '\ud83c\udc04',
  'mailbox': '\ud83d\udceb',
  'mailbox_closed': '\ud83d\udcea',
  'mailbox_with_mail': '\ud83d\udcec',
  'mailbox_with_no_mail': '\ud83d\udced',
  'malawi': '\ud83c\uddf2\ud83c\uddfc',
  'malaysia': '\ud83c\uddf2\ud83c\uddfe',
  'maldives': '\ud83c\uddf2\ud83c\uddfb',
  'male_detective': '\ud83d\udd75\ufe0f\u200d\u2642\ufe0f',
  'male_sign': '\u2642\ufe0f',
  'mali': '\ud83c\uddf2\ud83c\uddf1',
  'malta': '\ud83c\uddf2\ud83c\uddf9',
  'man': '\ud83d\udc68',
  'man_artist': '\ud83d\udc68\u200d\ud83c\udfa8',
  'man_astronaut': '\ud83d\udc68\u200d\ud83d\ude80',
  'man_cartwheeling': '\ud83e\udd38\u200d\u2642\ufe0f',
  'man_cook': '\ud83d\udc68\u200d\ud83c\udf73',
  'man_dancing': '\ud83d\udd7a',
  'man_facepalming': '\ud83e\udd26\u200d\u2642\ufe0f',
  'man_factory_worker': '\ud83d\udc68\u200d\ud83c\udfed',
  'man_farmer': '\ud83d\udc68\u200d\ud83c\udf3e',
  'man_firefighter': '\ud83d\udc68\u200d\ud83d\ude92',
  'man_health_worker': '\ud83d\udc68\u200d\u2695\ufe0f',
  'man_in_manual_wheelchair': '\ud83d\udc68\u200d\ud83e\uddbd',
  'man_in_motorized_wheelchair': '\ud83d\udc68\u200d\ud83e\uddbc',
  'man_in_tuxedo': '\ud83e\udd35',
  'man_judge': '\ud83d\udc68\u200d\u2696\ufe0f',
  'man_juggling': '\ud83e\udd39\u200d\u2642\ufe0f',
  'man_mechanic': '\ud83d\udc68\u200d\ud83d\udd27',
  'man_office_worker': '\ud83d\udc68\u200d\ud83d\udcbc',
  'man_pilot': '\ud83d\udc68\u200d\u2708\ufe0f',
  'man_playing_handball': '\ud83e\udd3e\u200d\u2642\ufe0f',
  'man_playing_water_polo': '\ud83e\udd3d\u200d\u2642\ufe0f',
  'man_scientist': '\ud83d\udc68\u200d\ud83d\udd2c',
  'man_shrugging': '\ud83e\udd37\u200d\u2642\ufe0f',
  'man_singer': '\ud83d\udc68\u200d\ud83c\udfa4',
  'man_student': '\ud83d\udc68\u200d\ud83c\udf93',
  'man_teacher': '\ud83d\udc68\u200d\ud83c\udfeb',
  'man_technologist': '\ud83d\udc68\u200d\ud83d\udcbb',
  'man_with_gua_pi_mao': '\ud83d\udc72',
  'man_with_probing_cane': '\ud83d\udc68\u200d\ud83e\uddaf',
  'man_with_turban': '\ud83d\udc73\u200d\u2642\ufe0f',
  'mandarin': '\ud83c\udf4a',
  'mango': '\ud83e\udd6d',
  'mans_shoe': '\ud83d\udc5e',
  'mantelpiece_clock': '\ud83d\udd70\ufe0f',
  'manual_wheelchair': '\ud83e\uddbd',
  'maple_leaf': '\ud83c\udf41',
  'marshall_islands': '\ud83c\uddf2\ud83c\udded',
  'martial_arts_uniform': '\ud83e\udd4b',
  'martinique': '\ud83c\uddf2\ud83c\uddf6',
  'mask': '\ud83d\ude37',
  'massage': '\ud83d\udc86',
  'massage_man': '\ud83d\udc86\u200d\u2642\ufe0f',
  'massage_woman': '\ud83d\udc86\u200d\u2640\ufe0f',
  'mate': '\ud83e\uddc9',
  'mauritania': '\ud83c\uddf2\ud83c\uddf7',
  'mauritius': '\ud83c\uddf2\ud83c\uddfa',
  'mayotte': '\ud83c\uddfe\ud83c\uddf9',
  'meat_on_bone': '\ud83c\udf56',
  'mechanic': '\ud83e\uddd1\u200d\ud83d\udd27',
  'mechanical_arm': '\ud83e\uddbe',
  'mechanical_leg': '\ud83e\uddbf',
  'medal_military': '\ud83c\udf96\ufe0f',
  'medal_sports': '\ud83c\udfc5',
  'medical_symbol': '\u2695\ufe0f',
  'mega': '\ud83d\udce3',
  'melon': '\ud83c\udf48',
  'memo': '\ud83d\udcdd',
  'men_wrestling': '\ud83e\udd3c\u200d\u2642\ufe0f',
  'menorah': '\ud83d\udd4e',
  'mens': '\ud83d\udeb9',
  'mermaid': '\ud83e\udddc\u200d\u2640\ufe0f',
  'merman': '\ud83e\udddc\u200d\u2642\ufe0f',
  'merperson': '\ud83e\udddc',
  'metal': '\ud83e\udd18',
  'metro': '\ud83d\ude87',
  'mexico': '\ud83c\uddf2\ud83c\uddfd',
  'microbe': '\ud83e\udda0',
  'micronesia': '\ud83c\uddeb\ud83c\uddf2',
  'microphone': '\ud83c\udfa4',
  'microscope': '\ud83d\udd2c',
  'middle_finger': '\ud83d\udd95',
  'milk_glass': '\ud83e\udd5b',
  'milky_way': '\ud83c\udf0c',
  'minibus': '\ud83d\ude90',
  'minidisc': '\ud83d\udcbd',
  'mobile_phone_off': '\ud83d\udcf4',
  'moldova': '\ud83c\uddf2\ud83c\udde9',
  'monaco': '\ud83c\uddf2\ud83c\udde8',
  'money_mouth_face': '\ud83e\udd11',
  'money_with_wings': '\ud83d\udcb8',
  'moneybag': '\ud83d\udcb0',
  'mongolia': '\ud83c\uddf2\ud83c\uddf3',
  'monkey': '\ud83d\udc12',
  'monkey_face': '\ud83d\udc35',
  'monocle_face': '\ud83e\uddd0',
  'monorail': '\ud83d\ude9d',
  'montenegro': '\ud83c\uddf2\ud83c\uddea',
  'montserrat': '\ud83c\uddf2\ud83c\uddf8',
  'moon': '\ud83c\udf14',
  'moon_cake': '\ud83e\udd6e',
  'morocco': '\ud83c\uddf2\ud83c\udde6',
  'mortar_board': '\ud83c\udf93',
  'mosque': '\ud83d\udd4c',
  'mosquito': '\ud83e\udd9f',
  'motor_boat': '\ud83d\udee5\ufe0f',
  'motor_scooter': '\ud83d\udef5',
  'motorcycle': '\ud83c\udfcd\ufe0f',
  'motorized_wheelchair': '\ud83e\uddbc',
  'motorway': '\ud83d\udee3\ufe0f',
  'mount_fuji': '\ud83d\uddfb',
  'mountain': '\u26f0\ufe0f',
  'mountain_bicyclist': '\ud83d\udeb5',
  'mountain_biking_man': '\ud83d\udeb5\u200d\u2642\ufe0f',
  'mountain_biking_woman': '\ud83d\udeb5\u200d\u2640\ufe0f',
  'mountain_cableway': '\ud83d\udea0',
  'mountain_railway': '\ud83d\ude9e',
  'mountain_snow': '\ud83c\udfd4\ufe0f',
  'mouse': '\ud83d\udc2d',
  'mouse2': '\ud83d\udc01',
  'movie_camera': '\ud83c\udfa5',
  'moyai': '\ud83d\uddff',
  'mozambique': '\ud83c\uddf2\ud83c\uddff',
  'mrs_claus': '\ud83e\udd36',
  'muscle': '\ud83d\udcaa',
  'mushroom': '\ud83c\udf44',
  'musical_keyboard': '\ud83c\udfb9',
  'musical_note': '\ud83c\udfb5',
  'musical_score': '\ud83c\udfbc',
  'mute': '\ud83d\udd07',
  'myanmar': '\ud83c\uddf2\ud83c\uddf2',
  'nail_care': '\ud83d\udc85',
  'name_badge': '\ud83d\udcdb',
  'namibia': '\ud83c\uddf3\ud83c\udde6',
  'national_park': '\ud83c\udfde\ufe0f',
  'nauru': '\ud83c\uddf3\ud83c\uddf7',
  'nauseated_face': '\ud83e\udd22',
  'nazar_amulet': '\ud83e\uddff',
  'necktie': '\ud83d\udc54',
  'negative_squared_cross_mark': '\u274e',
  'nepal': '\ud83c\uddf3\ud83c\uddf5',
  'nerd_face': '\ud83e\udd13',
  'netherlands': '\ud83c\uddf3\ud83c\uddf1',
  'neutral_face': '\ud83d\ude10',
  'new': '\ud83c\udd95',
  'new_caledonia': '\ud83c\uddf3\ud83c\udde8',
  'new_moon': '\ud83c\udf11',
  'new_moon_with_face': '\ud83c\udf1a',
  'new_zealand': '\ud83c\uddf3\ud83c\uddff',
  'newspaper': '\ud83d\udcf0',
  'newspaper_roll': '\ud83d\uddde\ufe0f',
  'next_track_button': '\u23ed\ufe0f',
  'ng': '\ud83c\udd96',
  'ng_man': '\ud83d\ude45\u200d\u2642\ufe0f',
  'ng_woman': '\ud83d\ude45\u200d\u2640\ufe0f',
  'nicaragua': '\ud83c\uddf3\ud83c\uddee',
  'niger': '\ud83c\uddf3\ud83c\uddea',
  'nigeria': '\ud83c\uddf3\ud83c\uddec',
  'night_with_stars': '\ud83c\udf03',
  'nine': '9\ufe0f\u20e3',
  'niue': '\ud83c\uddf3\ud83c\uddfa',
  'no_bell': '\ud83d\udd15',
  'no_bicycles': '\ud83d\udeb3',
  'no_entry': '\u26d4',
  'no_entry_sign': '\ud83d\udeab',
  'no_good': '\ud83d\ude45',
  'no_good_man': '\ud83d\ude45\u200d\u2642\ufe0f',
  'no_good_woman': '\ud83d\ude45\u200d\u2640\ufe0f',
  'no_mobile_phones': '\ud83d\udcf5',
  'no_mouth': '\ud83d\ude36',
  'no_pedestrians': '\ud83d\udeb7',
  'no_smoking': '\ud83d\udead',
  'non-potable_water': '\ud83d\udeb1',
  'norfolk_island': '\ud83c\uddf3\ud83c\uddeb',
  'north_korea': '\ud83c\uddf0\ud83c\uddf5',
  'northern_mariana_islands': '\ud83c\uddf2\ud83c\uddf5',
  'norway': '\ud83c\uddf3\ud83c\uddf4',
  'nose': '\ud83d\udc43',
  'notebook': '\ud83d\udcd3',
  'notebook_with_decorative_cover': '\ud83d\udcd4',
  'notes': '\ud83c\udfb6',
  'nut_and_bolt': '\ud83d\udd29',
  'o': '\u2b55',
  'o2': '\ud83c\udd7e\ufe0f',
  'ocean': '\ud83c\udf0a',
  'octopus': '\ud83d\udc19',
  'oden': '\ud83c\udf62',
  'office': '\ud83c\udfe2',
  'office_worker': '\ud83e\uddd1\u200d\ud83d\udcbc',
  'oil_drum': '\ud83d\udee2\ufe0f',
  'ok': '\ud83c\udd97',
  'ok_hand': '\ud83d\udc4c',
  'ok_man': '\ud83d\ude46\u200d\u2642\ufe0f',
  'ok_person': '\ud83d\ude46',
  'ok_woman': '\ud83d\ude46\u200d\u2640\ufe0f',
  'old_key': '\ud83d\udddd\ufe0f',
  'older_adult': '\ud83e\uddd3',
  'older_man': '\ud83d\udc74',
  'older_woman': '\ud83d\udc75',
  'om': '\ud83d\udd49\ufe0f',
  'oman': '\ud83c\uddf4\ud83c\uddf2',
  'on': '\ud83d\udd1b',
  'oncoming_automobile': '\ud83d\ude98',
  'oncoming_bus': '\ud83d\ude8d',
  'oncoming_police_car': '\ud83d\ude94',
  'oncoming_taxi': '\ud83d\ude96',
  'one': '1\ufe0f\u20e3',
  'one_piece_swimsuit': '\ud83e\ude71',
  'onion': '\ud83e\uddc5',
  'open_book': '\ud83d\udcd6',
  'open_file_folder': '\ud83d\udcc2',
  'open_hands': '\ud83d\udc50',
  'open_mouth': '\ud83d\ude2e',
  'open_umbrella': '\u2602\ufe0f',
  'ophiuchus': '\u26ce',
  'orange': '\ud83c\udf4a',
  'orange_book': '\ud83d\udcd9',
  'orange_circle': '\ud83d\udfe0',
  'orange_heart': '\ud83e\udde1',
  'orange_square': '\ud83d\udfe7',
  'orangutan': '\ud83e\udda7',
  'orthodox_cross': '\u2626\ufe0f',
  'otter': '\ud83e\udda6',
  'outbox_tray': '\ud83d\udce4',
  'owl': '\ud83e\udd89',
  'ox': '\ud83d\udc02',
  'oyster': '\ud83e\uddaa',
  'package': '\ud83d\udce6',
  'page_facing_up': '\ud83d\udcc4',
  'page_with_curl': '\ud83d\udcc3',
  'pager': '\ud83d\udcdf',
  'paintbrush': '\ud83d\udd8c\ufe0f',
  'pakistan': '\ud83c\uddf5\ud83c\uddf0',
  'palau': '\ud83c\uddf5\ud83c\uddfc',
  'palestinian_territories': '\ud83c\uddf5\ud83c\uddf8',
  'palm_tree': '\ud83c\udf34',
  'palms_up_together': '\ud83e\udd32',
  'panama': '\ud83c\uddf5\ud83c\udde6',
  'pancakes': '\ud83e\udd5e',
  'panda_face': '\ud83d\udc3c',
  'paperclip': '\ud83d\udcce',
  'paperclips': '\ud83d\udd87\ufe0f',
  'papua_new_guinea': '\ud83c\uddf5\ud83c\uddec',
  'parachute': '\ud83e\ude82',
  'paraguay': '\ud83c\uddf5\ud83c\uddfe',
  'parasol_on_ground': '\u26f1\ufe0f',
  'parking': '\ud83c\udd7f\ufe0f',
  'parrot': '\ud83e\udd9c',
  'part_alternation_mark': '\u303d\ufe0f',
  'partly_sunny': '\u26c5',
  'partying_face': '\ud83e\udd73',
  'passenger_ship': '\ud83d\udef3\ufe0f',
  'passport_control': '\ud83d\udec2',
  'pause_button': '\u23f8\ufe0f',
  'paw_prints': '\ud83d\udc3e',
  'peace_symbol': '\u262e\ufe0f',
  'peach': '\ud83c\udf51',
  'peacock': '\ud83e\udd9a',
  'peanuts': '\ud83e\udd5c',
  'pear': '\ud83c\udf50',
  'pen': '\ud83d\udd8a\ufe0f',
  'pencil': '\ud83d\udcdd',
  'pencil2': '\u270f\ufe0f',
  'penguin': '\ud83d\udc27',
  'pensive': '\ud83d\ude14',
  'people_holding_hands': '\ud83e\uddd1\u200d\ud83e\udd1d\u200d\ud83e\uddd1',
  'performing_arts': '\ud83c\udfad',
  'persevere': '\ud83d\ude23',
  'person_bald': '\ud83e\uddd1\u200d\ud83e\uddb2',
  'person_curly_hair': '\ud83e\uddd1\u200d\ud83e\uddb1',
  'person_fencing': '\ud83e\udd3a',
  'person_in_manual_wheelchair': '\ud83e\uddd1\u200d\ud83e\uddbd',
  'person_in_motorized_wheelchair': '\ud83e\uddd1\u200d\ud83e\uddbc',
  'person_red_hair': '\ud83e\uddd1\u200d\ud83e\uddb0',
  'person_white_hair': '\ud83e\uddd1\u200d\ud83e\uddb3',
  'person_with_probing_cane': '\ud83e\uddd1\u200d\ud83e\uddaf',
  'person_with_turban': '\ud83d\udc73',
  'peru': '\ud83c\uddf5\ud83c\uddea',
  'petri_dish': '\ud83e\uddeb',
  'philippines': '\ud83c\uddf5\ud83c\udded',
  'phone': '\u260e\ufe0f',
  'pick': '\u26cf\ufe0f',
  'pie': '\ud83e\udd67',
  'pig': '\ud83d\udc37',
  'pig2': '\ud83d\udc16',
  'pig_nose': '\ud83d\udc3d',
  'pill': '\ud83d\udc8a',
  'pilot': '\ud83e\uddd1\u200d\u2708\ufe0f',
  'pinching_hand': '\ud83e\udd0f',
  'pineapple': '\ud83c\udf4d',
  'ping_pong': '\ud83c\udfd3',
  'pirate_flag': '\ud83c\udff4\u200d\u2620\ufe0f',
  'pisces': '\u2653',
  'pitcairn_islands': '\ud83c\uddf5\ud83c\uddf3',
  'pizza': '\ud83c\udf55',
  'place_of_worship': '\ud83d\uded0',
  'plate_with_cutlery': '\ud83c\udf7d\ufe0f',
  'play_or_pause_button': '\u23ef\ufe0f',
  'pleading_face': '\ud83e\udd7a',
  'point_down': '\ud83d\udc47',
  'point_left': '\ud83d\udc48',
  'point_right': '\ud83d\udc49',
  'point_up': '\u261d\ufe0f',
  'point_up_2': '\ud83d\udc46',
  'poland': '\ud83c\uddf5\ud83c\uddf1',
  'police_car': '\ud83d\ude93',
  'police_officer': '\ud83d\udc6e',
  'policeman': '\ud83d\udc6e\u200d\u2642\ufe0f',
  'policewoman': '\ud83d\udc6e\u200d\u2640\ufe0f',
  'poodle': '\ud83d\udc29',
  'poop': '\ud83d\udca9',
  'popcorn': '\ud83c\udf7f',
  'portugal': '\ud83c\uddf5\ud83c\uddf9',
  'post_office': '\ud83c\udfe3',
  'postal_horn': '\ud83d\udcef',
  'postbox': '\ud83d\udcee',
  'potable_water': '\ud83d\udeb0',
  'potato': '\ud83e\udd54',
  'pouch': '\ud83d\udc5d',
  'poultry_leg': '\ud83c\udf57',
  'pound': '\ud83d\udcb7',
  'pout': '\ud83d\ude21',
  'pouting_cat': '\ud83d\ude3e',
  'pouting_face': '\ud83d\ude4e',
  'pouting_man': '\ud83d\ude4e\u200d\u2642\ufe0f',
  'pouting_woman': '\ud83d\ude4e\u200d\u2640\ufe0f',
  'pray': '\ud83d\ude4f',
  'prayer_beads': '\ud83d\udcff',
  'pregnant_woman': '\ud83e\udd30',
  'pretzel': '\ud83e\udd68',
  'previous_track_button': '\u23ee\ufe0f',
  'prince': '\ud83e\udd34',
  'princess': '\ud83d\udc78',
  'printer': '\ud83d\udda8\ufe0f',
  'probing_cane': '\ud83e\uddaf',
  'puerto_rico': '\ud83c\uddf5\ud83c\uddf7',
  'punch': '\ud83d\udc4a',
  'purple_circle': '\ud83d\udfe3',
  'purple_heart': '\ud83d\udc9c',
  'purple_square': '\ud83d\udfea',
  'purse': '\ud83d\udc5b',
  'pushpin': '\ud83d\udccc',
  'put_litter_in_its_place': '\ud83d\udeae',
  'qatar': '\ud83c\uddf6\ud83c\udde6',
  'question': '\u2753',
  'rabbit': '\ud83d\udc30',
  'rabbit2': '\ud83d\udc07',
  'raccoon': '\ud83e\udd9d',
  'racehorse': '\ud83d\udc0e',
  'racing_car': '\ud83c\udfce\ufe0f',
  'radio': '\ud83d\udcfb',
  'radio_button': '\ud83d\udd18',
  'radioactive': '\u2622\ufe0f',
  'rage': '\ud83d\ude21',
  'railway_car': '\ud83d\ude83',
  'railway_track': '\ud83d\udee4\ufe0f',
  'rainbow': '\ud83c\udf08',
  'rainbow_flag': '\ud83c\udff3\ufe0f\u200d\ud83c\udf08',
  'raised_back_of_hand': '\ud83e\udd1a',
  'raised_eyebrow': '\ud83e\udd28',
  'raised_hand': '\u270b',
  'raised_hand_with_fingers_splayed': '\ud83d\udd90\ufe0f',
  'raised_hands': '\ud83d\ude4c',
  'raising_hand': '\ud83d\ude4b',
  'raising_hand_man': '\ud83d\ude4b\u200d\u2642\ufe0f',
  'raising_hand_woman': '\ud83d\ude4b\u200d\u2640\ufe0f',
  'ram': '\ud83d\udc0f',
  'ramen': '\ud83c\udf5c',
  'rat': '\ud83d\udc00',
  'razor': '\ud83e\ude92',
  'receipt': '\ud83e\uddfe',
  'record_button': '\u23fa\ufe0f',
  'recycle': '\u267b\ufe0f',
  'red_car': '\ud83d\ude97',
  'red_circle': '\ud83d\udd34',
  'red_envelope': '\ud83e\udde7',
  'red_haired_man': '\ud83d\udc68\u200d\ud83e\uddb0',
  'red_haired_woman': '\ud83d\udc69\u200d\ud83e\uddb0',
  'red_square': '\ud83d\udfe5',
  'registered': '\u00ae\ufe0f',
  'relaxed': '\u263a\ufe0f',
  'relieved': '\ud83d\ude0c',
  'reminder_ribbon': '\ud83c\udf97\ufe0f',
  'repeat': '\ud83d\udd01',
  'repeat_one': '\ud83d\udd02',
  'rescue_worker_helmet': '\u26d1\ufe0f',
  'restroom': '\ud83d\udebb',
  'reunion': '\ud83c\uddf7\ud83c\uddea',
  'revolving_hearts': '\ud83d\udc9e',
  'rewind': '\u23ea',
  'rhinoceros': '\ud83e\udd8f',
  'ribbon': '\ud83c\udf80',
  'rice': '\ud83c\udf5a',
  'rice_ball': '\ud83c\udf59',
  'rice_cracker': '\ud83c\udf58',
  'rice_scene': '\ud83c\udf91',
  'right_anger_bubble': '\ud83d\uddef\ufe0f',
  'ring': '\ud83d\udc8d',
  'ringed_planet': '\ud83e\ude90',
  'robot': '\ud83e\udd16',
  'rocket': '\ud83d\ude80',
  'rofl': '\ud83e\udd23',
  'roll_eyes': '\ud83d\ude44',
  'roll_of_paper': '\ud83e\uddfb',
  'roller_coaster': '\ud83c\udfa2',
  'romania': '\ud83c\uddf7\ud83c\uddf4',
  'rooster': '\ud83d\udc13',
  'rose': '\ud83c\udf39',
  'rosette': '\ud83c\udff5\ufe0f',
  'rotating_light': '\ud83d\udea8',
  'round_pushpin': '\ud83d\udccd',
  'rowboat': '\ud83d\udea3',
  'rowing_man': '\ud83d\udea3\u200d\u2642\ufe0f',
  'rowing_woman': '\ud83d\udea3\u200d\u2640\ufe0f',
  'ru': '\ud83c\uddf7\ud83c\uddfa',
  'rugby_football': '\ud83c\udfc9',
  'runner': '\ud83c\udfc3',
  'running': '\ud83c\udfc3',
  'running_man': '\ud83c\udfc3\u200d\u2642\ufe0f',
  'running_shirt_with_sash': '\ud83c\udfbd',
  'running_woman': '\ud83c\udfc3\u200d\u2640\ufe0f',
  'rwanda': '\ud83c\uddf7\ud83c\uddfc',
  'sa': '\ud83c\ude02\ufe0f',
  'safety_pin': '\ud83e\uddf7',
  'safety_vest': '\ud83e\uddba',
  'sagittarius': '\u2650',
  'sailboat': '\u26f5',
  'sake': '\ud83c\udf76',
  'salt': '\ud83e\uddc2',
  'samoa': '\ud83c\uddfc\ud83c\uddf8',
  'san_marino': '\ud83c\uddf8\ud83c\uddf2',
  'sandal': '\ud83d\udc61',
  'sandwich': '\ud83e\udd6a',
  'santa': '\ud83c\udf85',
  'sao_tome_principe': '\ud83c\uddf8\ud83c\uddf9',
  'sari': '\ud83e\udd7b',
  'sassy_man': '\ud83d\udc81\u200d\u2642\ufe0f',
  'sassy_woman': '\ud83d\udc81\u200d\u2640\ufe0f',
  'satellite': '\ud83d\udce1',
  'satisfied': '\ud83d\ude06',
  'saudi_arabia': '\ud83c\uddf8\ud83c\udde6',
  'sauna_man': '\ud83e\uddd6\u200d\u2642\ufe0f',
  'sauna_person': '\ud83e\uddd6',
  'sauna_woman': '\ud83e\uddd6\u200d\u2640\ufe0f',
  'sauropod': '\ud83e\udd95',
  'saxophone': '\ud83c\udfb7',
  'scarf': '\ud83e\udde3',
  'school': '\ud83c\udfeb',
  'school_satchel': '\ud83c\udf92',
  'scientist': '\ud83e\uddd1\u200d\ud83d\udd2c',
  'scissors': '\u2702\ufe0f',
  'scorpion': '\ud83e\udd82',
  'scorpius': '\u264f',
  'scotland': '\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc73\udb40\udc63\udb40\udc74\udb40\udc7f',
  'scream': '\ud83d\ude31',
  'scream_cat': '\ud83d\ude40',
  'scroll': '\ud83d\udcdc',
  'seat': '\ud83d\udcba',
  'secret': '\u3299\ufe0f',
  'see_no_evil': '\ud83d\ude48',
  'seedling': '\ud83c\udf31',
  'selfie': '\ud83e\udd33',
  'senegal': '\ud83c\uddf8\ud83c\uddf3',
  'serbia': '\ud83c\uddf7\ud83c\uddf8',
  'service_dog': '\ud83d\udc15\u200d\ud83e\uddba',
  'seven': '7\ufe0f\u20e3',
  'seychelles': '\ud83c\uddf8\ud83c\udde8',
  'shallow_pan_of_food': '\ud83e\udd58',
  'shamrock': '\u2618\ufe0f',
  'shark': '\ud83e\udd88',
  'shaved_ice': '\ud83c\udf67',
  'sheep': '\ud83d\udc11',
  'shell': '\ud83d\udc1a',
  'shield': '\ud83d\udee1\ufe0f',
  'shinto_shrine': '\u26e9\ufe0f',
  'ship': '\ud83d\udea2',
  'shirt': '\ud83d\udc55',
  'shit': '\ud83d\udca9',
  'shoe': '\ud83d\udc5e',
  'shopping': '\ud83d\udecd\ufe0f',
  'shopping_cart': '\ud83d\uded2',
  'shorts': '\ud83e\ude73',
  'shower': '\ud83d\udebf',
  'shrimp': '\ud83e\udd90',
  'shrug': '\ud83e\udd37',
  'shushing_face': '\ud83e\udd2b',
  'sierra_leone': '\ud83c\uddf8\ud83c\uddf1',
  'signal_strength': '\ud83d\udcf6',
  'singapore': '\ud83c\uddf8\ud83c\uddec',
  'singer': '\ud83e\uddd1\u200d\ud83c\udfa4',
  'sint_maarten': '\ud83c\uddf8\ud83c\uddfd',
  'six': '6\ufe0f\u20e3',
  'six_pointed_star': '\ud83d\udd2f',
  'skateboard': '\ud83d\udef9',
  'ski': '\ud83c\udfbf',
  'skier': '\u26f7\ufe0f',
  'skull': '\ud83d\udc80',
  'skull_and_crossbones': '\u2620\ufe0f',
  'skunk': '\ud83e\udda8',
  'sled': '\ud83d\udef7',
  'sleeping': '\ud83d\ude34',
  'sleeping_bed': '\ud83d\udecc',
  'sleepy': '\ud83d\ude2a',
  'slightly_frowning_face': '\ud83d\ude41',
  'slightly_smiling_face': '\ud83d\ude42',
  'slot_machine': '\ud83c\udfb0',
  'sloth': '\ud83e\udda5',
  'slovakia': '\ud83c\uddf8\ud83c\uddf0',
  'slovenia': '\ud83c\uddf8\ud83c\uddee',
  'small_airplane': '\ud83d\udee9\ufe0f',
  'small_blue_diamond': '\ud83d\udd39',
  'small_orange_diamond': '\ud83d\udd38',
  'small_red_triangle': '\ud83d\udd3a',
  'small_red_triangle_down': '\ud83d\udd3b',
  'smile': '\ud83d\ude04',
  'smile_cat': '\ud83d\ude38',
  'smiley': '\ud83d\ude03',
  'smiley_cat': '\ud83d\ude3a',
  'smiling_face_with_three_hearts': '\ud83e\udd70',
  'smiling_imp': '\ud83d\ude08',
  'smirk': '\ud83d\ude0f',
  'smirk_cat': '\ud83d\ude3c',
  'smoking': '\ud83d\udeac',
  'snail': '\ud83d\udc0c',
  'snake': '\ud83d\udc0d',
  'sneezing_face': '\ud83e\udd27',
  'snowboarder': '\ud83c\udfc2',
  'snowflake': '\u2744\ufe0f',
  'snowman': '\u26c4',
  'snowman_with_snow': '\u2603\ufe0f',
  'soap': '\ud83e\uddfc',
  'sob': '\ud83d\ude2d',
  'soccer': '\u26bd',
  'socks': '\ud83e\udde6',
  'softball': '\ud83e\udd4e',
  'solomon_islands': '\ud83c\uddf8\ud83c\udde7',
  'somalia': '\ud83c\uddf8\ud83c\uddf4',
  'soon': '\ud83d\udd1c',
  'sos': '\ud83c\udd98',
  'sound': '\ud83d\udd09',
  'south_africa': '\ud83c\uddff\ud83c\udde6',
  'south_georgia_south_sandwich_islands': '\ud83c\uddec\ud83c\uddf8',
  'south_sudan': '\ud83c\uddf8\ud83c\uddf8',
  'space_invader': '\ud83d\udc7e',
  'spades': '\u2660\ufe0f',
  'spaghetti': '\ud83c\udf5d',
  'sparkle': '\u2747\ufe0f',
  'sparkler': '\ud83c\udf87',
  'sparkles': '\u2728',
  'sparkling_heart': '\ud83d\udc96',
  'speak_no_evil': '\ud83d\ude4a',
  'speaker': '\ud83d\udd08',
  'speaking_head': '\ud83d\udde3\ufe0f',
  'speech_balloon': '\ud83d\udcac',
  'speedboat': '\ud83d\udea4',
  'spider': '\ud83d\udd77\ufe0f',
  'spider_web': '\ud83d\udd78\ufe0f',
  'spiral_calendar': '\ud83d\uddd3\ufe0f',
  'spiral_notepad': '\ud83d\uddd2\ufe0f',
  'sponge': '\ud83e\uddfd',
  'spoon': '\ud83e\udd44',
  'squid': '\ud83e\udd91',
  'sri_lanka': '\ud83c\uddf1\ud83c\uddf0',
  'st_barthelemy': '\ud83c\udde7\ud83c\uddf1',
  'st_helena': '\ud83c\uddf8\ud83c\udded',
  'st_kitts_nevis': '\ud83c\uddf0\ud83c\uddf3',
  'st_lucia': '\ud83c\uddf1\ud83c\udde8',
  'st_martin': '\ud83c\uddf2\ud83c\uddeb',
  'st_pierre_miquelon': '\ud83c\uddf5\ud83c\uddf2',
  'st_vincent_grenadines': '\ud83c\uddfb\ud83c\udde8',
  'stadium': '\ud83c\udfdf\ufe0f',
  'standing_man': '\ud83e\uddcd\u200d\u2642\ufe0f',
  'standing_person': '\ud83e\uddcd',
  'standing_woman': '\ud83e\uddcd\u200d\u2640\ufe0f',
  'star': '\u2b50',
  'star2': '\ud83c\udf1f',
  'star_and_crescent': '\u262a\ufe0f',
  'star_of_david': '\u2721\ufe0f',
  'star_struck': '\ud83e\udd29',
  'stars': '\ud83c\udf20',
  'station': '\ud83d\ude89',
  'statue_of_liberty': '\ud83d\uddfd',
  'steam_locomotive': '\ud83d\ude82',
  'stethoscope': '\ud83e\ude7a',
  'stew': '\ud83c\udf72',
  'stop_button': '\u23f9\ufe0f',
  'stop_sign': '\ud83d\uded1',
  'stopwatch': '\u23f1\ufe0f',
  'straight_ruler': '\ud83d\udccf',
  'strawberry': '\ud83c\udf53',
  'stuck_out_tongue': '\ud83d\ude1b',
  'stuck_out_tongue_closed_eyes': '\ud83d\ude1d',
  'stuck_out_tongue_winking_eye': '\ud83d\ude1c',
  'student': '\ud83e\uddd1\u200d\ud83c\udf93',
  'studio_microphone': '\ud83c\udf99\ufe0f',
  'stuffed_flatbread': '\ud83e\udd59',
  'sudan': '\ud83c\uddf8\ud83c\udde9',
  'sun_behind_large_cloud': '\ud83c\udf25\ufe0f',
  'sun_behind_rain_cloud': '\ud83c\udf26\ufe0f',
  'sun_behind_small_cloud': '\ud83c\udf24\ufe0f',
  'sun_with_face': '\ud83c\udf1e',
  'sunflower': '\ud83c\udf3b',
  'sunglasses': '\ud83d\ude0e',
  'sunny': '\u2600\ufe0f',
  'sunrise': '\ud83c\udf05',
  'sunrise_over_mountains': '\ud83c\udf04',
  'superhero': '\ud83e\uddb8',
  'superhero_man': '\ud83e\uddb8\u200d\u2642\ufe0f',
  'superhero_woman': '\ud83e\uddb8\u200d\u2640\ufe0f',
  'supervillain': '\ud83e\uddb9',
  'supervillain_man': '\ud83e\uddb9\u200d\u2642\ufe0f',
  'supervillain_woman': '\ud83e\uddb9\u200d\u2640\ufe0f',
  'surfer': '\ud83c\udfc4',
  'surfing_man': '\ud83c\udfc4\u200d\u2642\ufe0f',
  'surfing_woman': '\ud83c\udfc4\u200d\u2640\ufe0f',
  'suriname': '\ud83c\uddf8\ud83c\uddf7',
  'sushi': '\ud83c\udf63',
  'suspension_railway': '\ud83d\ude9f',
  'svalbard_jan_mayen': '\ud83c\uddf8\ud83c\uddef',
  'swan': '\ud83e\udda2',
  'swaziland': '\ud83c\uddf8\ud83c\uddff',
  'sweat': '\ud83d\ude13',
  'sweat_drops': '\ud83d\udca6',
  'sweat_smile': '\ud83d\ude05',
  'sweden': '\ud83c\uddf8\ud83c\uddea',
  'sweet_potato': '\ud83c\udf60',
  'swim_brief': '\ud83e\ude72',
  'swimmer': '\ud83c\udfca',
  'swimming_man': '\ud83c\udfca\u200d\u2642\ufe0f',
  'swimming_woman': '\ud83c\udfca\u200d\u2640\ufe0f',
  'switzerland': '\ud83c\udde8\ud83c\udded',
  'symbols': '\ud83d\udd23',
  'synagogue': '\ud83d\udd4d',
  'syria': '\ud83c\uddf8\ud83c\uddfe',
  'syringe': '\ud83d\udc89',
  't-rex': '\ud83e\udd96',
  'taco': '\ud83c\udf2e',
  'tada': '\ud83c\udf89',
  'taiwan': '\ud83c\uddf9\ud83c\uddfc',
  'tajikistan': '\ud83c\uddf9\ud83c\uddef',
  'takeout_box': '\ud83e\udd61',
  'tanabata_tree': '\ud83c\udf8b',
  'tangerine': '\ud83c\udf4a',
  'tanzania': '\ud83c\uddf9\ud83c\uddff',
  'taurus': '\u2649',
  'taxi': '\ud83d\ude95',
  'tea': '\ud83c\udf75',
  'teacher': '\ud83e\uddd1\u200d\ud83c\udfeb',
  'technologist': '\ud83e\uddd1\u200d\ud83d\udcbb',
  'teddy_bear': '\ud83e\uddf8',
  'telephone': '\u260e\ufe0f',
  'telephone_receiver': '\ud83d\udcde',
  'telescope': '\ud83d\udd2d',
  'tennis': '\ud83c\udfbe',
  'tent': '\u26fa',
  'test_tube': '\ud83e\uddea',
  'thailand': '\ud83c\uddf9\ud83c\udded',
  'thermometer': '\ud83c\udf21\ufe0f',
  'thinking': '\ud83e\udd14',
  'thought_balloon': '\ud83d\udcad',
  'thread': '\ud83e\uddf5',
  'three': '3\ufe0f\u20e3',
  'thumbsdown': '\ud83d\udc4e',
  'thumbsup': '\ud83d\udc4d',
  'ticket': '\ud83c\udfab',
  'tickets': '\ud83c\udf9f\ufe0f',
  'tiger': '\ud83d\udc2f',
  'tiger2': '\ud83d\udc05',
  'timer_clock': '\u23f2\ufe0f',
  'timor_leste': '\ud83c\uddf9\ud83c\uddf1',
  'tipping_hand_man': '\ud83d\udc81\u200d\u2642\ufe0f',
  'tipping_hand_person': '\ud83d\udc81',
  'tipping_hand_woman': '\ud83d\udc81\u200d\u2640\ufe0f',
  'tired_face': '\ud83d\ude2b',
  'tm': '\u2122\ufe0f',
  'togo': '\ud83c\uddf9\ud83c\uddec',
  'toilet': '\ud83d\udebd',
  'tokelau': '\ud83c\uddf9\ud83c\uddf0',
  'tokyo_tower': '\ud83d\uddfc',
  'tomato': '\ud83c\udf45',
  'tonga': '\ud83c\uddf9\ud83c\uddf4',
  'tongue': '\ud83d\udc45',
  'toolbox': '\ud83e\uddf0',
  'tooth': '\ud83e\uddb7',
  'top': '\ud83d\udd1d',
  'tophat': '\ud83c\udfa9',
  'tornado': '\ud83c\udf2a\ufe0f',
  'tr': '\ud83c\uddf9\ud83c\uddf7',
  'trackball': '\ud83d\uddb2\ufe0f',
  'tractor': '\ud83d\ude9c',
  'traffic_light': '\ud83d\udea5',
  'train': '\ud83d\ude8b',
  'train2': '\ud83d\ude86',
  'tram': '\ud83d\ude8a',
  'triangular_flag_on_post': '\ud83d\udea9',
  'triangular_ruler': '\ud83d\udcd0',
  'trident': '\ud83d\udd31',
  'trinidad_tobago': '\ud83c\uddf9\ud83c\uddf9',
  'tristan_da_cunha': '\ud83c\uddf9\ud83c\udde6',
  'triumph': '\ud83d\ude24',
  'trolleybus': '\ud83d\ude8e',
  'trophy': '\ud83c\udfc6',
  'tropical_drink': '\ud83c\udf79',
  'tropical_fish': '\ud83d\udc20',
  'truck': '\ud83d\ude9a',
  'trumpet': '\ud83c\udfba',
  'tshirt': '\ud83d\udc55',
  'tulip': '\ud83c\udf37',
  'tumbler_glass': '\ud83e\udd43',
  'tunisia': '\ud83c\uddf9\ud83c\uddf3',
  'turkey': '\ud83e\udd83',
  'turkmenistan': '\ud83c\uddf9\ud83c\uddf2',
  'turks_caicos_islands': '\ud83c\uddf9\ud83c\udde8',
  'turtle': '\ud83d\udc22',
  'tuvalu': '\ud83c\uddf9\ud83c\uddfb',
  'tv': '\ud83d\udcfa',
  'twisted_rightwards_arrows': '\ud83d\udd00',
  'two': '2\ufe0f\u20e3',
  'two_hearts': '\ud83d\udc95',
  'two_men_holding_hands': '\ud83d\udc6c',
  'two_women_holding_hands': '\ud83d\udc6d',
  'u5272': '\ud83c\ude39',
  'u5408': '\ud83c\ude34',
  'u55b6': '\ud83c\ude3a',
  'u6307': '\ud83c\ude2f',
  'u6708': '\ud83c\ude37\ufe0f',
  'u6709': '\ud83c\ude36',
  'u6e80': '\ud83c\ude35',
  'u7121': '\ud83c\ude1a',
  'u7533': '\ud83c\ude38',
  'u7981': '\ud83c\ude32',
  'u7a7a': '\ud83c\ude33',
  'uganda': '\ud83c\uddfa\ud83c\uddec',
  'uk': '\ud83c\uddec\ud83c\udde7',
  'ukraine': '\ud83c\uddfa\ud83c\udde6',
  'umbrella': '\u2614',
  'unamused': '\ud83d\ude12',
  'underage': '\ud83d\udd1e',
  'unicorn': '\ud83e\udd84',
  'united_arab_emirates': '\ud83c\udde6\ud83c\uddea',
  'united_nations': '\ud83c\uddfa\ud83c\uddf3',
  'unlock': '\ud83d\udd13',
  'up': '\ud83c\udd99',
  'upside_down_face': '\ud83d\ude43',
  'uruguay': '\ud83c\uddfa\ud83c\uddfe',
  'us': '\ud83c\uddfa\ud83c\uddf8',
  'us_outlying_islands': '\ud83c\uddfa\ud83c\uddf2',
  'us_virgin_islands': '\ud83c\uddfb\ud83c\uddee',
  'uzbekistan': '\ud83c\uddfa\ud83c\uddff',
  'v': '\u270c\ufe0f',
  'vampire': '\ud83e\udddb',
  'vampire_man': '\ud83e\udddb\u200d\u2642\ufe0f',
  'vampire_woman': '\ud83e\udddb\u200d\u2640\ufe0f',
  'vanuatu': '\ud83c\uddfb\ud83c\uddfa',
  'vatican_city': '\ud83c\uddfb\ud83c\udde6',
  'venezuela': '\ud83c\uddfb\ud83c\uddea',
  'vertical_traffic_light': '\ud83d\udea6',
  'vhs': '\ud83d\udcfc',
  'vibration_mode': '\ud83d\udcf3',
  'video_camera': '\ud83d\udcf9',
  'video_game': '\ud83c\udfae',
  'vietnam': '\ud83c\uddfb\ud83c\uddf3',
  'violin': '\ud83c\udfbb',
  'virgo': '\u264d',
  'volcano': '\ud83c\udf0b',
  'volleyball': '\ud83c\udfd0',
  'vomiting_face': '\ud83e\udd2e',
  'vs': '\ud83c\udd9a',
  'vulcan_salute': '\ud83d\udd96',
  'waffle': '\ud83e\uddc7',
  'wales': '\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc77\udb40\udc6c\udb40\udc73\udb40\udc7f',
  'walking': '\ud83d\udeb6',
  'walking_man': '\ud83d\udeb6\u200d\u2642\ufe0f',
  'walking_woman': '\ud83d\udeb6\u200d\u2640\ufe0f',
  'wallis_futuna': '\ud83c\uddfc\ud83c\uddeb',
  'waning_crescent_moon': '\ud83c\udf18',
  'waning_gibbous_moon': '\ud83c\udf16',
  'warning': '\u26a0\ufe0f',
  'wastebasket': '\ud83d\uddd1\ufe0f',
  'watch': '\u231a',
  'water_buffalo': '\ud83d\udc03',
  'water_polo': '\ud83e\udd3d',
  'watermelon': '\ud83c\udf49',
  'wave': '\ud83d\udc4b',
  'wavy_dash': '\u3030\ufe0f',
  'waxing_crescent_moon': '\ud83c\udf12',
  'waxing_gibbous_moon': '\ud83c\udf14',
  'wc': '\ud83d\udebe',
  'weary': '\ud83d\ude29',
  'wedding': '\ud83d\udc92',
  'weight_lifting': '\ud83c\udfcb\ufe0f',
  'weight_lifting_man': '\ud83c\udfcb\ufe0f\u200d\u2642\ufe0f',
  'weight_lifting_woman': '\ud83c\udfcb\ufe0f\u200d\u2640\ufe0f',
  'western_sahara': '\ud83c\uddea\ud83c\udded',
  'whale': '\ud83d\udc33',
  'whale2': '\ud83d\udc0b',
  'wheel_of_dharma': '\u2638\ufe0f',
  'wheelchair': '\u267f',
  'white_check_mark': '\u2705',
  'white_circle': '\u26aa',
  'white_flag': '\ud83c\udff3\ufe0f',
  'white_flower': '\ud83d\udcae',
  'white_haired_man': '\ud83d\udc68\u200d\ud83e\uddb3',
  'white_haired_woman': '\ud83d\udc69\u200d\ud83e\uddb3',
  'white_heart': '\ud83e\udd0d',
  'white_large_square': '\u2b1c',
  'white_medium_small_square': '\u25fd',
  'white_medium_square': '\u25fb\ufe0f',
  'white_small_square': '\u25ab\ufe0f',
  'white_square_button': '\ud83d\udd33',
  'wilted_flower': '\ud83e\udd40',
  'wind_chime': '\ud83c\udf90',
  'wind_face': '\ud83c\udf2c\ufe0f',
  'wine_glass': '\ud83c\udf77',
  'wink': '\ud83d\ude09',
  'wolf': '\ud83d\udc3a',
  'woman': '\ud83d\udc69',
  'woman_artist': '\ud83d\udc69\u200d\ud83c\udfa8',
  'woman_astronaut': '\ud83d\udc69\u200d\ud83d\ude80',
  'woman_cartwheeling': '\ud83e\udd38\u200d\u2640\ufe0f',
  'woman_cook': '\ud83d\udc69\u200d\ud83c\udf73',
  'woman_dancing': '\ud83d\udc83',
  'woman_facepalming': '\ud83e\udd26\u200d\u2640\ufe0f',
  'woman_factory_worker': '\ud83d\udc69\u200d\ud83c\udfed',
  'woman_farmer': '\ud83d\udc69\u200d\ud83c\udf3e',
  'woman_firefighter': '\ud83d\udc69\u200d\ud83d\ude92',
  'woman_health_worker': '\ud83d\udc69\u200d\u2695\ufe0f',
  'woman_in_manual_wheelchair': '\ud83d\udc69\u200d\ud83e\uddbd',
  'woman_in_motorized_wheelchair': '\ud83d\udc69\u200d\ud83e\uddbc',
  'woman_judge': '\ud83d\udc69\u200d\u2696\ufe0f',
  'woman_juggling': '\ud83e\udd39\u200d\u2640\ufe0f',
  'woman_mechanic': '\ud83d\udc69\u200d\ud83d\udd27',
  'woman_office_worker': '\ud83d\udc69\u200d\ud83d\udcbc',
  'woman_pilot': '\ud83d\udc69\u200d\u2708\ufe0f',
  'woman_playing_handball': '\ud83e\udd3e\u200d\u2640\ufe0f',
  'woman_playing_water_polo': '\ud83e\udd3d\u200d\u2640\ufe0f',
  'woman_scientist': '\ud83d\udc69\u200d\ud83d\udd2c',
  'woman_shrugging': '\ud83e\udd37\u200d\u2640\ufe0f',
  'woman_singer': '\ud83d\udc69\u200d\ud83c\udfa4',
  'woman_student': '\ud83d\udc69\u200d\ud83c\udf93',
  'woman_teacher': '\ud83d\udc69\u200d\ud83c\udfeb',
  'woman_technologist': '\ud83d\udc69\u200d\ud83d\udcbb',
  'woman_with_headscarf': '\ud83e\uddd5',
  'woman_with_probing_cane': '\ud83d\udc69\u200d\ud83e\uddaf',
  'woman_with_turban': '\ud83d\udc73\u200d\u2640\ufe0f',
  'womans_clothes': '\ud83d\udc5a',
  'womans_hat': '\ud83d\udc52',
  'women_wrestling': '\ud83e\udd3c\u200d\u2640\ufe0f',
  'womens': '\ud83d\udeba',
  'woozy_face': '\ud83e\udd74',
  'world_map': '\ud83d\uddfa\ufe0f',
  'worried': '\ud83d\ude1f',
  'wrench': '\ud83d\udd27',
  'wrestling': '\ud83e\udd3c',
  'writing_hand': '\u270d\ufe0f',
  'x': '\u274c',
  'yarn': '\ud83e\uddf6',
  'yawning_face': '\ud83e\udd71',
  'yellow_circle': '\ud83d\udfe1',
  'yellow_heart': '\ud83d\udc9b',
  'yellow_square': '\ud83d\udfe8',
  'yemen': '\ud83c\uddfe\ud83c\uddea',
  'yen': '\ud83d\udcb4',
  'yin_yang': '\u262f\ufe0f',
  'yo_yo': '\ud83e\ude80',
  'yum': '\ud83d\ude0b',
  'zambia': '\ud83c\uddff\ud83c\uddf2',
  'zany_face': '\ud83e\udd2a',
  'zap': '\u26a1',
  'zebra': '\ud83e\udd93',
  'zero': '0\ufe0f\u20e3',
  'zimbabwe': '\ud83c\uddff\ud83c\uddfc',
  'zipper_mouth_face': '\ud83e\udd10',
  'zombie': '\ud83e\udddf',
  'zombie_man': '\ud83e\udddf\u200d\u2642\ufe0f',
  'zombie_woman': '\ud83e\udddf\u200d\u2640\ufe0f',
  'zzz': '\ud83d\udca4',

  /* special emojis :P */
  'atom': '<img alt="atom" width="20" height="20" align="absmiddle" src="https://github.githubassets.com/images/icons/emoji/atom.png?v8">',
  'basecamp': '<img alt="basecamp" width="20" height="20" align="absmiddle" src="https://github.githubassets.com/images/icons/emoji/basecamp.png?v8">',
  'basecampy': '<img alt="basecampy" width="20" height="20" align="absmiddle" src="https://github.githubassets.com/images/icons/emoji/basecampy.png?v8">',
  'bowtie': '<img alt="bowtie" width="20" height="20" align="absmiddle" src="https://github.githubassets.com/images/icons/emoji/bowtie.png?v8">',
  'electron': '<img alt="electron" width="20" height="20" align="absmiddle" src="https://github.githubassets.com/images/icons/emoji/electron.png?v8">',
  'feelsgood': '<img alt="feelsgood" width="20" height="20" align="absmiddle" src="https://github.githubassets.com/images/icons/emoji/feelsgood.png?v8">',
  'finnadie': '<img alt="finnadie" width="20" height="20" align="absmiddle" src="https://github.githubassets.com/images/icons/emoji/finnadie.png?v8">',
  'goberserk': '<img alt="goberserk" width="20" height="20" align="absmiddle" src="https://github.githubassets.com/images/icons/emoji/goberserk.png?v8">',
  'godmode': '<img alt="godmode" width="20" height="20" align="absmiddle" src="https://github.githubassets.com/images/icons/emoji/godmode.png?v8">',
  'hurtrealbad': '<img alt="hurtrealbad" width="20" height="20" align="absmiddle" src="https://github.githubassets.com/images/icons/emoji/hurtrealbad.png?v8">',
  'neckbeard': '<img alt="neckbeard" width="20" height="20" align="absmiddle" src="https://github.githubassets.com/images/icons/emoji/neckbeard.png?v8">',
  'octocat': '<img alt="octocat" width="20" height="20" align="absmiddle" src="https://github.githubassets.com/images/icons/emoji/octocat.png?v8">',
  'rage1': '<img alt="rage1" width="20" height="20" align="absmiddle" src="https://github.githubassets.com/images/icons/emoji/rage1.png?v8">',
  'rage2': '<img alt="rage2" width="20" height="20" align="absmiddle" src="https://github.githubassets.com/images/icons/emoji/rage2.png?v8">',
  'rage3': '<img alt="rage3" width="20" height="20" align="absmiddle" src="https://github.githubassets.com/images/icons/emoji/rage3.png?v8">',
  'rage4': '<img alt="rage4" width="20" height="20" align="absmiddle" src="https://github.githubassets.com/images/icons/emoji/rage4.png?v8">',
  'shipit': '<img alt="shipit" width="20" height="20" align="absmiddle" src="https://github.githubassets.com/images/icons/emoji/shipit.png?v8">',
  'suspect': '<img alt="suspect" width="20" height="20" align="absmiddle" src="https://github.githubassets.com/images/icons/emoji/suspect.png?v8">',
  'trollface': '<img alt="trollface" width="20" height="20" align="absmiddle" src="https://github.githubassets.com/images/icons/emoji/trollface.png?v8">',
  'showdown': '<img alt="showdown" width="20" height="20" align="absmiddle" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAAS1BMVEX///8jJS0jJS0jJS0jJS0jJS0jJS0jJS0jJS0jJS0jJS0jJS0jJS0jJS0jJS0jJS0jJS3b1q3b1q3b1q3b1q3b1q3b1q3b1q3b1q0565CIAAAAGXRSTlMAQHCAYCCw/+DQwPCQUBAwoHCAEP+wwFBgS2fvBgAAAUZJREFUeAHs1cGy7BAUheFFsEDw/k97VTq3T6ge2EmdM+pvrP6Iwd74XV9Kb52xuMU4/uc1YNgZLFOeV8FGdhGrNk5SEgUyPxAEdj4LlMRDyhVAMVEa2M7TBSeVZAFPdqHgzSZJwPKgcLFLAooHDJo4EDCw4gAtBoJA5UFj4Ng5LOGLwVXZuoIlji/jeQHFk7+baHxrCjeUwB9+s88KndvlhcyBN5BSkYNQIVVb4pV+Npm7hhuKDs/uMP5KxT3WzSNNLIuuoDpMmuAVMruMSeDyQBi24DTr43LAY7ILA1QYaWkgfHzFthYYzg67SQsCbB8GhJUEGCtO9n0rSaCLxgJQjS/JSgMTg2eBDEHAJ+H350AsjYNYscrErgI2e/l+mdR967TCX/v6N0EhPECYCP0i+IAoYQOE8BogNhQMEMdrgAQWHaMAAGi5I5euoY9NAAAAAElFTkSuQmCC">'
};

/**
 * Reverse lookup tables for emoji, used by the HTML->Markdown converters to turn
 * showdown-generated emoji back into `:code:` form. Built lazily from showdown.helper.emojis
 * and cached, since the table is large and never changes at runtime.
 *
 * Returns an object with:
 *  - images:  { <img src> : <code> }  for the "special" image-based emoji
 *  - unicode: { <unicode value> : <code> } for normal emoji (first code wins on duplicates)
 *  - regex:   a single global RegExp matching any unicode emoji value, alternatives sorted
 *             longest-first so multi-codepoint / ZWJ sequences win over their prefixes
 * @returns {{images: Object, unicode: Object, regex: RegExp}}
 */
showdown.helper.emojiReverse = (function () {
  'use strict';
  var cache = null;
  return function () {
    if (cache) { return cache; }
    var images = {},
        unicode = {},
        values = [];
    for (var code in showdown.helper.emojis) {
      if (!Object.prototype.hasOwnProperty.call(showdown.helper.emojis, code)) { continue; }
      var val = showdown.helper.emojis[code];
      if (/^\s*<img/.test(val)) {
        var srcMatch = val.match(/src="([^"]*)"/);
        if (srcMatch && !Object.prototype.hasOwnProperty.call(images, srcMatch[1])) {
          images[srcMatch[1]] = code;
        }
      } else if (!Object.prototype.hasOwnProperty.call(unicode, val)) {
        unicode[val] = code;
        values.push(val);
      }
    }
    // longest first so e.g. `zombie_woman` (🧟‍♀️) matches before `zombie` (🧟)
    values.sort(function (a, b) { return b.length - a.length; });
    var escaped = values.map(function (v) {
      return v.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    });
    cache = {
      images: images,
      unicode: unicode,
      regex: new RegExp('(' + escaped.join('|') + ')', 'g')
    };
    return cache;
  };
})();

/**
 * Created by Estevao on 31-05-2015.
 */

showdown.Event = class {

  /**
   * Creates a new showdown Event object
   * @param {string} name
   * @param {string} input
   * @param {{}} [params]
   * @param {string} params.output
   * @param {RegExp} params.regexp
   * @param {{}} params.matches
   * @param {{}} params.attributes
   * @param {{}} params.globals
   * @param {{}} params.options
   * @param {showdown.Converter} params.converter
   */
  constructor (name, input, params) {
    params = params || {};
    let {output, regexp, matches, attributes, globals, options, converter} = params;
    if (!showdown.helper.isString(name)) {
      if (!showdown.helper.isString(name)) {
        throw new TypeError('Event.name must be a string but ' + typeof name + ' given');
      }
    }
    this._name = name.toLowerCase();
    this.input = input;
    this.output = output || input;
    this.regexp = regexp || null;
    this.matches = matches || {};
    this.attributes = attributes || {};
    this._globals = globals || {};
    this._options = showdown.helper.cloneObject(options, true) || {};
    this._converter = converter || undefined;
  }

  /** @returns {string} */
  get name () {
    return this._name;
  }

  /** @returns {string} */
  get input () {
    return this._input;
  }

  /** @param {string} value */
  set input (value) {
    if (!showdown.helper.isString(value)) {
      throw new TypeError('Event.input must be a string but ' + typeof value + ' given');
    }
    this._input = value;
  }

  /** @returns {string} */
  get output () {
    return this._output;
  }

  /** @param {string|null} value */
  set output (value) {
    if (!showdown.helper.isString(value) && value !== null) {
      throw new TypeError('Event.output must be a string but ' + typeof value + ' given');
    }
    this._output = value;
  }

  /** @returns {null|RegExp} */
  get regexp () {
    return this._regexp;
  }

  /** @param {null|RegExp} value */
  set regexp (value) {
    if (!(value instanceof RegExp) && value !== null) {
      throw new TypeError('Event.regexp must be a RegExp object (or null) but ' + typeof value + ' given');
    }
    this._regexp = value;
  }

  /** @returns {{}} */
  get matches () {
    return this._matches;
  }

  /** @param {{}}value */
  set matches (value) {
    if (typeof value !== 'object') {
      throw new TypeError('Event.matches must be an object (or null) but ' + typeof value + ' given');
    }
    this._matches = {};
    for (let prop in value) {
      if (Object.prototype.hasOwnProperty.call(value, prop)) {
        let descriptor;
        if (/^_(.+)/.test(prop)) {
          descriptor = {
            enumerable: true,
            configurable: false,
            writable: false,
            value: value[prop]
          };
        } else {
          descriptor = {
            enumerable: true,
            configurable: false,
            writable: true,
            value: value[prop]
          };
        }
        Object.defineProperty(this._matches, prop, descriptor);
      }
    }
  }

  /** @returns {{}} */
  get attributes () {
    return this._attributes;
  }

  /** @param {{}} value */
  set attributes (value) {
    if (typeof value !== 'object') {
      throw new TypeError('Event.attributes must be an object (or null) but ' + typeof value + ' given');
    }
    this._attributes = value;
  }

  /** @param {showdown.Converter} converter */
  set converter (converter) {
    this._converter = converter;
  }

  /** @returns {showdown.Converter} */
  get converter () {
    return this._converter;
  }

  get options () {
    return this._options;
  }

  get globals () {
    return this._globals;
  }
  // FLUID INTERFACE

  /**
   *
   * @param {string} value
   * @returns {showdown.Event}
   */
  setInput (value) {
    this.input = value;
    return this;
  }

  /**
   *
   * @param {string|null} value
   * @returns {showdown.Event}
   */
  setOutput (value) {
    this.output = value;
    return this;
  }

  /**
   *
   * @param {RegExp} value
   * @returns {showdown.Event}
   */
  setRegexp (value) {
    this.regexp = value;
    return this;
  }

  /**
   *
   * @param {{}}value
   * @returns {showdown.Event}
   */
  setMatches (value) {
    this.matches = value;
    return this;
  }

  /**
   *
   * @param {{}}value
   * @returns {showdown.Event}
   */
  setAttributes (value) {
    this.attributes = value;
    return this;
  }

  _setOptions (value) {
    this._options = value;
    return this;
  }

  _setGlobals (value) {
    this._globals = value;
    return this;
  }

  _setConverter (value) {
    this.converter = value;
    return this;
  }

  /**
   * Legacy: Return the output text
   * @returns {string}
   */
  getText () {
    return this.output;
  }

  getMatches () {
    return this.matches;
  }
};

////
// makehtml/blockGamut.js
// Copyright (c) 2018 ShowdownJS
//
// These are all the transformations that form block-level
// tags like paragraphs, headers, and list items.
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.blockGamut', function (text, options, globals, skip) {
  'use strict';

  skip = skip || false;

  let startEvent = new showdown.Event('makehtml.blockGamut.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  if (skip !== 'makehtml.heading.setext') {
    text = showdown.subParser('makehtml.heading.setext')(text, options, globals);
  }
  if (skip !== 'makehtml.heading.atx') {
    text = showdown.subParser('makehtml.heading.atx')(text, options, globals);
  }

  // Do Horizontal Rules:
  if (skip !== 'makehtml.horizontalRule') {
    text = showdown.subParser('makehtml.horizontalRule')(text, options, globals);
  }

  text = showdown.subParser('makehtml.list')(text, options, globals);
  // In CommonMark container mode the converter-level githubCodeBlock pass only claims
  // indent-0 fences; list items own their indented fences (renderItem already ran
  // githubCodeBlock on the de-indented content). This pass picks up genuinely top-level
  // indented (1-3) fences here, after the list parser has claimed item content and before
  // codeBlock could mistake their content lines for indented code.
  if (options.cmSpec) {
    text = showdown.subParser('makehtml.githubCodeBlock')(text, options, globals);
  }
  text = showdown.subParser('makehtml.codeBlock')(text, options, globals);
  text = showdown.subParser('makehtml.table')(text, options, globals);
  text = showdown.subParser('makehtml.blockquote')(text, options, globals);
  // The block quote container can reveal top-level content that the earlier codeBlock pass
  // never saw (e.g. an indented-code line that followed a `>` line and so was not yet at the
  // start of a block). Re-run codeBlock in container mode so that revealed indented code is
  // recognized instead of falling through to a paragraph.
  if (options.cmSpec) {
    text = showdown.subParser('makehtml.codeBlock')(text, options, globals);
  }

  // We already ran _HashHTMLBlocks() before, in Markdown(), but that
  // was to escape raw HTML in the original Markdown source. This time,
  // we're escaping the markup we've just created, so that we don't wrap
  // <p> tags around block-level tags.
  text = showdown.subParser('makehtml.hashHTMLBlocks')(text, options, globals);

  let afterEvent = new showdown.Event('makehtml.blockGamut.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

////
// makehtml/blockquote.js
// Copyright (c) 2018 ShowdownJS
//
// Transforms MD blockquotes into `<blockquote>` html entities
//
// Markdown uses email-style > characters for blockquoting.
// Markdown allows you to be lazy and only put the > before the first line of a hard-wrapped paragraph but
// it looks best if the text is hard wrapped with a > before every line.
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.blockquote', function (text, options, globals) {
  'use strict';

  // Pathologically nested block quotes (e.g. `> > > …` thousands deep) recurse once per
  // level through blockGamut, which exhausts the call stack in the default path and blows
  // up super-linearly under cmSpec. Refuse to descend past a sane nesting depth; beyond it
  // the surplus `>` markers simply render as literal text. The deepest nesting in the whole
  // test corpus is 3, so this bound never affects real documents.
  const maxNestingDepth = 25;
  if ((globals.blockquoteDepth || 0) >= maxNestingDepth) {
    return text;
  }

  let startEvent = new showdown.Event('makehtml.blockquote.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  if (options.cmSpec) {
    text = parseCmBlockquotes(text);
  } else {
    let pattern = /(^ {0,3}>[ \t]?.+\n(.+\n)*\n*)+/gm;

    if (options.splitAdjacentBlockquotes) {
      pattern = /^ {0,3}>[\s\S]*?\n\n/gm;
    }

    text = text.replace(pattern, function (bq) {
      let wholeMatch = bq;
      bq = bq.replace(/^[ \t]*>[ \t]?/gm, ''); // trim one level of quoting
      bq = bq.replace(/^[ \t]+$/gm, ''); // trim whitespace-only lines
      return renderBlockquote(bq, wholeMatch, pattern);
    });
  }

  let afterEvent = new showdown.Event('makehtml.blockquote.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;

  /**
   * Render one block quote's already-stripped content into a hashed
   * `<blockquote>` element, dispatching the capture/hash lifecycle events.
   * @param {string} bq the block-quote content with markers already removed
   * @param {string} wholeMatch the original matched text (for the capture event)
   * @param {RegExp|null} pattern the matching pattern (event metadata only)
   * @returns {string}
   */
  function renderBlockquote (bq, wholeMatch, pattern) {
    let otp,
        attributes;

    let captureStartEvent = new showdown.Event('makehtml.blockquote.onCapture', bq);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(pattern || null)
      .setMatches({
        _wholeMatch: wholeMatch,
        blockquote: bq
      })
      .setAttributes({});
    captureStartEvent = globals.converter.dispatch(captureStartEvent);
    // if something was passed as output, it takes precedence
    // and will be used as output
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      otp = captureStartEvent.output;

    } else {
      bq = captureStartEvent.matches.blockquote;
      bq = showdown.subParser('makehtml.githubCodeBlock')(bq, options, globals);
      // CommonMark container mode: run the source-level leaf-block passes on the quote's
      // own (marker-stripped) content, mirroring the converter pipeline, so an HTML block
      // or a link reference definition nested inside the block quote is recognized in the
      // quote's context instead of only at the top level.
      if (options.cmSpec) {
        bq = showdown.subParser('makehtml.hashHTMLBlocks')(bq, options, globals, true);
        bq = showdown.subParser('makehtml.stripLinkDefinitions')(bq, options, globals);
      }
      globals.blockquoteDepth = (globals.blockquoteDepth || 0) + 1;
      bq = showdown.subParser('makehtml.blockGamut')(bq, options, globals); // recurse
      bq = showdown.subParser('makehtml.paragraphs')(bq, options, globals);
      globals.blockquoteDepth--;
      bq = bq.replace(/(^|\n)/g, '$1  ');
      // These leading spaces screw with <pre> content, so we need to fix that:
      bq = bq.replace(/(\s*<pre>[^\r]+?<\/pre>)/gm, function (wm, m1) {
        return m1.replace(/^ {2}/mg, '');
      });
      attributes = captureStartEvent.attributes;
      otp = '<blockquote' + showdown.helper._populateAttributes(attributes) + '>\n' +  bq + '\n</blockquote>';
    }

    let beforeHashEvent = new showdown.Event('makehtml.blockquote.onHash', otp);
    beforeHashEvent
      .setOutput(otp)
      ._setGlobals(globals)
      ._setOptions(options);
    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    otp = beforeHashEvent.output;
    return showdown.subParser('makehtml.hashBlock')(otp, options, globals);
  }

  /**
   * CommonMark block-quote container parsing (spec section 5.1). Scans line by
   * line: a block quote consumes consecutive lines that carry the `>` marker
   * (an optional single space after `>` is stripped), plus lazy paragraph
   * continuation lines (markerless non-blank text that follows a paragraph line).
   * A blank line, or a markerless line that cannot lazily continue a paragraph,
   * ends the block quote; two block quotes separated by a blank line are distinct.
   * @param {string} str
   * @returns {string}
   */
  function parseCmBlockquotes (str) {
    let marker = /^ {0,3}>/,
        lines = str.split('\n'),
        out = [],
        i = 0,
        n = lines.length;

    // a markerless line that can lazily continue a paragraph: non-blank text that
    // does not itself begin a block which would interrupt the paragraph
    function isLazyParagraph (line) {
      if (line.trim() === '') { return false; }
      return !(
        marker.test(line) ||                                // block quote
        /^ {0,3}#{1,6}(?:[ \t]|$)/.test(line) ||             // ATX heading
        /^ {0,3}(?:```|~~~)/.test(line) ||                   // fenced code
        /^ {0,3}([-*_])[ \t]*(?:\1[ \t]*){2,}$/.test(line) ||// thematic break
        /^ {0,3}(?:[-+*]|\d{1,9}[.)])[ \t]/.test(line)       // list item
      );
    }

    // true if, after peeling nested block-quote/list markers, the innermost block
    // on this line is an open paragraph - so a following markerless line may lazily
    // continue it (laziness propagates through container nesting)
    function isParagraphLine (stripped) {
      let s = stripped,
          indentedCode = /^ {4}/.test(stripped),
          m;
      while ((m = s.match(/^ {0,3}>[ \t]?/) || s.match(/^ {0,3}(?:[-+*]|\d{1,9}[.)])[ \t]/))) {
        s = s.slice(m[0].length);
        indentedCode = false; // leading spaces after a marker are container indent
      }
      if (s.trim() === '' || indentedCode) { return false; }
      return !(
        /^ {0,3}(?:```|~~~)/.test(s) ||
        /^ {0,3}#{1,6}(?:[ \t]|$)/.test(s) ||
        /^ {0,3}([-*_])[ \t]*(?:\1[ \t]*){2,}$/.test(s)
      );
    }

    while (i < n) {
      if (!marker.test(lines[i])) {
        out.push(lines[i]);
        i++;
        continue;
      }
      let bqLines = [],
          prevParagraph = false;
      while (i < n) {
        let line = lines[i];
        if (marker.test(line)) {
          let stripped = line.replace(/^ {0,3}>[ \t]?/, '');
          bqLines.push(stripped);
          prevParagraph = isParagraphLine(stripped);
          i++;
        } else if (prevParagraph && isLazyParagraph(line)) {
          // CommonMark: a setext underline may not be a lazy continuation line. Escape the
          // leading marker so the recursive setext parser can't claim it as an underline;
          // encodeBackslashEscapes restores the literal `=`/`-` downstream.
          if (/^ {0,3}(?:=+|-+)[ \t]*$/.test(line)) {
            line = line.replace(/^( {0,3})([=-])/, '$1\\$2');
          }
          bqLines.push(line);
          prevParagraph = isParagraphLine(line);
          i++;
        } else {
          break; // blank line or non-continuing line ends the block quote
        }
      }
      // trailing newline mirrors the original regex match (which ended in \n) so the
      // recursive block parsers see a complete final line
      let content = bqLines.join('\n') + '\n';
      out.push(renderBlockquote(content, content, null));
    }
    return out.join('\n');
  }
});

////
// makehtml/cmInline.js
// Copyright (c) 2024 ShowdownJS
//
// Unified CommonMark inline parser (spec section 6).
//
// Invoked only when the `commonmarkInline` option is enabled. It resolves code
// spans, backslash escapes, character references, autolinks, raw HTML, links,
// images and emphasis together on a single delimiter stack, so the cross-construct
// precedence rules CommonMark requires (a link cannot contain a link; code spans /
// autolinks / raw HTML bind before links; emphasis interleaves with link brackets)
// are expressible - which the sequential per-construct passes could not.
//
// It is built on the same doubly-linked node list + delimiter stack + processEmphasis
// design used by makehtml.emphasisAndStrong's CommonMark path.
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////

/* jshint esnext: false, esversion: 9 */

showdown.subParser('makehtml.cmInline', function (text, options, globals) {
  'use strict';

  // ASCII punctuation, used by the flanking rules and backslash-escape check.
  // Declared before parseCmInline runs (const is in the temporal dead zone until here).
  const asciiPunct = /[!-/:-@[-`{-~]/;

  // Sticky regexes anchored at the scan cursor (lastIndex) so the recognizers never
  // slice the tail of the string - keeps the tokenizer linear on `<`/`&`-heavy input.
  // Reused across calls; each recognizer sets lastIndex before exec and the parse is
  // not re-entrant within a single string.
  const reEntity = /&(?:#[0-9]{1,7}|#[xX][0-9a-fA-F]{1,6}|[a-zA-Z][a-zA-Z0-9]*);/y;
  // eslint-disable-next-line no-control-regex -- CommonMark autolinks exclude control chars (\x00-\x20) per spec
  const reAutoUri = /<[A-Za-z][A-Za-z0-9+.-]{1,31}:[^<>\x00-\x20]*>/y;
  // Showdown extension: <www...> angle autolinks (cmark-gfm does not autolink these, but the
  // explicit <> is unambiguous user intent). Single variable class → linear / ReDoS-safe.
  // eslint-disable-next-line no-control-regex -- same control-char exclusion as reAutoUri
  const reAutoWww = /<www\.[^<>\x00-\x20]+>/y;
  const reAutoEmail = /<[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*>/y;
  const reRawHtml = new RegExp('(?:' + showdown.helper.regexes.cmHTMLTagSource + ')', 'y');

  let startEvent = new showdown.Event('makehtml.cmInline.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  text = parseCmInline(text);

  // ghMentions and simplifiedAutoLink (GFM extensions) are applied to the serialized
  // inline output and to emphasis inner content (see parseCmInline) so URLs and mentions
  // inside emphasis are linked too. Real links, images and code spans are hashed by
  // parseCmInline, so they are protected from these regexes. Copied from link.js;
  // the writeAnchorTag / parseMail helpers below are too. TODO: share with link.js.
  text = applyGfmInlineLinks(text);

  function applyGfmInlineLinks (text) {
    // 5. Handle GithubMentions (if option is enabled)
    if (options.ghMentions) {
      let ghMentionsRegex = /(^|\s)(\\)?(@([a-z\d]+(?:[a-z\d._-]+?[a-z\d]+)*))/gi;
      text = text.replace(ghMentionsRegex, function (wholeMatch, st, escape, mentions, username) {
        // bail if the mentions was escaped
        if (escape === '\\') {
          return st + mentions;
        }
        // check if options.ghMentionsLink is a string
        // TODO Validation should be done at initialization not at runtime
        if (!showdown.helper.isString(options.ghMentionsLink)) {
          throw new Error('ghMentionsLink option must be a string');
        }
        let url = options.ghMentionsLink.replace(/\{u}/g, username);
        return st + writeAnchorTag ('reference', ghMentionsRegex, wholeMatch, mentions, null, url);
      });
    }

    // 8. Handle naked links (if option is enabled)
    if (options.simplifiedAutoLink) {
      // 8.1. Check for naked URLs
      // we also include leading markdown magic chars [_*~] for cases like __https://www.google.com/foobar__
      // An explicit scheme (http/https/ftp) does not require the host to contain a dot;
      // a `www.` shortcut does (and is domain-validated below).
      let nakedUrlRegex = /([_*~]*?)((?:(?:https?|ftp):\/\/[^\s<>"'`´]+|www\.[^\s<>"'`´.-][^\s<>"'`´]*?\.[a-z\d.]+[^\s<>"']*))\1/gi;
      text = text.replace(nakedUrlRegex, function (wholeMatch, leadingMDChars, url, offset, fullText) {
        let isWww = /^www\./i.test(url);
        // GFM boundary rule: a "www." autolink (unlike a scheme URL) is not recognized when
        // preceded by "<". By this pass "<" has been escaped to "&lt;", so a www match sitting
        // right after it (e.g. the interior of a malformed <www.x.com foo> the angle recognizer
        // could not consume) is left untouched — matching cmark-gfm, which links <https://x bim>
        // but not <www.x bim>.
        let urlStart = offset + leadingMDChars.length;
        if (isWww && fullText.substring(urlStart - 4, urlStart) === '&lt;') { return wholeMatch; }
        // we now will start traversing the url from the front to back, looking for punctuation chars [_*~,;:.!?\)\]]
        const len = url.length;
        let suffix = '';

        for (let i = len - 1; i >= 0; --i) {
          let char = url.charAt(i);
          if (/[_*~,;:.!?]/.test(char)) {
            // it's a punctuation char so we remove it from the url
            url = url.slice(0, -1);
            // and prepend it to the suffix
            suffix = char + suffix;
          } else if (/[)\]]/.test(char)) {
            // it's a parenthesis so we need to check for "balance" (kinda)
            let opPar, clPar;
            if (/\)/.test(char)) {
              // it's a curved parenthesis
              opPar = url.match(/\(/g) || [];
              clPar = url.match(/\)/g);
            } else {
              // it's a squared parenthesis
              opPar = url.match(/\[/g) || [];
              clPar = url.match(/]/g);
            }
            if (opPar.length < clPar.length) {
              // there are more closing Parenthesis than opening so chop it!!!!!
              url = url.slice(0, -1);
              // and prepend it to the suffix
              suffix = char + suffix;
            } else {
              // it's (kinda) balanced so our work is done
              break;
            }
          } else {
            // it's not a punctuation or a parenthesis so our work is done
            break;
          }
        }

        // GFM: a trailing ";" that completes an entity-reference-like "&name" is excluded
        // from the link, so move the whole "&name;" into the suffix.
        if (suffix.charAt(0) === ';') {
          let entity = url.match(/&(?:amp;)?[a-z\d]+$/i);
          if (entity) {
            url = url.slice(0, -entity[0].length);
            suffix = entity[0] + suffix;
          }
        }

        // GFM: "<" terminates the link. By this pass it has already been escaped to "&lt;"
        // (and ">" to "&gt;"), so split there and keep the remainder as plain text.
        let ltMatch = url.match(/&(?:lt|gt);/);
        if (ltMatch) {
          let at = url.indexOf(ltMatch[0]);
          suffix = url.slice(at) + suffix;
          url = url.slice(0, at);
        }

        // GFM: the last two labels of the host may not contain "_"; otherwise it is not a
        // valid autolink.
        if (!validAutolinkHost(url, isWww)) {
          return wholeMatch;
        }

        // we copy the treated url to the text variable
        let txt = url;
        // finally, if it's a www shortcut, we prepend http(s)
        // noinspection HttpUrlsUsage
        url = isWww ? (options.httpsAutoLinks ? 'https://' : 'http://') + url : url;
        // GFM: percent-encode non-ASCII characters in the href (the display text keeps the
        // literal characters)
        // eslint-disable-next-line no-control-regex -- \x00-\x7F is the ASCII range
        url = url.replace(/[^\x00-\x7F]+/g, function (s) { return encodeURI(s); });

        // url part is done so let's take care of text now
        // we need to escape the text (because of links such as www.example.com/foo__bar__baz)
        txt = txt.replace(showdown.helper.regexes.asteriskDashTildeAndColon, showdown.helper.escapeCharactersCallback);

        // and return the link tag, with the leadingMDChars and  suffix. The leadingMDChars are added at the end too because
        // we consumed those characters in the regexp
        return leadingMDChars +
          writeAnchorTag ('autoLink', nakedUrlRegex, wholeMatch, txt, null, url) +
          suffix +
          leadingMDChars;
      });

      // 8.2. Check for naked mail (GFM extended email autolink).
      let localPart = '[A-Za-z\\d._+-]+',
          domainPart = '[A-Za-z\\d_-]+(?:\\.[A-Za-z\\d_-]+)*';

      // A scheme is only recognised when it is not part of a preceding word (so `mmmmailto:`
      // does not count) — any non-alphanumeric character (including `/`) is a valid boundary.
      let schemeBoundary = '(^|[^A-Za-z\\d])';

      // 8.2.1. `xmpp:` addresses keep their scheme and an optional `/resource`.
      let xmppMailRegex = new RegExp(schemeBoundary + '(xmpp:)(' + localPart + '@' + domainPart + ')(\\/[A-Za-z\\d._-]*)?', 'gi');
      text = text.replace(xmppMailRegex, function (wholeMatch, lead, scheme, addr, resource) {
        resource = resource || '';
        let trail = '',
            body = resource || addr;
        while (/[.,;:!?]$/.test(body)) {
          trail = body.slice(-1) + trail;
          body = body.slice(0, -1);
        }
        if (resource) { resource = body; } else { addr = body; }
        if (!validMailAddr(addr)) { return wholeMatch; }
        let target = 'xmpp:' + addr + resource;
        return lead + writeAnchorTag ('autoLink', xmppMailRegex, wholeMatch, target, null, target) + trail;
      });

      // 8.2.2. `mailto:` addresses keep their scheme but never carry a path.
      let mailtoRegex = new RegExp(schemeBoundary + '(mailto:)(' + localPart + '@' + domainPart + ')', 'gi');
      text = text.replace(mailtoRegex, function (wholeMatch, lead, scheme, addr) {
        let trail = '';
        while (/[.,;:!?]$/.test(addr)) {
          trail = addr.slice(-1) + trail;
          addr = addr.slice(0, -1);
        }
        if (!validMailAddr(addr)) { return wholeMatch; }
        let target = 'mailto:' + addr;
        return lead + writeAnchorTag ('autoLink', mailtoRegex, wholeMatch, target, null, target) + trail;
      });

      // 8.2.3. Bare addresses become mailto: links. The address must be preceded by the
      // string start or a character that cannot be part of the local-part (this also keeps
      // us out of hash placeholders like the `¨E43E` produced for an escaped char).
      let nakedMailRegex = new RegExp('(^|[^A-Za-z\\d._+\\-\\u00a8])(' + localPart + '@' + domainPart + ')', 'g');
      text = text.replace(nakedMailRegex, function (wholeMatch, lead, addr) {
        if (!validMailAddr(addr)) { return wholeMatch; }
        const m = parseMail(addr);
        return lead + writeAnchorTag ('autoLink', nakedMailRegex, wholeMatch, m.mail, null, m.url);
      });
    }
    return text;
  }

  let afterEvent = new showdown.Event('makehtml.cmInline.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;

  // ---- shared character helpers (flanking rules) -------------------------------

  function isPunct (ch) {
    return ch !== undefined && (asciiPunct.test(ch) || /[\p{P}\p{S}]/u.test(ch));
  }
  function isWhitespace (ch) {
    return ch === undefined || /\s/.test(ch) || /\p{Z}/u.test(ch);
  }
  function isEscapable (ch) {
    return ch !== undefined && asciiPunct.test(ch);
  }

  // HTML-escape a run of plain text (entities already resolved to characters)
  function escapeText (str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function hashSpan (html) {
    return showdown.helper._hashHTMLSpan(html, globals);
  }

  // resolve backslash escapes of ASCII punctuation to the literal character
  function resolveBackslash (str) {
    return str.replace(/\\([!-/:-@[-`{-~])/g, '$1');
  }

  // ---- main parse --------------------------------------------------------------

  function parseCmInline (str) {
    let head = null,
        tail = null,
        delimiters = null, // top of emphasis delimiter stack
        brackets = null,   // top of bracket (link/image) stack
        // backtick runs of these lengths have no closer in the rest of the string;
        // future opens of the same length fail immediately (keeps backticks linear)
        backtickNoCloser = {};

    function appendNode (node) {
      node.prev = tail;
      node.next = null;
      node.raw = node.raw || false;
      if (tail) { tail.next = node; } else { head = node; }
      tail = node;
      return node;
    }
    function appendText (literal) {
      return appendNode({type: 'text', literal: literal});
    }
    // append already-final HTML that must not be escaped at render time
    function appendRaw (html) {
      return appendNode({type: 'text', literal: html, raw: true});
    }

    const len = str.length;
    let i = 0;
    while (i < len) {
      let ch = str.charAt(i);

      if (ch === '\n') {
        // hard line break: two+ trailing spaces or a backslash before the newline.
        // The <br /> is hashed so the later encodeAmpsAndAngles pass leaves it intact.
        let n = tail;
        if (n && n.type === 'text' && !n.raw && / {2,}$/.test(n.literal)) {
          n.literal = n.literal.replace(/ +$/, '');
          appendRaw(hashSpan('<br />') + '\n');
        } else if (n && n.type === 'text' && !n.raw && /\\$/.test(n.literal)) {
          n.literal = n.literal.slice(0, -1);
          appendRaw(hashSpan('<br />') + '\n');
        } else {
          if (n && n.type === 'text' && !n.raw) { n.literal = n.literal.replace(/ +$/, ''); }
          appendText('\n');
        }
        i++;
        continue;
      }

      if (ch === '\\') {
        let next = str.charAt(i + 1);
        if (next === '\n') {
          appendRaw(hashSpan('<br />') + '\n');
          i += 2;
        } else if (next === '¨' && str.charAt(i + 2) === 'D') {
          // escaped `$` (the converter hashes `$` to the `¨D` placeholder early)
          appendText('¨D');
          i += 3;
        } else if (isEscapable(next)) {
          // Emit ordinary escaped punctuation as a Showdown escape placeholder (¨E<code>E)
          // so the later passes (ghMentions, simplifiedAutoLink, emoji, strikethrough,
          // ellipsis, ...) don't treat the char as markup - e.g. `\@user` must not become a
          // mention. unescapeSpecialChars restores the literal char at the end of the
          // pipeline. HTML-special chars stay literal so escapeText turns them into entities
          // (&amp; &lt; &gt; &quot;); placeholders would otherwise round-trip to raw `<`/`&`.
          if (next === '&' || next === '<' || next === '>' || next === '"') {
            appendText(next);
          } else {
            appendText('¨E' + next.charCodeAt(0) + 'E');
          }
          i += 2;
        } else {
          appendText('\\');
          i++;
        }
        continue;
      }

      if (ch === '`') {
        let res = parseBacktick(str, i, backtickNoCloser);
        if (res) {
          appendRaw(res.html); i = res.end;
        } else {
          let e = skipRun(str, i, '`'); appendText(str.slice(i, e)); i = e;
        }
        continue;
      }

      if (ch === '<') {
        let res = parseAutolink(str, i) || parseRawHTML(str, i);
        if (res) { appendRaw(res.html); i = res.end; continue; }
        appendText('<');
        i++;
        continue;
      }

      if (ch === '&') {
        reEntity.lastIndex = i;
        let m = reEntity.exec(str);
        if (m) {
          let decoded = showdown.helper.cmDecodeEntities(m[0]);
          if (decoded !== m[0]) { appendText(decoded); i += m[0].length; continue; }
        }
        appendText('&');
        i++;
        continue;
      }

      if (ch === '!' && str.charAt(i + 1) === '[') {
        let node = appendText('![');
        pushBracket(node, true, i + 2);
        i += 2;
        continue;
      }
      if (ch === '[') {
        let node = appendText('[');
        pushBracket(node, false, i + 1);
        i++;
        continue;
      }
      if (ch === ']') {
        i = parseCloseBracket(str, i);
        continue;
      }

      if (ch === '*' || ch === '_') {
        let start = i;
        while (i < len && str.charAt(i) === ch) { ++i; }
        let run = str.slice(start, i),
            before = (start === 0) ? undefined : str.charAt(start - 1),
            after = (i >= len) ? undefined : str.charAt(i);
        // `$` and `¨` are swapped for the two-char placeholders `¨D`/`¨T` before inline
        // parsing (see converter.js) and only restored at the end. Resolve them here so
        // flanking sees the real adjacent character rather than the placeholder's
        // trailing/leading letter (e.g. the `D` of `¨D` would otherwise read as a letter).
        if ((before === 'D' || before === 'T') && str.charAt(start - 2) === '¨') {
          before = (before === 'D') ? '$' : '¨';
        }
        if (after === '¨' && (str.charAt(i + 1) === 'D' || str.charAt(i + 1) === 'T')) {
          after = (str.charAt(i + 1) === 'D') ? '$' : '¨';
        }
        let beforeWs = isWhitespace(before),
            afterWs = isWhitespace(after),
            beforePt = isPunct(before),
            afterPt = isPunct(after),
            leftFlanking = !afterWs && (!afterPt || beforeWs || beforePt),
            rightFlanking = !beforeWs && (!beforePt || afterWs || afterPt),
            canOpen, canClose;
        if (ch === '_') {
          canOpen = leftFlanking && (!rightFlanking || beforePt);
          canClose = rightFlanking && (!leftFlanking || afterPt);
        } else {
          canOpen = leftFlanking;
          canClose = rightFlanking;
        }
        let node = appendNode({type: 'delim', cc: ch, literal: run, numdelims: run.length, origdelims: run.length, canOpen: canOpen, canClose: canClose});
        node.delimPrev = delimiters;
        node.delimNext = null;
        if (delimiters) { delimiters.delimNext = node; }
        delimiters = node;
        continue;
      }

      // plain text run up to the next significant char
      let start = i;
      while (i < len && '\n\\`<&![]*_'.indexOf(str.charAt(i)) === -1) { ++i; }
      if (i === start) {
        appendText(str.charAt(i)); i++;
      } else {
        appendText(str.slice(start, i));
      }
    }

    processEmphasis(null);

    // render the node list
    let out = '';
    for (let n = head; n !== null; n = n.next) {
      out += n.raw ? n.literal : escapeText(n.literal);
    }
    return out;

    // ---- bracket stack ---------------------------------------------------------

    function pushBracket (node, image, sourceStart) {
      brackets = {
        node: node,
        prev: brackets,
        prevDelim: delimiters,
        image: image,
        active: true,
        sourceStart: sourceStart // index in `str` where the label text begins
      };
    }

    function parseCloseBracket (s, idx) {
      let opener = brackets;
      if (opener === null) { appendText(']'); return idx + 1; }
      if (!opener.active) { brackets = opener.prev; appendText(']'); return idx + 1; }

      // try to parse the destination/title or a reference that follows the `]`
      let dest = null, title = null, width = null, height = null, matched = false, endIdx = idx + 1;

      if (s.charAt(idx + 1) === '(') {
        let j = idx + 2, n2 = s.length, isWs = function (c) { return c === ' ' || c === '\t' || c === '\n'; };
        while (j < n2 && isWs(s.charAt(j))) { j++; }
        let d = showdown.helper.cmScanDestination(s, j);
        if (d) {
          j = d.end;
          // parseImgDimensions (Showdown extension, not CommonMark): an optional
          // ` =WxH` between destination and title. The `=WxH` is always consumed here so
          // it never leaks into the output; buildImage only renders it when the option is
          // on. Regex fragment copied from the inline image regex in image.js.
          let dimStart = j;
          while (dimStart < n2 && isWs(s.charAt(dimStart))) { dimStart++; }
          if (dimStart > j && s.charAt(dimStart) === '=') {
            let dim = /^=([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4})/.exec(s.slice(dimStart));
            if (dim) {
              width = dim[1];
              height = dim[2];
              j = dimStart + dim[0].length;
            }
          }
          let hadWs = false;
          while (j < n2 && isWs(s.charAt(j))) { hadWs = true; j++; }
          let tc = s.charAt(j), t = null;
          if (hadWs && (tc === '"' || tc === '\'' || tc === '(')) {
            t = showdown.helper.cmScanTitle(s, j);
            if (t) { j = t.end; }
          }
          while (j < n2 && isWs(s.charAt(j))) { j++; }
          if (s.charAt(j) === ')') {
            dest = d.url;
            title = t ? t.title : null;
            matched = true;
            endIdx = j + 1;
          }
        }
      }

      if (!matched) {
        // reference: full [label], collapsed [] or shortcut. Use the RAW source label
        // (backslash escapes intact) - CommonMark matches labels by case-fold +
        // whitespace only, so `[foo\!]` must not match a `[foo!]` definition.
        let labelText = s.slice(opener.sourceStart, idx),
            refKey = null;
        if (s.charAt(idx + 1) === '[') {
          let close = findRefClose(s, idx + 2);
          if (close !== -1) {
            let inner = s.slice(idx + 2, close);
            refKey = inner.trim() === '' ? labelText : inner;
            endIdx = close + 1;
          }
        } else {
          refKey = labelText; // shortcut
          endIdx = idx + 1;
        }
        if (refKey !== null) {
          let key = showdown.helper.cmNormalizeLabel(refKey);
          if (key !== '' && !showdown.helper.isUndefined(globals.gUrls[key])) {
            dest = globals.gUrls[key];
            title = globals.gTitles[key];
            // parseImgDimensions: reference-style dimensions stored by stripLinkDefinitions
            if (globals.gDimensions[key]) {
              width = globals.gDimensions[key].width;
              height = globals.gDimensions[key].height;
            }
            matched = true;
          }
        }
      }

      if (!matched) { brackets = opener.prev; appendText(']'); return idx + 1; }

      // process emphasis on the delimiters inside the brackets
      processEmphasis(opener.prevDelim);

      // collect and render the inner nodes
      let innerHTML = renderNodes(opener.node.next, null);

      let otpHTML;
      if (opener.image) {
        otpHTML = buildImage(innerHTML, dest, title, width, height);
      } else {
        otpHTML = buildLink(innerHTML, dest, title);
      }

      // drop the opener node and everything after it, append the built span
      removeFrom(opener.node);
      appendRaw(otpHTML);
      // remove any emphasis delimiters that belonged to the consumed range
      pruneDelimiters(opener.prevDelim);

      if (!opener.image) {
        // a link cannot be nested in another link
        for (let b = opener.prev; b !== null; b = b.prev) {
          if (!b.image) { b.active = false; }
        }
      }
      brackets = opener.prev;
      return endIdx;
    }

    // ---- rendering helpers -----------------------------------------------------

    // concatenate the rendered HTML of nodes [from .. to)
    function renderNodes (from, to) {
      let out = '';
      for (let n = from; n !== null && n !== to; n = n.next) {
        out += n.raw ? n.literal : escapeText(n.literal);
      }
      return out;
    }
    function removeFrom (node) {
      tail = node.prev;
      if (tail) { tail.next = null; } else { head = null; }
    }

    function normalizeDest (dest) {
      dest = resolveBackslash(dest);
      dest = showdown.helper.applyBaseUrl(options.relativePathBaseUrl, dest);
      return showdown.helper.cmNormalizeURL(dest);
    }
    function buildTitleAttr (title) {
      if (title === null || title === undefined) { return ''; }
      return ' title="' + showdown.helper.cmEscapeTitle(resolveBackslash(title)) + '"';
    }

    function buildLink (innerHTML, dest, title) {
      // safeMode: neutralize dangerous URL schemes (javascript:, vbscript:, data:, ...)
      let href = (options.safeMode && !showdown.helper.isSafeUrl(dest)) ? '' : normalizeDest(dest);
      let attrs = ' href="' + href + '"' + buildTitleAttr(title);
      innerHTML = showdown.subParser('makehtml.hardLineBreaks')(innerHTML, options, globals);
      return hashSpan('<a' + attrs + '>' + innerHTML + '</a>');
    }

    function buildImage (innerHTML, dest, title, width, height) {
      // alt text is the plain-text rendering of the label (markup stripped); the inner
      // spans are hashed, so restore them before flattening
      let alt = showdown.subParser('makehtml.unhashHTMLSpans')(innerHTML, options, globals)
        .replace(/<img\b[^>]*?\salt="([^"]*)"[^>]*?\/?>/g, '$1')
        .replace(/<[^>]*>/g, '');
      // safeMode: neutralize dangerous URL schemes; data:image/* stays allowed
      let src = (options.safeMode && !showdown.helper.isSafeUrl(dest, {allowDataImage: true})) ? '' : normalizeDest(dest);
      let attrs = ' src="' + src + '" alt="' + alt + '"' + buildTitleAttr(title);
      // width/height gating copied from writeImageTag in image.js (parseImgDimensions)
      if (options.parseImgDimensions) {
        if (width)  { attrs += ' width="'  + (width  === '*' ? 'auto' : width)  + '"'; }
        if (height) { attrs += ' height="' + (height === '*' ? 'auto' : height) + '"'; }
      }
      return hashSpan('<img' + attrs + ' />');
    }

    // ---- emphasis (CommonMark reference algorithm) -----------------------------

    function removeDelimiter (d) {
      if (d.delimPrev) { d.delimPrev.delimNext = d.delimNext; }
      if (d.delimNext) { d.delimNext.delimPrev = d.delimPrev; } else { delimiters = d.delimPrev; }
    }
    function insertAfter (node, newNode) {
      newNode.prev = node;
      newNode.next = node.next;
      if (node.next) { node.next.prev = newNode; } else { tail = newNode; }
      node.next = newNode;
    }
    // drop every delimiter at or above `bottom` from the stack (after a bracket span
    // has consumed the nodes they pointed at)
    function pruneDelimiters (bottom) {
      let d = delimiters;
      while (d !== null && d !== bottom) {
        let p = d.delimPrev;
        removeDelimiter(d);
        d = p;
      }
    }

    function processEmphasis (stackBottom) {
      let openersBottom = {
        '_': [stackBottom, stackBottom, stackBottom],
        '*': [stackBottom, stackBottom, stackBottom]
      };

      let closer = delimiters;
      while (closer !== null && closer.delimPrev !== null && closer.delimPrev !== stackBottom) {
        closer = closer.delimPrev;
      }
      if (closer === stackBottom) { closer = (stackBottom === null) ? closer : stackBottom.delimNext; }

      while (closer !== null) {
        if (!closer.canClose) { closer = closer.delimNext; continue; }
        let opener = closer.delimPrev,
            openerFound = false,
            oddMatch;
        while (opener !== null && opener !== stackBottom && opener !== openersBottom[closer.cc][closer.origdelims % 3]) {
          oddMatch = (closer.canOpen || opener.canClose) &&
                     (closer.origdelims % 3 !== 0) &&
                     ((opener.origdelims + closer.origdelims) % 3 === 0);
          if (opener.cc === closer.cc && opener.canOpen && !oddMatch) { openerFound = true; break; }
          opener = opener.delimPrev;
        }
        let oldCloser = closer;

        if (openerFound) {
          let use = (opener.numdelims >= 2 && closer.numdelims >= 2) ? 2 : 1,
              tagOpen = (use === 2) ? '<strong>' : '<em>',
              tagClose = (use === 2) ? '</strong>' : '</em>';

          opener.literal = opener.literal.slice(0, opener.literal.length - use);
          opener.numdelims -= use;
          closer.literal = closer.literal.slice(use);
          closer.numdelims -= use;

          let inner = renderNodes(opener.next, closer);
          inner = applyGfmInlineLinks(inner);
          inner = showdown.subParser('makehtml.hardLineBreaks')(inner, options, globals);
          let wrapped = hashSpan(tagOpen + inner + tagClose);

          let n2 = opener.next;
          while (n2 !== null && n2 !== closer) {
            let nx = n2.next;
            if (n2.type === 'delim') { removeDelimiter(n2); }
            n2 = nx;
          }
          let wrapNode = {type: 'text', literal: wrapped, raw: true};
          insertAfter(opener, wrapNode);
          wrapNode.next = closer;
          closer.prev = wrapNode;

          if (opener.numdelims === 0) { opener.literal = ''; removeDelimiter(opener); }
          if (closer.numdelims === 0) {
            closer.literal = '';
            let tmp = closer.delimNext;
            removeDelimiter(closer);
            closer = tmp;
          }
        } else {
          openersBottom[oldCloser.cc][oldCloser.origdelims % 3] = oldCloser.delimPrev;
          if (!oldCloser.canOpen) { removeDelimiter(oldCloser); }
          closer = oldCloser.delimNext;
        }
      }
    }
  }

  // ---- token recognizers (return {html, end} or null) ----------------------------

  function skipRun (str, i, ch) {
    let j = i;
    while (j < str.length && str.charAt(j) === ch) { j++; }
    return j;
  }

  function parseBacktick (str, i, noCloser) {
    let openEnd = skipRun(str, i, '`'),
        runLen = openEnd - i,
        n = str.length,
        j = openEnd;
    if (noCloser[runLen]) { return null; }
    // find a closing run of backticks of exactly runLen (not part of a longer run)
    while (j < n) {
      if (str.charAt(j) === '`') {
        let runStart = j,
            runEnd = skipRun(str, j, '`');
        if (runEnd - runStart === runLen) {
          let content = str.slice(openEnd, runStart).replace(/\n/g, ' ');
          // strip exactly one leading and trailing space if the content is not all spaces
          if (content.length >= 2 && content.charAt(0) === ' ' && content.charAt(content.length - 1) === ' ' && /[^ ]/.test(content)) {
            content = content.slice(1, -1);
          }
          let encoded = showdown.subParser('makehtml.encodeCode')(content, options, globals);
          return {html: showdown.helper._hashHTMLSpan('<code>' + encoded + '</code>', globals), end: runEnd};
        }
        j = runEnd;
      } else {
        j++;
      }
    }
    noCloser[runLen] = true; // no closer of this length anywhere after here
    return null;
  }

  function parseAutolink (str, i) {
    if (!options.cmSpec) { return null; }
    reAutoUri.lastIndex = i;
    let uri = reAutoUri.exec(str);
    if (uri) {
      let raw = uri[0].slice(1, -1),
          href = showdown.helper.cmEncodeURI(raw).replace(/&/g, '&amp;');
      // safeMode: neutralize dangerous autolink schemes but keep the visible text
      if (options.safeMode && !showdown.helper.isSafeUrl(raw)) { href = ''; }
      return {html: showdown.helper._hashHTMLSpan('<a href="' + href + '">' + escapeAngles(raw) + '</a>', globals), end: i + uri[0].length};
    }
    reAutoEmail.lastIndex = i;
    let email = reAutoEmail.exec(str);
    if (email) {
      let raw = email[0].slice(1, -1),
          href, txt;
      // encodeEmails: entity-encode the address (href and text) when the option is on,
      // so it works under cmSpec too. Mirrors parseMail in link.js (copied behavior).
      if (options.encodeEmails) {
        href = showdown.helper.encodeEmailAddress('mailto:' + raw);
        txt = showdown.helper.encodeEmailAddress(raw);
      } else {
        href = 'mailto:' + escapeAngles(raw);
        txt = escapeAngles(raw);
      }
      return {html: showdown.helper._hashHTMLSpan('<a href="' + href + '">' + txt + '</a>', globals), end: i + email[0].length};
    }
    // Showdown extension: <www...> angle autolink. Applies the GFM www rule (http(s)://
    // prepend + domain validation) to the explicitly delimited form. Active whenever
    // cmSpec is on (the early `!options.cmSpec` guard above already scopes this).
    reAutoWww.lastIndex = i;
    let www = reAutoWww.exec(str);
    if (www) {
      let raw = www[0].slice(1, -1),
          host = raw.split(/[/?#]/)[0];
      // GFM www rule: the domain after "www." must contain a period, plus the shared host
      // validation (>= 2 labels, last two labels have no "_").
      if (host.slice(4).indexOf('.') !== -1 && validAutolinkHost(raw, true)) {
        let full = (options.httpsAutoLinks ? 'https://' : 'http://') + raw,
            href = showdown.helper.cmEncodeURI(full).replace(/&/g, '&amp;');
        // safeMode: neutralize dangerous schemes but keep the visible text
        if (options.safeMode && !showdown.helper.isSafeUrl(full)) { href = ''; }
        return {html: showdown.helper._hashHTMLSpan('<a href="' + href + '">' + escapeAngles(raw) + '</a>', globals), end: i + www[0].length};
      }
    }
    return null;
  }

  function escapeAngles (s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // ==== writeAnchorTag and parseMail copied verbatim from link.js ====
  // Used by the copied ghMentions / simplifiedAutoLink post-passes above so they emit
  // the exact same anchors as the legacy path. TODO: refactor to share with link.js.
  function writeAnchorTag (subEvtName, pattern, wholeMatch, text, linkId, url, title, emptyCase) {

    let matches = {
          _wholeMatch: wholeMatch,
          _linkId: linkId,
          _url: url,
          _title: title,
          text: text
        },
        otp,
        attributes = {};

    title = title || null;
    url = url || null;
    if (linkId) {
      linkId = options.cmSpec ? showdown.helper.cmNormalizeLabel(linkId) : showdown.helper.caseFold(linkId);
    } else {
      linkId = null;
    }
    emptyCase = !!emptyCase;

    if (emptyCase) {
      url = '';
    } else if (!url) {
      if (!linkId) {
        // lower-case and turn embedded newlines into spaces
        linkId = options.cmSpec ? showdown.helper.cmNormalizeLabel(text) : showdown.helper.caseFold(text).replace(/ ?\n/g, ' ');
      }
      if (!showdown.helper.isUndefined(globals.gUrls[linkId])) {
        url = globals.gUrls[linkId];
        if (!showdown.helper.isUndefined(globals.gTitles[linkId])) {
          title = globals.gTitles[linkId];
        }
      } else {
        return wholeMatch;
      }
    }

    url = showdown.helper.applyBaseUrl(options.relativePathBaseUrl, url);
    // NOTE: deliberately diverges from the link.js original - we do NOT call
    // cmNormalizeURL here even though cmSpec is on. These ghMentions/simplifiedAutoLink
    // anchors are legacy GFM constructs; cmNormalizeURL would decode the entity-encoded
    // mailto: href produced by encodeEmails, making the href/text inconsistent. Skipping
    // it makes the output identical to the legacy (non-cmSpec) path.
    url = url.replace(showdown.helper.regexes.asteriskDashTildeAndColon, showdown.helper.escapeCharactersCallback);
    attributes.href = url;

    if (title && showdown.helper.isString(title)) {
      if (options.cmSpec) {
        title = showdown.helper.cmEscapeTitle(title);
      } else {
        title = title
          .replace(/"/g, '&quot;');
      }
      title = title.replace(showdown.helper.regexes.asteriskDashTildeAndColon, showdown.helper.escapeCharactersCallback);
      attributes.title = title;
    }

    let captureStartEvent = new showdown.Event('makehtml.link.' + subEvtName + '.onCapture', wholeMatch);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(pattern)
      .setMatches(matches)
      .setAttributes(attributes);
    captureStartEvent = globals.converter.dispatch(captureStartEvent);

    // if something was passed as output, it takes precedence
    // and will be used as output
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      otp = captureStartEvent.output;
    } else {
      attributes = captureStartEvent.attributes;
      text = captureStartEvent.matches.text || '';
      // Text can be a markdown element, so we run through the appropriate parsers
      text = showdown.subParser('makehtml.codeSpan')(text, options, globals);
      text = showdown.subParser('makehtml.emoji')(text, options, globals);
      text = showdown.subParser('makehtml.underline')(text, options, globals);
      text = showdown.subParser('makehtml.emphasisAndStrong')(text, options, globals);
      text = showdown.subParser('makehtml.strikethrough')(text, options, globals);
      text = showdown.subParser('makehtml.ellipsis')(text, options, globals);
      text = showdown.subParser('makehtml.hashHTMLSpans')(text, options, globals);
      otp = '<a' + showdown.helper._populateAttributes(attributes) + '>' + text + '</a>';
    }

    let beforeHashEvent = new showdown.Event('makehtml.link.' + subEvtName + '.onHash', otp);
    beforeHashEvent
      .setOutput(otp)
      ._setGlobals(globals)
      ._setOptions(options);
    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    otp = beforeHashEvent.output;
    return showdown.subParser('makehtml.hashHTMLSpans')(otp, options, globals);
  }

  function parseMail (mail) {
    let url = 'mailto:';
    mail = showdown.subParser('makehtml.unescapeSpecialChars')(mail, options, globals);
    if (options.encodeEmails) {
      url = showdown.helper.encodeEmailAddress(url + mail);
      mail = showdown.helper.encodeEmailAddress(mail);
    } else {
      url = url + mail;
    }
    return {
      mail: mail,
      url: url
    };
  }
  // ==== end copied region ====

  // GFM extended www autolink: the host must have at least two labels and the last two
  // must not contain "_". Explicit-scheme (http/https/ftp) urls are not domain-validated.
  function validAutolinkHost (url, isWww) {
    if (!isWww) { return true; }
    let host = url.split(/[/?#]/)[0],
        labels = host.split('.');
    if (labels.length < 2) { return false; }
    return !/_/.test(labels.slice(-2).join('.'));
  }

  // GFM extended email autolink: the domain must have at least two labels, must not end in
  // "-" or "_", and its last two labels must not contain "_".
  function validMailAddr (addr) {
    let at = addr.lastIndexOf('@');
    if (at < 1) { return false; }
    let domain = addr.slice(at + 1),
        labels = domain.split('.');
    if (labels.length < 2) { return false; }
    if (/[-_]$/.test(domain)) { return false; }
    return !/_/.test(labels.slice(-2).join('.'));
  }

  function parseRawHTML (str, i) {
    if (!options.cmSpec) { return null; }
    reRawHtml.lastIndex = i;
    let m = reRawHtml.exec(str);
    if (!m) { return null; }
    return {html: showdown.helper._hashHTMLSpan(m[0], globals), end: i + m[0].length};
  }

  // find the closing `]` of a reference label, honoring backslash escapes
  function findRefClose (str, j) {
    let n = str.length;
    while (j < n) {
      let c = str.charAt(j);
      if (c === '\\' && j + 1 < n) { j += 2; continue; }
      if (c === ']') { return j; }
      if (c === '[') { return -1; }
      j++;
    }
    return -1;
  }
});

////
// makehtml/cmList.js
// Copyright (c) 2024 ShowdownJS
//
// CommonMark list container-block parser (spec section 5.2/5.3).
//
// This is a separate, line-based parser invoked only when the `commonmarkLists`
// option is enabled (it is part of the `commonmark` flavor). Showdown's default
// regex list parser (`makehtml.list`) is left untouched; `makehtml.list` simply
// delegates here when the flag is on.
//
// It differs from the regex parser in the ways CommonMark requires: a change of
// bullet character or ordered delimiter starts a new list, ordered lists keep
// their start number and the `)` delimiter, loose/tight is decided per list (not
// per item), and items nest by content indentation.
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.cmList', function (text, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makehtml.list.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  text = parseCmList(text);

  let afterEvent = new showdown.Event('makehtml.list.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;

  /** @param {string} line @returns {number} count of leading spaces */
  function leadingSpaces (line) {
    let m = line.match(/^ */);
    return m[0].length;
  }

  /** @param {string} line @returns {boolean} */
  function isBlank (line) {
    return /^[ \t]*$/.test(line);
  }

  // a markerless line that can lazily continue an open paragraph: non-blank text
  // that does not itself begin an interrupting block
  function isLazyParagraph (line) {
    if (isBlank(line)) { return false; }
    return !(
      /^ {0,3}>/.test(line) ||                               // block quote
      /^ {0,3}#{1,6}(?:[ \t]|$)/.test(line) ||               // ATX heading
      /^ {0,3}(?:```|~~~)/.test(line) ||                     // fenced code
      /^ {0,3}([-*_])[ \t]*(?:\1[ \t]*){2,}$/.test(line) ||  // thematic break
      /^ {0,3}(?:[-+*]|\d{1,9}[.)])(?:[ \t]|$)/.test(line)   // list item
    );
  }

  /**
   * Match a list-item marker at the start of a line.
   * @param {string} line
   * @returns {{type:string, bullet:(string|null), delim:(string|null),
   *   num:(number|null), markerIndent:number, contentIndent:number,
   *   firstContent:string}|null}
   */
  function matchMarker (line) {
    let m = line.match(/^( {0,3})([-+*]|\d{1,9}[.)])( *)([\s\S]*)$/);
    if (!m) { return null; }
    let indent = m[1].length,
        markerTxt = m[2],
        spaces = m[3].length,
        rest = m[4];
    // the marker must be followed by at least one space (or end the line); `-one`
    // is a paragraph, not a list
    if (rest !== '' && spaces === 0) { return null; }

    let k = markerTxt.length,
        type = /[-+*]/.test(markerTxt) ? 'ul' : 'ol',
        contentIndent,
        firstContent;
    if (rest === '') {
      contentIndent = indent + k + 1;
      firstContent = '';
    } else if (spaces >= 5) {
      // 5+ spaces: one space is the marker gap, the rest is indented code
      contentIndent = indent + k + 1;
      firstContent = new Array(spaces).join(' ') + rest;
    } else {
      contentIndent = indent + k + spaces;
      firstContent = rest;
    }
    return {
      type: type,
      bullet: type === 'ul' ? markerTxt : null,
      delim: type === 'ol' ? markerTxt.slice(-1) : null,
      num: type === 'ol' ? parseInt(markerTxt, 10) : null,
      markerIndent: indent,
      contentIndent: contentIndent,
      firstContent: firstContent
    };
  }

  /**
   * Gather one list item starting at line index `i`. Consumes the marker line and
   * subsequent lines indented to the item's content column, plus lazy paragraph
   * continuations. Blank lines that are followed by more item content are kept
   * (internal); trailing blank lines are left for the caller.
   * @returns {{content:string[], end:number, blanksFollow:number, internalBlank:boolean}}
   */
  function gatherItem (lines, i, m) {
    let n = lines.length,
        w = m.contentIndent,
        content = [m.firstContent],
        internalBlank = false;
    i++;
    // a list item may begin with at most one blank line: an empty marker followed
    // by a blank line is an empty item; later indented content is not part of it
    if (m.firstContent === '' && i < n && isBlank(lines[i])) {
      let j = i;
      while (j < n && isBlank(lines[j])) { j++; }
      return {content: [''], end: i, blanksFollow: j - i, internalBlank: false};
    }
    while (i < n) {
      let line = lines[i];
      if (isBlank(line)) {
        // look ahead: blanks are internal only if the item continues afterwards
        let j = i;
        while (j < n && isBlank(lines[j])) { j++; }
        if (j < n && leadingSpaces(lines[j]) >= w && !isBlank(lines[j])) {
          for (let b = i; b < j; ++b) { content.push(''); }
          if (content.some(function (c) { return c.trim() !== ''; })) { internalBlank = true; }
          i = j;
          continue;
        }
        return {content: content, end: i, blanksFollow: j - i, internalBlank: internalBlank};
      }
      if (leadingSpaces(line) >= w) {
        content.push(line.slice(w));
        i++;
      } else if (isLazyParagraph(line) && lastIsParagraph(content)) {
        content.push(line);
        i++;
      } else {
        return {content: content, end: i, blanksFollow: 0, internalBlank: internalBlank};
      }
    }
    return {content: content, end: i, blanksFollow: 0, internalBlank: internalBlank};
  }

  // Whether an item's content has a blank line separating two of its *top-level*
  // blocks (which makes the list loose). A blank line inside a nested list/block
  // quote does not count - it makes the nested list loose, not this one. We track
  // the content-indent of the deepest open nested container and ignore lines (and
  // blanks) inside it.
  function itemLoose (content) {
    let containerIndent = -1, // content indent of the open nested container (-1 = none)
        topBlockSeen = false,
        blank = false;
    for (let li = 0; li < content.length; ++li) {
      let line = content[li];
      if (line.trim() === '') { blank = true; continue; }
      let ind = leadingSpaces(line);
      if (containerIndent >= 0 && ind >= containerIndent) {
        continue; // inside the nested container - not a top-level line of this item
      }
      if (blank && topBlockSeen) { return true; } // blank between two top-level blocks
      blank = false;
      topBlockSeen = true;
      let mk = matchMarker(line);
      if (mk) {
        containerIndent = mk.contentIndent;
      } else if (/^ {0,3}>/.test(line)) {
        containerIndent = ind + 1;
      } else {
        containerIndent = -1; // a plain top-level block (paragraph / indented code)
        // a fenced code block is a single block: skip its interior (including blank
        // lines) so blanks inside the fence are not counted as separators between two
        // top-level blocks (which would wrongly make the list loose)
        let fence = line.match(/^ {0,3}(```+|~~~+)/);
        if (fence) {
          let closeRe = new RegExp('^ {0,3}[' + fence[1][0] + ']{' + fence[1].length + ',}[ \\t]*$');
          while (li + 1 < content.length && !closeRe.test(content[li + 1])) { li++; }
          if (li + 1 < content.length) { li++; } // consume the closing fence line
        }
      }
    }
    return false;
  }

  // whether the last content line is an open paragraph (so a lazy continuation line
  // may be appended). Nested block-quote / list markers are peeled first, so lazy
  // continuation propagates through container nesting (e.g. `1. > Blockquote`
  // followed by a markerless line continues the inner block quote's paragraph).
  function lastIsParagraph (content) {
    let last = content[content.length - 1];
    if (last === undefined) { return false; }
    let s = last,
        indentedCode = /^ {4}/.test(last),
        m;
    while ((m = s.match(/^ {0,3}>[ \t]?/) || s.match(/^ {0,3}(?:[-+*]|\d{1,9}[.)])[ \t]/))) {
      s = s.slice(m[0].length);
      indentedCode = false;
    }
    if (s.trim() === '' || indentedCode) { return false; }
    return !(
      /^ {0,3}(?:```|~~~)/.test(s) ||
      /^ {0,3}#{1,6}(?:[ \t]|$)/.test(s)
    );
  }

  /**
   * Render one list item's content into `<li>…</li>`. In a tight list the item's
   * direct paragraphs are not wrapped in `<p>`; in a loose list they are. Nested
   * blocks (sub-lists, block quotes, code) are produced by blockGamut.
   */
  function renderItem (content, loose) {
    // trailing newline so the recursive block parsers (esp. indented code, which
    // requires each line to end in \n) see a complete final line
    let str = content.join('\n') + '\n';
    // drop the empty leading line that an empty marker (`-` with content on the next
    // line) contributes, so an indented-code first block sees a clean block start
    // (codeBlock keys off `^`/a preceding blank line) instead of a lone leading newline
    str = str.replace(/^\n+/, '');

    // The item's raw source — the payload for the per-item capture event below (matches
    // makehtml.list, which emits the item's raw markdown).
    let rawItem = content.join('\n');

    // GFM task detection on the (leading-newline-stripped) raw line: it selects the event
    // name and the <li> attributes. The marker must be followed by whitespace (see
    // makehtml.list.taskListItem.checkbox); a bare `[ ]` is not a task.
    let taskMatch = options.tasklists ? /^[ \t]*\[([xX ])](?=[ \t])/.exec(str) : null,
        checked = !!taskMatch && taskMatch[1].trim() !== '',
        eventName = taskMatch ? 'makehtml.list.taskListItem' : 'makehtml.list.listItem',
        attributes = {},
        matches = { _wholeMatch: rawItem, listItem: rawItem };

    if (taskMatch) {
      matches._taskListButton = '[' + taskMatch[1] + ']';
      matches._taskListButtonChecked = taskMatch[1];
      // Bare `<li>` per the GFM spec; the legacy bullet styling/classes are only added
      // when `moreStyling` is enabled.
      if (options.moreStyling) {
        attributes.classes = ['task-list-item'];
        attributes.style = 'list-style-type: none;';
        if (checked) {
          attributes.classes.push('task-list-item-complete');
        }
      }
    }

    let captureStartEvent = new showdown.Event(eventName + '.onCapture', rawItem);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setMatches(matches)
      .setAttributes(attributes);
    captureStartEvent = globals.converter.dispatch(captureStartEvent);

    let rendered;
    // A listener may pass output, which takes precedence and is used verbatim as the item
    // markup (mirrors makehtml.list); otherwise we render the (possibly edited) item.
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      rendered = captureStartEvent.output;
    } else {
      attributes = captureStartEvent.attributes;
      let liAttrs = showdown.helper._populateAttributes(attributes);

      // honor a listener that rewrote the item's raw markdown via matches.listItem
      if (captureStartEvent.matches.listItem !== rawItem) {
        str = (captureStartEvent.matches.listItem + '\n').replace(/^\n+/, '');
      }

      // Render the checkbox on the raw line, before any block/span parsing, so the
      // injected <input> flows through blockGamut/spanGamut just like any other inline HTML.
      if (taskMatch) {
        str = showdown.subParser('makehtml.list.taskListItem.checkbox')(str, options, globals);
      }
      str = showdown.subParser('makehtml.githubCodeBlock')(str, options, globals);
      str = showdown.subParser('makehtml.blockGamut')(str, options, globals);
      str = str.replace(/^\n+/, '').replace(/\n+$/, '');

      let grafs = str.split(/\n{2,}/g),
          out = [];
      for (let gi = 0; gi < grafs.length; ++gi) {
        let g = grafs[gi];
        if (/¨([KG])(\d+)\1/.test(g)) {
          out.push(g);
        } else if (/\S/.test(g)) {
          g = showdown.subParser('makehtml.spanGamut')(g, options, globals);
          if (loose) {
            g = g.replace(/^[ \t]*/, '<p>') + '</p>';
          }
          out.push(g);
        }
      }
      let body = out.join('\n');

      // an empty item is always `<li></li>`, regardless of loose/tight
      if (body.trim() === '') {
        rendered = '<li' + liAttrs + '></li>\n';
      } else {
        // CommonMark serialization: a loose item opens/closes on its own lines; a tight
        // item opens on a new line only when its content begins with a block child, and
        // closes on a new line only when its content ends with a block child (so trailing
        // inline text hugs `</li>`).
        let open = (loose || /^¨[KG]\d+[KG]/.test(body)) ? '<li' + liAttrs + '>\n' : '<li' + liAttrs + '>',
            close = (loose || /¨[KG]\d+[KG]\s*$/.test(body)) ? '\n</li>\n' : '</li>\n';
        rendered = open + body + close;
      }
    }

    let beforeHashEvent = new showdown.Event(eventName + '.onHash', rendered);
    beforeHashEvent
      .setOutput(rendered)
      ._setGlobals(globals)
      ._setOptions(options);
    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    return beforeHashEvent.output;
  }

  // a line that is open paragraph text (so a following list marker would have to
  // "interrupt a paragraph" - which empty items and non-1 ordered lists may not do)
  function isParaText (line) {
    if (isBlank(line) || /¨[A-Za-z]?\d+[A-Za-z]/.test(line)) { return false; }
    return isLazyParagraph(line) || matchMarker(line) !== null;
  }

  /**
   * CommonMark list parsing. Scans line by line, leaving non-list lines untouched
   * and converting each run of list items of the same type into a hashed list.
   * @param {string} str
   * @returns {string}
   */
  function parseCmList (str) {
    let lines = str.split('\n'),
        out = [],
        i = 0,
        n = lines.length,
        prevParagraph = false;

    while (i < n) {
      let m = matchMarker(lines[i]);
      if (!m) {
        out.push(lines[i]);
        prevParagraph = isParaText(lines[i]);
        i++;
        continue;
      }

      // a list item may interrupt a paragraph only if it is non-empty and (for
      // ordered lists) starts with 1; otherwise the marker line is paragraph text
      if (prevParagraph && (m.firstContent.trim() === '' || (m.type === 'ol' && m.num !== 1))) {
        out.push(lines[i]);
        prevParagraph = true;
        i++;
        continue;
      }

      // collect a run of items that form a single list
      let type = m.type,
          bullet = m.bullet,
          delim = m.delim,
          startNum = m.num,
          listStart = i,
          items = [],
          loose = false;

      while (i < n) {
        let mm = matchMarker(lines[i]);
        if (!mm || mm.type !== type) { break; }
        if (type === 'ul' && mm.bullet !== bullet) { break; }
        if (type === 'ol' && mm.delim !== delim) { break; }

        let item = gatherItem(lines, i, mm);
        if (itemLoose(item.content)) { loose = true; }
        items.push(item.content);
        i = item.end;

        if (item.blanksFollow > 0) {
          let j = i + item.blanksFollow,
              next = (j < n) ? matchMarker(lines[j]) : null,
              continues = next && next.type === type &&
                (type === 'ul' ? next.bullet === bullet : next.delim === delim);
          if (continues) {
            loose = true; // blank line between items
            i = j;
            continue;
          }
          break; // blanks end the list (left in place for the outer loop)
        }
      }

      // the raw source of this whole list block — payload for the list-level capture event
      let rawList = lines.slice(listStart, i).join('\n');
      let listCapture = new showdown.Event('makehtml.list.onCapture', rawList);
      listCapture
        .setOutput(null)
        ._setGlobals(globals)
        ._setOptions(options)
        .setMatches({ _wholeMatch: rawList, list: rawList })
        .setAttributes({});
      listCapture = globals.converter.dispatch(listCapture);

      let otp;
      // a listener may pass output, which takes precedence over rendering the items
      if (listCapture.output && listCapture.output !== '') {
        otp = listCapture.output;
      } else {
        let attrs = listCapture.attributes || {};
        if (type === 'ol' && startNum !== 1) {
          attrs.start = startNum;
        }
        let body = '';
        for (let k = 0; k < items.length; ++k) {
          body += renderItem(items[k], loose);
        }
        otp = '\n\n<' + type + showdown.helper._populateAttributes(attrs) + '>\n' + body + '</' + type + '>\n';
      }

      let listHash = new showdown.Event('makehtml.list.onHash', otp);
      listHash
        .setOutput(otp)
        ._setGlobals(globals)
        ._setOptions(options);
      listHash = globals.converter.dispatch(listHash);
      otp = listHash.output;

      out.push(showdown.subParser('makehtml.hashBlock')(otp, options, globals));
      prevParagraph = false;
    }

    return out.join('\n');
  }
});

////
// makehtml/codeBlock.js
// Copyright (c) 2022 ShowdownJS
//
// Process Markdown `<pre><code>` blocks.
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.codeBlock', function (text, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makehtml.codeBlock.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  // sentinel workarounds for lack of \A and \Z, safari\khtml bug
  text += '¨0';

  let pattern = /(?:\n\n|^)((?:(?: {4}|\t).*\n+)+)(\n* {0,3}[^ \t\n]|(?=¨0))/g;
  text = text.replace(pattern, function (wholeMatch, m1, m2) {
    let codeblock = m1,
        nextChar = m2,
        end = '\n',
        otp,
        attributes = {
          pre: {},
          code: {}
        };

    let captureStartEvent = new showdown.Event('makehtml.codeBlock.onCapture', codeblock);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(pattern)
      .setMatches({
        _wholeMatch: wholeMatch,
        codeblock: codeblock
      })
      .setAttributes(attributes);
    captureStartEvent = globals.converter.dispatch(captureStartEvent);

    // if something was passed as output, it takes precedence
    // and will be used as output
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      otp = captureStartEvent.output;
    } else {
      codeblock = captureStartEvent.matches.codeblock;
      codeblock = showdown.helper.outdent(codeblock);
      codeblock = showdown.subParser('makehtml.encodeCode')(codeblock, options, globals);
      //codeblock = showdown.subParser('makehtml.detab')(codeblock, options, globals);
      codeblock = codeblock.replace(/^\n+/g, ''); // trim leading newlines
      codeblock = codeblock.replace(/\n+$/g, ''); // trim trailing newlines
      attributes = captureStartEvent.attributes;

      otp = '<pre><code>';
      if (!showdown.helper.isUndefined(attributes)) {
        otp = '<pre' + showdown.helper._populateAttributes(attributes.pre) + '>';
        otp += '<code' + showdown.helper._populateAttributes(attributes.code) + '>';
      }
      if (options.omitExtraWLInCodeBlocks) {
        end = '';
      }
      otp += codeblock + end + '</code></pre>';
    }

    let beforeHashEvent = new showdown.Event('makehtml.codeBlock.onHash', otp);
    beforeHashEvent
      .setOutput(otp)
      ._setGlobals(globals)
      ._setOptions(options);

    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    otp = beforeHashEvent.output;
    return showdown.subParser('makehtml.hashBlock')(otp, options, globals) + nextChar;
  });

  // strip sentinel
  text = text.replace(/¨0/, '');

  let afterEvent = new showdown.Event('makehtml.codeBlock.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

////
// makehtml/codeSpan.js
// Copyright (c) 2018 ShowdownJS
//
// Transforms MD code spans into `<code>` html entities
//
// Backtick quotes are used for <code></code> spans.
//
// You can use multiple backticks as the delimiters if you want to
// include literal backticks in the code span. So, this input:
//
// Just type ``foo `bar` baz`` at the prompt.
//
// Will translate to:
//
// <p>Just type <code>foo `bar` baz</code> at the prompt.</p>
//
// There's no arbitrary limit to the number of backticks you
// can use as delimters. If you need three consecutive backticks
// in your code, use four for delimiters, etc.
//
// You can use spaces to get literal backticks at the edges:
// ... type `` `bar` `` ...
//
// Turns to:
// ... type <code>`bar`</code> ...
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.codeSpan', function (text, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makehtml.codeSpan.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);

  startEvent = globals.converter.dispatch(startEvent);

  text = startEvent.output;

  if (showdown.helper.isUndefined((text))) {
    text = '';
  }

  let pattern = /(^|[^\\])(`+)([^\r]*?[^`])\2(?!`)/gm;

  text = text.replace(pattern, function (wholeMatch, m1, m2, c) {
    let otp,
        attributes = {};

    c = c.replace(/^([ \t]*)/g, '');	// leading whitespace
    c = c.replace(/[ \t]*$/g, '');	// trailing whitespace
    // remove newlines
    c = c.replace(/\n/g, ' ');

    let captureStartEvent = new showdown.Event('makehtml.codeSpan.onCapture', c);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(pattern)
      .setMatches({
        _wholeMatch: wholeMatch,
        code: c
      })
      .setAttributes({});
    captureStartEvent = globals.converter.dispatch(captureStartEvent);

    // if something was passed as output, it takes precedence
    // and will be used as output
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      otp = m1 + captureStartEvent.output;
    } else {
      c = captureStartEvent.matches.code;
      c = showdown.subParser('makehtml.encodeCode')(c, options, globals);
      otp = m1 + '<code' + showdown.helper._populateAttributes(attributes) + '>' +  c + '</code>';
    }

    let beforeHashEvent = new showdown.Event('makehtml.codeSpan.onHash', otp);
    beforeHashEvent
      .setOutput(otp)
      ._setGlobals(globals)
      ._setOptions(options);

    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    otp = beforeHashEvent.output;
    return showdown.subParser('makehtml.hashHTMLSpans')(otp, options, globals);
  });

  let afterEvent = new showdown.Event('makehtml.codeSpan.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

////
// makehtml/completeHTMLDocument.js
// Copyright (c) 2018 ShowdownJS
//
// Create a full HTML document from the processed markdown
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////
// noinspection HtmlRequiredLangAttribute


showdown.subParser('makehtml.completeHTMLDocument', function (text, options, globals) {
  'use strict';

  if (!options.completeHTMLDocument) {
    return text;
  }

  let startEvent = new showdown.Event('makehtml.completeHTMLDocument.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  let doctype = 'html',
      doctypeParsed = '<!DOCTYPE HTML>\n',
      title = '',
      charset = '<meta charset="utf-8">\n',
      lang = '',
      metadata = '';

  if (typeof globals.metadata.parsed.doctype !== 'undefined') {
    doctypeParsed = '<!DOCTYPE ' +  globals.metadata.parsed.doctype + '>\n';
    doctype = globals.metadata.parsed.doctype.toString().toLowerCase();
    if (doctype === 'html' || doctype === 'html5') {
      charset = '<meta charset="utf-8">';
    }
  }

  for (let meta in globals.metadata.parsed) {
    if (Object.prototype.hasOwnProperty.call(globals.metadata.parsed, meta)) {
      switch (meta.toLowerCase()) {
        case 'doctype':
          break;

        case 'title':
          title = '<title>' +  globals.metadata.parsed.title + '</title>\n';
          break;

        case 'charset':
          if (doctype === 'html' || doctype === 'html5') {
            charset = '<meta charset="' + globals.metadata.parsed.charset + '">\n';
          } else {
            charset = '<meta name="charset" content="' + globals.metadata.parsed.charset + '">\n';
          }
          break;

        case 'language':
        case 'lang':
          lang = ' lang="' + globals.metadata.parsed[meta] + '"';
          metadata += '<meta name="' + meta + '" content="' + globals.metadata.parsed[meta] + '">\n';
          break;

        default:
          metadata += '<meta name="' + meta + '" content="' + globals.metadata.parsed[meta] + '">\n';
      }
    }
  }

  text = doctypeParsed + '<html' + lang + '>\n<head>\n' + title + charset + metadata + '</head>\n<body>\n' + text.trim() + '\n</body>\n</html>';

  let afterEvent = new showdown.Event('makehtml.completeHTMLDocument.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

////
// makehtml/decodeEntities.js
// Copyright (c) 2024 ShowdownJS
//
// Resolves HTML5 named (`&copy;`), decimal (`&#35;`) and hexadecimal (`&#xcab;`)
// character references to their corresponding characters, per the CommonMark spec.
//
// This diverges from Showdown's default behavior (which preserves entities verbatim),
// so it is gated behind the `decodeEntities` option (enabled by the `commonmark` flavor).
//
// It runs late in the pipeline - after inline parsing and while code spans/blocks are
// still hashed - so that:
//   - a decoded markdown character (e.g. `&#42;` -> `*`) is NOT re-parsed as emphasis;
//   - entities inside code remain escaped (the code is hashed, hence untouched);
//   - decoded newlines stay literal inside their block.
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////

showdown.subParser('makehtml.decodeEntities', function (text, options, globals) {
  'use strict';

  if (!options.decodeEntities) {
    return text;
  }

  let startEvent = new showdown.Event('makehtml.decodeEntities.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  const entities = showdown.helper.htmlEntities;

  // Re-escape HTML-significant characters so a decoded char (e.g. `&lt;` -> `<`) stays
  // a literal in the HTML output rather than being read as markup.
  function escapeOutput (str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Map a code point to its character, replacing disallowed values with U+FFFD.
  function fromCodePoint (cp) {
    if (cp === 0 || cp > 0x10FFFF || (cp >= 0xD800 && cp <= 0xDFFF)) {
      return '�';
    }
    try {
      return String.fromCodePoint(cp);
    } catch {
      return '�';
    }
  }

  // Match any `&…;` candidate that survived encodeAmpsAndAngles (which already escaped
  // bare ampersands and `&name`/`&name?;` non-references). We classify each candidate here.
  text = text.replace(/&([#0-9a-zA-Z]+);/g, function (wholeMatch, body) {
    let m;
    // decimal numeric reference: 1-7 digits
    if ((m = /^#([0-9]{1,7})$/.exec(body))) {
      return escapeOutput(fromCodePoint(parseInt(m[1], 10)));
    }
    // hexadecimal numeric reference: 1-6 hex digits
    if ((m = /^#[xX]([0-9a-fA-F]{1,6})$/.exec(body))) {
      return escapeOutput(fromCodePoint(parseInt(m[1], 16)));
    }
    // named reference (must be a known HTML5 entity name)
    if (/^[a-zA-Z][a-zA-Z0-9]*$/.test(body) && Object.prototype.hasOwnProperty.call(entities, body)) {
      return escapeOutput(entities[body]);
    }
    // not a valid reference - escape the ampersand and leave the rest intact
    return '&amp;' + body + ';';
  });

  let afterEvent = new showdown.Event('makehtml.decodeEntities.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

////
// makehtml/disallowedHtmlTags.js
// Copyright (c) 2018 ShowdownJS
//
// GFM "disallowed raw HTML" extension (tagfilter): a small blacklist of HTML tags
// is neutralized in the output by escaping their leading `<` to `&lt;`. These tags
// are singled out because they change how the surrounding markup is interpreted
// (script/style/iframe/etc.). See https://github.github.com/gfm/#disallowed-raw-html-extension-
//
// When the `safeMode` option is on, this stage also neutralizes a broader set of
// dangerous raw-HTML tags Showdown never generates and strips inline event-handler
// attributes (on*=...), so that embedded `<script>`, `<img onerror>`, `<svg onload>`
// and similar cannot execute. This is defense-in-depth, not a full HTML sanitizer.
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.disallowedHtmlTags', function (text, options, globals) {
  'use strict';
  if (!options.disallowRawHTML && !options.safeMode) {
    return text;
  }

  let startEvent = new showdown.Event('makehtml.disallowedHtmlTags.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  // Run over the (near final) output: Showdown never generates these tags from Markdown
  // and code blocks/spans already entity-escape `<`, so only genuine raw-HTML passthrough
  // is touched. Both opening and closing forms are filtered, case-insensitively.
  text = text.replace(
    /<(\/?(?:title|textarea|style|xmp|iframe|noembed|noframes|script|plaintext))/gi,
    '&lt;$1'
  );

  if (options.safeMode) {
    // Additional dangerous tags Showdown never emits from Markdown (svg/math/form/
    // media/embedding/document-metadata). Escaping the leading `<` renders them inert.
    text = text.replace(
      /<(\/?(?:svg|math|form|object|embed|base|link|meta|applet|frame|frameset|button|select|option|audio|video|source|track|template|portal))(?=[\s/>])/gi,
      '&lt;$1'
    );
    // Strip inline event-handler attributes (onclick, onerror, onload, ...) from any
    // surviving tag. Showdown's own generated attributes are never `on*`, so this only
    // affects raw-HTML passthrough (e.g. `<img src=x onerror=alert(1)>`). The separator
    // before the handler may be whitespace, `/`, or the closing quote of the previous
    // attribute — browsers accept all of these (`<img/onerror>`, `<img\tonerror>`,
    // `<a href="x"onmouseover=y>`). A whitespace/`/` separator is dropped; a quote
    // separator is preserved so the previous attribute stays terminated.
    text = text.replace(
      /(["'\s/])on[a-z]+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s"'>]+)/gi,
      function (whole, sep) { return (sep === '"' || sep === '\'') ? sep : ''; }
    );
    // Neutralize dangerous URL schemes (javascript:, vbscript:, data:text/html, ...) in the
    // URL-bearing attributes of raw-HTML tags — Showdown's own scheme allowlist only covers the
    // links/images it generates, not raw HTML the author embedded. This runs over EVERY surviving
    // tag (not just `<a>`/`<area>`) so it also catches e.g. `<input formaction="javascript:...">`
    // (`<input>` is intentionally not escaped, to keep tasklist checkboxes). Only real tags are
    // matched (code blocks have their `<` entity-escaped, so `&lt;a ...` is skipped), and Showdown's
    // generated tags carry only safe/relative URLs so re-checking them is a harmless no-op.
    //   - The tag body is `(?:"[^"]*"|'[^']*'|[^>])*` (quote-aware) rather than `[^>]*` so a `>`
    //     inside a quoted attribute value does not truncate the tag early.
    //   - The attribute separator is `["'\s/]` (not just `\s`) because browsers accept `/` and
    //     quote-adjacent attributes (`<a/href=…>`, `<a id="x"href=…>`); the separator is preserved.
    text = text.replace(/<[a-zA-Z][a-zA-Z0-9:-]*\b(?:"[^"]*"|'[^']*'|[^>])*>/g, function (tag) {
      return tag.replace(
        /(["'\s/](?:href|xlink:href|formaction|action)\s*=\s*)("[^"]*"|'[^']*'|[^\s"'>]+)/gi,
        function (whole, pre, val) {
          let unquoted = val.replace(/^(["'])([\s\S]*)\1$/, '$2');
          return showdown.helper.isSafeUrl(unquoted) ? whole : pre + '""';
        }
      );
    });
  }

  let afterEvent = new showdown.Event('makehtml.disallowedHtmlTags.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

////
// makehtml/ellipsis.js
// Copyright (c) 2018 ShowdownJS
//
// transform three dots (...) into ellipsis (…)
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.ellipsis', function (text, options, globals) {
  'use strict';

  if (!options.ellipsis) {
    return text;
  }

  let startEvent = new showdown.Event('makehtml.ellipsis.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  const ellipsisRegex = /\.\.\./g;
  text = text.replace(ellipsisRegex, function (wholeMatch) {

    let otp;
    let captureStartEvent = new showdown.Event('makehtml.ellipsis.onCapture', wholeMatch);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(ellipsisRegex)
      .setMatches({
        _wholeMatch: wholeMatch,
        ellipsis: wholeMatch
      })
      .setAttributes({});
    captureStartEvent = globals.converter.dispatch(captureStartEvent);
    // if something was passed as output, it takes precedence
    // and will be used as output
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      otp = captureStartEvent.output;
    } else {
      otp = '…';
    }

    let beforeHashEvent = new showdown.Event('makehtml.ellipsis.onHash', otp);
    beforeHashEvent
      .setOutput(otp)
      ._setGlobals(globals)
      ._setOptions(options);
    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    return beforeHashEvent.output;
  });

  let afterEvent = new showdown.Event('makehtml.ellipsis.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

////
// makehtml/emoji.js
// Copyright (c) 2018 ShowdownJS
//
// Turn emoji codes into emojis
// List of supported emojis: https://github.com/showdownjs/showdown/wiki/Emojis
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.emoji', function (text, options, globals) {
  'use strict';

  if (!options.emoji) {
    return text;
  }

  let startEvent = new showdown.Event('makehtml.emoji.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  let pattern = /:(\S+?):/g;

  text = text.replace(pattern, function (wholeMatch, emojiCode) {
    if (!Object.prototype.hasOwnProperty.call(showdown.helper.emojis, emojiCode)) {
      return wholeMatch;
    }
    let otp;
    let captureStartEvent = new showdown.Event('makehtml.emoji.onCapture', emojiCode);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(pattern)
      .setMatches({
        _wholeMatch: wholeMatch,
        emojiCode: emojiCode
      })
      .setAttributes({});
    captureStartEvent = globals.converter.dispatch(captureStartEvent);

    // if something was passed as output, it takes precedence and will be used as output
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      otp = captureStartEvent.output;
    } else {
      otp = showdown.helper.emojis[emojiCode];
    }

    let beforeHashEvent = new showdown.Event('makehtml.emoji.onHash', otp);
    beforeHashEvent
      .setOutput(otp)
      ._setGlobals(globals)
      ._setOptions(options);

    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    otp = beforeHashEvent.output;

    // Image-based emoji (e.g. :octocat:) render as an <img> tag. Hash it so later
    // HTML-escaping passes don't turn its `<`/`>` into entities - under cmSpec the
    // generic span hashing skips void tags (it is meant to escape malformed raw HTML),
    // so the generated markup must protect itself here. Unicode emoji are returned as-is.
    if (/^\s*</.test(otp)) {
      otp = showdown.helper._hashHTMLSpan(otp, globals);
    }
    return otp;
  });

  let afterEvent = new showdown.Event('makehtml.emoji.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

////
// makehtml/emphasisAndStrong.js
// Copyright (c) 2022 ShowdownJS
//
// Transforms MD emphasis and strong into `<em>` and `<strong>` html entities
//
// Markdown treats asterisks (*) and underscores (_) as indicators of emphasis.
// Text wrapped with one * or _ will be wrapped with an HTML <em> tag;
// double *’s or _’s will be wrapped with an HTML <strong> tag
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////

/* jshint esnext: false, esversion: 9 */
// (esversion 9 enables the \p{...} Unicode property escapes used for CommonMark flanking rules)

showdown.subParser('makehtml.emphasisAndStrong', function (text, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makehtml.emphasisAndStrong.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  /**
   * @param {string} txt
   * @param {string} tags
   * @param {string} wholeMatch
   * @param {RegExp} pattern
   * @returns {string}
   */
  function parseInside (txt, tags, wholeMatch, pattern) {
    let otp = 'ERROR',
        attributes,
        subEventName;

    switch (tags) {
      case '<em>':
        attributes = {
          em: {}
        };
        subEventName = 'emphasis';
        break;
      case '<strong>':
        attributes = {
          strong: {}
        };
        subEventName = 'strong';
        break;
      case '<strong><em>':
        attributes = {
          em: {},
          strong: {}
        };
        subEventName = 'emphasisAndStrong';
        break;
      default:
        attributes = {};
        subEventName = 'emphasisAndStrong';
        break;
    }

    let captureStartEvent = new showdown.Event('makehtml.emphasisAndStrong.' + subEventName + '.onCapture', txt);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(pattern)
      .setMatches({
        _wholeMatch: wholeMatch,
        text: txt
      })
      .setAttributes(attributes);
    captureStartEvent = globals.converter.dispatch(captureStartEvent);
    // if something was passed as output, it takes precedence
    // and will be used as output
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      otp = captureStartEvent.output;
    } else {
      attributes = captureStartEvent.attributes;
      if (showdown.helper.isUndefined(attributes.em)) {
        attributes.em = {};
      }
      if (showdown.helper.isUndefined(attributes.strong)) {
        attributes.strong = {};
      }

      switch (tags) {
        case '<em>':
          otp = '<em' + showdown.helper._populateAttributes(attributes.em) + '>' +
                showdown.subParser('makehtml.hardLineBreaks')(txt, options, globals) +
                '</em>';
          break;
        case '<strong>':
          otp = '<strong' + showdown.helper._populateAttributes(attributes.strong) + '>' +
                showdown.subParser('makehtml.hardLineBreaks')(txt, options, globals) +
                '</strong>';
          break;
        case '<strong><em>':
          otp = '<strong' + showdown.helper._populateAttributes(attributes.strong) + '>' +
                '<em' + showdown.helper._populateAttributes(attributes.em) + '>' +
                showdown.subParser('makehtml.hardLineBreaks')(txt, options, globals) +
                '</em>' +
                '</strong>';
          break;
      }
    }

    let beforeHashEvent = new showdown.Event('makehtml.emphasisAndStrong.' + subEventName + '.onHash', otp);
    beforeHashEvent
      .setOutput(otp)
      ._setGlobals(globals)
      ._setOptions(options);
    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    otp = beforeHashEvent.output;
    otp = showdown.subParser('makehtml.hashHTMLSpans')(otp, options, globals);
    return otp;
  }

  // CommonMark-compliant emphasis/strong parsing (delimiter-run algorithm).
  // Gated behind the `commonmarkEmphasis` option (enabled by the commonmark flavor) because
  // it diverges from Showdown's default behavior (e.g. intraword underscores, flanking rules).
  if (options.cmSpec) {
    text = parseCommonmarkEmphasis(text);

    let cmAfterEvent = new showdown.Event('makehtml.emphasisAndStrong.onEnd', text);
    cmAfterEvent
      .setOutput(text)
      ._setGlobals(globals)
      ._setOptions(options);
    cmAfterEvent = globals.converter.dispatch(cmAfterEvent);
    return cmAfterEvent.output;
  }

  /**
   * Parse emphasis and strong emphasis using the CommonMark delimiter-run algorithm.
   * @param {string} str
   * @returns {string}
   */
  function parseCommonmarkEmphasis (str) {
    // CommonMark punctuation = ASCII punctuation + Unicode P and S categories
    const asciiPunct = /[!-/:-@[-`{-~]/;
    function isPunct (ch) {
      return ch !== undefined && (asciiPunct.test(ch) || /[\p{P}\p{S}]/u.test(ch));
    }
    function isWhitespace (ch) {
      return ch === undefined || /\s/.test(ch) || /\p{Z}/u.test(ch);
    }

    // 1. Tokenize into a doubly-linked list of nodes; collect a delimiter stack.
    let head = null,
        tail = null,
        delimiters = null; // tail of delimiter stack

    function appendNode (node) {
      node.prev = tail;
      node.next = null;
      if (tail) {
        tail.next = node;
      } else {
        head = node;
      }
      tail = node;
      return node;
    }

    const len = str.length;
    let i = 0;
    while (i < len) {
      let ch = str.charAt(i);
      if (ch === '*' || ch === '_') {
        let start = i;
        while (i < len && str.charAt(i) === ch) {
          ++i;
        }
        let run = str.slice(start, i),
            before = (start === 0) ? undefined : str.charAt(start - 1),
            after = (i >= len) ? undefined : str.charAt(i),
            beforeWs = isWhitespace(before),
            afterWs = isWhitespace(after),
            beforePt = isPunct(before),
            afterPt = isPunct(after),
            leftFlanking = !afterWs && (!afterPt || beforeWs || beforePt),
            rightFlanking = !beforeWs && (!beforePt || afterWs || afterPt),
            canOpen, canClose;
        if (ch === '_') {
          canOpen = leftFlanking && (!rightFlanking || beforePt);
          canClose = rightFlanking && (!leftFlanking || afterPt);
        } else {
          canOpen = leftFlanking;
          canClose = rightFlanking;
        }
        let node = appendNode({type: 'delim', cc: ch, literal: run, numdelims: run.length, origdelims: run.length, canOpen: canOpen, canClose: canClose});
        node.delimPrev = delimiters;
        node.delimNext = null;
        if (delimiters) {
          delimiters.delimNext = node;
        }
        delimiters = node;
      } else {
        // accumulate a literal text run up to the next delimiter
        let start = i;
        while (i < len && str.charAt(i) !== '*' && str.charAt(i) !== '_') {
          ++i;
        }
        appendNode({type: 'text', literal: str.slice(start, i)});
      }
    }

    // 2. Process emphasis (CommonMark reference algorithm).
    processEmphasis();

    // 3. Render remaining nodes back to a string.
    let out = '';
    for (let n = head; n !== null; n = n.next) {
      out += n.literal;
    }
    return out;

    function removeDelimiter (d) {
      if (d.delimPrev) {
        d.delimPrev.delimNext = d.delimNext;
      }
      if (d.delimNext) {
        d.delimNext.delimPrev = d.delimPrev;
      } else {
        delimiters = d.delimPrev; // top of stack
      }
    }

    function insertAfter (node, newNode) {
      newNode.prev = node;
      newNode.next = node.next;
      if (node.next) {
        node.next.prev = newNode;
      } else {
        tail = newNode;
      }
      node.next = newNode;
    }

    function processEmphasis () {
      // one lower-bound per delimiter char, bucketed by (origdelims % 3) per the spec
      let openersBottom = {'_': [null, null, null], '*': [null, null, null]};

      // start from the bottom-most delimiter on the stack
      let closer = delimiters;
      while (closer !== null && closer.delimPrev !== null) {
        closer = closer.delimPrev;
      }

      while (closer !== null) {
        if (!closer.canClose) {
          closer = closer.delimNext;
          continue;
        }
        // look back for a matching opener
        let opener = closer.delimPrev,
            openerFound = false,
            oddMatch;
        while (opener !== null && opener !== openersBottom[closer.cc][closer.origdelims % 3]) {
          oddMatch = (closer.canOpen || opener.canClose) &&
                     (closer.origdelims % 3 !== 0) &&
                     ((opener.origdelims + closer.origdelims) % 3 === 0);
          if (opener.cc === closer.cc && opener.canOpen && !oddMatch) {
            openerFound = true;
            break;
          }
          opener = opener.delimPrev;
        }
        let oldCloser = closer;

        if (openerFound) {
          let use = (opener.numdelims >= 2 && closer.numdelims >= 2) ? 2 : 1,
              tagOpen = (use === 2) ? '<strong>' : '<em>',
              tagClose = (use === 2) ? '</strong>' : '</em>';

          // trim consumed delimiters from the opener (end) and closer (start) literals
          opener.literal = opener.literal.slice(0, opener.literal.length - use);
          opener.numdelims -= use;
          closer.literal = closer.literal.slice(use);
          closer.numdelims -= use;

          // collect inner nodes (between opener and closer), render and hash them
          let inner = '';
          for (let n = opener.next; n !== null && n !== closer; n = n.next) {
            inner += n.literal;
          }
          // emphasis content is hashed here, before the rest of the span gamut runs, so apply
          // hard line breaks and encode double quotes now (CommonMark renders quotes as &quot;)
          inner = showdown.subParser('makehtml.hardLineBreaks')(inner, options, globals);
          inner = inner.replace(/"/g, '&quot;');
          let wrapped = showdown.subParser('makehtml.hashHTMLSpans')(tagOpen + inner + tagClose, options, globals);

          // remove inner nodes and their delimiters from the lists
          let n2 = opener.next;
          while (n2 !== null && n2 !== closer) {
            let nx = n2.next;
            if (n2.type === 'delim') {
              removeDelimiter(n2);
            }
            n2 = nx;
          }
          // splice in a single text node holding the wrapped (hashed) result
          let wrapNode = {type: 'text', literal: wrapped};
          insertAfter(opener, wrapNode);
          // relink opener.next directly to closer (drop the removed inner nodes)
          wrapNode.next = closer;
          closer.prev = wrapNode;

          // drop fully-consumed delimiters
          if (opener.numdelims === 0) {
            opener.literal = '';
            removeDelimiter(opener);
          }
          if (closer.numdelims === 0) {
            closer.literal = '';
            let tmp = closer.delimNext;
            removeDelimiter(closer);
            closer = tmp;
          }
        } else {
          openersBottom[oldCloser.cc][oldCloser.origdelims % 3] = oldCloser.delimPrev;
          if (!oldCloser.canOpen) {
            removeDelimiter(oldCloser);
          }
          closer = oldCloser.delimNext;
        }
      }
    }
  }

  // it's faster to have separate regexes for each case than have just one
  // because of backtracking, in some cases, it could lead to an exponential effect
  // called "catastrophic backtrace". Ominous!
  const lmwuStrongEmRegex         = /\b___(\S[\s\S]*?)___\b/g,
      lmwuStrongRegex             = /\b__(\S[\s\S]*?)__\b/g,
      lmwuEmRegex                 = /\b_(\S[\s\S]*?)_\b/g,
      underscoreStrongEmRegex     = /___(\S[\s\S]*?)___/g,
      unserscoreStrongRegex       = /__(\S[\s\S]*?)__/g,
      unserscoreEmRegex           = /_([^\s_][\s\S]*?)_/g,

      asteriskStrongEm            = /\*\*\*(\S[\s\S]*?)\*\*\*/g,
      asteriskStrong              = /\*\*(\S[\s\S]*?)\*\*/g,
      asteriskEm                  = /\*([^\s*][\s\S]*?)\*/g;


  // Parse underscores
  if (options.literalMidWordUnderscores) {
    text = text.replace(lmwuStrongEmRegex, function (wm, txt) {
      return parseInside (txt, '<strong><em>', wm, lmwuStrongEmRegex);
    });
    text = text.replace(lmwuStrongRegex, function (wm, txt) {
      return parseInside (txt, '<strong>', wm, lmwuStrongRegex);
    });
    text = text.replace(lmwuEmRegex, function (wm, txt) {
      return parseInside (txt, '<em>', wm, lmwuEmRegex);
    });
  } else {
    text = text.replace(underscoreStrongEmRegex, function (wm, m) {
      return (/\S$/.test(m)) ? parseInside (m, '<strong><em>', wm, underscoreStrongEmRegex) : wm;
    });
    text = text.replace(unserscoreStrongRegex, function (wm, m) {
      return (/\S$/.test(m)) ? parseInside (m, '<strong>', wm, unserscoreStrongRegex) : wm;
    });
    text = text.replace(unserscoreEmRegex, function (wm, m) {
      // !/^_[^_]/.test(m) - test if it doesn't start with __ (since it seems redundant, we removed it)
      return (/\S$/.test(m)) ? parseInside (m, '<em>', wm, unserscoreEmRegex) : wm;
    });
  }

  // Now parse asterisks
  text = text.replace(asteriskStrongEm, function (wm, m) {
    return (/\S$/.test(m)) ? parseInside (m, '<strong><em>', wm, asteriskStrongEm) : wm;
  });
  text = text.replace(asteriskStrong, function (wm, m) {
    return (/\S$/.test(m)) ? parseInside (m, '<strong>', wm, asteriskStrong) : wm;
  });
  text = text.replace(asteriskEm, function (wm, m) {
    // !/^\*[^*]/.test(m) - test if it doesn't start with ** (since it seems redundant, we removed it)
    return (/\S$/.test(m)) ? parseInside (m, '<em>', wm, asteriskEm) : wm;
  });
  //}
  let afterEvent = new showdown.Event('makehtml.emphasisAndStrong.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

////
// makehtml/encodeAmpsAndAngles.js
// Copyright (c) 2018 ShowdownJS
//
// Smart processing for ampersands and angle brackets that need to be encoded.
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.encodeAmpsAndAngles', function (text, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makehtml.encodeAmpsAndAngles.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  // Ampersand-encoding based entirely on Nat Irons's Amputator MT plugin:
  // http://bumppo.net/projects/amputator/
  text = text.replace(/&(?!#?[xX]?(?:[\da-fA-F]+|\w+);)/g, '&amp;');

  // Encode naked <'s
  text = text.replace(/<(?![a-z/?$!])/gi, '&lt;');

  // Encode <
  text = text.replace(/</g, '&lt;');

  // Encode >
  text = text.replace(/>/g, '&gt;');

  // encode "
  text = text.replace(/"/g, '&quot;');

  let afterEvent = new showdown.Event('makehtml.encodeAmpsAndAngles.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

////
// makehtml/encodeBackslashEscapes.js
// Copyright (c) 2018 ShowdownJS
//
// Returns the string, with after processing the following backslash escape sequences.
//
// The polite way to do this is with the new escapeCharacters() function:
//
// text = escapeCharacters(text,"\\",true);
// text = escapeCharacters(text,"`*_{}[]()>#+-.!",true);
//
// ...but we're sidestepping its use of the (slow) RegExp constructor
// as an optimization for Firefox.  This function gets called a LOT.
//
// ***Author:***
// - attacklab
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.encodeBackslashEscapes', function (text, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makehtml.encodeBackslashEscapes.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  text = text
    .replace(/\\(\\)/g, showdown.helper.escapeCharactersCallback)
    .replace(/\\([!#%'()*+,\-./:;=?@[\]\\^_`{|}~])/g, showdown.helper.escapeCharactersCallback)
    .replace(/\\¨D/g, '¨D') // escape $ (which was already escaped as ¨D) (charcode is 36)
    .replace(/\\&/g, '&amp;') // escape &
    .replace(/\\"/g, '&quot;') // escaping "
    .replace(/\\</g, '&lt;') // escaping <
    .replace(/\\>/g, '&gt;'); // escaping >

  let afterEvent = new showdown.Event('makehtml.encodeBackslashEscapes.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

////
// makehtml/emoji.js
// Copyright (c) 2018 ShowdownJS
//
// Encode/escape certain characters inside Markdown code runs.
// The point is that in code, these characters are literals,
// and lose their special Markdown meanings.
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.encodeCode', function (text, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makehtml.encodeCode.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  // Encode all ampersands; HTML entities are not
  // entities within a Markdown code span.
  text = text
    .replace(/&/g, '&amp;')
  // Do the angle bracket song and dance:
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
  // encode "
    .replace(/"/g, '&quot;')
  // Now, escape characters that are magic in Markdown:
    .replace(/([*_{}[\]\\=~-])/g, showdown.helper.escapeCharactersCallback);

  let afterEvent = new showdown.Event('makehtml.encodeCode.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

////
// makehtml/escapeSpecialCharsWithinTagAttributes.js
// Copyright (c) 2018 ShowdownJS
//
// Within tags -- meaning between < and > -- encode [\ ` * _ ~ =] so they
// don't conflict with their use in Markdown for code, italics and strong.
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.escapeSpecialCharsWithinTagAttributes', function (text, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makehtml.escapeSpecialCharsWithinTagAttributes.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  // In CommonMark raw-HTML mode this escaping is skipped: inline raw HTML is instead
  // recognized with the strict grammar and hashed in spanGamut (makehtml.hashCmRawHTML),
  // after backslash escapes and link/image destinations have been resolved. Escaping
  // `=`/`_`/etc. here would corrupt that later strict tag recognition.
  if (!options.cmSpec) {
    // Build a regex to find HTML tags.
    let tags     = /<\/?[a-z\d_:-]+(?:\s+[\s\S]+?)?>/gi,
        comments = /<!(--(([^>-]|-[^>])([^-]|-[^-])*)--)>/gi;

    text = text.replace(tags, function (wholeMatch) {
      return wholeMatch
        .replace(/(.)<\/?code>(?=.)/g, '$1`')
        .replace(/([\\`*_~=|])/g, showdown.helper.escapeCharactersCallback);
    });

    text = text.replace(comments, function (wholeMatch) {
      return wholeMatch
        .replace(/([\\`*_~=|])/g, showdown.helper.escapeCharactersCallback);
    });
  }

  let afterEvent = new showdown.Event('makehtml.escapeSpecialCharsWithinTagAttributes.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

/**
 * GFM footnotes (cmark-gfm footnotes extension).
 *
 * Runs in two phases (selected by the `phase` argument):
 *   'strip' - before stripLinkDefinitions: collect `[^label]: body` definitions
 *             into globals and replace `[^label]` references that have a definition
 *             with a hashed `<sup>` span (numbered by order of first reference).
 *   'build' - after paragraphs: render the referenced footnotes into a
 *             `<section class="footnotes">` and append it to the document.
 */
showdown.subParser('makehtml.footnotes', function (text, options, globals, phase) {
  'use strict';

  if (!options.footnotes) {
    return text;
  }

  if (phase === 'strip') {
    text = collectDefinitions(text);
    text = replaceReferences(text);
    return text;
  }
  if (phase === 'build') {
    return buildSection(text);
  }
  return text;

  // ---- phase 1a: collect (and remove) `[^label]: body` definitions ----------

  function collectDefinitions (str) {
    globals.gFootnotes = globals.gFootnotes || {};
    str += '¨0';
    let n = str.length,
        out = '',
        i = 0;
    while (i < n) {
      // `i` is always at a line start here; a footnote definition may begin at any line
      // (it can interrupt a paragraph), so we try one at every line.
      let def = tryParseDefinition(str, i);
      if (def) {
        let norm = showdown.helper.cmNormalizeLabel(def.rawLabel);
        if (norm !== '' && showdown.helper.isUndefined(globals.gFootnotes[norm])) {
          globals.gFootnotes[norm] = { bodyRaw: def.body, rawLabel: def.rawLabel };
        }
        i = def.end;
        continue;
      }
      let nl = str.indexOf('\n', i);
      if (nl === -1) {
        out += str.slice(i);
        break;
      }
      out += str.slice(i, nl + 1);
      i = nl + 1;
    }
    return out.replace(/¨0/, '');
  }

  /**
   * Try to parse a single footnote definition starting at `start` (a line start).
   * The body is the same-line remainder plus continuation lines indented by at
   * least 4 spaces (with that 4-space base removed), up to a less-indented line.
   * @returns {{rawLabel: string, body: string, end: number}|null}
   */
  function tryParseDefinition (str, start) {
    let n = str.length,
        j = start,
        sp = 0;
    while (j < n && str.charAt(j) === ' ' && sp < 3) { j++; sp++; }
    if (str.charAt(j) !== '[' || str.charAt(j + 1) !== '^') { return null; }
    j += 2;

    let label = '';
    while (j < n) {
      let c = str.charAt(j);
      if (c === '\\' && j + 1 < n) { label += c + str.charAt(j + 1); j += 2; continue; }
      if (c === ']') { break; }
      // a footnote label may not contain whitespace or a nested '['
      if (c === '[' || /\s/.test(c)) { return null; }
      label += c;
      j++;
    }
    if (str.charAt(j) !== ']' || label === '' || str.charAt(j + 1) !== ':') { return null; }
    j += 2;

    let nl = str.indexOf('\n', j),
        firstEnd = (nl === -1) ? n : nl,
        firstLine = str.slice(j, firstEnd).replace(/^[ \t]+/, '').replace(/¨0$/, ''),
        bodyLines = [];
    if (firstLine !== '') { bodyLines.push(firstLine); }
    let k = (nl === -1) ? n : nl + 1;

    while (k < n) {
      let lineNl = str.indexOf('\n', k),
          lineEnd = (lineNl === -1) ? n : lineNl,
          line = str.slice(k, lineEnd);
      if (line.slice(0, 2) === '¨0') { break; }
      if (/^[ \t]*$/.test(line)) {
        bodyLines.push('');
        k = (lineNl === -1) ? n : lineNl + 1;
        continue;
      }
      if (/^ {4}/.test(line)) {
        bodyLines.push(line.slice(4));
        k = (lineNl === -1) ? n : lineNl + 1;
      } else {
        break;
      }
    }

    while (bodyLines.length && bodyLines[bodyLines.length - 1] === '') { bodyLines.pop(); }
    return { rawLabel: label, body: bodyLines.join('\n'), end: k };
  }

  // ---- phase 1b: replace `[^label]` references with hashed <sup> spans -------

  // Replace inline code spans with `¨FN<n>¨` placeholders so a `[^id]` inside them stays
  // literal. Linear scan (ReDoS-safe): a code span is a back-tick run closed by a run of the
  // same length. Unbalanced runs are left as text. Worst case is sub-quadratic because runs
  // that stay unmatched must have distinct lengths (equal-length runs pair up).
  function hashInlineCodeSpans (str, store) {
    let pieces = [], textStart = 0, i = 0, n = str.length;
    while (i < n) {
      if (str.charAt(i) !== '`') { i++; continue; }
      let j = i;
      while (j < n && str.charAt(j) === '`') { j++; }
      let len = j - i, k = j, close = -1;
      while (k < n) {
        if (str.charAt(k) === '`') {
          let m = k;
          while (m < n && str.charAt(m) === '`') { m++; }
          if (m - k === len) { close = m; break; }
          k = m;
        } else {
          k++;
        }
      }
      if (close !== -1) {
        pieces.push(str.substring(textStart, i));
        store.push(str.substring(i, close));
        pieces.push('¨FN' + (store.length - 1) + '¨');
        textStart = close;
        i = close;
      } else {
        // opening run with no matching closer: leave it as literal text
        i = j;
      }
    }
    pieces.push(str.substring(textStart));
    return pieces.join('');
  }

  function replaceReferences (str, raw) {
    globals.gFootnoteOrder = globals.gFootnoteOrder || [];
    globals.gFootnoteRefs = globals.gFootnoteRefs || {};

    // Protect inline code spans so a `[^id]` inside back-ticks stays literal. A linear scan
    // (not a backtracking regex) keeps this safe on long back-tick runs in attacker input.
    // Fenced/indented code is already hashed before this pass.
    let spans = [];
    str = hashInlineCodeSpans(str, spans);

    // a footnote label may not contain whitespace, so `[^a b]` is not a reference.
    // `[` is excluded from the label too: it can never appear in a valid label, and
    // excluding it stops the scan from running past the label start of the *next*
    // `[^...` (which would otherwise backtrack quadratically on inputs like `[^`.repeat(n)).
    str = str.replace(/\[\^([^\s\][]+)]/g, function (whole, rawLabel, offset, full) {
      // an escaped reference (`\[^id]`, an odd number of leading back-slashes) is literal
      let bs = 0, p = offset - 1;
      while (p >= 0 && full.charAt(p) === '\\') { bs++; p--; }
      if (bs % 2 === 1) {
        return whole;
      }
      let norm = showdown.helper.cmNormalizeLabel(rawLabel),
          fn = globals.gFootnotes[norm];
      if (showdown.helper.isUndefined(fn)) {
        return whole;
      }
      let ref = globals.gFootnoteRefs[norm];
      if (showdown.helper.isUndefined(ref)) {
        globals.gFootnoteOrder.push(norm);
        ref = globals.gFootnoteRefs[norm] = {
          number: globals.gFootnoteOrder.length,
          encId: showdown.helper.cmEncodeURI(fn.rawLabel),
          occurrences: 0
        };
      }
      ref.occurrences++;
      let idSuffix = (ref.occurrences === 1) ? '' : '-' + ref.occurrences,
          sup = '<sup class="footnote-ref"><a href="#fn-' + ref.encId +
            '" id="fnref-' + ref.encId + idSuffix + '" data-footnote-ref>' + ref.number + '</a></sup>';
      // `raw` (footnote bodies): emit the markup inline so the nested conversion keeps it;
      // otherwise (main text) hash it so the inline parser leaves it alone.
      return raw ? sup : showdown.helper._hashHTMLSpan(sup, globals);
    });

    // restore the protected code spans
    str = str.replace(/¨FN(\d+)¨/g, function (whole, n) { return spans[n]; });
    return str;
  }

  // ---- phase 2: render the referenced footnotes into a <section> ------------

  function buildSection (str) {
    let order = globals.gFootnoteOrder;
    if (!order || order.length === 0) {
      return str;
    }
    let items = '';
    for (let idx = 0; idx < order.length; idx++) {
      let norm = order[idx],
          fn = globals.gFootnotes[norm],
          ref = globals.gFootnoteRefs[norm],
          body = renderBody(fn.bodyRaw);
      body = insertBackrefs(body, buildBackrefs(ref));
      items += '<li id="fn-' + ref.encId + '">\n' + body + '\n</li>\n';
    }
    return str + '\n<section class="footnotes" data-footnotes>\n<ol>\n' + items + '</ol>\n</section>\n';
  }

  function renderBody (bodyRaw) {
    // Resolve any footnote references nested inside this body, continuing the document's
    // numbering (this may append further footnotes to the order, which buildSection's
    // loop then renders). They are emitted as raw <sup> markup so the nested conversion
    // preserves them.
    let body = replaceReferences(bodyRaw, true);
    // Render the (multi-block) body to complete HTML via a nested conversion. This runs
    // the full block pipeline (indented-code framing, fenced code, block quotes,
    // paragraphs) and leaves no hash placeholders behind, which matters because the
    // section is appended after the main paragraphs pass.
    return globals.converter.makeHtml(body).replace(/\n+$/, '');
  }

  function buildBackrefs (ref) {
    let parts = [];
    for (let j = 1; j <= ref.occurrences; j++) {
      let id = 'fnref-' + ref.encId + (j === 1 ? '' : '-' + j),
          idx = ref.number + (j === 1 ? '' : '-' + j),
          inner = (j === 1) ? '↩' : '↩<sup class="footnote-ref">' + j + '</sup>';
      parts.push('<a href="#' + id + '" class="footnote-backref" data-footnote-backref data-footnote-backref-idx="' +
        idx + '" aria-label="Back to reference ' + idx + '">' + inner + '</a>');
    }
    return parts.join(' ');
  }

  function insertBackrefs (body, backrefs) {
    if (/<\/p>\s*$/.test(body)) {
      return body.replace(/<\/p>\s*$/, ' ' + backrefs + '</p>');
    }
    return body + '\n' + backrefs;
  }
});

////
// makehtml/githubCodeBlock.js
// Copyright (c) 2018 ShowdownJS
//
// Handle github codeblocks prior to running HashHTML so that
// HTML contained within the codeblock gets escaped properly
// Example:
// ```ruby
// def hello_world(x)
//     puts "Hello, #{x}"
// end
// ```
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.githubCodeBlock', function (text, options, globals, topLevelOnly) {
  'use strict';

  // early exit if option is not enabled
  if (!options.ghCodeBlocks) {
    return text;
  }

  let startEvent = new showdown.Event('makehtml.githubCodeBlock.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output + '¨0';

  // In CommonMark container mode the converter-level pass restricts the *opening* fence to
  // indent 0; indent 1-3 opening fences are owned by the container parsers (a list item's /
  // block quote's own fence) or handled by a later blockGamut pass for true top-level ones.
  // This stops an item's indented opening/closing fence from being mistaken for a new
  // top-level opening fence. The closing fence keeps its 0-3 indent allowance either way.
  const open = topLevelOnly ? '' : ' {0,3}';
  //const accentRegex = /(?:^|\n) {0,3}(```+|~~~+) *([^\n\t`~]*)\n([\s\S]*?)(?:(\n {0,3}\1[`~]*)|¨0)/g;
  // The info string is the rest of the opening line. CommonMark forbids backticks only in a
  // *backtick* fence's info string (a tilde fence may contain backticks and tildes); that
  // restriction is enforced in parse() since it needs to know the fence type. The `(?!`)` /
  // `(?!~)` lookaheads keep the opening fence maximal: without them the now-permissive info
  // class lets the delimiter backtrack (e.g. `~~~~~~` splitting into a `~~~` fence + `~~~`
  // info), inventing a spurious shorter fence.
  const fence = '(```+(?!`)|~~~+(?!~))';
  const closedBlockRegex   = new RegExp('^' + open + fence + ' *([^\\n]*)\\n([\\s\\S]*?)\\n {0,3}\\1[`~]*', 'gm');
  const unclosedBlockRegex = new RegExp('^' + open + fence + ' *([^\\n]*)\\n([\\s\\S]*?)¨0', 'gm');
  const emptyBlockRegex    = new RegExp('^' + open + fence + ' *([^\\n]*)\\n {0,3}\\1[`~]*', 'gm');

  text = text.replace(closedBlockRegex, function (wholeMatch, delim, language, codeblock) {
    return parse(closedBlockRegex, wholeMatch, delim, language, codeblock);
  });

  text = text.replace(emptyBlockRegex, function (wholeMatch, delim, language) {
    return parse(emptyBlockRegex, wholeMatch, delim, language, '');
  });

  // In topLevelOnly mode, skip the unclosed (run-to-EOF) pass: a genuine indent-0 opener
  // pairs via the closed/empty passes above, whereas a lone indent-0 *closing* fence of an
  // indent 1-3 top-level block would otherwise be mistaken for an opener and swallow the
  // rest of the document. Such an indented top-level fence (and any truly unclosed one) is
  // handled by the 0-3 blockGamut pass that runs after the container parsers.
  if (!topLevelOnly) {
    text = text.replace(unclosedBlockRegex, function (wholeMatch, delim, language, codeblock) {
      return parse(unclosedBlockRegex, wholeMatch, delim, language, codeblock);
    });
  }

  // attacklab: strip sentinel
  text = text.replace(/¨0/, '');

  let afterEvent = new showdown.Event('makehtml.githubCodeBlock.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;


  function parse (pattern, wholeMatch, delim, language, codeblock) {
    // CommonMark: a backtick info string may not contain backticks (tilde fences may). When it
    // does, this is not a code block, so leave the text for inline/paragraph parsing.
    if (delim.charAt(0) === '`' && language.indexOf('`') !== -1) {
      return wholeMatch;
    }
    let end = (options.omitExtraWLInCodeBlocks) ? '' : '\n',
        otp,
        attributes = {
          pre: {},
          code: {},
        };

    let captureStartEvent = new showdown.Event('makehtml.githubCodeBlock.onCapture', codeblock);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(pattern)
      .setMatches({
        _whoteMatch: wholeMatch,
        codeblock: codeblock,
        infostring: language
      })
      .setAttributes(attributes);
    captureStartEvent = globals.converter.dispatch(captureStartEvent);

    // if something was passed as output, it takes precedence
    // and will be used as output
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      otp = captureStartEvent.output;

    } else {

      // First parse the github code block
      let infostring = captureStartEvent.matches.infostring;
      let lang = infostring.trim().split(' ')[0];
      // CommonMark resolves backslash escapes of ASCII punctuation in the info string
      if (options.decodeEntities) {
        lang = lang.replace(/\\([!-/:-@[-`{-~])/g, '$1');
      }
      // The language ends up inside the code element's `class` attribute, so escape the
      // characters that could break out of it. Otherwise an info string such as
      // `js"onmouseover="alert(1)` would close the attribute and inject an event handler (XSS).
      // `&` is intentionally left alone: the later decodeEntities pass resolves real entities
      // (e.g. `&ouml;`) for the class and re-escapes any that decode to `"`/`<`/`>`, so these
      // replacements survive it while a literal quote is neutralized in both modes.
      lang = lang
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
      codeblock = captureStartEvent.matches.codeblock;
      codeblock = showdown.subParser('makehtml.encodeCode')(codeblock, options, globals);
      //codeblock = showdown.subParser('makehtml.detab')(codeblock, options, globals);
      codeblock = codeblock
        .replace(/^\n+/g, '')  // trim leading newlines
        .replace(/\n+$/g, ''); // trim trailing whitespace

      attributes = captureStartEvent.attributes;
      otp = '<pre><code>';
      if (!showdown.helper.isUndefined(attributes)) {
        otp = '<pre' + showdown.helper._populateAttributes(attributes.pre) + '>';

        // if the language has spaces followed by some other chars, according to the spec we should just ignore everything
        // after the first space
        if (infostring) {
          if (!attributes.code) {
            attributes.code = {};
          }
          if (!attributes.code.classes) {
            attributes.code.classes = [];
          }

          if (attributes.code.classes) {
            if (showdown.helper.isString(attributes.code.classes)) {
              attributes.code.classes += ' ' + lang + ' language-' + lang;
            } else if (showdown.helper.isArray(attributes.code.classes)) {
              attributes.code.classes.push(lang);
              attributes.code.classes.push('language-' + lang);
            }
          }
        }

        otp += '<code' + showdown.helper._populateAttributes(attributes.code) + '>';
      }
      if (options.omitExtraWLInCodeBlocks) {
        end = '';
      }
      otp += codeblock + end + '</code></pre>';
    }

    let beforeHashEvent = new showdown.Event('makehtml.githubCodeBlock.onHash', otp);
    beforeHashEvent
      .setOutput(otp)
      ._setGlobals(globals)
      ._setOptions(options);
    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    otp = beforeHashEvent.output;
    otp = showdown.subParser('makehtml.hashBlock')(otp, options, globals);

    // Since GHCodeblocks can be false positives, we need to
    // store the primitive text and the parsed text in a global var,
    // and then return a token
    return '\n\n¨G' + (globals.ghCodeBlocks.push({text: wholeMatch, codeblock: otp}) - 1) + 'G\n\n';
  }


});

////
// makehtml/hardLineBreaks.js
// Copyright (c) 2022 ShowdownJS
//
// Transforms hard line breaks (trailing spaces / backslash) into `<br />` tags.
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////

showdown.subParser('makehtml.hardLineBreaks', function (text, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makehtml.hardLineBreaks.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  // Do hard breaks
  if (options.simpleLineBreaks) {
    // GFM style hard breaks
    // only add line breaks if the text does not contain a block (special case for lists)
    if (!/\n\n¨K/.test(text)) {
      text = text.replace(/\n+/gm, '<br />\n');
    }
  } else {
    // Vanilla hard breaks
    text = text.replace(/  +\n/g, '<br />\n');
  }
  text = text.replace(/\\\n/g, '<br />\n');

  let afterEvent = new showdown.Event('makehtml.hardLineBreaks.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;

});

////
// makehtml/hashBlock.js
// Copyright (c) 2018 ShowdownJS
//
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.hashBlock', function (text, options, globals) {
  'use strict';
  let startEvent = new showdown.Event('makehtml.hashBlock.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  text = text.replace(/(^\n+|\n+$)/g, '');
  text = '\n\n¨K' + (globals.gHtmlBlocks.push(text) - 1) + 'K\n\n';

  let afterEvent = new showdown.Event('makehtml.hashBlock.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

////
// makehtml/hashCodeTags.js
// Copyright (c) 2018 ShowdownJS
//
// Hash and escape <code> elements that should not be parsed as markdown
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.hashCodeTags', function (text, options, globals) {
  'use strict';
  let startEvent = new showdown.Event('makehtml.hashCodeTags.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  let repFunc = function (wholeMatch, match, left, right) {
    let codeblock = left + showdown.subParser('makehtml.encodeCode')(match, options, globals) + right;
    return '¨C' + (globals.gHtmlSpans.push(codeblock) - 1) + 'C';
  };

  // Hash naked <code>
  text = showdown.helper.replaceRecursiveRegExp(text, repFunc, '<code\\b[^>]*>', '</code>', 'gim');

  let afterEvent = new showdown.Event('makehtml.hashCodeTags.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

showdown.subParser('makehtml.hashElement', function (text, options, globals) {
  'use strict';

  return function (wholeMatch, m1) {
    let blockText = m1;

    // Undo double lines
    blockText = blockText.replace(/\n\n/g, '\n');
    blockText = blockText.replace(/^\n/, '');

    // strip trailing blank lines
    blockText = blockText.replace(/\n+$/g, '');

    // Replace the element text with a marker ("¨KxK" where x is its key)
    blockText = '\n\n¨K' + (globals.gHtmlBlocks.push(blockText) - 1) + 'K\n\n';

    return blockText;
  };
});

////
// makehtml/hashHTMLBlocks.js
// Copyright (c) 2018 ShowdownJS
//
// Hash HTML blocks
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.hashHTMLBlocks', function (text, options, globals, sourceMode) {
  'use strict';
  let startEvent = new showdown.Event('makehtml.hashHTMLBlocks.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  let blockTags = [
        'pre',
        'div',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'blockquote',
        'table',
        'dl',
        'ol',
        'ul',
        'script',
        'noscript',
        'form',
        'fieldset',
        'iframe',
        'math',
        'style',
        'section',
        'header',
        'footer',
        'nav',
        'article',
        'aside',
        'address',
        'audio',
        'canvas',
        'figure',
        'hgroup',
        'output',
        'video',
        'details',
        'p'
      ],
      repFunc = function (wholeMatch, match, left, right) {
        let txt = wholeMatch;
        // check if this html element is marked as markdown
        // if so, it's contents should be parsed as markdown
        if (left.search(/\bmarkdown\b/) !== -1) {
          txt = left + globals.converter.makeHtml(match) + right;
        }
        return '\n\n¨K' + (globals.gHtmlBlocks.push(txt) - 1) + 'K\n\n';
      };

  if (options.backslashEscapesHTMLTags) {
    // encode backslash escaped HTML tags
    text = text.replace(/\\<(\/?[^>]+?)>/g, function (wm, inside) {
      return '&lt;' + inside + '&gt;';
    });
  }

  // The CommonMark block scanner only applies to the original Markdown source
  // (the converter-level pass). blockGamut re-invokes this subparser on the markup
  // it has just generated to prevent <p>-wrapping; there the existing balanced-tag
  // hashing is correct (and must not over-consume generated block tags).
  if (options.cmSpec && sourceMode) {
    text = parseCmHTMLBlocks(text);

    let cmAfterEvent = new showdown.Event('makehtml.hashHTMLBlocks.onEnd', text);
    cmAfterEvent
      .setOutput(text)
      ._setGlobals(globals)
      ._setOptions(options);
    cmAfterEvent = globals.converter.dispatch(cmAfterEvent);
    return cmAfterEvent.output;
  }

  // hash HTML Blocks
  for (let i = 0; i < blockTags.length; ++i) {

    let opTagPos,
        rgx1     = new RegExp('^ {0,3}(<' + blockTags[i] + '\\b[^>]*>)', 'im'),
        patLeft  = '<' + blockTags[i] + '\\b[^>]*>',
        patRight = '</' + blockTags[i] + '>';
    // 1. Look for the first position of the first opening HTML tag in the text
    while ((opTagPos = showdown.helper.regexIndexOf(text, rgx1)) !== -1) {

      // if the HTML tag is \ escaped, we need to escape it and break


      //2. Split the text in that position
      let subTexts = showdown.helper.splitAtIndex(text, opTagPos),
          //3. Match recursively
          newSubText1 = showdown.helper.replaceRecursiveRegExp(subTexts[1], repFunc, patLeft, patRight, 'im');

      // prevent an infinite loop
      if (newSubText1 === subTexts[1]) {
        break;
      }
      text = subTexts[0].concat(newSubText1);
    }
  }
  // HR SPECIAL CASE
  text = text.replace(/(\n {0,3}(<(hr)\b([^<>])*?\/?>)[ \t]*(?=\n{2,}))/g,
    showdown.subParser('makehtml.hashElement')(text, options, globals));

  // Special case for standalone HTML comments
  // A comment is terminated by either `-->` or `--!>` (the HTML "comment end
  // bang" state). Matching only `-->` lets content an author believes is
  // commented-out leak through to the browser as live HTML (js/bad-tag-filter).
  text = showdown.helper.replaceRecursiveRegExp(text, function (txt) {
    return '\n\n¨K' + (globals.gHtmlBlocks.push(txt) - 1) + 'K\n\n';
  }, '^ {0,3}<!--', '--!?>', 'gm');

  // PHP and ASP-style processor instructions (<?...?> and <%...%>)
  text = text.replace(/\n\n( {0,3}<([?%])[^\r]*?\2>[ \t]*(?=\n{2,}))/g,
    showdown.subParser('makehtml.hashElement')(text, options, globals));

  let afterEvent = new showdown.Event('makehtml.hashHTMLBlocks.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;

  /**
   * CommonMark HTML blocks (spec section 4.6): a line-based scanner implementing the
   * 7 block types, each with its own start and end condition. Block content is hashed
   * verbatim (not parsed as Markdown). Types 1-6 may interrupt a paragraph; type 7
   * may only start at a block boundary (document start or after a blank line).
   * @param {string} str
   * @returns {string}
   */
  function parseCmHTMLBlocks (str) {
    const blockNames = 'address|article|aside|base|basefont|blockquote|body|caption|' +
      'center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|' +
      'footer|form|frame|frameset|h1|h2|h3|h4|h5|h6|head|header|hr|html|iframe|legend|' +
      'li|link|main|menu|menuitem|nav|noframes|ol|optgroup|option|p|param|section|' +
      'summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul';

    let type1Start = /^ {0,3}<(?:script|pre|style|textarea)(?:[ \t>]|$)/i,
        type1End   = /<\/(?:script|pre|style|textarea)>/i,
        type2Start = /^ {0,3}<!--/,
        type2End   = /-->/,
        type3Start = /^ {0,3}<\?/,
        type3End   = /\?>/,
        type4Start = /^ {0,3}<![A-Za-z]/,
        type4End   = />/,
        type5Start = /^ {0,3}<!\[CDATA\[/,
        type5End   = /]]>/,
        type6Start = new RegExp('^ {0,3}</?(?:' + blockNames + ')(?:[ \\t/>]|$)', 'i'),
        type7Start = new RegExp('^ {0,3}(?:' + showdown.helper.regexes.cmOpenTagSource + '|' +
                      showdown.helper.regexes.cmCloseTagSource + ')[ \\t]*$'),
        isBlank    = /^[ \t]*$/;

    function startType (line, prevBlank) {
      if (type1Start.test(line)) { return 1; }
      if (type2Start.test(line)) { return 2; }
      if (type3Start.test(line)) { return 3; }
      if (type5Start.test(line)) { return 5; }
      if (type4Start.test(line)) { return 4; }
      if (type6Start.test(line)) { return 6; }
      // type 7 cannot interrupt a paragraph
      if (prevBlank && type7Start.test(line)) { return 7; }
      return 0;
    }

    // a fenced-code opener (mirrors githubCodeBlock: an info string carries no backtick,
    // tilde or tab). A fenced code block takes precedence over an HTML block start, so its
    // interior lines must not be scanned for HTML block starts.
    let fenceOpen = /^ {0,3}(```+|~~~+) *[^`~\t]*$/;

    let lines = str.split('\n'),
        out = [],
        i = 0,
        prevBlank = true; // document start behaves like "after a blank line"

    while (i < lines.length) {
      let type = startType(lines[i], prevBlank);
      if (type === 0) {
        let fence = lines[i].match(fenceOpen);
        if (fence) {
          // consume the whole fenced region verbatim (closing fence inclusive, or EOF) so
          // an HTML-block-like line inside the fence cannot open an HTML block. The fence
          // itself is hashed later by githubCodeBlock.
          let closeRe = new RegExp('^ {0,3}[' + fence[1][0] + ']{' + fence[1].length + ',}[ \\t]*$');
          out.push(lines[i]);
          i++;
          while (i < lines.length) {
            out.push(lines[i]);
            if (closeRe.test(lines[i])) { i++; break; }
            i++;
          }
          prevBlank = false;
          continue;
        }
        out.push(lines[i]);
        prevBlank = isBlank.test(lines[i]);
        i++;
        continue;
      }

      let blockLines = [];
      if (type >= 1 && type <= 5) {
        // ends on (and includes) the line matching the end condition; may be the
        // start line itself
        let endRe = [null, type1End, type2End, type3End, type4End, type5End][type];
        while (i < lines.length) {
          let l = lines[i];
          blockLines.push(l);
          i++;
          if (endRe.test(l)) { break; }
        }
      } else {
        // types 6 and 7 end before the first following blank line (or at EOF)
        while (i < lines.length && !isBlank.test(lines[i])) {
          blockLines.push(lines[i]);
          i++;
        }
      }

      // wrap the placeholder in blank lines so later block parsing treats it as its
      // own block. A CommonMark HTML block is raw verbatim source: its content (including
      // any entities) must NOT be decoded, so it gets a distinct `¨R` marker and a separate
      // store, and is restored late - after decodeEntities - rather than being unhashed in
      // paragraphs like generated `¨K`/`¨G` blocks (which legitimately decode).
      out.push('\n¨R' + (globals.gHtmlRawBlocks.push(blockLines.join('\n')) - 1) + 'R\n');
      prevBlank = false;
    }

    return out.join('\n');
  }
});

////
// makehtml/hashHTMLSpans.js
// Copyright (c) 2018 ShowdownJS
//
// Hash span elements that should not be parsed as markdown
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.hashHTMLSpans', function (text, options, globals) {
  'use strict';
  let startEvent = new showdown.Event('makehtml.hashHTMLSpans.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  // NOTE: the self-closing character classes exclude `<` (`[^<>]` rather than `[^>]`) so a scan
  // for a tag's `>` can never run across the start of the *next* `<`. This keeps matching linear
  // on pathological input (`'<'.repeat(n)`) without changing results — a real tag has no bare `<`.

  // Hash Self Closing tags
  if (!options.cmSpec) {
    text = text.replace(/<[^<>]+?\/>/gi, function (wm) {
      return showdown.helper._hashHTMLSpan(wm, globals);
    });
  }

  // Hash whole `<tag …>…</tag>` spans. This is done with a forward cursor + an "absent close
  // tag" cache rather than a `<([^<>]+?)>[\s\S]*?<\/\1>` regex: that regex re-scans to EOF for a
  // matching `</tag>` at *every* `<` when none follows, which is O(n^2) on inputs like
  // `'<a>'.repeat(n)` or `'<a>'.repeat(n) + '</z>'`. The cursor scans each character once and, the
  // first time a given `</name>` is found to be absent ahead, never searches for it again. Two
  // passes preserve the old ordering/semantics: first tags whose *entire* `<…>` content is the
  // closing name (no attributes), then tags whose first token is the closing name (with attributes).
  text = hashPairedTags(text, 'full');
  text = hashPairedTags(text, 'name');

  // Hash self closing tags without />. In CommonMark raw-HTML mode the valid inline
  // raw HTML has already been hashed earlier (spanGamut); any `<…>` left here is
  // malformed and must NOT be hashed (it is escaped by encodeAmpsAndAngles instead).
  if (!options.cmSpec) {
    text = text.replace(/<[^<>]+?>/gi, function (wm) {
      return showdown.helper._hashHTMLSpan(wm, globals);
    });
  }

  /**
   * Hash `<open>…</close>` spans in a single linear pass.
   * @param {string} str
   * @param {'full'|'name'} mode `full`: the close tag name is the whole `<…>` content (tags
   *   without attributes); `name`: the content must contain whitespace and the close tag name
   *   is its first token (tags with attributes).
   * @returns {string}
   */
  function hashPairedTags (str, mode) {
    let out = '',
        i = 0,
        len = str.length,
        absent = Object.create(null);
    while (i < len) {
      if (str.charAt(i) !== '<') { out += str.charAt(i); i++; continue; }
      let gt = str.indexOf('>', i + 1);
      // a real open tag has a `>` and no `<` between `<` and `>`
      if (gt === -1) { out += str.charAt(i); i++; continue; }
      let inner = str.slice(i + 1, gt);
      if (inner.indexOf('<') !== -1) { out += str.charAt(i); i++; continue; }
      let closeName;
      if (mode === 'full') {
        if (inner.length === 0) { out += str.charAt(i); i++; continue; }
        closeName = inner;
      } else {
        let sp = inner.search(/\s/);
        if (sp <= 0) { out += str.charAt(i); i++; continue; }
        closeName = inner.slice(0, sp);
      }
      let closeStr = '</' + closeName + '>';
      if (absent[closeStr]) { out += str.charAt(i); i++; continue; }
      let ci = str.indexOf(closeStr, gt + 1);
      if (ci === -1) { absent[closeStr] = true; out += str.charAt(i); i++; continue; }
      out += showdown.helper._hashHTMLSpan(str.slice(i, ci + closeStr.length), globals);
      i = ci + closeStr.length;
    }
    return out;
  }

  let afterEvent = new showdown.Event('makehtml.hashHTMLSpans.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

////
// makehtml/githubCodeBlock.js
// Copyright (c) 2018 ShowdownJS
//
// Hash and escape <pre><code> elements that should not be parsed as markdown
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.hashPreCodeTags', function (text, options, globals) {
  'use strict';
  let startEvent = new showdown.Event('makehtml.hashPreCodeTags.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  let repFunc = function (wholeMatch, match, left, right) {
    // encode html entities
    let codeblock = left + showdown.subParser('makehtml.encodeCode')(match, options, globals) + right;
    return '\n\n¨G' + (globals.ghCodeBlocks.push({text: wholeMatch, codeblock: codeblock}) - 1) + 'G\n\n';
  };

  // Hash <pre><code>
  text = showdown.helper.replaceRecursiveRegExp(text, repFunc, '^ {0,3}<pre\\b[^>]*>\\s*<code\\b[^>]*>', '^ {0,3}</code>\\s*</pre>', 'gim');

  let afterEvent = new showdown.Event('makehtml.hashPreCodeTags.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

////
// makehtml/blockquote.js
// Copyright (c) 2018 ShowdownJS
//
// Transforms MD headings into `<h#>` html entities
//
// Setext-style headers:
//	Header 1
//	========
//
//	Header 2
//	--------
//
// atx-style headers:
//  # Header 1
//  ## Header 2
//  ## Header 2 with closing hashes ##
//  ...
//  ###### Header 6
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////
(function () {

  /**
   *
   * @param {string} subEvtName Heading style ('atx' or 'setext'), used to namespace the dispatched events
   * @param {RegExp} pattern
   * @param {string} wholeMatch
   * @param {string} headingText
   * @param {string} headingLevel
   * @param {string} headingId
   * @param {{}} options
   * @param {{}} globals
   * @returns {string}
   */
  function parseHeader (subEvtName, pattern, wholeMatch, headingText, headingLevel, headingId, options, globals) {
    let captureStartEvent = new showdown.Event('makehtml.heading.' + subEvtName + '.onCapture', headingText),
        otp;

    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(pattern)
      .setMatches({
        _wholeMatch: wholeMatch,
        heading: headingText
      })
      .setAttributes({
        id: headingId
      });
    captureStartEvent = globals.converter.dispatch(captureStartEvent);
    // if something was passed as output, it takes precedence
    // and will be used as output
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      otp = captureStartEvent.output;

    } else {
      headingText = captureStartEvent.matches.heading;
      let spanGamut = showdown.subParser('makehtml.spanGamut')(headingText, options, globals),
          attributes = captureStartEvent.attributes;
      otp = '<h' + headingLevel + showdown.helper._populateAttributes(attributes) + '>' + spanGamut + '</h' + headingLevel + '>';
    }

    let beforeHashEvent = new showdown.Event('makehtml.heading.' + subEvtName + '.onHash', otp);
    beforeHashEvent
      .setOutput(otp)
      ._setGlobals(globals)
      ._setOptions(options);
    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    otp = beforeHashEvent.output;

    return showdown.subParser('makehtml.hashBlock')(otp, options, globals);
  }

  showdown.subParser('makehtml.heading', function (text, options, globals) {
    'use strict';

    let startEvent = new showdown.Event('makehtml.heading.onStart', text);
    startEvent
      .setOutput(text)
      ._setGlobals(globals)
      ._setOptions(options);
    startEvent = globals.converter.dispatch(startEvent);
    text = startEvent.output;

    text = showdown.subParser('makehtml.heading.setext')(text, options, globals);
    text = showdown.subParser('makehtml.heading.atx')(text, options, globals);

    let afterEvent = new showdown.Event('makehtml.heading.onEnd', text);
    afterEvent
      .setOutput(text)
      ._setGlobals(globals)
      ._setOptions(options);
    afterEvent = globals.converter.dispatch(afterEvent);
    return afterEvent.output;

  });

  // Normalize the `headerIds` option into {enabled, prefix, raw}. Accepts `false`
  // (no ids), an object `{prefix, raw}`, or `true`/undefined (github ids, no prefix).
  function resolveHeaderIds (opt) {
    if (opt === false) {
      return { enabled: false, prefix: '', raw: false };
    }
    if (showdown.helper.isObject(opt)) {
      return {
        enabled: true,
        prefix: showdown.helper.isString(opt.prefix) ? opt.prefix : '',
        raw: !!opt.raw
      };
    }
    // true / null / undefined / anything else: default github ids, no prefix
    return { enabled: true, prefix: '', raw: false };
  }

  showdown.subParser('makehtml.heading.id', function (m, options, globals) {
    let title;

    let cfg = resolveHeaderIds(options.headerIds);
    // when ids are disabled the caller omits the attribute entirely
    if (!cfg.enabled) {
      return null;
    }

    // Prefix id to prevent causing inadvertent pre-existing style matches.
    title = cfg.prefix + m;

    if (cfg.raw) {
      // minimal sanitization: only spaces, ', ", > and < become dashes (the prefix is
      // included, so it gets the same treatment). WARNING: may produce malformed ids.
      title = title
        .replace(/ /g, '-')
        // replace previously escaped chars (&, ¨ and $)
        .replace(/&amp;/g, '&')
        .replace(/¨T/g, '¨')
        .replace(/¨D/g, '$')
        // replace ", ', > and <
        .replace(/["'><]/g, '-')
        .toLowerCase();
    } else {
      // default: GitHub-compatible ids (spaces become dashes, non-alphanumeric chars
      // are stripped). Borrowed from github's redcarpet so results are similar.
      title = title
        .replace(/ /g, '-')
        // replace previously escaped chars (&, ¨ and $)
        .replace(/&amp;/g, '')
        .replace(/¨T/g, '')
        .replace(/¨D/g, '')
        // replace rest of the chars (&~$ are repeated as they might have been escaped)
        .replace(/[&+$,/:;=?@"#{}|^¨¿？：~[\]`、゠＝…‥『』〝〟「」\\*()｛｝（）［］【】%.。，¡!！'<>]/g, '')
        .toLowerCase();
    }

    if (globals.hashLinkCounts[title]) {
      title = title + '-' + (globals.hashLinkCounts[title]++);
    } else {
      globals.hashLinkCounts[title] = 1;
    }
    return title;
  });

  showdown.subParser('makehtml.heading.setext', function (text, options, globals) {

    let startEvent = new showdown.Event('makehtml.heading.setext.onStart', text);
    startEvent
      .setOutput(text)
      ._setGlobals(globals)
      ._setOptions(options);
    startEvent = globals.converter.dispatch(startEvent);
    text = startEvent.output;

    // NOTE: the first line is `[^ \t\n].*` (single leading non-space + rest) rather
    // than `[^ \t\n]+.*`. The latter has two overlapping greedy quantifiers that can
    // consume the same characters, causing O(n^2) backtracking on a long line with no
    // trailing underline (a DoS via any long whitespace-free input). The two forms
    // match the same set of lines and capture the same substring.
    const setextRegexH1 = /^( {0,3}([^ \t\n].*\n)(.+\n)?(.+\n)?)( {0,3}=+[ \t]*)$/gm,
        setextRegexH2 = /^( {0,3}([^ \t\n].*\n)(.+\n)?(.+\n)?)( {0,3}(-+)[ \t]*)$/gm;

    // CommonMark: a setext heading's text is a paragraph, so the line(s) before the
    // underline may not begin another kind of block. Since setext runs before the
    // list/block-quote parsers in blockGamut, a `-` underline would otherwise steal
    // list-item lines (e.g. `- foo\n-`). When commonmarkLists is enabled, skip the
    // match if the heading text starts a list item or block quote; the container
    // parsers then handle those lines (and any genuine underline inside an item).
    function cmSkipSetext (headingText) {
      let first = headingText.split('\n')[0];
      return /^ {0,3}(?:[-+*]|\d{1,9}[.)])(?:[ \t]|$)/.test(first) ||
             /^ {0,3}>/.test(first) ||
             // a fenced-code opener is a leaf block, not setext paragraph text. In container
             // mode the converter-level fence pass leaves indent 1-3 fences for the block
             // parsers, so they can reach setext here; let the fence (and any container
             // marker below it) be claimed by the block/container parsers instead.
             /^ {0,3}(?:```|~~~)/.test(first);
    }

    text = text.replace(setextRegexH1, function (wholeMatch, headingText, line1, line2, line3, line4) {
      if (options.cmSpec && cmSkipSetext(headingText)) { return wholeMatch; }
      return parseSetextHeading(setextRegexH2, options.headerLevelStart, wholeMatch, headingText, line1, line2, line3, line4);
    });

    text = text.replace(setextRegexH2, function (wholeMatch, headingText, line1, line2, line3, line4) {
      if (options.cmSpec && cmSkipSetext(headingText)) { return wholeMatch; }
      return parseSetextHeading(setextRegexH2, options.headerLevelStart + 1, wholeMatch, headingText, line1, line2, line3, line4);
    });

    let afterEvent = new showdown.Event('makehtml.heading.setext.onEnd', text);
    afterEvent
      .setOutput(text)
      ._setGlobals(globals)
      ._setOptions(options);
    afterEvent = globals.converter.dispatch(afterEvent);

    return showdown.subParser('makehtml.hashHTMLBlocks')(afterEvent.output, options, globals);


    function parseSetextHeading (pattern, headingLevel, wholeMatch, headingText, line1, line2, line3, line4) {

      // count lines
      let count = headingText.trim().split('\n').length;
      let prepend = '';
      let nPrepend;
      const hrCheckRgx = /^ {0,3}[-_*]([-_*] ?){2,}$/;

      // one liner edge cases
      if (count === 1) {
        // hr
        // let's find the hr edge case first
        if (showdown.helper.trimEnd(line1).match(hrCheckRgx)) {
          // it's the edge case, so it's a false positive
          prepend = showdown.subParser('makehtml.horizontalRule')(line1, options, globals);
          if (prepend !== line1) {
            // it's an oneliner list
            return prepend.trim() + '\n' + line4;
          }
        }

        // now check if it's an unordered list
        if (line1.match(/^ {0,3}[-*+][ \t]/)) {
          if (line4.trim().match(/^=+/)) {
            line1 += line4;
          }
          prepend = showdown.subParser('makehtml.list')(line1, options, globals);
          if (prepend !== line1) {
            // it's an oneliner list
            return prepend.trim() + '\n' + line4;
          }
        }

        // check if it's a blockquote
        if (line1.match(/^ {0,3}>[ \t]?[^ \t]/)) {
          if (line4.trim().match(/^=+/)) {
            line1 += line4;
          }
          prepend = showdown.subParser('makehtml.blockquote')(line1, options, globals);
          if (prepend !== line1) {
            // it's an oneliner blockquote
            return prepend.trim() + '\n' + line4;
          }
        }

        // no edge case let's proceed as usual
      } else {
        let multilineText;

        // multiline is a bit trickier
        // first we must take care of the edge cases of:
        // case1: |  case2:
        // ---    |  ---
        // foo    |  foo
        // ---    |  bar
        //        |  ---
        //
        if (showdown.helper.trimEnd(line1).match(hrCheckRgx)) {
          nPrepend  = showdown.subParser('makehtml.horizontalRule')(line1, options, globals);
          if (nPrepend !== line1) {
            line1 = '';
            // we add the parsed block to prepend
            prepend = nPrepend.trim();
            // and remove the line from the headingText, so it doesn't appear repeated
            headingText = line2 + ((line3) ? line3 : '');
          }
        }

        // now we take care of these cases:
        // case1: |  case2:
        // foo    |  foo
        // ***    |  ***
        // ---    |  bar
        //        |  ---
        //
        if (showdown.helper.trimEnd(line2).match(hrCheckRgx)) {
          // This case sucks, because the first line could be anything!!!
          // first let's make sure it's a hr
          nPrepend  = showdown.subParser('makehtml.horizontalRule')(line2, options, globals);
          if (nPrepend !== line2) {
            line2 = nPrepend;
            // it is, so now we must parse line1 also
            if (line1) {
              line1 = showdown.subParser('makehtml.blockGamut')(line1, options, globals);
              line1 = showdown.subParser('makehtml.paragraphs')(line1, options, globals);
              line1 = line1.trim() + '\n';
              prepend = line1;
              // and clear line1
              line1 = '';
            }
            // we add the parsed blocks to prepend
            prepend += line2.trim() + '\n';
            line2 = '';
            // and remove the lines from the headingText, so it doesn't appear repeated
            headingText = (line3) ? line3 : '';
          }
        }

        // all edge cases should be treated now
        multilineText = line1 + line2 + ((line3) ? line3 : '');
        //if (line4.trim().match(/^=+/)) {
        //  multilineText += line4;
        //}

        nPrepend = showdown.subParser('makehtml.blockGamut')(multilineText, options, globals, 'makehtml.heading.setext');
        if (nPrepend !== multilineText) {
          // we found one or more blocks, so we need to reparse (blocks should take precendence though)
          nPrepend = showdown.helper.trimEnd(nPrepend);
          // let's check if the last line is a parsed block
          let newLines = nPrepend.trim().split('\n');
          let nLastLine = newLines.pop().toString();

          if (/^¨K\d+K$/.test(nLastLine) || /^\s*$/gm.test(nLastLine)) {
            // everything before --- or === is a block or empty line, so it's a false positive
            prepend += nPrepend + '\n\n';
            headingText = '';
          } else {
            // the last line is something else... so let's look at the line before that
            let toHeading = nLastLine;
            nLastLine = newLines.pop().toString();
            if (/^¨K\d+K$/.test(nLastLine) === false && /^\s*$/gm.test(nLastLine) === false) {
              toHeading = nLastLine + '\n' + toHeading;
            }
            headingText = toHeading;
            prepend = newLines.join('\n').trim();
          }
        }
      }

      // trim stuff
      headingText = headingText.trim();

      // let's check if heading is empty
      // after looking for blocks, heading text might be empty which is a false positive
      if (!headingText) {
        return prepend + line4;
      }

      // after this, we're pretty sure it's a heading so let's proceed
      // (the id subparser returns null when the headerIds option disables ids)
      let id = showdown.subParser('makehtml.heading.id')(headingText, options, globals);
      return prepend + parseHeader('setext', pattern, wholeMatch, headingText, headingLevel, id, options, globals);
    }


  });

  // Strip a trailing ATX closing sequence — `[ \t]*#*[ \t]*` — from a heading's text, computed
  // right-to-left in linear time (a regex `/[ \t]*#*[ \t]*$/` would itself backtrack quadratically
  // while searching for the match position). If the whole text is strippable (e.g. `# ###`), the
  // legacy lazy regex kept the first character, so we do the same.
  function stripAtxClosingSequence (str) {
    let end = str.length;
    while (end > 0 && (str.charAt(end - 1) === ' ' || str.charAt(end - 1) === '\t')) { end--; }
    while (end > 0 && str.charAt(end - 1) === '#') { end--; }
    while (end > 0 && (str.charAt(end - 1) === ' ' || str.charAt(end - 1) === '\t')) { end--; }
    let stripped = str.slice(0, end);
    return stripped === '' ? str.charAt(0) : stripped;
  }

  showdown.subParser('makehtml.heading.atx', function (text, options, globals) {

    let startEvent = new showdown.Event('makehtml.heading.atx.onStart', text);
    startEvent
      .setOutput(text)
      ._setGlobals(globals)
      ._setOptions(options);
    startEvent = globals.converter.dispatch(startEvent);
    text = startEvent.output;

    // The default variant captures the heading text greedily (`(.+)$`) and strips the optional
    // trailing closing-hash sequence (of ANY length, per CommonMark) in code below. The old
    // `(.+?)[ \t]*#*[ \t]*$` form backtracked quadratically on a line of many `#` followed by
    // text (e.g. `'#'.repeat(n) + ' h'`), because the lazy text capture re-scanned the `#` run
    // at every position. The requireSpace variant already can't backtrack that way (its `[ \t]+`
    // after the opening hashes fails fast on a pure/`#`-prefixed line), so it is left unchanged.
    const atxRegex = (options.requireSpaceBeforeHeadingText) ? /^ {0,3}(#{1,6})[ \t]+(.+?)(?:[ \t]+#+)?[ \t]*$/gm : /^ {0,3}(#{1,6})[ \t]*(.+)$/gm;
    const stripClosing = !options.requireSpaceBeforeHeadingText;
    text = text.replace(atxRegex, function (wholeMatch, m1, m2) {
      let headingText = stripClosing ? stripAtxClosingSequence(m2) : m2,
          headingLevel = options.headerLevelStart - 1 + m1.length,
          // the id subparser returns null when the headerIds option disables ids
          id = showdown.subParser('makehtml.heading.id')(headingText, options, globals);
      return parseHeader('atx', atxRegex, wholeMatch, headingText, headingLevel, id, options, globals);
    });

    let afterEvent = new showdown.Event('makehtml.heading.atx.onEnd', text);
    afterEvent
      .setOutput(text)
      ._setGlobals(globals)
      ._setOptions(options);
    afterEvent = globals.converter.dispatch(afterEvent);

    return showdown.subParser('makehtml.hashHTMLBlocks')(afterEvent.output, options, globals);

  });

})();

////
// makehtml/blockquote.js
// Copyright (c) 2018 ShowdownJS
//
// Turn Markdown horizontal rule shortcuts into <hr /> tags.
//
// Any 3 or more unindented consecutive hyphens, asterisks or underscores with or without a space beetween them
// in a single line is considered a horizontal rule
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////
showdown.subParser('makehtml.horizontalRule', function (text, options, globals) {
  'use strict';
  let startEvent = new showdown.Event('makehtml.horizontalRule.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;


  // CommonMark: an *indented* line of consecutive dashes that directly follows a
  // non-blank line is a setext underline inside a list item (e.g. `- Bar\n  ---`),
  // not a thematic break. When commonmarkLists is on, leave it for the list/setext
  // parsers. An unindented `---` after a list item is still a real thematic break
  // (it ends the list), and a spaced form like `- - -` is never an underline.
  function isSetextUnderlineDash (wholeMatch, args) {
    if (!options.cmSpec || !/^ +-+[ \t]*$/.test(wholeMatch)) { return false; }
    return precededByNonBlank(args[args.length - 1], args[args.length - 2]);
  }

  // parses: --- and - - -
  const rgx1 = /^ {0,2}( ?-){3,}[ \t]*$/gm;
  text = text.replace(rgx1, function (wholeMatch) {
    if (isSetextUnderlineDash(wholeMatch, arguments)) { return wholeMatch; }
    return parse(rgx1, wholeMatch);
  });
  // parses: -\t-\t-
  const rgx2 = /^ {0,3}-(\t?-){2,}[ \t]*$/gm;
  text = text.replace(rgx2, function (wholeMatch) {
    if (isSetextUnderlineDash(wholeMatch, arguments)) { return wholeMatch; }
    return parse(rgx2, wholeMatch);
  });

  const rgx3 = /^ {0,2}( ?\*){3,}[ \t]*$/gm;
  text = text.replace(rgx3, function (wholeMatch) {
    return parse(rgx3, wholeMatch);
  });
  const rgx4 = /^ {0,3}\*(\t?\*){2,}[ \t]*$/gm;
  text = text.replace(rgx4, function (wholeMatch) {
    return parse(rgx4, wholeMatch);
  });


  const rgx5 = /^ {0,2}( ?_){3,}[ \t]*$/gm;
  text = text.replace(rgx5, function (wholeMatch) {
    return parse(rgx5, wholeMatch);
  });
  const rgx6 = /^ {0,3}_(\t?_){2,}[ \t]*$/gm;
  text = text.replace(rgx6, function (wholeMatch) {
    return parse(rgx6, wholeMatch);
  });

  // super weird horizontal rule

  const rgx7 = /^ {0,3}(- *){2,}-[ \t]*$/gm;
  text = text.replace(rgx7, function (wholeMatch) {
    if (isSetextUnderlineDash(wholeMatch, arguments)) { return wholeMatch; }
    return parse(rgx7, wholeMatch);
  });
  const rgx8 = /^ {0,3}(\* *){2,}\*[ \t]*$/gm;
  text = text.replace(rgx8, function (wholeMatch) {
    return parse(rgx8, wholeMatch);
  });
  const rgx9 = /^ {0,3}(_ *){2,}_[ \t]*$/gm;
  text = text.replace(rgx9, function (wholeMatch) {
    return parse(rgx9, wholeMatch);
  });

  let afterEvent = new showdown.Event('makehtml.horizontalRule.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;

  /**
   * Whether the line preceding the match at `offset` is non-blank.
   * @param {string} str
   * @param {number} offset start index of the matched line (a line start)
   * @returns {boolean}
   */
  function precededByNonBlank (str, offset) {
    if (offset === 0) { return false; }
    let end = offset - 1, // index of the newline ending the previous line
        start = str.lastIndexOf('\n', end - 1) + 1;
    return str.slice(start, end).trim() !== '';
  }

  /**
   *
   * @param {RegExp} pattern
   * @param {string} wholeMatch
   * @returns {string}
   */
  function parse (pattern, wholeMatch) {
    let otp;
    let captureStartEvent = new showdown.Event('makehtml.horizontalRule.onCapture', wholeMatch);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(pattern)
      .setMatches({
        _whoteMatch: wholeMatch
      })
      .setAttributes({});
    captureStartEvent = globals.converter.dispatch(captureStartEvent);

    // if something was passed as output, it takes precedence
    // and will be used as output
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      otp = captureStartEvent.output;
    } else {
      otp = '<hr' + showdown.helper._populateAttributes(captureStartEvent.attributes) + ' />';
    }

    let beforeHashEvent = new showdown.Event('makehtml.horizontalRule.onHash', otp);
    beforeHashEvent
      .setOutput(otp)
      ._setGlobals(globals)
      ._setOptions(options);
    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    otp = beforeHashEvent.output;
    otp = showdown.subParser('makehtml.hashBlock')(otp, options, globals);
    return otp;
  }

});

////
// makehtml/htmlEntities.js
// Copyright (c) 2024 ShowdownJS
//
// HTML5 named character reference table (name -> replacement string).
// Generated from the WHATWG HTML5 named character reference set.
// Used by makehtml.decodeEntities to resolve &name; references (CommonMark).
////

showdown.helper.htmlEntities = {
  'AElig': 'Æ',
  'AMP': '&',
  'Aacute': 'Á',
  'Abreve': 'Ă',
  'Acirc': 'Â',
  'Acy': 'А',
  'Afr': '𝔄',
  'Agrave': 'À',
  'Alpha': 'Α',
  'Amacr': 'Ā',
  'And': '⩓',
  'Aogon': 'Ą',
  'Aopf': '𝔸',
  'ApplyFunction': '⁡',
  'Aring': 'Å',
  'Ascr': '𝒜',
  'Assign': '≔',
  'Atilde': 'Ã',
  'Auml': 'Ä',
  'Backslash': '∖',
  'Barv': '⫧',
  'Barwed': '⌆',
  'Bcy': 'Б',
  'Because': '∵',
  'Bernoullis': 'ℬ',
  'Beta': 'Β',
  'Bfr': '𝔅',
  'Bopf': '𝔹',
  'Breve': '˘',
  'Bscr': 'ℬ',
  'Bumpeq': '≎',
  'CHcy': 'Ч',
  'COPY': '©',
  'Cacute': 'Ć',
  'Cap': '⋒',
  'CapitalDifferentialD': 'ⅅ',
  'Cayleys': 'ℭ',
  'Ccaron': 'Č',
  'Ccedil': 'Ç',
  'Ccirc': 'Ĉ',
  'Cconint': '∰',
  'Cdot': 'Ċ',
  'Cedilla': '¸',
  'CenterDot': '·',
  'Cfr': 'ℭ',
  'Chi': 'Χ',
  'CircleDot': '⊙',
  'CircleMinus': '⊖',
  'CirclePlus': '⊕',
  'CircleTimes': '⊗',
  'ClockwiseContourIntegral': '∲',
  'CloseCurlyDoubleQuote': '”',
  'CloseCurlyQuote': '’',
  'Colon': '∷',
  'Colone': '⩴',
  'Congruent': '≡',
  'Conint': '∯',
  'ContourIntegral': '∮',
  'Copf': 'ℂ',
  'Coproduct': '∐',
  'CounterClockwiseContourIntegral': '∳',
  'Cross': '⨯',
  'Cscr': '𝒞',
  'Cup': '⋓',
  'CupCap': '≍',
  'DD': 'ⅅ',
  'DDotrahd': '⤑',
  'DJcy': 'Ђ',
  'DScy': 'Ѕ',
  'DZcy': 'Џ',
  'Dagger': '‡',
  'Darr': '↡',
  'Dashv': '⫤',
  'Dcaron': 'Ď',
  'Dcy': 'Д',
  'Del': '∇',
  'Delta': 'Δ',
  'Dfr': '𝔇',
  'DiacriticalAcute': '´',
  'DiacriticalDot': '˙',
  'DiacriticalDoubleAcute': '˝',
  'DiacriticalGrave': '`',
  'DiacriticalTilde': '˜',
  'Diamond': '⋄',
  'DifferentialD': 'ⅆ',
  'Dopf': '𝔻',
  'Dot': '¨',
  'DotDot': '⃜',
  'DotEqual': '≐',
  'DoubleContourIntegral': '∯',
  'DoubleDot': '¨',
  'DoubleDownArrow': '⇓',
  'DoubleLeftArrow': '⇐',
  'DoubleLeftRightArrow': '⇔',
  'DoubleLeftTee': '⫤',
  'DoubleLongLeftArrow': '⟸',
  'DoubleLongLeftRightArrow': '⟺',
  'DoubleLongRightArrow': '⟹',
  'DoubleRightArrow': '⇒',
  'DoubleRightTee': '⊨',
  'DoubleUpArrow': '⇑',
  'DoubleUpDownArrow': '⇕',
  'DoubleVerticalBar': '∥',
  'DownArrow': '↓',
  'DownArrowBar': '⤓',
  'DownArrowUpArrow': '⇵',
  'DownBreve': '̑',
  'DownLeftRightVector': '⥐',
  'DownLeftTeeVector': '⥞',
  'DownLeftVector': '↽',
  'DownLeftVectorBar': '⥖',
  'DownRightTeeVector': '⥟',
  'DownRightVector': '⇁',
  'DownRightVectorBar': '⥗',
  'DownTee': '⊤',
  'DownTeeArrow': '↧',
  'Downarrow': '⇓',
  'Dscr': '𝒟',
  'Dstrok': 'Đ',
  'ENG': 'Ŋ',
  'ETH': 'Ð',
  'Eacute': 'É',
  'Ecaron': 'Ě',
  'Ecirc': 'Ê',
  'Ecy': 'Э',
  'Edot': 'Ė',
  'Efr': '𝔈',
  'Egrave': 'È',
  'Element': '∈',
  'Emacr': 'Ē',
  'EmptySmallSquare': '◻',
  'EmptyVerySmallSquare': '▫',
  'Eogon': 'Ę',
  'Eopf': '𝔼',
  'Epsilon': 'Ε',
  'Equal': '⩵',
  'EqualTilde': '≂',
  'Equilibrium': '⇌',
  'Escr': 'ℰ',
  'Esim': '⩳',
  'Eta': 'Η',
  'Euml': 'Ë',
  'Exists': '∃',
  'ExponentialE': 'ⅇ',
  'Fcy': 'Ф',
  'Ffr': '𝔉',
  'FilledSmallSquare': '◼',
  'FilledVerySmallSquare': '▪',
  'Fopf': '𝔽',
  'ForAll': '∀',
  'Fouriertrf': 'ℱ',
  'Fscr': 'ℱ',
  'GJcy': 'Ѓ',
  'GT': '>',
  'Gamma': 'Γ',
  'Gammad': 'Ϝ',
  'Gbreve': 'Ğ',
  'Gcedil': 'Ģ',
  'Gcirc': 'Ĝ',
  'Gcy': 'Г',
  'Gdot': 'Ġ',
  'Gfr': '𝔊',
  'Gg': '⋙',
  'Gopf': '𝔾',
  'GreaterEqual': '≥',
  'GreaterEqualLess': '⋛',
  'GreaterFullEqual': '≧',
  'GreaterGreater': '⪢',
  'GreaterLess': '≷',
  'GreaterSlantEqual': '⩾',
  'GreaterTilde': '≳',
  'Gscr': '𝒢',
  'Gt': '≫',
  'HARDcy': 'Ъ',
  'Hacek': 'ˇ',
  'Hat': '^',
  'Hcirc': 'Ĥ',
  'Hfr': 'ℌ',
  'HilbertSpace': 'ℋ',
  'Hopf': 'ℍ',
  'HorizontalLine': '─',
  'Hscr': 'ℋ',
  'Hstrok': 'Ħ',
  'HumpDownHump': '≎',
  'HumpEqual': '≏',
  'IEcy': 'Е',
  'IJlig': 'Ĳ',
  'IOcy': 'Ё',
  'Iacute': 'Í',
  'Icirc': 'Î',
  'Icy': 'И',
  'Idot': 'İ',
  'Ifr': 'ℑ',
  'Igrave': 'Ì',
  'Im': 'ℑ',
  'Imacr': 'Ī',
  'ImaginaryI': 'ⅈ',
  'Implies': '⇒',
  'Int': '∬',
  'Integral': '∫',
  'Intersection': '⋂',
  'InvisibleComma': '⁣',
  'InvisibleTimes': '⁢',
  'Iogon': 'Į',
  'Iopf': '𝕀',
  'Iota': 'Ι',
  'Iscr': 'ℐ',
  'Itilde': 'Ĩ',
  'Iukcy': 'І',
  'Iuml': 'Ï',
  'Jcirc': 'Ĵ',
  'Jcy': 'Й',
  'Jfr': '𝔍',
  'Jopf': '𝕁',
  'Jscr': '𝒥',
  'Jsercy': 'Ј',
  'Jukcy': 'Є',
  'KHcy': 'Х',
  'KJcy': 'Ќ',
  'Kappa': 'Κ',
  'Kcedil': 'Ķ',
  'Kcy': 'К',
  'Kfr': '𝔎',
  'Kopf': '𝕂',
  'Kscr': '𝒦',
  'LJcy': 'Љ',
  'LT': '<',
  'Lacute': 'Ĺ',
  'Lambda': 'Λ',
  'Lang': '⟪',
  'Laplacetrf': 'ℒ',
  'Larr': '↞',
  'Lcaron': 'Ľ',
  'Lcedil': 'Ļ',
  'Lcy': 'Л',
  'LeftAngleBracket': '⟨',
  'LeftArrow': '←',
  'LeftArrowBar': '⇤',
  'LeftArrowRightArrow': '⇆',
  'LeftCeiling': '⌈',
  'LeftDoubleBracket': '⟦',
  'LeftDownTeeVector': '⥡',
  'LeftDownVector': '⇃',
  'LeftDownVectorBar': '⥙',
  'LeftFloor': '⌊',
  'LeftRightArrow': '↔',
  'LeftRightVector': '⥎',
  'LeftTee': '⊣',
  'LeftTeeArrow': '↤',
  'LeftTeeVector': '⥚',
  'LeftTriangle': '⊲',
  'LeftTriangleBar': '⧏',
  'LeftTriangleEqual': '⊴',
  'LeftUpDownVector': '⥑',
  'LeftUpTeeVector': '⥠',
  'LeftUpVector': '↿',
  'LeftUpVectorBar': '⥘',
  'LeftVector': '↼',
  'LeftVectorBar': '⥒',
  'Leftarrow': '⇐',
  'Leftrightarrow': '⇔',
  'LessEqualGreater': '⋚',
  'LessFullEqual': '≦',
  'LessGreater': '≶',
  'LessLess': '⪡',
  'LessSlantEqual': '⩽',
  'LessTilde': '≲',
  'Lfr': '𝔏',
  'Ll': '⋘',
  'Lleftarrow': '⇚',
  'Lmidot': 'Ŀ',
  'LongLeftArrow': '⟵',
  'LongLeftRightArrow': '⟷',
  'LongRightArrow': '⟶',
  'Longleftarrow': '⟸',
  'Longleftrightarrow': '⟺',
  'Longrightarrow': '⟹',
  'Lopf': '𝕃',
  'LowerLeftArrow': '↙',
  'LowerRightArrow': '↘',
  'Lscr': 'ℒ',
  'Lsh': '↰',
  'Lstrok': 'Ł',
  'Lt': '≪',
  'Map': '⤅',
  'Mcy': 'М',
  'MediumSpace': ' ',
  'Mellintrf': 'ℳ',
  'Mfr': '𝔐',
  'MinusPlus': '∓',
  'Mopf': '𝕄',
  'Mscr': 'ℳ',
  'Mu': 'Μ',
  'NJcy': 'Њ',
  'Nacute': 'Ń',
  'Ncaron': 'Ň',
  'Ncedil': 'Ņ',
  'Ncy': 'Н',
  'NegativeMediumSpace': '​',
  'NegativeThickSpace': '​',
  'NegativeThinSpace': '​',
  'NegativeVeryThinSpace': '​',
  'NestedGreaterGreater': '≫',
  'NestedLessLess': '≪',
  'NewLine': '\n',
  'Nfr': '𝔑',
  'NoBreak': '⁠',
  'NonBreakingSpace': ' ',
  'Nopf': 'ℕ',
  'Not': '⫬',
  'NotCongruent': '≢',
  'NotCupCap': '≭',
  'NotDoubleVerticalBar': '∦',
  'NotElement': '∉',
  'NotEqual': '≠',
  'NotEqualTilde': '≂̸',
  'NotExists': '∄',
  'NotGreater': '≯',
  'NotGreaterEqual': '≱',
  'NotGreaterFullEqual': '≧̸',
  'NotGreaterGreater': '≫̸',
  'NotGreaterLess': '≹',
  'NotGreaterSlantEqual': '⩾̸',
  'NotGreaterTilde': '≵',
  'NotHumpDownHump': '≎̸',
  'NotHumpEqual': '≏̸',
  'NotLeftTriangle': '⋪',
  'NotLeftTriangleBar': '⧏̸',
  'NotLeftTriangleEqual': '⋬',
  'NotLess': '≮',
  'NotLessEqual': '≰',
  'NotLessGreater': '≸',
  'NotLessLess': '≪̸',
  'NotLessSlantEqual': '⩽̸',
  'NotLessTilde': '≴',
  'NotNestedGreaterGreater': '⪢̸',
  'NotNestedLessLess': '⪡̸',
  'NotPrecedes': '⊀',
  'NotPrecedesEqual': '⪯̸',
  'NotPrecedesSlantEqual': '⋠',
  'NotReverseElement': '∌',
  'NotRightTriangle': '⋫',
  'NotRightTriangleBar': '⧐̸',
  'NotRightTriangleEqual': '⋭',
  'NotSquareSubset': '⊏̸',
  'NotSquareSubsetEqual': '⋢',
  'NotSquareSuperset': '⊐̸',
  'NotSquareSupersetEqual': '⋣',
  'NotSubset': '⊂⃒',
  'NotSubsetEqual': '⊈',
  'NotSucceeds': '⊁',
  'NotSucceedsEqual': '⪰̸',
  'NotSucceedsSlantEqual': '⋡',
  'NotSucceedsTilde': '≿̸',
  'NotSuperset': '⊃⃒',
  'NotSupersetEqual': '⊉',
  'NotTilde': '≁',
  'NotTildeEqual': '≄',
  'NotTildeFullEqual': '≇',
  'NotTildeTilde': '≉',
  'NotVerticalBar': '∤',
  'Nscr': '𝒩',
  'Ntilde': 'Ñ',
  'Nu': 'Ν',
  'OElig': 'Œ',
  'Oacute': 'Ó',
  'Ocirc': 'Ô',
  'Ocy': 'О',
  'Odblac': 'Ő',
  'Ofr': '𝔒',
  'Ograve': 'Ò',
  'Omacr': 'Ō',
  'Omega': 'Ω',
  'Omicron': 'Ο',
  'Oopf': '𝕆',
  'OpenCurlyDoubleQuote': '“',
  'OpenCurlyQuote': '‘',
  'Or': '⩔',
  'Oscr': '𝒪',
  'Oslash': 'Ø',
  'Otilde': 'Õ',
  'Otimes': '⨷',
  'Ouml': 'Ö',
  'OverBar': '‾',
  'OverBrace': '⏞',
  'OverBracket': '⎴',
  'OverParenthesis': '⏜',
  'PartialD': '∂',
  'Pcy': 'П',
  'Pfr': '𝔓',
  'Phi': 'Φ',
  'Pi': 'Π',
  'PlusMinus': '±',
  'Poincareplane': 'ℌ',
  'Popf': 'ℙ',
  'Pr': '⪻',
  'Precedes': '≺',
  'PrecedesEqual': '⪯',
  'PrecedesSlantEqual': '≼',
  'PrecedesTilde': '≾',
  'Prime': '″',
  'Product': '∏',
  'Proportion': '∷',
  'Proportional': '∝',
  'Pscr': '𝒫',
  'Psi': 'Ψ',
  'QUOT': '"',
  'Qfr': '𝔔',
  'Qopf': 'ℚ',
  'Qscr': '𝒬',
  'RBarr': '⤐',
  'REG': '®',
  'Racute': 'Ŕ',
  'Rang': '⟫',
  'Rarr': '↠',
  'Rarrtl': '⤖',
  'Rcaron': 'Ř',
  'Rcedil': 'Ŗ',
  'Rcy': 'Р',
  'Re': 'ℜ',
  'ReverseElement': '∋',
  'ReverseEquilibrium': '⇋',
  'ReverseUpEquilibrium': '⥯',
  'Rfr': 'ℜ',
  'Rho': 'Ρ',
  'RightAngleBracket': '⟩',
  'RightArrow': '→',
  'RightArrowBar': '⇥',
  'RightArrowLeftArrow': '⇄',
  'RightCeiling': '⌉',
  'RightDoubleBracket': '⟧',
  'RightDownTeeVector': '⥝',
  'RightDownVector': '⇂',
  'RightDownVectorBar': '⥕',
  'RightFloor': '⌋',
  'RightTee': '⊢',
  'RightTeeArrow': '↦',
  'RightTeeVector': '⥛',
  'RightTriangle': '⊳',
  'RightTriangleBar': '⧐',
  'RightTriangleEqual': '⊵',
  'RightUpDownVector': '⥏',
  'RightUpTeeVector': '⥜',
  'RightUpVector': '↾',
  'RightUpVectorBar': '⥔',
  'RightVector': '⇀',
  'RightVectorBar': '⥓',
  'Rightarrow': '⇒',
  'Ropf': 'ℝ',
  'RoundImplies': '⥰',
  'Rrightarrow': '⇛',
  'Rscr': 'ℛ',
  'Rsh': '↱',
  'RuleDelayed': '⧴',
  'SHCHcy': 'Щ',
  'SHcy': 'Ш',
  'SOFTcy': 'Ь',
  'Sacute': 'Ś',
  'Sc': '⪼',
  'Scaron': 'Š',
  'Scedil': 'Ş',
  'Scirc': 'Ŝ',
  'Scy': 'С',
  'Sfr': '𝔖',
  'ShortDownArrow': '↓',
  'ShortLeftArrow': '←',
  'ShortRightArrow': '→',
  'ShortUpArrow': '↑',
  'Sigma': 'Σ',
  'SmallCircle': '∘',
  'Sopf': '𝕊',
  'Sqrt': '√',
  'Square': '□',
  'SquareIntersection': '⊓',
  'SquareSubset': '⊏',
  'SquareSubsetEqual': '⊑',
  'SquareSuperset': '⊐',
  'SquareSupersetEqual': '⊒',
  'SquareUnion': '⊔',
  'Sscr': '𝒮',
  'Star': '⋆',
  'Sub': '⋐',
  'Subset': '⋐',
  'SubsetEqual': '⊆',
  'Succeeds': '≻',
  'SucceedsEqual': '⪰',
  'SucceedsSlantEqual': '≽',
  'SucceedsTilde': '≿',
  'SuchThat': '∋',
  'Sum': '∑',
  'Sup': '⋑',
  'Superset': '⊃',
  'SupersetEqual': '⊇',
  'Supset': '⋑',
  'THORN': 'Þ',
  'TRADE': '™',
  'TSHcy': 'Ћ',
  'TScy': 'Ц',
  'Tab': '\t',
  'Tau': 'Τ',
  'Tcaron': 'Ť',
  'Tcedil': 'Ţ',
  'Tcy': 'Т',
  'Tfr': '𝔗',
  'Therefore': '∴',
  'Theta': 'Θ',
  'ThickSpace': '  ',
  'ThinSpace': ' ',
  'Tilde': '∼',
  'TildeEqual': '≃',
  'TildeFullEqual': '≅',
  'TildeTilde': '≈',
  'Topf': '𝕋',
  'TripleDot': '⃛',
  'Tscr': '𝒯',
  'Tstrok': 'Ŧ',
  'Uacute': 'Ú',
  'Uarr': '↟',
  'Uarrocir': '⥉',
  'Ubrcy': 'Ў',
  'Ubreve': 'Ŭ',
  'Ucirc': 'Û',
  'Ucy': 'У',
  'Udblac': 'Ű',
  'Ufr': '𝔘',
  'Ugrave': 'Ù',
  'Umacr': 'Ū',
  'UnderBar': '_',
  'UnderBrace': '⏟',
  'UnderBracket': '⎵',
  'UnderParenthesis': '⏝',
  'Union': '⋃',
  'UnionPlus': '⊎',
  'Uogon': 'Ų',
  'Uopf': '𝕌',
  'UpArrow': '↑',
  'UpArrowBar': '⤒',
  'UpArrowDownArrow': '⇅',
  'UpDownArrow': '↕',
  'UpEquilibrium': '⥮',
  'UpTee': '⊥',
  'UpTeeArrow': '↥',
  'Uparrow': '⇑',
  'Updownarrow': '⇕',
  'UpperLeftArrow': '↖',
  'UpperRightArrow': '↗',
  'Upsi': 'ϒ',
  'Upsilon': 'Υ',
  'Uring': 'Ů',
  'Uscr': '𝒰',
  'Utilde': 'Ũ',
  'Uuml': 'Ü',
  'VDash': '⊫',
  'Vbar': '⫫',
  'Vcy': 'В',
  'Vdash': '⊩',
  'Vdashl': '⫦',
  'Vee': '⋁',
  'Verbar': '‖',
  'Vert': '‖',
  'VerticalBar': '∣',
  'VerticalLine': '|',
  'VerticalSeparator': '❘',
  'VerticalTilde': '≀',
  'VeryThinSpace': ' ',
  'Vfr': '𝔙',
  'Vopf': '𝕍',
  'Vscr': '𝒱',
  'Vvdash': '⊪',
  'Wcirc': 'Ŵ',
  'Wedge': '⋀',
  'Wfr': '𝔚',
  'Wopf': '𝕎',
  'Wscr': '𝒲',
  'Xfr': '𝔛',
  'Xi': 'Ξ',
  'Xopf': '𝕏',
  'Xscr': '𝒳',
  'YAcy': 'Я',
  'YIcy': 'Ї',
  'YUcy': 'Ю',
  'Yacute': 'Ý',
  'Ycirc': 'Ŷ',
  'Ycy': 'Ы',
  'Yfr': '𝔜',
  'Yopf': '𝕐',
  'Yscr': '𝒴',
  'Yuml': 'Ÿ',
  'ZHcy': 'Ж',
  'Zacute': 'Ź',
  'Zcaron': 'Ž',
  'Zcy': 'З',
  'Zdot': 'Ż',
  'ZeroWidthSpace': '​',
  'Zeta': 'Ζ',
  'Zfr': 'ℨ',
  'Zopf': 'ℤ',
  'Zscr': '𝒵',
  'aacute': 'á',
  'abreve': 'ă',
  'ac': '∾',
  'acE': '∾̳',
  'acd': '∿',
  'acirc': 'â',
  'acute': '´',
  'acy': 'а',
  'aelig': 'æ',
  'af': '⁡',
  'afr': '𝔞',
  'agrave': 'à',
  'alefsym': 'ℵ',
  'aleph': 'ℵ',
  'alpha': 'α',
  'amacr': 'ā',
  'amalg': '⨿',
  'amp': '&',
  'and': '∧',
  'andand': '⩕',
  'andd': '⩜',
  'andslope': '⩘',
  'andv': '⩚',
  'ang': '∠',
  'ange': '⦤',
  'angle': '∠',
  'angmsd': '∡',
  'angmsdaa': '⦨',
  'angmsdab': '⦩',
  'angmsdac': '⦪',
  'angmsdad': '⦫',
  'angmsdae': '⦬',
  'angmsdaf': '⦭',
  'angmsdag': '⦮',
  'angmsdah': '⦯',
  'angrt': '∟',
  'angrtvb': '⊾',
  'angrtvbd': '⦝',
  'angsph': '∢',
  'angst': 'Å',
  'angzarr': '⍼',
  'aogon': 'ą',
  'aopf': '𝕒',
  'ap': '≈',
  'apE': '⩰',
  'apacir': '⩯',
  'ape': '≊',
  'apid': '≋',
  'apos': '\'',
  'approx': '≈',
  'approxeq': '≊',
  'aring': 'å',
  'ascr': '𝒶',
  'ast': '*',
  'asymp': '≈',
  'asympeq': '≍',
  'atilde': 'ã',
  'auml': 'ä',
  'awconint': '∳',
  'awint': '⨑',
  'bNot': '⫭',
  'backcong': '≌',
  'backepsilon': '϶',
  'backprime': '‵',
  'backsim': '∽',
  'backsimeq': '⋍',
  'barvee': '⊽',
  'barwed': '⌅',
  'barwedge': '⌅',
  'bbrk': '⎵',
  'bbrktbrk': '⎶',
  'bcong': '≌',
  'bcy': 'б',
  'bdquo': '„',
  'becaus': '∵',
  'because': '∵',
  'bemptyv': '⦰',
  'bepsi': '϶',
  'bernou': 'ℬ',
  'beta': 'β',
  'beth': 'ℶ',
  'between': '≬',
  'bfr': '𝔟',
  'bigcap': '⋂',
  'bigcirc': '◯',
  'bigcup': '⋃',
  'bigodot': '⨀',
  'bigoplus': '⨁',
  'bigotimes': '⨂',
  'bigsqcup': '⨆',
  'bigstar': '★',
  'bigtriangledown': '▽',
  'bigtriangleup': '△',
  'biguplus': '⨄',
  'bigvee': '⋁',
  'bigwedge': '⋀',
  'bkarow': '⤍',
  'blacklozenge': '⧫',
  'blacksquare': '▪',
  'blacktriangle': '▴',
  'blacktriangledown': '▾',
  'blacktriangleleft': '◂',
  'blacktriangleright': '▸',
  'blank': '␣',
  'blk12': '▒',
  'blk14': '░',
  'blk34': '▓',
  'block': '█',
  'bne': '=⃥',
  'bnequiv': '≡⃥',
  'bnot': '⌐',
  'bopf': '𝕓',
  'bot': '⊥',
  'bottom': '⊥',
  'bowtie': '⋈',
  'boxDL': '╗',
  'boxDR': '╔',
  'boxDl': '╖',
  'boxDr': '╓',
  'boxH': '═',
  'boxHD': '╦',
  'boxHU': '╩',
  'boxHd': '╤',
  'boxHu': '╧',
  'boxUL': '╝',
  'boxUR': '╚',
  'boxUl': '╜',
  'boxUr': '╙',
  'boxV': '║',
  'boxVH': '╬',
  'boxVL': '╣',
  'boxVR': '╠',
  'boxVh': '╫',
  'boxVl': '╢',
  'boxVr': '╟',
  'boxbox': '⧉',
  'boxdL': '╕',
  'boxdR': '╒',
  'boxdl': '┐',
  'boxdr': '┌',
  'boxh': '─',
  'boxhD': '╥',
  'boxhU': '╨',
  'boxhd': '┬',
  'boxhu': '┴',
  'boxminus': '⊟',
  'boxplus': '⊞',
  'boxtimes': '⊠',
  'boxuL': '╛',
  'boxuR': '╘',
  'boxul': '┘',
  'boxur': '└',
  'boxv': '│',
  'boxvH': '╪',
  'boxvL': '╡',
  'boxvR': '╞',
  'boxvh': '┼',
  'boxvl': '┤',
  'boxvr': '├',
  'bprime': '‵',
  'breve': '˘',
  'brvbar': '¦',
  'bscr': '𝒷',
  'bsemi': '⁏',
  'bsim': '∽',
  'bsime': '⋍',
  'bsol': '\\',
  'bsolb': '⧅',
  'bsolhsub': '⟈',
  'bull': '•',
  'bullet': '•',
  'bump': '≎',
  'bumpE': '⪮',
  'bumpe': '≏',
  'bumpeq': '≏',
  'cacute': 'ć',
  'cap': '∩',
  'capand': '⩄',
  'capbrcup': '⩉',
  'capcap': '⩋',
  'capcup': '⩇',
  'capdot': '⩀',
  'caps': '∩︀',
  'caret': '⁁',
  'caron': 'ˇ',
  'ccaps': '⩍',
  'ccaron': 'č',
  'ccedil': 'ç',
  'ccirc': 'ĉ',
  'ccups': '⩌',
  'ccupssm': '⩐',
  'cdot': 'ċ',
  'cedil': '¸',
  'cemptyv': '⦲',
  'cent': '¢',
  'centerdot': '·',
  'cfr': '𝔠',
  'chcy': 'ч',
  'check': '✓',
  'checkmark': '✓',
  'chi': 'χ',
  'cir': '○',
  'cirE': '⧃',
  'circ': 'ˆ',
  'circeq': '≗',
  'circlearrowleft': '↺',
  'circlearrowright': '↻',
  'circledR': '®',
  'circledS': 'Ⓢ',
  'circledast': '⊛',
  'circledcirc': '⊚',
  'circleddash': '⊝',
  'cire': '≗',
  'cirfnint': '⨐',
  'cirmid': '⫯',
  'cirscir': '⧂',
  'clubs': '♣',
  'clubsuit': '♣',
  'colon': ':',
  'colone': '≔',
  'coloneq': '≔',
  'comma': ',',
  'commat': '@',
  'comp': '∁',
  'compfn': '∘',
  'complement': '∁',
  'complexes': 'ℂ',
  'cong': '≅',
  'congdot': '⩭',
  'conint': '∮',
  'copf': '𝕔',
  'coprod': '∐',
  'copy': '©',
  'copysr': '℗',
  'crarr': '↵',
  'cross': '✗',
  'cscr': '𝒸',
  'csub': '⫏',
  'csube': '⫑',
  'csup': '⫐',
  'csupe': '⫒',
  'ctdot': '⋯',
  'cudarrl': '⤸',
  'cudarrr': '⤵',
  'cuepr': '⋞',
  'cuesc': '⋟',
  'cularr': '↶',
  'cularrp': '⤽',
  'cup': '∪',
  'cupbrcap': '⩈',
  'cupcap': '⩆',
  'cupcup': '⩊',
  'cupdot': '⊍',
  'cupor': '⩅',
  'cups': '∪︀',
  'curarr': '↷',
  'curarrm': '⤼',
  'curlyeqprec': '⋞',
  'curlyeqsucc': '⋟',
  'curlyvee': '⋎',
  'curlywedge': '⋏',
  'curren': '¤',
  'curvearrowleft': '↶',
  'curvearrowright': '↷',
  'cuvee': '⋎',
  'cuwed': '⋏',
  'cwconint': '∲',
  'cwint': '∱',
  'cylcty': '⌭',
  'dArr': '⇓',
  'dHar': '⥥',
  'dagger': '†',
  'daleth': 'ℸ',
  'darr': '↓',
  'dash': '‐',
  'dashv': '⊣',
  'dbkarow': '⤏',
  'dblac': '˝',
  'dcaron': 'ď',
  'dcy': 'д',
  'dd': 'ⅆ',
  'ddagger': '‡',
  'ddarr': '⇊',
  'ddotseq': '⩷',
  'deg': '°',
  'delta': 'δ',
  'demptyv': '⦱',
  'dfisht': '⥿',
  'dfr': '𝔡',
  'dharl': '⇃',
  'dharr': '⇂',
  'diam': '⋄',
  'diamond': '⋄',
  'diamondsuit': '♦',
  'diams': '♦',
  'die': '¨',
  'digamma': 'ϝ',
  'disin': '⋲',
  'div': '÷',
  'divide': '÷',
  'divideontimes': '⋇',
  'divonx': '⋇',
  'djcy': 'ђ',
  'dlcorn': '⌞',
  'dlcrop': '⌍',
  'dollar': '$',
  'dopf': '𝕕',
  'dot': '˙',
  'doteq': '≐',
  'doteqdot': '≑',
  'dotminus': '∸',
  'dotplus': '∔',
  'dotsquare': '⊡',
  'doublebarwedge': '⌆',
  'downarrow': '↓',
  'downdownarrows': '⇊',
  'downharpoonleft': '⇃',
  'downharpoonright': '⇂',
  'drbkarow': '⤐',
  'drcorn': '⌟',
  'drcrop': '⌌',
  'dscr': '𝒹',
  'dscy': 'ѕ',
  'dsol': '⧶',
  'dstrok': 'đ',
  'dtdot': '⋱',
  'dtri': '▿',
  'dtrif': '▾',
  'duarr': '⇵',
  'duhar': '⥯',
  'dwangle': '⦦',
  'dzcy': 'џ',
  'dzigrarr': '⟿',
  'eDDot': '⩷',
  'eDot': '≑',
  'eacute': 'é',
  'easter': '⩮',
  'ecaron': 'ě',
  'ecir': '≖',
  'ecirc': 'ê',
  'ecolon': '≕',
  'ecy': 'э',
  'edot': 'ė',
  'ee': 'ⅇ',
  'efDot': '≒',
  'efr': '𝔢',
  'eg': '⪚',
  'egrave': 'è',
  'egs': '⪖',
  'egsdot': '⪘',
  'el': '⪙',
  'elinters': '⏧',
  'ell': 'ℓ',
  'els': '⪕',
  'elsdot': '⪗',
  'emacr': 'ē',
  'empty': '∅',
  'emptyset': '∅',
  'emptyv': '∅',
  'emsp': ' ',
  'emsp13': ' ',
  'emsp14': ' ',
  'eng': 'ŋ',
  'ensp': ' ',
  'eogon': 'ę',
  'eopf': '𝕖',
  'epar': '⋕',
  'eparsl': '⧣',
  'eplus': '⩱',
  'epsi': 'ε',
  'epsilon': 'ε',
  'epsiv': 'ϵ',
  'eqcirc': '≖',
  'eqcolon': '≕',
  'eqsim': '≂',
  'eqslantgtr': '⪖',
  'eqslantless': '⪕',
  'equals': '=',
  'equest': '≟',
  'equiv': '≡',
  'equivDD': '⩸',
  'eqvparsl': '⧥',
  'erDot': '≓',
  'erarr': '⥱',
  'escr': 'ℯ',
  'esdot': '≐',
  'esim': '≂',
  'eta': 'η',
  'eth': 'ð',
  'euml': 'ë',
  'euro': '€',
  'excl': '!',
  'exist': '∃',
  'expectation': 'ℰ',
  'exponentiale': 'ⅇ',
  'fallingdotseq': '≒',
  'fcy': 'ф',
  'female': '♀',
  'ffilig': 'ﬃ',
  'fflig': 'ﬀ',
  'ffllig': 'ﬄ',
  'ffr': '𝔣',
  'filig': 'ﬁ',
  'fjlig': 'fj',
  'flat': '♭',
  'fllig': 'ﬂ',
  'fltns': '▱',
  'fnof': 'ƒ',
  'fopf': '𝕗',
  'forall': '∀',
  'fork': '⋔',
  'forkv': '⫙',
  'fpartint': '⨍',
  'frac12': '½',
  'frac13': '⅓',
  'frac14': '¼',
  'frac15': '⅕',
  'frac16': '⅙',
  'frac18': '⅛',
  'frac23': '⅔',
  'frac25': '⅖',
  'frac34': '¾',
  'frac35': '⅗',
  'frac38': '⅜',
  'frac45': '⅘',
  'frac56': '⅚',
  'frac58': '⅝',
  'frac78': '⅞',
  'frasl': '⁄',
  'frown': '⌢',
  'fscr': '𝒻',
  'gE': '≧',
  'gEl': '⪌',
  'gacute': 'ǵ',
  'gamma': 'γ',
  'gammad': 'ϝ',
  'gap': '⪆',
  'gbreve': 'ğ',
  'gcirc': 'ĝ',
  'gcy': 'г',
  'gdot': 'ġ',
  'ge': '≥',
  'gel': '⋛',
  'geq': '≥',
  'geqq': '≧',
  'geqslant': '⩾',
  'ges': '⩾',
  'gescc': '⪩',
  'gesdot': '⪀',
  'gesdoto': '⪂',
  'gesdotol': '⪄',
  'gesl': '⋛︀',
  'gesles': '⪔',
  'gfr': '𝔤',
  'gg': '≫',
  'ggg': '⋙',
  'gimel': 'ℷ',
  'gjcy': 'ѓ',
  'gl': '≷',
  'glE': '⪒',
  'gla': '⪥',
  'glj': '⪤',
  'gnE': '≩',
  'gnap': '⪊',
  'gnapprox': '⪊',
  'gne': '⪈',
  'gneq': '⪈',
  'gneqq': '≩',
  'gnsim': '⋧',
  'gopf': '𝕘',
  'grave': '`',
  'gscr': 'ℊ',
  'gsim': '≳',
  'gsime': '⪎',
  'gsiml': '⪐',
  'gt': '>',
  'gtcc': '⪧',
  'gtcir': '⩺',
  'gtdot': '⋗',
  'gtlPar': '⦕',
  'gtquest': '⩼',
  'gtrapprox': '⪆',
  'gtrarr': '⥸',
  'gtrdot': '⋗',
  'gtreqless': '⋛',
  'gtreqqless': '⪌',
  'gtrless': '≷',
  'gtrsim': '≳',
  'gvertneqq': '≩︀',
  'gvnE': '≩︀',
  'hArr': '⇔',
  'hairsp': ' ',
  'half': '½',
  'hamilt': 'ℋ',
  'hardcy': 'ъ',
  'harr': '↔',
  'harrcir': '⥈',
  'harrw': '↭',
  'hbar': 'ℏ',
  'hcirc': 'ĥ',
  'hearts': '♥',
  'heartsuit': '♥',
  'hellip': '…',
  'hercon': '⊹',
  'hfr': '𝔥',
  'hksearow': '⤥',
  'hkswarow': '⤦',
  'hoarr': '⇿',
  'homtht': '∻',
  'hookleftarrow': '↩',
  'hookrightarrow': '↪',
  'hopf': '𝕙',
  'horbar': '―',
  'hscr': '𝒽',
  'hslash': 'ℏ',
  'hstrok': 'ħ',
  'hybull': '⁃',
  'hyphen': '‐',
  'iacute': 'í',
  'ic': '⁣',
  'icirc': 'î',
  'icy': 'и',
  'iecy': 'е',
  'iexcl': '¡',
  'iff': '⇔',
  'ifr': '𝔦',
  'igrave': 'ì',
  'ii': 'ⅈ',
  'iiiint': '⨌',
  'iiint': '∭',
  'iinfin': '⧜',
  'iiota': '℩',
  'ijlig': 'ĳ',
  'imacr': 'ī',
  'image': 'ℑ',
  'imagline': 'ℐ',
  'imagpart': 'ℑ',
  'imath': 'ı',
  'imof': '⊷',
  'imped': 'Ƶ',
  'in': '∈',
  'incare': '℅',
  'infin': '∞',
  'infintie': '⧝',
  'inodot': 'ı',
  'int': '∫',
  'intcal': '⊺',
  'integers': 'ℤ',
  'intercal': '⊺',
  'intlarhk': '⨗',
  'intprod': '⨼',
  'iocy': 'ё',
  'iogon': 'į',
  'iopf': '𝕚',
  'iota': 'ι',
  'iprod': '⨼',
  'iquest': '¿',
  'iscr': '𝒾',
  'isin': '∈',
  'isinE': '⋹',
  'isindot': '⋵',
  'isins': '⋴',
  'isinsv': '⋳',
  'isinv': '∈',
  'it': '⁢',
  'itilde': 'ĩ',
  'iukcy': 'і',
  'iuml': 'ï',
  'jcirc': 'ĵ',
  'jcy': 'й',
  'jfr': '𝔧',
  'jmath': 'ȷ',
  'jopf': '𝕛',
  'jscr': '𝒿',
  'jsercy': 'ј',
  'jukcy': 'є',
  'kappa': 'κ',
  'kappav': 'ϰ',
  'kcedil': 'ķ',
  'kcy': 'к',
  'kfr': '𝔨',
  'kgreen': 'ĸ',
  'khcy': 'х',
  'kjcy': 'ќ',
  'kopf': '𝕜',
  'kscr': '𝓀',
  'lAarr': '⇚',
  'lArr': '⇐',
  'lAtail': '⤛',
  'lBarr': '⤎',
  'lE': '≦',
  'lEg': '⪋',
  'lHar': '⥢',
  'lacute': 'ĺ',
  'laemptyv': '⦴',
  'lagran': 'ℒ',
  'lambda': 'λ',
  'lang': '⟨',
  'langd': '⦑',
  'langle': '⟨',
  'lap': '⪅',
  'laquo': '«',
  'larr': '←',
  'larrb': '⇤',
  'larrbfs': '⤟',
  'larrfs': '⤝',
  'larrhk': '↩',
  'larrlp': '↫',
  'larrpl': '⤹',
  'larrsim': '⥳',
  'larrtl': '↢',
  'lat': '⪫',
  'latail': '⤙',
  'late': '⪭',
  'lates': '⪭︀',
  'lbarr': '⤌',
  'lbbrk': '❲',
  'lbrace': '{',
  'lbrack': '[',
  'lbrke': '⦋',
  'lbrksld': '⦏',
  'lbrkslu': '⦍',
  'lcaron': 'ľ',
  'lcedil': 'ļ',
  'lceil': '⌈',
  'lcub': '{',
  'lcy': 'л',
  'ldca': '⤶',
  'ldquo': '“',
  'ldquor': '„',
  'ldrdhar': '⥧',
  'ldrushar': '⥋',
  'ldsh': '↲',
  'le': '≤',
  'leftarrow': '←',
  'leftarrowtail': '↢',
  'leftharpoondown': '↽',
  'leftharpoonup': '↼',
  'leftleftarrows': '⇇',
  'leftrightarrow': '↔',
  'leftrightarrows': '⇆',
  'leftrightharpoons': '⇋',
  'leftrightsquigarrow': '↭',
  'leftthreetimes': '⋋',
  'leg': '⋚',
  'leq': '≤',
  'leqq': '≦',
  'leqslant': '⩽',
  'les': '⩽',
  'lescc': '⪨',
  'lesdot': '⩿',
  'lesdoto': '⪁',
  'lesdotor': '⪃',
  'lesg': '⋚︀',
  'lesges': '⪓',
  'lessapprox': '⪅',
  'lessdot': '⋖',
  'lesseqgtr': '⋚',
  'lesseqqgtr': '⪋',
  'lessgtr': '≶',
  'lesssim': '≲',
  'lfisht': '⥼',
  'lfloor': '⌊',
  'lfr': '𝔩',
  'lg': '≶',
  'lgE': '⪑',
  'lhard': '↽',
  'lharu': '↼',
  'lharul': '⥪',
  'lhblk': '▄',
  'ljcy': 'љ',
  'll': '≪',
  'llarr': '⇇',
  'llcorner': '⌞',
  'llhard': '⥫',
  'lltri': '◺',
  'lmidot': 'ŀ',
  'lmoust': '⎰',
  'lmoustache': '⎰',
  'lnE': '≨',
  'lnap': '⪉',
  'lnapprox': '⪉',
  'lne': '⪇',
  'lneq': '⪇',
  'lneqq': '≨',
  'lnsim': '⋦',
  'loang': '⟬',
  'loarr': '⇽',
  'lobrk': '⟦',
  'longleftarrow': '⟵',
  'longleftrightarrow': '⟷',
  'longmapsto': '⟼',
  'longrightarrow': '⟶',
  'looparrowleft': '↫',
  'looparrowright': '↬',
  'lopar': '⦅',
  'lopf': '𝕝',
  'loplus': '⨭',
  'lotimes': '⨴',
  'lowast': '∗',
  'lowbar': '_',
  'loz': '◊',
  'lozenge': '◊',
  'lozf': '⧫',
  'lpar': '(',
  'lparlt': '⦓',
  'lrarr': '⇆',
  'lrcorner': '⌟',
  'lrhar': '⇋',
  'lrhard': '⥭',
  'lrm': '‎',
  'lrtri': '⊿',
  'lsaquo': '‹',
  'lscr': '𝓁',
  'lsh': '↰',
  'lsim': '≲',
  'lsime': '⪍',
  'lsimg': '⪏',
  'lsqb': '[',
  'lsquo': '‘',
  'lsquor': '‚',
  'lstrok': 'ł',
  'lt': '<',
  'ltcc': '⪦',
  'ltcir': '⩹',
  'ltdot': '⋖',
  'lthree': '⋋',
  'ltimes': '⋉',
  'ltlarr': '⥶',
  'ltquest': '⩻',
  'ltrPar': '⦖',
  'ltri': '◃',
  'ltrie': '⊴',
  'ltrif': '◂',
  'lurdshar': '⥊',
  'luruhar': '⥦',
  'lvertneqq': '≨︀',
  'lvnE': '≨︀',
  'mDDot': '∺',
  'macr': '¯',
  'male': '♂',
  'malt': '✠',
  'maltese': '✠',
  'map': '↦',
  'mapsto': '↦',
  'mapstodown': '↧',
  'mapstoleft': '↤',
  'mapstoup': '↥',
  'marker': '▮',
  'mcomma': '⨩',
  'mcy': 'м',
  'mdash': '—',
  'measuredangle': '∡',
  'mfr': '𝔪',
  'mho': '℧',
  'micro': 'µ',
  'mid': '∣',
  'midast': '*',
  'midcir': '⫰',
  'middot': '·',
  'minus': '−',
  'minusb': '⊟',
  'minusd': '∸',
  'minusdu': '⨪',
  'mlcp': '⫛',
  'mldr': '…',
  'mnplus': '∓',
  'models': '⊧',
  'mopf': '𝕞',
  'mp': '∓',
  'mscr': '𝓂',
  'mstpos': '∾',
  'mu': 'μ',
  'multimap': '⊸',
  'mumap': '⊸',
  'nGg': '⋙̸',
  'nGt': '≫⃒',
  'nGtv': '≫̸',
  'nLeftarrow': '⇍',
  'nLeftrightarrow': '⇎',
  'nLl': '⋘̸',
  'nLt': '≪⃒',
  'nLtv': '≪̸',
  'nRightarrow': '⇏',
  'nVDash': '⊯',
  'nVdash': '⊮',
  'nabla': '∇',
  'nacute': 'ń',
  'nang': '∠⃒',
  'nap': '≉',
  'napE': '⩰̸',
  'napid': '≋̸',
  'napos': 'ŉ',
  'napprox': '≉',
  'natur': '♮',
  'natural': '♮',
  'naturals': 'ℕ',
  'nbsp': ' ',
  'nbump': '≎̸',
  'nbumpe': '≏̸',
  'ncap': '⩃',
  'ncaron': 'ň',
  'ncedil': 'ņ',
  'ncong': '≇',
  'ncongdot': '⩭̸',
  'ncup': '⩂',
  'ncy': 'н',
  'ndash': '–',
  'ne': '≠',
  'neArr': '⇗',
  'nearhk': '⤤',
  'nearr': '↗',
  'nearrow': '↗',
  'nedot': '≐̸',
  'nequiv': '≢',
  'nesear': '⤨',
  'nesim': '≂̸',
  'nexist': '∄',
  'nexists': '∄',
  'nfr': '𝔫',
  'ngE': '≧̸',
  'nge': '≱',
  'ngeq': '≱',
  'ngeqq': '≧̸',
  'ngeqslant': '⩾̸',
  'nges': '⩾̸',
  'ngsim': '≵',
  'ngt': '≯',
  'ngtr': '≯',
  'nhArr': '⇎',
  'nharr': '↮',
  'nhpar': '⫲',
  'ni': '∋',
  'nis': '⋼',
  'nisd': '⋺',
  'niv': '∋',
  'njcy': 'њ',
  'nlArr': '⇍',
  'nlE': '≦̸',
  'nlarr': '↚',
  'nldr': '‥',
  'nle': '≰',
  'nleftarrow': '↚',
  'nleftrightarrow': '↮',
  'nleq': '≰',
  'nleqq': '≦̸',
  'nleqslant': '⩽̸',
  'nles': '⩽̸',
  'nless': '≮',
  'nlsim': '≴',
  'nlt': '≮',
  'nltri': '⋪',
  'nltrie': '⋬',
  'nmid': '∤',
  'nopf': '𝕟',
  'not': '¬',
  'notin': '∉',
  'notinE': '⋹̸',
  'notindot': '⋵̸',
  'notinva': '∉',
  'notinvb': '⋷',
  'notinvc': '⋶',
  'notni': '∌',
  'notniva': '∌',
  'notnivb': '⋾',
  'notnivc': '⋽',
  'npar': '∦',
  'nparallel': '∦',
  'nparsl': '⫽⃥',
  'npart': '∂̸',
  'npolint': '⨔',
  'npr': '⊀',
  'nprcue': '⋠',
  'npre': '⪯̸',
  'nprec': '⊀',
  'npreceq': '⪯̸',
  'nrArr': '⇏',
  'nrarr': '↛',
  'nrarrc': '⤳̸',
  'nrarrw': '↝̸',
  'nrightarrow': '↛',
  'nrtri': '⋫',
  'nrtrie': '⋭',
  'nsc': '⊁',
  'nsccue': '⋡',
  'nsce': '⪰̸',
  'nscr': '𝓃',
  'nshortmid': '∤',
  'nshortparallel': '∦',
  'nsim': '≁',
  'nsime': '≄',
  'nsimeq': '≄',
  'nsmid': '∤',
  'nspar': '∦',
  'nsqsube': '⋢',
  'nsqsupe': '⋣',
  'nsub': '⊄',
  'nsubE': '⫅̸',
  'nsube': '⊈',
  'nsubset': '⊂⃒',
  'nsubseteq': '⊈',
  'nsubseteqq': '⫅̸',
  'nsucc': '⊁',
  'nsucceq': '⪰̸',
  'nsup': '⊅',
  'nsupE': '⫆̸',
  'nsupe': '⊉',
  'nsupset': '⊃⃒',
  'nsupseteq': '⊉',
  'nsupseteqq': '⫆̸',
  'ntgl': '≹',
  'ntilde': 'ñ',
  'ntlg': '≸',
  'ntriangleleft': '⋪',
  'ntrianglelefteq': '⋬',
  'ntriangleright': '⋫',
  'ntrianglerighteq': '⋭',
  'nu': 'ν',
  'num': '#',
  'numero': '№',
  'numsp': ' ',
  'nvDash': '⊭',
  'nvHarr': '⤄',
  'nvap': '≍⃒',
  'nvdash': '⊬',
  'nvge': '≥⃒',
  'nvgt': '>⃒',
  'nvinfin': '⧞',
  'nvlArr': '⤂',
  'nvle': '≤⃒',
  'nvlt': '<⃒',
  'nvltrie': '⊴⃒',
  'nvrArr': '⤃',
  'nvrtrie': '⊵⃒',
  'nvsim': '∼⃒',
  'nwArr': '⇖',
  'nwarhk': '⤣',
  'nwarr': '↖',
  'nwarrow': '↖',
  'nwnear': '⤧',
  'oS': 'Ⓢ',
  'oacute': 'ó',
  'oast': '⊛',
  'ocir': '⊚',
  'ocirc': 'ô',
  'ocy': 'о',
  'odash': '⊝',
  'odblac': 'ő',
  'odiv': '⨸',
  'odot': '⊙',
  'odsold': '⦼',
  'oelig': 'œ',
  'ofcir': '⦿',
  'ofr': '𝔬',
  'ogon': '˛',
  'ograve': 'ò',
  'ogt': '⧁',
  'ohbar': '⦵',
  'ohm': 'Ω',
  'oint': '∮',
  'olarr': '↺',
  'olcir': '⦾',
  'olcross': '⦻',
  'oline': '‾',
  'olt': '⧀',
  'omacr': 'ō',
  'omega': 'ω',
  'omicron': 'ο',
  'omid': '⦶',
  'ominus': '⊖',
  'oopf': '𝕠',
  'opar': '⦷',
  'operp': '⦹',
  'oplus': '⊕',
  'or': '∨',
  'orarr': '↻',
  'ord': '⩝',
  'order': 'ℴ',
  'orderof': 'ℴ',
  'ordf': 'ª',
  'ordm': 'º',
  'origof': '⊶',
  'oror': '⩖',
  'orslope': '⩗',
  'orv': '⩛',
  'oscr': 'ℴ',
  'oslash': 'ø',
  'osol': '⊘',
  'otilde': 'õ',
  'otimes': '⊗',
  'otimesas': '⨶',
  'ouml': 'ö',
  'ovbar': '⌽',
  'par': '∥',
  'para': '¶',
  'parallel': '∥',
  'parsim': '⫳',
  'parsl': '⫽',
  'part': '∂',
  'pcy': 'п',
  'percnt': '%',
  'period': '.',
  'permil': '‰',
  'perp': '⊥',
  'pertenk': '‱',
  'pfr': '𝔭',
  'phi': 'φ',
  'phiv': 'ϕ',
  'phmmat': 'ℳ',
  'phone': '☎',
  'pi': 'π',
  'pitchfork': '⋔',
  'piv': 'ϖ',
  'planck': 'ℏ',
  'planckh': 'ℎ',
  'plankv': 'ℏ',
  'plus': '+',
  'plusacir': '⨣',
  'plusb': '⊞',
  'pluscir': '⨢',
  'plusdo': '∔',
  'plusdu': '⨥',
  'pluse': '⩲',
  'plusmn': '±',
  'plussim': '⨦',
  'plustwo': '⨧',
  'pm': '±',
  'pointint': '⨕',
  'popf': '𝕡',
  'pound': '£',
  'pr': '≺',
  'prE': '⪳',
  'prap': '⪷',
  'prcue': '≼',
  'pre': '⪯',
  'prec': '≺',
  'precapprox': '⪷',
  'preccurlyeq': '≼',
  'preceq': '⪯',
  'precnapprox': '⪹',
  'precneqq': '⪵',
  'precnsim': '⋨',
  'precsim': '≾',
  'prime': '′',
  'primes': 'ℙ',
  'prnE': '⪵',
  'prnap': '⪹',
  'prnsim': '⋨',
  'prod': '∏',
  'profalar': '⌮',
  'profline': '⌒',
  'profsurf': '⌓',
  'prop': '∝',
  'propto': '∝',
  'prsim': '≾',
  'prurel': '⊰',
  'pscr': '𝓅',
  'psi': 'ψ',
  'puncsp': ' ',
  'qfr': '𝔮',
  'qint': '⨌',
  'qopf': '𝕢',
  'qprime': '⁗',
  'qscr': '𝓆',
  'quaternions': 'ℍ',
  'quatint': '⨖',
  'quest': '?',
  'questeq': '≟',
  'quot': '"',
  'rAarr': '⇛',
  'rArr': '⇒',
  'rAtail': '⤜',
  'rBarr': '⤏',
  'rHar': '⥤',
  'race': '∽̱',
  'racute': 'ŕ',
  'radic': '√',
  'raemptyv': '⦳',
  'rang': '⟩',
  'rangd': '⦒',
  'range': '⦥',
  'rangle': '⟩',
  'raquo': '»',
  'rarr': '→',
  'rarrap': '⥵',
  'rarrb': '⇥',
  'rarrbfs': '⤠',
  'rarrc': '⤳',
  'rarrfs': '⤞',
  'rarrhk': '↪',
  'rarrlp': '↬',
  'rarrpl': '⥅',
  'rarrsim': '⥴',
  'rarrtl': '↣',
  'rarrw': '↝',
  'ratail': '⤚',
  'ratio': '∶',
  'rationals': 'ℚ',
  'rbarr': '⤍',
  'rbbrk': '❳',
  'rbrace': '}',
  'rbrack': ']',
  'rbrke': '⦌',
  'rbrksld': '⦎',
  'rbrkslu': '⦐',
  'rcaron': 'ř',
  'rcedil': 'ŗ',
  'rceil': '⌉',
  'rcub': '}',
  'rcy': 'р',
  'rdca': '⤷',
  'rdldhar': '⥩',
  'rdquo': '”',
  'rdquor': '”',
  'rdsh': '↳',
  'real': 'ℜ',
  'realine': 'ℛ',
  'realpart': 'ℜ',
  'reals': 'ℝ',
  'rect': '▭',
  'reg': '®',
  'rfisht': '⥽',
  'rfloor': '⌋',
  'rfr': '𝔯',
  'rhard': '⇁',
  'rharu': '⇀',
  'rharul': '⥬',
  'rho': 'ρ',
  'rhov': 'ϱ',
  'rightarrow': '→',
  'rightarrowtail': '↣',
  'rightharpoondown': '⇁',
  'rightharpoonup': '⇀',
  'rightleftarrows': '⇄',
  'rightleftharpoons': '⇌',
  'rightrightarrows': '⇉',
  'rightsquigarrow': '↝',
  'rightthreetimes': '⋌',
  'ring': '˚',
  'risingdotseq': '≓',
  'rlarr': '⇄',
  'rlhar': '⇌',
  'rlm': '‏',
  'rmoust': '⎱',
  'rmoustache': '⎱',
  'rnmid': '⫮',
  'roang': '⟭',
  'roarr': '⇾',
  'robrk': '⟧',
  'ropar': '⦆',
  'ropf': '𝕣',
  'roplus': '⨮',
  'rotimes': '⨵',
  'rpar': ')',
  'rpargt': '⦔',
  'rppolint': '⨒',
  'rrarr': '⇉',
  'rsaquo': '›',
  'rscr': '𝓇',
  'rsh': '↱',
  'rsqb': ']',
  'rsquo': '’',
  'rsquor': '’',
  'rthree': '⋌',
  'rtimes': '⋊',
  'rtri': '▹',
  'rtrie': '⊵',
  'rtrif': '▸',
  'rtriltri': '⧎',
  'ruluhar': '⥨',
  'rx': '℞',
  'sacute': 'ś',
  'sbquo': '‚',
  'sc': '≻',
  'scE': '⪴',
  'scap': '⪸',
  'scaron': 'š',
  'sccue': '≽',
  'sce': '⪰',
  'scedil': 'ş',
  'scirc': 'ŝ',
  'scnE': '⪶',
  'scnap': '⪺',
  'scnsim': '⋩',
  'scpolint': '⨓',
  'scsim': '≿',
  'scy': 'с',
  'sdot': '⋅',
  'sdotb': '⊡',
  'sdote': '⩦',
  'seArr': '⇘',
  'searhk': '⤥',
  'searr': '↘',
  'searrow': '↘',
  'sect': '§',
  'semi': ';',
  'seswar': '⤩',
  'setminus': '∖',
  'setmn': '∖',
  'sext': '✶',
  'sfr': '𝔰',
  'sfrown': '⌢',
  'sharp': '♯',
  'shchcy': 'щ',
  'shcy': 'ш',
  'shortmid': '∣',
  'shortparallel': '∥',
  'shy': '­',
  'sigma': 'σ',
  'sigmaf': 'ς',
  'sigmav': 'ς',
  'sim': '∼',
  'simdot': '⩪',
  'sime': '≃',
  'simeq': '≃',
  'simg': '⪞',
  'simgE': '⪠',
  'siml': '⪝',
  'simlE': '⪟',
  'simne': '≆',
  'simplus': '⨤',
  'simrarr': '⥲',
  'slarr': '←',
  'smallsetminus': '∖',
  'smashp': '⨳',
  'smeparsl': '⧤',
  'smid': '∣',
  'smile': '⌣',
  'smt': '⪪',
  'smte': '⪬',
  'smtes': '⪬︀',
  'softcy': 'ь',
  'sol': '/',
  'solb': '⧄',
  'solbar': '⌿',
  'sopf': '𝕤',
  'spades': '♠',
  'spadesuit': '♠',
  'spar': '∥',
  'sqcap': '⊓',
  'sqcaps': '⊓︀',
  'sqcup': '⊔',
  'sqcups': '⊔︀',
  'sqsub': '⊏',
  'sqsube': '⊑',
  'sqsubset': '⊏',
  'sqsubseteq': '⊑',
  'sqsup': '⊐',
  'sqsupe': '⊒',
  'sqsupset': '⊐',
  'sqsupseteq': '⊒',
  'squ': '□',
  'square': '□',
  'squarf': '▪',
  'squf': '▪',
  'srarr': '→',
  'sscr': '𝓈',
  'ssetmn': '∖',
  'ssmile': '⌣',
  'sstarf': '⋆',
  'star': '☆',
  'starf': '★',
  'straightepsilon': 'ϵ',
  'straightphi': 'ϕ',
  'strns': '¯',
  'sub': '⊂',
  'subE': '⫅',
  'subdot': '⪽',
  'sube': '⊆',
  'subedot': '⫃',
  'submult': '⫁',
  'subnE': '⫋',
  'subne': '⊊',
  'subplus': '⪿',
  'subrarr': '⥹',
  'subset': '⊂',
  'subseteq': '⊆',
  'subseteqq': '⫅',
  'subsetneq': '⊊',
  'subsetneqq': '⫋',
  'subsim': '⫇',
  'subsub': '⫕',
  'subsup': '⫓',
  'succ': '≻',
  'succapprox': '⪸',
  'succcurlyeq': '≽',
  'succeq': '⪰',
  'succnapprox': '⪺',
  'succneqq': '⪶',
  'succnsim': '⋩',
  'succsim': '≿',
  'sum': '∑',
  'sung': '♪',
  'sup': '⊃',
  'sup1': '¹',
  'sup2': '²',
  'sup3': '³',
  'supE': '⫆',
  'supdot': '⪾',
  'supdsub': '⫘',
  'supe': '⊇',
  'supedot': '⫄',
  'suphsol': '⟉',
  'suphsub': '⫗',
  'suplarr': '⥻',
  'supmult': '⫂',
  'supnE': '⫌',
  'supne': '⊋',
  'supplus': '⫀',
  'supset': '⊃',
  'supseteq': '⊇',
  'supseteqq': '⫆',
  'supsetneq': '⊋',
  'supsetneqq': '⫌',
  'supsim': '⫈',
  'supsub': '⫔',
  'supsup': '⫖',
  'swArr': '⇙',
  'swarhk': '⤦',
  'swarr': '↙',
  'swarrow': '↙',
  'swnwar': '⤪',
  'szlig': 'ß',
  'target': '⌖',
  'tau': 'τ',
  'tbrk': '⎴',
  'tcaron': 'ť',
  'tcedil': 'ţ',
  'tcy': 'т',
  'tdot': '⃛',
  'telrec': '⌕',
  'tfr': '𝔱',
  'there4': '∴',
  'therefore': '∴',
  'theta': 'θ',
  'thetasym': 'ϑ',
  'thetav': 'ϑ',
  'thickapprox': '≈',
  'thicksim': '∼',
  'thinsp': ' ',
  'thkap': '≈',
  'thksim': '∼',
  'thorn': 'þ',
  'tilde': '˜',
  'times': '×',
  'timesb': '⊠',
  'timesbar': '⨱',
  'timesd': '⨰',
  'tint': '∭',
  'toea': '⤨',
  'top': '⊤',
  'topbot': '⌶',
  'topcir': '⫱',
  'topf': '𝕥',
  'topfork': '⫚',
  'tosa': '⤩',
  'tprime': '‴',
  'trade': '™',
  'triangle': '▵',
  'triangledown': '▿',
  'triangleleft': '◃',
  'trianglelefteq': '⊴',
  'triangleq': '≜',
  'triangleright': '▹',
  'trianglerighteq': '⊵',
  'tridot': '◬',
  'trie': '≜',
  'triminus': '⨺',
  'triplus': '⨹',
  'trisb': '⧍',
  'tritime': '⨻',
  'trpezium': '⏢',
  'tscr': '𝓉',
  'tscy': 'ц',
  'tshcy': 'ћ',
  'tstrok': 'ŧ',
  'twixt': '≬',
  'twoheadleftarrow': '↞',
  'twoheadrightarrow': '↠',
  'uArr': '⇑',
  'uHar': '⥣',
  'uacute': 'ú',
  'uarr': '↑',
  'ubrcy': 'ў',
  'ubreve': 'ŭ',
  'ucirc': 'û',
  'ucy': 'у',
  'udarr': '⇅',
  'udblac': 'ű',
  'udhar': '⥮',
  'ufisht': '⥾',
  'ufr': '𝔲',
  'ugrave': 'ù',
  'uharl': '↿',
  'uharr': '↾',
  'uhblk': '▀',
  'ulcorn': '⌜',
  'ulcorner': '⌜',
  'ulcrop': '⌏',
  'ultri': '◸',
  'umacr': 'ū',
  'uml': '¨',
  'uogon': 'ų',
  'uopf': '𝕦',
  'uparrow': '↑',
  'updownarrow': '↕',
  'upharpoonleft': '↿',
  'upharpoonright': '↾',
  'uplus': '⊎',
  'upsi': 'υ',
  'upsih': 'ϒ',
  'upsilon': 'υ',
  'upuparrows': '⇈',
  'urcorn': '⌝',
  'urcorner': '⌝',
  'urcrop': '⌎',
  'uring': 'ů',
  'urtri': '◹',
  'uscr': '𝓊',
  'utdot': '⋰',
  'utilde': 'ũ',
  'utri': '▵',
  'utrif': '▴',
  'uuarr': '⇈',
  'uuml': 'ü',
  'uwangle': '⦧',
  'vArr': '⇕',
  'vBar': '⫨',
  'vBarv': '⫩',
  'vDash': '⊨',
  'vangrt': '⦜',
  'varepsilon': 'ϵ',
  'varkappa': 'ϰ',
  'varnothing': '∅',
  'varphi': 'ϕ',
  'varpi': 'ϖ',
  'varpropto': '∝',
  'varr': '↕',
  'varrho': 'ϱ',
  'varsigma': 'ς',
  'varsubsetneq': '⊊︀',
  'varsubsetneqq': '⫋︀',
  'varsupsetneq': '⊋︀',
  'varsupsetneqq': '⫌︀',
  'vartheta': 'ϑ',
  'vartriangleleft': '⊲',
  'vartriangleright': '⊳',
  'vcy': 'в',
  'vdash': '⊢',
  'vee': '∨',
  'veebar': '⊻',
  'veeeq': '≚',
  'vellip': '⋮',
  'verbar': '|',
  'vert': '|',
  'vfr': '𝔳',
  'vltri': '⊲',
  'vnsub': '⊂⃒',
  'vnsup': '⊃⃒',
  'vopf': '𝕧',
  'vprop': '∝',
  'vrtri': '⊳',
  'vscr': '𝓋',
  'vsubnE': '⫋︀',
  'vsubne': '⊊︀',
  'vsupnE': '⫌︀',
  'vsupne': '⊋︀',
  'vzigzag': '⦚',
  'wcirc': 'ŵ',
  'wedbar': '⩟',
  'wedge': '∧',
  'wedgeq': '≙',
  'weierp': '℘',
  'wfr': '𝔴',
  'wopf': '𝕨',
  'wp': '℘',
  'wr': '≀',
  'wreath': '≀',
  'wscr': '𝓌',
  'xcap': '⋂',
  'xcirc': '◯',
  'xcup': '⋃',
  'xdtri': '▽',
  'xfr': '𝔵',
  'xhArr': '⟺',
  'xharr': '⟷',
  'xi': 'ξ',
  'xlArr': '⟸',
  'xlarr': '⟵',
  'xmap': '⟼',
  'xnis': '⋻',
  'xodot': '⨀',
  'xopf': '𝕩',
  'xoplus': '⨁',
  'xotime': '⨂',
  'xrArr': '⟹',
  'xrarr': '⟶',
  'xscr': '𝓍',
  'xsqcup': '⨆',
  'xuplus': '⨄',
  'xutri': '△',
  'xvee': '⋁',
  'xwedge': '⋀',
  'yacute': 'ý',
  'yacy': 'я',
  'ycirc': 'ŷ',
  'ycy': 'ы',
  'yen': '¥',
  'yfr': '𝔶',
  'yicy': 'ї',
  'yopf': '𝕪',
  'yscr': '𝓎',
  'yucy': 'ю',
  'yuml': 'ÿ',
  'zacute': 'ź',
  'zcaron': 'ž',
  'zcy': 'з',
  'zdot': 'ż',
  'zeetrf': 'ℨ',
  'zeta': 'ζ',
  'zfr': '𝔷',
  'zhcy': 'ж',
  'zigrarr': '⇝',
  'zopf': '𝕫',
  'zscr': '𝓏',
  'zwj': '‍',
  'zwnj': '‌'
};

////
// makehtml/blockquote.js
// Copyright (c) 2018 ShowdownJS
//
// Turn Markdown image into <img> tags.
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.image', function (text, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makehtml.image.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  let inlineRegExp      = /!\[([^\]]*?)][ \t]*\([ \t]?<?(\S+?(?:\(\S{0,200}?\)\S{0,200}?)?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\5)?[ \t]?\)/g,
      crazyRegExp       = /!\[([^\]]*?)][ \t]*\([ \t]?<([^>]*)>(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\5)?[ \t]?\)/g,
      base64RegExp      = /!\[([^\]]*?)][ \t]*\([ \t]?<?(data:.+?\/.+?;base64,[A-Za-z\d+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\6)?[ \t]?\)/g,
      referenceRegExp   = /!\[([^\]]*?)] ?(?:\n *)?\[([\s\S]*?)]/g,
      refShortcutRegExp = /!\[([^[\]]+)]/g;

  // Every markdown image syntax requires a closing ']'. When there is none there is nothing to
  // match, so skip the (backtracking-prone) passes. This also neutralizes pathological inputs
  // such as '!['.repeat(n), whose alt-text scan would otherwise cost O(n^2) looking for a ']'.
  if (text.indexOf(']') !== -1) {
  // First, handle reference-style labeled images: ![alt text][id]
    text = text.replace(referenceRegExp, function (wholeMatch, altText, linkId) {
      return writeImageTag ('reference', referenceRegExp, wholeMatch, altText, null, linkId);
    });

    // Next, handle inline images:  ![alt text](url =<width>x<height> "optional title")
    if (options.cmSpec) {
    // CommonMark inline-image parsing, symmetric to the link scanner: balanced-paren
    // and `<...>` destinations, titles, backslash escapes, arbitrary label nesting.
      text = parseCmInlineImages(text);
    } else if (text.indexOf(')') !== -1) {
    // Every legacy inline-image syntax ends in ')'. Without one there is nothing to match, so
    // skip these passes — this neutralizes inputs like '![a](' + 'a('.repeat(n) whose
    // destination scan would otherwise backtrack quadratically looking for a ')'.
    // base64 encoded images
      text = text.replace(base64RegExp, function (wholeMatch, altText, url, width, height, m5, title) {
        url = url.replace(/\s/g, '');
        return writeImageTag ('inline', base64RegExp, wholeMatch, altText, url, null, width, height, title);
      });

      // cases with crazy urls like ./image/cat1).png
      text = text.replace(crazyRegExp, function (wholeMatch, altText, url, width, height, m5, title) {
        url = showdown.helper.applyBaseUrl(options.relativePathBaseUrl, url);
        return writeImageTag ('inline', crazyRegExp, wholeMatch, altText, url, null, width, height, title);
      });

      // normal cases
      text = text.replace(inlineRegExp, function (wholeMatch, altText, url, width, height, m5, title) {
        url = showdown.helper.applyBaseUrl(options.relativePathBaseUrl, url);
        return writeImageTag ('inline', inlineRegExp, wholeMatch, altText, url, null, width, height, title);
      });
    }

    // handle reference-style shortcuts: ![img text]
    text = text.replace(refShortcutRegExp, function (wholeMatch, altText) {
      return writeImageTag ('reference', refShortcutRegExp, wholeMatch, altText);
    });
  }

  let afterEvent = new showdown.Event('makehtml.image.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;



  /**
   * @param {string} subEvtName
   * @param {RegExp} pattern
   * @param {string} wholeMatch
   * @param {string} altText
   * @param {string|null} [url]
   * @param {string|null} [linkId]
   * @param {string|null} [width]
   * @param {string|null} [height]
   * @param {string|null} [title]
   * @returns {string}
   */
  function writeImageTag (subEvtName, pattern, wholeMatch, altText, url, linkId, width, height, title) {

    let gUrls    = globals.gUrls,
        gTitles  = globals.gTitles,
        gDims    = globals.gDimensions,
        matches = {
          _wholeMatch: wholeMatch,
          _altText: altText,
          _linkId: linkId,
          _url: url,
          _width: width,
          _height: height,
          _title: title
        },
        otp,
        attributes;

    if (linkId) {
      linkId = options.cmSpec ? showdown.helper.cmNormalizeLabel(linkId) : showdown.helper.caseFold(linkId);
    } else {
      linkId = null;
    }

    if (!title) {
      title = null;
    }
    // Special case for explicit empty url
    if (wholeMatch.search(/\(<?\s*>? ?(['"].*['"])?\)$/m) > -1) {
      url = '';

    } else if (showdown.helper.isUndefined(url) || url === '' || url === null) {
      if (linkId === '' || linkId === null) {
        // lower-case and turn embedded newlines into spaces
        linkId = options.cmSpec ? showdown.helper.cmNormalizeLabel(altText) : showdown.helper.caseFold(altText).replace(/ ?\n/g, ' ');
      }
      if (!showdown.helper.isUndefined(gUrls[linkId])) {
        url = gUrls[linkId];
        if (!showdown.helper.isUndefined(gTitles[linkId])) {
          title = gTitles[linkId];
        }
        if (!showdown.helper.isUndefined(gDims[linkId])) {
          width = gDims[linkId].width;
          height = gDims[linkId].height;
        }
      } else {
        return wholeMatch;
      }
    }

    // safeMode: neutralize dangerous URL schemes; data:image/* stays allowed so
    // inline base64 images keep working
    if (options.safeMode && !showdown.helper.isSafeUrl(url, {allowDataImage: true})) {
      url = '';
    }

    if (options.cmSpec) {
      // CommonMark: the alt text is the plain-text rendering of the label, with
      // inline markup stripped (`![foo *bar*]` -> alt="foo bar").
      altText = flattenAltText(altText);
    }
    altText = altText
      .replace(/"/g, '&quot;')
      //altText = showdown.helper.escapeCharacters(altText, '*_', false);
      .replace(showdown.helper.regexes.asteriskDashTildeAndColon, showdown.helper.escapeCharactersCallback);
    //url = showdown.helper.escapeCharacters(url, '*_', false);
    if (options.cmSpec) {
      url = showdown.helper.cmNormalizeURL(url);
    }
    url = url.replace(showdown.helper.regexes.asteriskDashTildeAndColon, showdown.helper.escapeCharactersCallback);
    // escape characters that would otherwise break out of the quoted src attribute
    // (a `"` in the URL is an attribute-injection vector). cmSpec flavors already
    // percent-encode the URL above, so this is a no-op there.
    url = url
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    if (title && showdown.helper.isString(title)) {
      if (options.cmSpec) {
        title = showdown.helper.cmEscapeTitle(title);
      } else {
        title = title
          .replace(/"/g, '&quot;');
      }
      title = title.replace(showdown.helper.regexes.asteriskDashTildeAndColon, showdown.helper.escapeCharactersCallback);
    }

    // Image dimensions are a non-standard extension: only honor them when
    // parseImgDimensions is enabled. The `=WxH` syntax is still consumed by the
    // regex (so it never leaks into the output), but the width/height attributes
    // are dropped when the option is off - matching the reference-definition path,
    // which only stores dimensions in gDimensions when the option is on.
    if (options.parseImgDimensions && width) {
      width  = (width === '*') ? 'auto' : width;
    } else {
      width = null;
    }

    if (options.parseImgDimensions && height) {
      height = (height === '*') ? 'auto' : height;
    } else {
      height = null;
    }

    let captureStartEvent = new showdown.Event('makehtml.image.' + subEvtName + '.onCapture', wholeMatch);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(pattern)
      .setMatches(matches)
      .setAttributes({
        src: url,
        alt: altText,
        title: title,
        width: width,
        height: height
      });

    captureStartEvent = globals.converter.dispatch(captureStartEvent);
    // if something was passed as output, it takes precedence
    // and will be used as output
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      otp = captureStartEvent.output;
    } else {
      attributes = captureStartEvent.attributes;
      otp = '<img' + showdown.helper._populateAttributes(attributes) + ' />';
    }

    let beforeHashEvent = new showdown.Event('makehtml.image.' + subEvtName + '.onHash', otp);
    beforeHashEvent
      .setOutput(otp)
      ._setGlobals(globals)
      ._setOptions(options);
    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    otp = beforeHashEvent.output;

    return otp;
  }

  /**
   * CommonMark inline-image scanner. Finds `![label](destination "title")` spans,
   * matching the label by counting nested brackets and parsing the destination and
   * title with the shared cursor-based helpers.
   * @param {string} str
   * @returns {string}
   */
  function parseCmInlineImages (str) {
    let inlineImgRegexp = /!\[[\s\S]*?]\([\s\S]*?\)/, // representative pattern (event metadata only)
        n = str.length,
        out = '',
        last = 0,
        i = 0;
    while (i < n) {
      if (str.charAt(i) !== '!' || str.charAt(i + 1) !== '[') { i++; continue; }
      let depth = 1, k = i + 2, labelEnd = -1;
      while (k < n) {
        let c = str.charAt(k);
        if (c === '\\' && k + 1 < n) { k += 2; continue; }
        if (c === '[') { depth++; } else if (c === ']') {
          depth--;
          if (depth === 0) { labelEnd = k; break; }
        }
        k++;
      }
      if (labelEnd !== -1 && str.charAt(labelEnd + 1) === '(') {
        let parsed = parseCmImgDestTitle(str, labelEnd + 2);
        if (parsed) {
          let label = str.slice(i + 2, labelEnd),
              url = showdown.helper.applyBaseUrl(options.relativePathBaseUrl, parsed.url);
          out += str.slice(last, i);
          out += writeImageTag('inline', inlineImgRegexp, str.slice(i, parsed.end + 1), label, url, null, null, null, parsed.title);
          i = parsed.end + 1;
          last = i;
          continue;
        }
      }
      i++;
    }
    out += str.slice(last);
    return out;
  }

  /**
   * Parse an image destination and optional title starting just after the opening
   * `(`. Returns `{url, title, end}` (end = index of the closing `)`) or `null`.
   * @param {string} str
   * @param {number} j
   * @returns {{url: string, title: (string|null), end: number}|null}
   */
  function parseCmImgDestTitle (str, j) {
    let n = str.length,
        isWs = function (c) { return c === ' ' || c === '\t' || c === '\n'; };
    while (j < n && isWs(str.charAt(j))) { j++; }
    let dest = showdown.helper.cmScanDestination(str, j);
    if (!dest) { return null; }
    j = dest.end;
    let hadWs = false;
    while (j < n && isWs(str.charAt(j))) { hadWs = true; j++; }
    let title = null,
        tc = str.charAt(j);
    if (j < n && (tc === '"' || tc === '\'' || tc === '(')) {
      if (!hadWs) { return null; }
      let t = showdown.helper.cmScanTitle(str, j);
      if (!t) { return null; }
      title = t.title;
      j = t.end;
    }
    while (j < n && isWs(str.charAt(j))) { j++; }
    if (j >= n || str.charAt(j) !== ')') { return null; }
    return {url: dest.url, title: title, end: j};
  }

  /**
   * Produce the plain-text rendering of an image label for the `alt` attribute,
   * per CommonMark: inline markup is processed and then flattened to text. Nested
   * images contribute their own alt text; links and emphasis contribute their
   * text content.
   * @param {string} t
   * @returns {string}
   */
  function flattenAltText (t) {
    t = showdown.subParser('makehtml.codeSpan')(t, options, globals);
    t = showdown.subParser('makehtml.image')(t, options, globals);
    t = showdown.subParser('makehtml.link')(t, options, globals);
    t = showdown.subParser('makehtml.emoji')(t, options, globals);
    t = showdown.subParser('makehtml.underline')(t, options, globals);
    t = showdown.subParser('makehtml.emphasisAndStrong')(t, options, globals);
    t = showdown.subParser('makehtml.strikethrough')(t, options, globals);
    t = showdown.subParser('makehtml.ellipsis')(t, options, globals);
    // restore hashed spans (e.g. produced by nested images/links) so we can read them
    t = showdown.subParser('makehtml.unhashHTMLSpans')(t, options, globals);
    // a nested image contributes its alt text; every other tag contributes its
    // text content, so replace images by their alt then strip the remaining tags
    t = t.replace(/<img\b[^>]*?\salt="([^"]*)"[^>]*?\/?>/g, '$1');
    t = t.replace(/<[^>]*>/g, '');
    return t;
  }

});

////
// makehtml/links.js
// Copyright (c) 2018 ShowdownJS
//
// Transforms MD links into `<a>` html anchors
//
// A link contains link text (the visible text), a link destination (the URI that is the link destination), and
// optionally a link title. There are two basic kinds of links in Markdown.
// In inline links the destination and title are given immediately after the link text.
// In reference links the destination and title are defined elsewhere in the document.
//
// ***Author:***
// - Estevão Soares dos Santos (Tivie) <https://github.com/tivie>
////

showdown.subParser('makehtml.link', function (text, options, globals) {

  //
  // Parser starts here
  //
  let startEvent = new showdown.Event('makehtml.link.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  // Every markdown link/reference syntax requires a closing ']'. When there is none there is
  // nothing for the (backtracking-prone) reference/inline passes to match, so skip them. This
  // also neutralizes pathological inputs such as '['.repeat(n), which would otherwise cost
  // O(n^2) as each pass scans forward for a ']' that never appears. Autolinks (< >) below do
  // not need ']', so they stay outside this guard.
  if (text.indexOf(']') !== -1) {
  // 1. Handle reference-style links: [link text] [id]
    // The label sub-pattern excludes `[` from the inner negated class (`[^\][]` not `[^\]]`) so a
    // scan for the label's closing `]` cannot run across the `[` that starts the *next* bracket
    // group. This keeps matching linear on inputs like `'[^'.repeat(n) + ' ]'` (which contain a
    // stray `]` that defeats the earlier "no `]` at all" fast-path) without changing results.
    let referenceRegex = /\[((?:\[[^\][]*]|[^[\]])*)] ?(?:\n *)?\[(.*?)]/g;
    text = text.replace(referenceRegex, function (wholeMatch, text, linkId) {
    // bail if we find 2 newlines somewhere
      if (/\n\n/.test(wholeMatch)) {
        return wholeMatch;
      }
      return writeAnchorTag ('reference', referenceRegex, wholeMatch, text, linkId);
    });

    // 2. Handle inline-style links: [link text](url "optional title")
    if (options.cmSpec) {
    // CommonMark inline-link parsing: a manual scanner that handles balanced-paren
    // and `<...>` destinations, titles in "...", '...' or (...), and backslash escapes.
      text = parseCmInlineLinks(text);
    } else if (text.indexOf(')') !== -1) {
    // Every legacy inline-link syntax ends in ')'. Without one there is nothing to match, so
    // skip these passes — this neutralizes pathological inputs like '[a](' + 'a('.repeat(n),
    // whose destination scan would otherwise backtrack quadratically looking for a ')'.
    // 2.1. Look for empty cases: []() and [empty]() and []("title")
      // The link text and title captures exclude their own delimiters (`[^\]]*?` / `[^"']*`)
      // rather than the unbounded `.*?` / `.*`. Run as the first inline pass over raw text, the
      // old form re-scanned O(n) chars from every `[` on balanced nested input like
      // `'[x]('.repeat(n) + 'u' + ')'.repeat(n)`, giving O(n^2). This mirrors the bounding already
      // applied to the sibling inline/image regexes (the image parser likewise disallows `]` in alt).
      let inlineEmptyRegex = /\[([^\]]*?)]\(<? ?>? ?(["']([^"']*)["'])?\)/g;
      text = text.replace(inlineEmptyRegex, function (wholeMatch, text, m1, title) {
        return writeAnchorTag ('inline', inlineEmptyRegex, wholeMatch, text, null, null, title, true);
      });

      // 2.2. Look for cases with crazy urls like ./image/cat1).png
      // the url mus be enclosed in <>
      let inlineCrazyRegex = /\[((?:\[[^\][]*]|[^[\]])*)]\s?\([ \t]?<([^>]*)>(?:[ \t]*((["'])([^"]*?)\4))?[ \t]?\)/g;
      text = text.replace(inlineCrazyRegex, function (wholeMatch, text, url, m1, m2, title) {
        return writeAnchorTag ('inline', inlineCrazyRegex, wholeMatch, text, null, url, title);
      });

      // 2.3. inline links with no title or titles wrapped in ' or ":
      // [text](url.com) || [text](<url.com>) || [text](url.com "title") || [text](<url.com> "title")
      let inlineNormalRegex1 = /\[([\S ]*?)]\s?\( *<?([^\s'"]*?(?:\(\S{0,200}?\)\S{0,200}?)?)>?\s*(?:(['"])(.*?)\3)? *\)/g;
      text = text.replace(inlineNormalRegex1, function (wholeMatch, text, url, m1, title) {
        return writeAnchorTag ('inline', inlineNormalRegex1, wholeMatch, text, null, url, title);
      });

      // 2.4. inline links with titles wrapped in (): [foo](bar.com (title))
      let inlineNormalRegex2 = /\[([\S ]*?)]\s?\( *<?([^\s'"]*?(?:\(\S{0,200}?\)\S{0,200}?)?)>?\s+\((.*?)\) *\)/g;
      text = text.replace(inlineNormalRegex2, function (wholeMatch, text, url, title) {
        return writeAnchorTag ('inline', inlineNormalRegex2, wholeMatch, text, null, url, title);
      });
    }


    // 3. Handle reference-style shortcuts: [link text]
    // These must come last in case there's a [link text][1] or [link text](/foo)
    let referenceShortcutRegex = /\[([^[\]]+)]/g;
    text = text.replace(referenceShortcutRegex, function (wholeMatch, text) {
      return writeAnchorTag ('reference', referenceShortcutRegex, wholeMatch, text);
    });
  }

  // 4. Handle angle brackets links -> `<http://example.com/>`
  // Must come after links, because you can use < and > delimiters in inline links like [this](<url>).

  if (options.cmSpec) {
    // CommonMark autolinks: any scheme (2-32 chars) URI, and emails, with no entity encoding.
    // 4.1. URI autolinks: <scheme:rest>
    // eslint-disable-next-line no-control-regex -- CommonMark autolinks exclude control chars (\x00-\x20) per spec
    let cmUriAutolinkRegex = /<([A-Za-z][A-Za-z0-9+.-]{1,31}:[^<>\x00-\x20]*)>/g;
    text = text.replace(cmUriAutolinkRegex, function (wholeMatch, uri) {
      // backslash escapes do not work inside autolinks, so restore them to literal backslash + char
      let raw = showdown.subParser('makehtml.unescapeSpecialChars')(uri.replace(/(¨E\d+E)/g, '\\$1'), options, globals);
      // safeMode: neutralize dangerous autolink schemes but keep the visible text
      let href = (options.safeMode && !showdown.helper.isSafeUrl(raw)) ? '' : cmEscapeHref(showdown.helper.cmEncodeURI(raw));
      let otp = '<a href="' + href + '">' + cmEscapeText(raw) + '</a>';
      return showdown.subParser('makehtml.hashHTMLSpans')(otp, options, globals);
    });

    // 4.2. Email autolinks: <foo@bar.example.com>
    let cmEmailAutolinkRegex = /<([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/g;
    text = text.replace(cmEmailAutolinkRegex, function (wholeMatch, email) {
      let raw = showdown.subParser('makehtml.unescapeSpecialChars')(email.replace(/(¨E\d+E)/g, '\\$1'), options, globals);
      let otp = '<a href="' + cmEscapeHref('mailto:' + raw) + '">' + cmEscapeText(raw) + '</a>';
      return showdown.subParser('makehtml.hashHTMLSpans')(otp, options, globals);
    });

  } else {
    // 4.1. Handle links first
    let angleBracketsLinksRegex = /<(((?:https?|ftp):\/\/|www\.)[^'">\s]+)>/gi;
    text = text.replace(angleBracketsLinksRegex, function (wholeMatch, url, urlStart) {

      // backslash escaped characters do not work inside autolinks (according to commonmark spec... sure)
      // so let's unescape them (and add a backslash html entity before)
      url = url.replace(/(¨E\d+E)/g, '\\$1');
      url = showdown.subParser('makehtml.unescapeSpecialChars')(url, options, globals);
      let text = url;

      // now let's replace some entities which should be properly url encoded
      url = showdown.helper.urlASCIIEncoding(url);

      // noinspection HttpUrlsUsage
      url = (urlStart === 'www.') ? (options.httpsAutoLinks ? 'https://' : 'http://') + url : url;
      return writeAnchorTag ('angleBrackets', angleBracketsLinksRegex, wholeMatch, text, null, url);
    });

    // 4.2. Then mail adresses
    let angleBracketsMailRegex = /<(?:mailto:)?([-.\w]+@[-a-z\d]+(\.[-a-z\d]+)*\.[a-z]+)>/gi;
    text = text.replace(angleBracketsMailRegex, function (wholeMatch, mail) {
      const m = parseMail(mail);
      return writeAnchorTag ('angleBrackets', angleBracketsMailRegex, wholeMatch, m.mail, null, m.url);
    });
  }

  // 5. Handle GithubMentions (if option is enabled)
  if (options.ghMentions) {
    let ghMentionsRegex = /(^|\s)(\\)?(@([a-z\d]+(?:[a-z\d._-]+?[a-z\d]+)*))/gi;
    text = text.replace(ghMentionsRegex, function (wholeMatch, st, escape, mentions, username) {
      // bail if the mentions was escaped
      if (escape === '\\') {
        return st + mentions;
      }
      // check if options.ghMentionsLink is a string
      // TODO Validation should be done at initialization not at runtime
      if (!showdown.helper.isString(options.ghMentionsLink)) {
        throw new Error('ghMentionsLink option must be a string');
      }
      let url = options.ghMentionsLink.replace(/\{u}/g, username);
      return st + writeAnchorTag ('reference', ghMentionsRegex, wholeMatch, mentions, null, url);
    });
  }

  // 6 and 7 have to come here to prevent naked links to catch html
  // 6. Handle <a> tags
  text = text.replace(/<a\s[^>]*>[\s\S]*<\/a>/g, function (wholeMatch) {
    return showdown.helper._hashHTMLSpan(wholeMatch, globals);
  });

  // 7. Handle <img> tags
  text = text.replace(/<img\s[^>]*\/?>/g, function (wholeMatch) {
    return showdown.helper._hashHTMLSpan(wholeMatch, globals);
  });

  // 8. Handle naked links (if option is enabled)
  if (options.simplifiedAutoLink) {
    // 8.1. Check for naked URLs
    // we also include leading markdown magic chars [_*~] for cases like __https://www.google.com/foobar__
    let nakedUrlRegex = /([_*~]*?)(((?:https?|ftp):\/\/|www\.)[^\s<>"'`´.-][^\s<>"'`´]*?\.[a-z\d.]+[^\s<>"']*)\1/gi;
    text = text.replace(nakedUrlRegex, function (wholeMatch, leadingMDChars, url, urlPrefix) {
      // we now will start traversing the url from the front to back, looking for punctuation chars [_*~,;:.!?\)\]]
      const len = url.length;
      let suffix = '';

      for (let i = len - 1; i >= 0; --i) {
        let char = url.charAt(i);
        if (/[_*~,;:.!?]/.test(char)) {
          // it's a punctuation char so we remove it from the url
          url = url.slice(0, -1);
          // and prepend it to the suffix
          suffix = char + suffix;
        } else if (/[)\]]/.test(char)) {
          // it's a parenthesis so we need to check for "balance" (kinda)
          let opPar, clPar;
          if (/\)/.test(char)) {
            // it's a curved parenthesis
            opPar = url.match(/\(/g) || [];
            clPar = url.match(/\)/g);
          } else {
            // it's a squared parenthesis
            opPar = url.match(/\[/g) || [];
            clPar = url.match(/]/g);
          }
          if (opPar.length < clPar.length) {
            // there are more closing Parenthesis than opening so chop it!!!!!
            url = url.slice(0, -1);
            // and prepend it to the suffix
            suffix = char + suffix;
          } else {
            // it's (kinda) balanced so our work is done
            break;
          }
        } else {
          // it's not a punctuation or a parenthesis so our work is done
          break;
        }
      }

      // we copy the treated url to the text variable
      let txt = url;
      // finally, if it's a www shortcut, we prepend http(s)
      // noinspection HttpUrlsUsage
      url = (urlPrefix === 'www.') ? (options.httpsAutoLinks ? 'https://' : 'http://') + url : url;

      // url part is done so let's take care of text now
      // we need to escape the text (because of links such as www.example.com/foo__bar__baz)
      txt = txt.replace(showdown.helper.regexes.asteriskDashTildeAndColon, showdown.helper.escapeCharactersCallback);

      // and return the link tag, with the leadingMDChars and  suffix. The leadingMDChars are added at the end too because
      // we consumed those characters in the regexp
      return leadingMDChars +
        writeAnchorTag ('autoLink', nakedUrlRegex, wholeMatch, txt, null, url) +
        suffix +
        leadingMDChars;
    });

    // 8.2. Now check for naked mail
    let nakedMailRegex = /(^|\s)(?:mailto:)?([A-Za-z\d!#$%&'*+-/=?^_`{|}~.]+@[-a-z\d]+(\.[-a-z\d]+)*\.[a-z]+)(?=$|\s)/gmi;
    text = text.replace(nakedMailRegex, function (wholeMatch, leadingChar, mail) {
      const m = parseMail(mail);
      return leadingChar + writeAnchorTag ('autoLink', nakedMailRegex, wholeMatch, m.mail, null, m.url);
    });
  }

  let afterEvent = new showdown.Event('makehtml.link.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;



  /**
   * CommonMark inline-link scanner. Finds `[label](destination "title")` spans,
   * parsing the destination and title with a hand-written cursor so that balanced
   * parentheses, `<...>` destinations, the three title delimiters and backslash
   * escapes are handled per the spec. Anything that does not parse as a valid
   * inline link is left untouched (to be handled by the reference/shortcut passes).
   * @param {string} str
   * @returns {string}
   */
  function parseCmInlineLinks (str) {
    let inlineLinkRegexp = /\[[\s\S]*?]\([\s\S]*?\)/, // representative pattern (for event metadata only)
        n = str.length,
        out = '',
        last = 0,
        i = 0;
    while (i < n) {
      if (str.charAt(i) !== '[') { i++; continue; }
      // find the matching `]`, counting nested brackets and honoring backslash escapes
      let depth = 1, k = i + 1, labelEnd = -1;
      while (k < n) {
        let c = str.charAt(k);
        if (c === '\\' && k + 1 < n) { k += 2; continue; }
        if (c === '[') { depth++; } else if (c === ']') {
          depth--;
          if (depth === 0) { labelEnd = k; break; }
        }
        k++;
      }
      if (labelEnd !== -1 && str.charAt(labelEnd + 1) === '(') {
        let parsed = parseCmDestTitle(str, labelEnd + 2);
        if (parsed) {
          let label = str.slice(i + 1, labelEnd);
          out += str.slice(last, i);
          out += writeAnchorTag('inline', inlineLinkRegexp, str.slice(i, parsed.end + 1), label, null, parsed.url, parsed.title, parsed.emptyCase);
          i = parsed.end + 1;
          last = i;
          continue;
        }
      }
      // not a valid inline link here; advance past this `[` so a nested `[...]( )`
      // still gets a chance to match
      i++;
    }
    out += str.slice(last);
    return out;
  }

  /**
   * Parse a CommonMark link destination and optional title starting just after the
   * opening `(`. Returns `{url, title, emptyCase, end}` where `end` is the index of
   * the closing `)`, or `null` if the span is not a valid destination/title.
   * @param {string} str
   * @param {number} j index right after the opening `(`
   * @returns {{url: string, title: (string|null), emptyCase: boolean, end: number}|null}
   */
  function parseCmDestTitle (str, j) {
    let n = str.length,
        isWs = function (c) { return c === ' ' || c === '\t' || c === '\n'; },
        url,
        emptyCase = false;

    // optional leading whitespace
    while (j < n && isWs(str.charAt(j))) { j++; }

    if (str.charAt(j) === '<') {
      // angle-bracket destination: up to an unescaped `>`, no raw newline or `<`
      j++;
      let buf = '';
      while (j < n && str.charAt(j) !== '>') {
        let c = str.charAt(j);
        if (c === '\n' || c === '<') { return null; }
        if (c === '\\' && j + 1 < n) { buf += c + str.charAt(j + 1); j += 2; continue; }
        buf += c; j++;
      }
      if (j >= n || str.charAt(j) !== '>') { return null; }
      j++; // consume `>`
      url = buf;
      if (url === '') { emptyCase = true; }
    } else {
      // bare destination: balanced parentheses, ends at whitespace or an unbalanced `)`
      let depth = 0, buf = '';
      while (j < n) {
        let c = str.charAt(j);
        if (c === '\\' && j + 1 < n) { buf += c + str.charAt(j + 1); j += 2; continue; }
        if (isWs(c)) { break; }
        if (c === '(') { depth++; buf += c; j++; continue; }
        if (c === ')') {
          if (depth === 0) { break; }
          depth--; buf += c; j++; continue;
        }
        buf += c; j++;
      }
      if (depth !== 0) { return null; } // unbalanced parens -> not a link
      url = buf;
      if (url === '') { emptyCase = true; }
    }

    // optional whitespace separating destination and title
    let hadWs = false;
    while (j < n && isWs(str.charAt(j))) { hadWs = true; j++; }

    let title = null,
        tc = str.charAt(j);
    if (j < n && (tc === '"' || tc === '\'' || tc === '(')) {
      // a title must be separated from the destination by whitespace
      if (!hadWs) { return null; }
      let close = (tc === '(') ? ')' : tc,
          buf = '';
      j++;
      let closed = false;
      while (j < n) {
        let c = str.charAt(j);
        if (c === '\\' && j + 1 < n) { buf += c + str.charAt(j + 1); j += 2; continue; }
        if (tc === '(' && c === '(') { return null; } // unescaped `(` invalid in (...) title
        if (c === close) { closed = true; j++; break; }
        buf += c; j++;
      }
      if (!closed) { return null; }
      title = buf;
    }

    // optional trailing whitespace, then the required closing `)`
    while (j < n && isWs(str.charAt(j))) { j++; }
    if (j >= n || str.charAt(j) !== ')') { return null; }
    return {url: url, title: title, emptyCase: emptyCase, end: j};
  }

  /**
   *
   * @param {string} subEvtName
   * @param {RegExp} pattern
   * @param {string} wholeMatch
   * @param {string} text
   * @param {string|null} [linkId]
   * @param {string|null} [url]
   * @param {string|null} [title]
   * @param {boolean} [emptyCase]
   * @returns {string}
   */
  function writeAnchorTag (subEvtName, pattern, wholeMatch, text, linkId, url, title, emptyCase) {

    let matches = {
          _wholeMatch: wholeMatch,
          _linkId: linkId,
          _url: url,
          _title: title,
          text: text
        },
        otp,
        attributes = {};

    title = title || null;
    url = url || null;
    if (linkId) {
      linkId = options.cmSpec ? showdown.helper.cmNormalizeLabel(linkId) : showdown.helper.caseFold(linkId);
    } else {
      linkId = null;
    }
    emptyCase = !!emptyCase;

    if (emptyCase) {
      url = '';
    } else if (!url) {
      if (!linkId) {
        // lower-case and turn embedded newlines into spaces
        linkId = options.cmSpec ? showdown.helper.cmNormalizeLabel(text) : showdown.helper.caseFold(text).replace(/ ?\n/g, ' ');
      }
      if (!showdown.helper.isUndefined(globals.gUrls[linkId])) {
        url = globals.gUrls[linkId];
        if (!showdown.helper.isUndefined(globals.gTitles[linkId])) {
          title = globals.gTitles[linkId];
        }
      } else {
        return wholeMatch;
      }
    }

    url = showdown.helper.applyBaseUrl(options.relativePathBaseUrl, url);
    // safeMode: neutralize dangerous URL schemes (javascript:, vbscript:, data:, ...)
    if (options.safeMode && !showdown.helper.isSafeUrl(url)) {
      url = '';
    }
    if (options.cmSpec) {
      url = showdown.helper.cmNormalizeURL(url);
    }
    url = url.replace(showdown.helper.regexes.asteriskDashTildeAndColon, showdown.helper.escapeCharactersCallback);
    // escape characters that would otherwise break out of the quoted href attribute
    // (a `"` in the destination is an attribute-injection vector). cmSpec flavors already
    // percent-encode the URL above, so this is a no-op there.
    url = url
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    attributes.href = url;

    if (title && showdown.helper.isString(title)) {
      if (options.cmSpec) {
        title = showdown.helper.cmEscapeTitle(title);
      } else {
        title = title
          .replace(/"/g, '&quot;');
      }
      title = title.replace(showdown.helper.regexes.asteriskDashTildeAndColon, showdown.helper.escapeCharactersCallback);
      attributes.title = title;
    }

    let captureStartEvent = new showdown.Event('makehtml.link.' + subEvtName + '.onCapture', wholeMatch);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(pattern)
      .setMatches(matches)
      .setAttributes(attributes);
    captureStartEvent = globals.converter.dispatch(captureStartEvent);

    // if something was passed as output, it takes precedence
    // and will be used as output
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      otp = captureStartEvent.output;
    } else {
      attributes = captureStartEvent.attributes;
      text = captureStartEvent.matches.text || '';
      // Text can be a markdown element, so we run through the appropriate parsers
      text = showdown.subParser('makehtml.codeSpan')(text, options, globals);
      text = showdown.subParser('makehtml.emoji')(text, options, globals);
      text = showdown.subParser('makehtml.underline')(text, options, globals);
      text = showdown.subParser('makehtml.emphasisAndStrong')(text, options, globals);
      text = showdown.subParser('makehtml.strikethrough')(text, options, globals);
      text = showdown.subParser('makehtml.ellipsis')(text, options, globals);
      text = showdown.subParser('makehtml.hashHTMLSpans')(text, options, globals);
      otp = '<a' + showdown.helper._populateAttributes(attributes) + '>' + text + '</a>';
    }

    let beforeHashEvent = new showdown.Event('makehtml.link.' + subEvtName + '.onHash', otp);
    beforeHashEvent
      .setOutput(otp)
      ._setGlobals(globals)
      ._setOptions(options);
    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    otp = beforeHashEvent.output;
    return showdown.subParser('makehtml.hashHTMLSpans')(otp, options, globals);
  }

  /**
   * @param {string} mail
   * @returns {{mail: string, url: string}}
   */
  function parseMail (mail) {
    let url = 'mailto:';
    mail = showdown.subParser('makehtml.unescapeSpecialChars')(mail, options, globals);
    if (options.encodeEmails) {
      url = showdown.helper.encodeEmailAddress(url + mail);
      mail = showdown.helper.encodeEmailAddress(mail);
    } else {
      url = url + mail;
    }
    return {
      mail: mail,
      url: url
    };
  }

  // HTML-escape an autolink href (the URL is already percent-encoded)
  function cmEscapeHref (url) {
    return url
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // HTML-escape the visible autolink text (no percent-encoding)
  function cmEscapeText (txt) {
    return txt
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
});

////
// makehtml/list.js
// Copyright (c) 2022 ShowdownJS
//
// Transforms MD lists into `<ul>` or `<ol>` html list
//
// Markdown supports ordered (numbered) and unordered (bulleted) lists.
// Unordered lists use asterisks, pluses, and hyphens - interchangably - as list markers
// Ordered lists use numbers followed by periods.
//
// ***Author:***
// - Estevão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.list', function (text, options, globals) {
  'use strict';

  // Start of list parsing
  const subListRgx = /^(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(¨0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm;
  const mainListRgx = /(\n\n|^\n?)(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(¨0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm;
  const listTypeRgx = /[*+-]/g;

  // CommonMark list parsing is a separate container-block parser, invoked only when
  // the commonmark flavor selects it. The regex parser below stays the default path.
  if (options.cmSpec) {
    return showdown.subParser('makehtml.cmList')(text, options, globals);
  }

  let startEvent = new showdown.Event('makehtml.list.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  // add sentinel to hack around khtml/safari bug:
  // http://bugs.webkit.org/show_bug.cgi?id=11231
  text += '¨0';

  if (globals.gListLevel) {
    text = text.replace(subListRgx, function (wholeMatch, list, m2) {
      return parseConsecutiveLists(subListRgx, list, (m2.search(listTypeRgx) > -1) ? 'ul' : 'ol', true);
    });
  } else {
    text = text.replace(mainListRgx, function (wholeMatch, m1, list, m3) {
      return parseConsecutiveLists(mainListRgx, list, (m3.search(listTypeRgx) > -1) ? 'ul' : 'ol', false);
    });
  }

  // strip sentinel
  text = text.replace(/¨0/, '');

  let afterEvent = new showdown.Event('makehtml.list.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;

  /**
   * Process the contents of a single ordered or unordered list, splitting it
   * into individual list items.
   * @param {string} listStr
   * @param {boolean} trimTrailing
   * @returns {string}
   */
  function processListItems (listStr, trimTrailing) {
    // The $g_list_level global keeps track of when we're inside a list.
    // Each time we enter a list, we increment it; when we leave a list,
    // we decrement. If it's zero, we're not in a list anymore.
    //
    // We do this because when we're not inside a list, we want to treat
    // something like this:
    //
    //    I recommend upgrading to version
    //    8. Oops, now this line is treated
    //    as a sub-list.
    //
    // As a single paragraph, despite the fact that the second line starts
    // with a digit-period-space sequence.
    //
    // Whereas when we're inside a list (or sub-list), that line will be
    // treated as the start of a sub-list. What a kludge, huh? This is
    // an aspect of Markdown's syntax that's hard to parse perfectly
    // without resorting to mind-reading. Perhaps the solution is to
    // change the syntax rules such that sub-lists must start with a
    // starting cardinal number; e.g. "1." or "a.".
    globals.gListLevel++;

    // trim trailing blank lines:
    listStr = listStr.replace(/\n{2,}$/, '\n');

    // attacklab: add sentinel to emulate \z
    listStr += '¨0';

    let rgx = /(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[([xX ])])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(¨0| {0,3}([*+-]|\d+[.])[ \t]+))/gm,
        isParagraphed = (/\n[ \t]*\n(?!¨0)/.test(listStr));

    // Since version 1.5, nesting sublists requires 4 spaces (or 1 tab) indentation,
    // which is a syntax breaking change
    // activating this option reverts to old behavior
    // This will be removed in version 2.0
    if (options.disableForced4SpacesIndentedSublists) {
      rgx = /(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[([xX ])])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(¨0|\2([*+-]|\d+[.])[ \t]+))/gm;
    }

    listStr = listStr.replace(rgx, function (wholeMatch, m1, m2, m3, m4, taskbtn, checkedRaw) {
      let item = showdown.helper.outdent(m4),
          attributes = {},
          checked = (checkedRaw && checkedRaw.trim() !== ''),
          eventName = 'makehtml.list.listItem',
          captureStartEvent,
          matches = {
            _wholeMatch: wholeMatch,
            listItem: item,
          };


      // Support for github tasklists. GFM requires whitespace after the marker (see
      // makehtml.list.taskListItem.checkbox), so a bare `[ ]`/`[ ]x` is not a task and is left literal.
      if (taskbtn && options.tasklists && /^[ \t]*\[[xX ]][ \t]/.test(item)) {
        // it's a github tasklist and tasklists are enabled

        // Bare `<li>` per the GFM spec; the legacy bullet styling/classes are only added
        // when `moreStyling` is enabled.
        if (options.moreStyling) {
          attributes.classes = ['task-list-item'];
          attributes.style = 'list-style-type: none;';
          if (checked) {
            attributes.classes.push('task-list-item-complete');
          }
        }
        eventName = 'makehtml.list.taskListItem';
        matches._taskListButton = taskbtn;
        matches._taskListButtonChecked = checkedRaw;
      }


      captureStartEvent = new showdown.Event(eventName + '.onCapture', item);
      captureStartEvent
        .setOutput(null)
        ._setGlobals(globals)
        ._setOptions(options)
        .setRegexp(rgx)
        .setMatches(matches)
        .setAttributes(attributes);
      captureStartEvent = globals.converter.dispatch(captureStartEvent);

      // if something was passed as output, it takes precedence
      // and will be used as output
      if (captureStartEvent.output && captureStartEvent.output !== '') {
        item = captureStartEvent.output;
      } else {

        attributes = captureStartEvent.attributes;
        item = captureStartEvent.matches.listItem;

        // even if user there's no tasklist, it's fine because the tasklist handler will bail without raising the event
        if (options.tasklists) {
          item = showdown.subParser('makehtml.list.taskListItem.checkbox')(item, options, globals);
        }

        // ISSUE #312
        // This input: - - - a
        // causes trouble to the parser, since it interprets it as:
        // <ul><li><li><li>a</li></li></li></ul>
        // instead of:
        // <ul><li>- - a</li></ul>
        // So, to prevent it, we will put a marker (¨A)in the beginning of the line
        // Kind of hackish/monkey patching, but seems more effective than overcomplicating the list parser
        item = item.replace(/^([-*+]|\d\.)[ \t]+[\S\n ]*/g, function (wm2) {
          return '¨A' + wm2;
        });

        // SPECIAL CASE: a heading followed by a paragraph of text that is not separated by a double newline
        // or/nor indented. ex:
        //
        // - # foo
        // bar is great
        //
        // While this does now follow the spec per se, not allowing for this might cause confusion since
        // header blocks don't need double-newlines after
        if (/^#+.+\n.+/.test(item)) {
          item = item.replace(/^(#+.+)$/m, '$1\n');
        }

        // m1 - Leading line or
        // Has a double return (multi paragraph)
        if (m1 || (item.search(/\n{2,}/) > -1)) {
          item = showdown.subParser('makehtml.githubCodeBlock')(item, options, globals);
          item = showdown.subParser('makehtml.blockquote')(item, options, globals);
          item = showdown.subParser('makehtml.heading')(item, options, globals);
          item = showdown.subParser('makehtml.list')(item, options, globals);
          item = showdown.subParser('makehtml.codeBlock')(item, options, globals);
          item = showdown.subParser('makehtml.table')(item, options, globals);
          item = showdown.subParser('makehtml.hashHTMLBlocks')(item, options, globals);
          //item = showdown.subParser('makehtml.paragraphs')(item, options, globals);

          // TODO: This is a copy of the paragraph parser
          // This is a provisory fix for issue #494
          // For a permanent fix we need to rewrite the paragraph parser, passing the unhashify logic outside
          // so that we can call the paragraph parser without accidently unashifying previously parsed blocks

          // Strip leading and trailing lines:
          item = item.replace(/^\n+/g, '');
          item = item.replace(/\n+$/g, '');

          let grafs = item.split(/\n{2,}/g),
              grafsOut = [],
              end = grafs.length; // Wrap <p> tags

          for (let i = 0; i < end; i++) {
            let str = grafs[i];
            // if this is an HTML marker, copy it
            if (str.search(/¨([KG])(\d+)\1/g) >= 0) {
              grafsOut.push(str);

              // test for presence of characters to prevent empty lines being parsed
              // as paragraphs (resulting in undesired extra empty paragraphs)
            } else if (str.search(/\S/) >= 0) {
              str = showdown.subParser('makehtml.spanGamut')(str, options, globals);
              str = str.replace(/^([ \t]*)/g, '<p>');
              str += '</p>';
              grafsOut.push(str);
            }
          }
          item = grafsOut.join('\n');
          // Strip leading and trailing lines:
          item = item.replace(/^\n+/g, '');
          item = item.replace(/\n+$/g, '');

        } else {

          // Recursion for sub-lists:
          item = showdown.subParser('makehtml.list')(item, options, globals);
          item = item.replace(/\n$/, ''); // chomp(item)
          item = showdown.subParser('makehtml.hashHTMLBlocks')(item, options, globals);

          // Colapse double linebreaks
          item = item.replace(/\n\n+/g, '\n\n');

          if (isParagraphed) {
            item = showdown.subParser('makehtml.paragraphs')(item, options, globals);
          } else {
            item = showdown.subParser('makehtml.spanGamut')(item, options, globals);
          }
        }

        // now we need to remove the marker (¨A)
        item = item.replace('¨A', '');
        // we can finally wrap the line in list item tags

        item =  '<li' + showdown.helper._populateAttributes(attributes) + '>' + item + '</li>\n';

      }

      let beforeHashEvent = new showdown.Event(eventName + '.onHash', item);
      beforeHashEvent
        .setOutput(item)
        ._setGlobals(globals)
        ._setOptions(options);
      beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
      return beforeHashEvent.output;
    });

    // attacklab: strip sentinel
    listStr = listStr.replace(/¨0/g, '');

    globals.gListLevel--;

    if (trimTrailing) {
      listStr = listStr.replace(/\s+$/, '');
    }

    return listStr;
  }

  /**
   *
   * @param {string} list
   * @param {string} listType
   * @returns {string|null}
   */
  function styleStartNumber (list, listType) {
    // check if ol and starts by a number different than 1
    if (listType === 'ol') {
      let res = list.match(/^ *(\d+)\./);
      if (res && res[1] !== '1') {
        return res[1];
      }
    }
    return null;
  }

  /**
   * Check and parse consecutive lists (better fix for issue #142)
   * @param {RegExp} pattern
   * @param {string} list
   * @param {string} listType
   * @param {boolean} trimTrailing
   * @returns {string}
   */
  function parseConsecutiveLists (pattern, list, listType, trimTrailing) {
    let otp = '';
    let captureStartEvent = new showdown.Event('makehtml.list.onCapture', list);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(pattern)
      .setMatches({
        _wholeMatch: list,
        list: list
      })
      .setAttributes({});
    captureStartEvent = globals.converter.dispatch(captureStartEvent);
    let attributes = captureStartEvent.attributes;
    // if something was passed as output, it takes precedence
    // and will be used as output
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      otp = captureStartEvent.output;
    } else {

      // check if we caught 2 or more consecutive lists by mistake
      // we use the counterRgx, meaning if listType is UL we look for OL and vice versa
      const olRgx = (options.disableForced4SpacesIndentedSublists) ? /^ ?\d+\.[ \t]/gm : /^ {0,3}\d+\.[ \t]/gm;
      const ulRgx = (options.disableForced4SpacesIndentedSublists) ? /^ ?[*+-][ \t]/gm : /^ {0,3}[*+-][ \t]/gm;
      let counterRxg = (listType === 'ul') ? olRgx : ulRgx;

      let attrs = showdown.helper.cloneObject(attributes);
      if (list.search(counterRxg) !== -1) {

        (function parseCL (txt) {
          let pos = txt.search(counterRxg);
          attrs.start = styleStartNumber(list, listType);

          if (pos !== -1) {
            // slice
            otp += '\n\n<' + listType + showdown.helper._populateAttributes(attrs) + '>\n' + processListItems(txt.slice(0, pos), !!trimTrailing) + '</' + listType + '>\n';

            // invert counterType and listType
            listType = (listType === 'ul') ? 'ol' : 'ul';
            counterRxg = (listType === 'ul') ? olRgx : ulRgx;

            //recurse
            parseCL(txt.slice(pos), attrs);
          } else {
            otp += '\n\n<' + listType + showdown.helper._populateAttributes(attrs) + '>\n' + processListItems(txt, !!trimTrailing) + '</' + listType + '>\n';
          }
        })(list, attributes);

      } else {
        attrs.start = styleStartNumber(list, listType);
        otp = '\n\n<' + listType + showdown.helper._populateAttributes(attrs) + '>\n' + processListItems(list, !!trimTrailing) + '</' + listType + '>\n';
      }
    }

    let beforeHashEvent = new showdown.Event('makehtml.list.onHash', otp);
    beforeHashEvent
      .setOutput(otp)
      ._setGlobals(globals)
      ._setOptions(options);
    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    return beforeHashEvent.output;
  }
});

/**
 * Parse metadata at the top of the document
 */
showdown.subParser('makehtml.metadata', function (text, options, globals) {
  'use strict';

  if (!options.metadata) {
    return text;
  }

  let startEvent = new showdown.Event('makehtml.metadata.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  /**
   * @param {RegExp} pattern
   * @param {string} wholeMatch
   * @param {string} format
   * @param {string} content
   * @returns {string}
   */
  function parseMetadataContents (pattern, wholeMatch, format, content) {
    let otp;
    let captureStartEvent = new showdown.Event('makehtml.metadata.onCapture', content);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(pattern)
      .setMatches({
        _wholeMatch: wholeMatch,
        format: format,
        content: content
      })
      .setAttributes({});
    captureStartEvent = globals.converter.dispatch(captureStartEvent);

    format = captureStartEvent.matches.format;
    content = captureStartEvent.matches.content;

    // if something was passed as output, it will be used as output
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      otp = captureStartEvent.output;
    } else {
      otp = '¨M';
    }

    // raw is raw so it's not changed in any way
    globals.metadata.raw = content;
    globals.metadata.format = format;

    // escape chars significant in html element and attribute contexts so metadata
    // values/keys can't break out of <title>, <meta ...> or the doctype when
    // completeHTMLDocument concatenates them into the document head
    content = showdown.helper.escapeHTMLEntities(content)
    // Restore dollar signs and tremas
      .replace(/¨D/g, '$$')
      .replace(/¨T/g, '¨')
      // replace multiple spaces
      .replace(/\n {4}/g, ' ');

    content.replace(/^([\S ]+): +([\s\S]+?)$/gm, function (wm, key, value) {
      globals.metadata.parsed[key] = value;
      return '';
    });
    let beforeHashEvent = new showdown.Event('makehtml.metadata.onHash', otp);
    beforeHashEvent
      .setOutput(otp)
      ._setGlobals(globals)
      ._setOptions(options);
    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    otp = beforeHashEvent.output;
    if (!otp) {
      otp = '¨M';
    }
    return otp;
  }

  // 1. Metadata with «««»»» delimiters
  const rgx1 = /^\s*«««+\s*(\S*?)\n([\s\S]+?)\n»»»+\s*\n/;
  text = text.replace(rgx1, function (wholeMatch, format, content) {
    return parseMetadataContents(rgx1, wholeMatch, format, content);
  });

  // 2. Metadata with YAML delimiters
  const rgx2 = /^\s*---+\s*(\S*?)\n([\s\S]+?)\n---+\s*\n/;
  text = text.replace(rgx2, function (wholeMatch, format, content) {
    return parseMetadataContents(rgx1, wholeMatch, format, content);
  });
  text = text.replace(/¨M/g, '');
  let afterEvent = new showdown.Event('makehtml.metadata.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

/**
 *
 */
showdown.subParser('makehtml.paragraphs', function (text, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makehtml.paragraphs.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  // Strip leading and trailing lines:
  text = text.replace(/^\n+/g, '');
  text = text.replace(/\n+$/g, '');

  let grafs = text.split(/\n{2,}/g),
      grafsOut = [],
      end = grafs.length; // Wrap <p> tags

  for (let i = 0; i < end; i++) {
    let str = grafs[i];
    // if this is an HTML marker, copy it (¨R = a raw CommonMark HTML block, deferred past
    // decodeEntities and restored later - it must not be <p>-wrapped or unhashed here)
    if (str.search(/¨([KGR])(\d+)\1/g) >= 0) {
      grafsOut.push(str);

    // test for presence of characters to prevent empty lines being parsed
    // as paragraphs (resulting in undesired extra empty paragraphs)
    } else if (str.search(/\S/) >= 0) {
      str = showdown.subParser('makehtml.spanGamut')(str, options, globals);
      str = str.replace(/^([ \t]*)/g, '<p>');
      str += '</p>';
      grafsOut.push(str);
    }
  }

  /** Unhashify HTML blocks */
  end = grafsOut.length;
  for (let i = 0; i < end; i++) {
    let blockText,
        grafsOutIt = grafsOut[i],
        codeFlag = false;
    // if this is a marker for an html block...
    let blockMatch;
    while ((blockMatch = /¨([KG])(\d+)\1/.exec(grafsOutIt)) !== null) {
      let delim = blockMatch[1],
          num   = blockMatch[2];

      if (delim === 'K') {
        blockText = globals.gHtmlBlocks[num];
      } else {
        // we need to check if ghBlock is a false positive
        if (codeFlag) {
          // use encoded version of all text
          blockText = showdown.subParser('makehtml.encodeCode')(globals.ghCodeBlocks[num].text, options, globals);
        } else {
          blockText = globals.ghCodeBlocks[num].codeblock;
        }
      }
      blockText = blockText.replace(/\$/g, '$$$$'); // Escape any dollar signs

      grafsOutIt = grafsOutIt.replace(/(\n\n)?¨([KG])\d+\2(\n\n)?/, blockText);
      // Check if grafsOutIt is a pre->code
      if (/^<pre\b[^>]*>\s*<code\b[^>]*>/.test(grafsOutIt)) {
        codeFlag = true;
      }
    }
    grafsOut[i] = grafsOutIt;
  }
  text = grafsOut.join('\n');
  // Strip leading and trailing lines:
  text = text.replace(/^\n+/g, '');
  text = text.replace(/\n+$/g, '');

  let afterEvent = new showdown.Event('makehtml.paragraphs.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

/**
 * Run extension
 */
showdown.subParser('makehtml.runExtension', function (ext, text, options, globals) {
  'use strict';

  if (ext.filter) {
    text = ext.filter(text, globals.converter, options);

  } else if (ext.regex) {
    // TODO remove this when old extension loading mechanism is deprecated
    let re = ext.regex;
    if (!(re instanceof RegExp)) {
      re = new RegExp(re, 'g');
    }
    text = text.replace(re, ext.replace);
  }

  return text;
});

/**
 * These are all the transformations that occur *within* block-level
 * tags like paragraphs, headers, and list items.
 */
showdown.subParser('makehtml.spanGamut', function (text, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makehtml.spanGamut.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  if (options.cmSpec) {
    // underline runs BEFORE cmInline (mirroring the legacy order, where underline runs
    // before emphasisAndStrong): it claims `__`/`___` as `<u>` and escapes any remaining
    // `_`, so cmInline doesn't consume those underscores as emphasis. cmInline then hashes
    // the raw `<u>` tags as CommonMark raw HTML and leaves the escaped `_` placeholders be.
    text = showdown.subParser('makehtml.underline')(text, options, globals);

    // Unified CommonMark inline parser: code spans, backslash escapes, entities,
    // autolinks, raw HTML, links, images and emphasis resolved together on one
    // delimiter stack (replaces the sequential codeSpan/link/image/emphasis passes
    // and the raw-HTML hashing below). The remaining Showdown-only extras (emoji,
    // strikethrough, ellipsis) and the final encodeAmpsAndAngles/hardLineBreaks run
    // after, on the non-hashed text.
    text = showdown.subParser('makehtml.cmInline')(text, options, globals);

    text = showdown.subParser('makehtml.emoji')(text, options, globals);
    text = showdown.subParser('makehtml.strikethrough')(text, options, globals);
    text = showdown.subParser('makehtml.ellipsis')(text, options, globals);

    // hash the raw HTML these extras produce (e.g. strikethrough's `<del>`, image-based
    // emoji's `<img>`) before encodeAmpsAndAngles, otherwise their `<`/`>` get escaped to
    // `&lt;`/`&gt;`. Mirrors the legacy branch, which hashes spans before encoding.
    text = showdown.subParser('makehtml.hashHTMLSpans')(text, options, globals);

    text = showdown.subParser('makehtml.encodeAmpsAndAngles')(text, options, globals);
    text = showdown.subParser('makehtml.hardLineBreaks')(text, options, globals);

    let cmAfterEvent = new showdown.Event('makehtml.spanGamut.onEnd', text);
    cmAfterEvent
      .setOutput(text)
      ._setGlobals(globals)
      ._setOptions(options);
    cmAfterEvent = globals.converter.dispatch(cmAfterEvent);
    return cmAfterEvent.output;
  }

  text = showdown.subParser('makehtml.codeSpan')(text, options, globals);
  text = showdown.subParser('makehtml.escapeSpecialCharsWithinTagAttributes')(text, options, globals);
  text = showdown.subParser('makehtml.encodeBackslashEscapes')(text, options, globals);

  // Process link and image tags. Images must come first,
  // because ![foo][f] looks like a link.
  text = showdown.subParser('makehtml.image')(text, options, globals);
  text = showdown.subParser('makehtml.link')(text, options, globals);

  if (options.cmSpec) {
    // CommonMark inline raw HTML: recognize well-formed tags/comments/PIs/
    // declarations/CDATA and hash them now - after backslash escapes and link/image
    // destinations are resolved, but before emphasis - so that markup characters
    // inside a tag (e.g. `<a href="**">`) are not parsed as emphasis. Malformed
    // `<…>` is left for encodeAmpsAndAngles to escape. Fresh regex per call (this
    // subparser runs re-entrantly).
    text = text.replace(new RegExp(showdown.helper.regexes.cmHTMLTagSource, 'g'), function (wm) {
      // Backslash escapes are not processed inside raw HTML, so restore any escape
      // placeholders that encodeBackslashEscapes produced back to literal `\<char>`.
      wm = wm.replace(/¨E(\d+)E/g, function (m, code) {
        return '\\' + String.fromCharCode(parseInt(code, 10));
      });
      return showdown.helper._hashHTMLSpan(wm, globals);
    });
  }

  text = showdown.subParser('makehtml.emoji')(text, options, globals);
  text = showdown.subParser('makehtml.underline')(text, options, globals);
  text = showdown.subParser('makehtml.emphasisAndStrong')(text, options, globals);
  text = showdown.subParser('makehtml.strikethrough')(text, options, globals);
  text = showdown.subParser('makehtml.ellipsis')(text, options, globals);

  // we need to hash HTML tags inside spans
  text = showdown.subParser('makehtml.hashHTMLSpans')(text, options, globals);

  // now we encode amps and angles
  text = showdown.subParser('makehtml.encodeAmpsAndAngles')(text, options, globals);

  text = showdown.subParser('makehtml.hardLineBreaks')(text, options, globals);

  let afterEvent = new showdown.Event('makehtml.spanGamut.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

showdown.subParser('makehtml.strikethrough', function (text, options, globals) {
  'use strict';
  if (!options.strikethrough) {
    return text;
  }

  let startEvent = new showdown.Event('makehtml.strikethrough.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  // GFM strikethrough: a run of one or two tildes, matched in length, with flanking
  // (the run must hug non-whitespace on the inside) and rejecting runs of three or more.
  // Group 1 captures the character before the opening run (or the string start) so it can
  // be restored; group 3 is the struck-through content.
  const strikethroughRegex = /(^|[^~])(~{1,2})(?=[^\s~])([\s\S]*?[^\s~])\2(?!~)/g;
  text = text.replace(strikethroughRegex, function (wholeMatch, prefix, run, txt) {

    let otp;
    let captureStartEvent = new showdown.Event('makehtml.strikethrough.onCapture', txt);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(strikethroughRegex)
      .setMatches({
        _wholeMatch: wholeMatch,
        strikethrough: txt
      })
      .setAttributes({});
    captureStartEvent = globals.converter.dispatch(captureStartEvent);
    // if something was passed as output, it takes precedence
    // and will be used as output
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      otp = captureStartEvent.output;
    } else {
      otp = '<del' + showdown.helper._populateAttributes(captureStartEvent.attributes) + '>' +
            showdown.subParser('makehtml.hardLineBreaks')(txt, options, globals) +
            '</del>';
    }

    let beforeHashEvent = new showdown.Event('makehtml.strikethrough.onHash', otp);
    beforeHashEvent
      .setOutput(otp)
      ._setGlobals(globals)
      ._setOptions(options);
    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    // restore the character that preceded the opening run
    return prefix + beforeHashEvent.output;
  });

  let afterEvent = new showdown.Event('makehtml.strikethrough.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

/**
 * Strips link definitions from text, stores the URLs and titles in
 * hash references.
 * Link defs are in the form: ^[id]: url "optional title"
 */
showdown.subParser('makehtml.stripLinkDefinitions', function (text, options, globals) {
  'use strict';

  const regex     = /^ {0,3}\[([^\]]+)]:[ \t]*\n?[ \t]*<?([^>\s]+)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n+|(?=¨0))/gm,
      base64Regex = /^ {0,3}\[([^\]]+)]:[ \t]*\n?[ \t]*<?(data:.+?\/.+?;base64,[A-Za-z\d+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n\n|(?=¨0)|(?=\n\[))/gm;

  let startEvent = new showdown.Event('makehtml.stripLinkDefinitions.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  // attacklab: sentinel workarounds for lack of \A and \Z, safari\khtml bug
  text += '¨0';

  let replaceFunc = function (wholeMatch, linkId, url, width, height, blankLines, title) {

    // Link IDs are case-insensitive
    linkId = showdown.helper.caseFold(linkId);

    let captureStartEvent = new showdown.Event('makehtml.stripLinkDefinitions.onCapture', wholeMatch);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(regex)
      .setMatches({
        _wholeMatch: wholeMatch,
        linkId: linkId,
        url: url,
        width: width,
        height: height,
        blankLines: blankLines,
        title: title
      })
      .setAttributes({});
    captureStartEvent = globals.converter.dispatch(captureStartEvent);

    let otp;
    // if something was passed as output, it takes precedence and will be used as output
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      otp = captureStartEvent.output;
    } else {
      // a listener may have normalized the captured groups
      linkId     = captureStartEvent.matches.linkId;
      url        = captureStartEvent.matches.url;
      width      = captureStartEvent.matches.width;
      height     = captureStartEvent.matches.height;
      blankLines = captureStartEvent.matches.blankLines;
      title      = captureStartEvent.matches.title;

      if (url.match(/^data:.+?\/.+?;base64,/)) {
        // remove newlines
        globals.gUrls[linkId] = url.replace(/\s/g, '');
      } else {
        url = showdown.helper.applyBaseUrl(options.relativePathBaseUrl, url);

        globals.gUrls[linkId] = showdown.subParser('makehtml.encodeAmpsAndAngles')(url, options, globals);
      }

      if (blankLines) {
        // Oops, found blank lines, so it's not a title.
        // Put back the parenthetical statement we stole.
        otp = blankLines + title;

      } else {
        if (title) {
          globals.gTitles[linkId] = title.replace(/["']/g, '&quot;');
        }
        if (options.parseImgDimensions && width && height) {
          globals.gDimensions[linkId] = {
            width:  width,
            height: height
          };
        }
        // Completely remove the definition from the text
        otp = '';
      }
    }

    let beforeHashEvent = new showdown.Event('makehtml.stripLinkDefinitions.onHash', otp);
    beforeHashEvent
      .setOutput(otp)
      ._setGlobals(globals)
      ._setOptions(options);
    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    return beforeHashEvent.output;
  };

  if (options.cmSpec) {
    text = parseCmLinkDefinitions(text);
  } else {
    // first we try to find base64 link references
    text = text.replace(base64Regex, replaceFunc);

    text = text.replace(regex, replaceFunc);
  }

  // attacklab: strip sentinel
  text = text.replace(/¨0/, '');

  let afterEvent = new showdown.Event('makehtml.stripLinkDefinitions.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;

  /**
   * CommonMark link reference definition parsing. Scans block by block: a
   * definition may appear at the start of the document, after a blank line, or
   * immediately after another definition. Supports multi-line definitions,
   * `<...>` (and empty `<>`) destinations, multi-line titles, backslash escapes
   * and first-definition-wins for duplicate labels.
   * @param {string} str text with the trailing `¨0` sentinel
   * @returns {string}
   */
  function parseCmLinkDefinitions (str) {
    let n = str.length,
        out = '',
        i = 0,
        atBlockStart = true;
    while (i < n) {
      if (atBlockStart) {
        let def = tryParseCmDefinition(str, i);
        if (def) {
          commitDefinition(def);
          i = def.end;
          atBlockStart = true; // consecutive definitions are allowed
          continue;
        }
      }
      // consume one line verbatim
      let nl = str.indexOf('\n', i);
      if (nl === -1) {
        out += str.slice(i);
        break;
      }
      let line = str.slice(i, nl + 1);
      out += line;
      i = nl + 1;
      // A definition can begin after a blank line or after a self-contained leaf
      // block such as an ATX heading or a thematic break, but it must not
      // interrupt a paragraph.
      atBlockStart = /^[ \t]*\n$/.test(line) ||
        /^ {0,3}#{1,6}(?:[ \t]|\n)/.test(line) ||
        /^ {0,3}([-*_])[ \t]*(?:\1[ \t]*){2,}\n$/.test(line);
    }
    return out;
  }

  /**
   * Store a parsed definition, honoring first-definition-wins, and dispatch the
   * capture event so listener extensions still observe link-definition captures.
   * @param {{linkId: string, url: string, title: (string|null), wholeMatch: string}} def
   */
  function commitDefinition (def) {
    let captureStartEvent = new showdown.Event('makehtml.stripLinkDefinitions.onCapture', def.wholeMatch);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(null)
      .setMatches({
        _wholeMatch: def.wholeMatch,
        linkId: def.linkId,
        url: def.url,
        title: def.title
      })
      .setAttributes({});
    captureStartEvent = globals.converter.dispatch(captureStartEvent);
    let linkId = captureStartEvent.matches.linkId,
        url = captureStartEvent.matches.url,
        title = captureStartEvent.matches.title;

    // first definition wins
    if (showdown.helper.isUndefined(globals.gUrls[linkId])) {
      globals.gUrls[linkId] = url;
      if (title !== null && !showdown.helper.isUndefined(title)) {
        globals.gTitles[linkId] = title;
      }
      // parseImgDimensions: store reference-style dimensions (gating copied from the
      // legacy stripLinkDefinitions replaceFunc); consumed by cmInline's image builder
      if (options.parseImgDimensions && def.width && def.height) {
        globals.gDimensions[linkId] = { width: def.width, height: def.height };
      }
    }
  }

  /**
   * Attempt to parse a single CommonMark link reference definition starting at
   * `start` (a line start). Returns the parsed definition with `end` (index just
   * past the consumed text) or `null` if there is no definition here.
   * @param {string} str
   * @param {number} start
   * @returns {{linkId: string, url: string, title: (string|null), wholeMatch: string, end: number}|null}
   */
  function tryParseCmDefinition (str, start) {
    let n = str.length,
        j = start,
        isEnd = function (p) { return p >= n || str.charAt(p) === '\n' || str.slice(p, p + 2) === '¨0'; };

    // up to 3 leading spaces
    let sp = 0;
    while (j < n && str.charAt(j) === ' ' && sp < 3) { j++; sp++; }
    if (str.charAt(j) !== '[') { return null; }
    j++;

    // label: up to the first unescaped ']', no nested '[' or blank line
    let label = '', sawNonWs = false;
    while (j < n) {
      let c = str.charAt(j);
      if (c === '\\' && j + 1 < n) { label += c + str.charAt(j + 1); j += 2; sawNonWs = true; continue; }
      if (c === ']') { break; }
      if (c === '[') { return null; }
      if (!/\s/.test(c)) { sawNonWs = true; }
      label += c; j++;
    }
    if (j >= n || str.charAt(j) !== ']' || !sawNonWs || /\n[ \t]*\n/.test(label)) { return null; }
    j++; // consume ']'
    if (str.charAt(j) !== ':') { return null; }
    j++;

    // whitespace (incl at most one line ending) before the destination
    let nlCount = 0;
    while (j < n && /[ \t\n]/.test(str.charAt(j))) {
      if (str.charAt(j) === '\n') { nlCount++; if (nlCount > 1) { return null; } }
      j++;
    }

    let dest = showdown.helper.cmScanDestination(str, j);
    if (!dest || (!dest.angle && dest.url === '')) { return null; }
    let afterDest = dest.end,
        url = dest.url;

    // parseImgDimensions (Showdown extension, not CommonMark): an optional ` =WxH`
    // between the destination and the title. Always consumed here; only stored as
    // dimensions when the option is on (see commitDefinition). Regex fragment copied
    // from the inline image regex in image.js.
    let width = null, height = null;
    let dimPos = afterDest;
    while (dimPos < n && /[ \t]/.test(str.charAt(dimPos))) { dimPos++; }
    if (dimPos > afterDest && str.charAt(dimPos) === '=') {
      let dim = /^=([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4})/.exec(str.slice(dimPos));
      if (dim) {
        width = dim[1];
        height = dim[2];
        afterDest = dimPos + dim[0].length;
      }
    }

    // optional title, separated from the destination by whitespace (and at most
    // one line ending, with no blank line)
    let k = afterDest, sawSpace = false, sawNl = false;
    while (k < n && /[ \t]/.test(str.charAt(k))) { k++; sawSpace = true; }
    if (str.charAt(k) === '\n') { sawNl = true; k++; while (k < n && /[ \t]/.test(str.charAt(k))) { k++; } }

    let title = null, end;
    let tc = str.charAt(k);
    if ((sawSpace || sawNl) && (tc === '"' || tc === '\'' || tc === '(')) {
      let t = showdown.helper.cmScanTitle(str, k);
      if (t) {
        let p = t.end;
        while (p < n && /[ \t]/.test(str.charAt(p))) { p++; }
        if (isEnd(p)) {
          title = t.title;
          end = (str.charAt(p) === '\n') ? p + 1 : p;
        }
      }
    }

    if (title === null) {
      // no (valid) title: the destination must be the last token on its line
      let p = afterDest;
      while (p < n && /[ \t]/.test(str.charAt(p))) { p++; }
      if (!isEnd(p)) { return null; }
      end = (str.charAt(p) === '\n') ? p + 1 : p;
    }

    let linkId = showdown.helper.cmNormalizeLabel(label);
    if (linkId === '') { return null; }

    if (url.match(/^data:.+?\/.+?;base64,/)) {
      url = url.replace(/\s/g, '');
    } else {
      url = showdown.helper.cmNormalizeURL(showdown.helper.applyBaseUrl(options.relativePathBaseUrl, url));
    }
    if (title !== null) { title = showdown.helper.cmEscapeTitle(title); }

    return {
      linkId: linkId,
      url: url,
      title: title,
      width: width,
      height: height,
      wholeMatch: str.slice(start, end),
      end: end
    };
  }
});

showdown.subParser('makehtml.table', function (text, options, globals) {
  'use strict';

  if (!options.tables) {
    return text;
  }

  //
  // parser starts here
  //
  let startEvent = new showdown.Event('makehtml.table.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  // GFM §4.10: a table is broken at the first line that begins another
  // block-level construct (blockquote, ATX heading, fenced code, thematic
  // break). Such a line is not a table row, so we split it — and everything
  // after it — off the match. Because `table` runs immediately before
  // `blockquote` (and the rest of blockGamut) in the pipeline, the returned
  // tail is reprocessed and converted normally.
  const blockStartRgx = /^ {0,3}(?:>|#{1,6}(?:[ \t]|$)|```|~~~|(?:\*[ \t]*){3,}$|(?:-[ \t]*){3,}$|(?:_[ \t]*){3,}$)/;

  // parse multi column tables.
  // The header row is matched as `(?=[^\n]*\|)[^\n]+\n` (a whole line that contains at least one
  // pipe) instead of `\|?.+\|.+\n`. The old form had two greedy `.+` around a `\|`, so when the
  // following delimiter row failed to match it backtracked over every pipe position in the header
  // — quadratic on a long pipe-heavy line like `'|a'.repeat(n)`. The lookahead + single greedy
  // `[^\n]+` matches the same set of header lines without that backtracking.
  const tableRgx = /^ {0,3}(?=[^\n]*\|)[^\n]+\n {0,3}\|?[ \t]*:?[ \t]*[-=]+[ \t]*:?[ \t]*\|[ \t]*:?[ \t]*[-=]+[\s\S]+?(?:\n\n|¨0)/gm;
  text = text.replace(tableRgx, function (wholeMatch) {
    let split = breakOnBlock(wholeMatch);
    // Neutralize escaped pipes only within the actual table text (not the trailing block
    // or any non-table content) so `\|` inside code spans elsewhere is left for the normal
    // backslash-escape / code-span passes to handle.
    let table = split.table.replace(/\\(\|)/g, showdown.helper.escapeCharactersCallback);
    return parse(tableRgx, table) + split.tail;
  });

  const singeColTblRgx = /^ {0,3}\|.+\|[ \t]*\n {0,3}\|?[ \t]*:?[ \t]*[-=]+[ \t]*:?[ \t]*\|[ \t]*\n( {0,3}\|.+\|[ \t]*\n)*(?:\n|¨0)/gm;
  text = text.replace(singeColTblRgx, function (wholeMatch) {
    let table = wholeMatch.replace(/\\(\|)/g, showdown.helper.escapeCharactersCallback);
    return parse(singeColTblRgx, table);
  });

  let afterEvent = new showdown.Event('makehtml.table.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;



  /**
   * Split a greedily-matched table block at the first body line that begins
   * another block-level construct. The header (line 0) and delimiter (line 1)
   * are never terminators; scanning starts at the first body row.
   * @param {string} wholeMatch
   * @returns {{table: string, tail: string}}
   */
  function breakOnBlock (wholeMatch) {
    let lines = wholeMatch.split('\n');
    for (let i = 2; i < lines.length; ++i) {
      if (blockStartRgx.test(lines[i])) {
        return {
          table: lines.slice(0, i).join('\n') + '\n',
          tail: lines.slice(i).join('\n')
        };
      }
    }
    return { table: wholeMatch, tail: '' };
  }

  /**
   *
   * @param {RegExp} pattern
   * @param {string} wholeMatch
   * @returns {string}
   */
  function parse (pattern, wholeMatch) {
    let tab = preParse(wholeMatch);

    // if parseTable returns null then it's a malformed table so we return what we caught
    if (!tab) {
      return wholeMatch;
    }

    // only now we consider it to be a markdown table and start doing stuff
    let headers = tab.rawHeaders;
    let styles = tab.rawStyles;
    let cells = tab.rawCells;

    let otp;
    let captureStartEvent = new showdown.Event('makehtml.table.onCapture', wholeMatch);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(pattern)
      .setMatches({
        _wholeMatch: wholeMatch,
        table: wholeMatch
      })
      .setAttributes({});
    captureStartEvent = globals.converter.dispatch(captureStartEvent);
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      // user provided an otp, so we use it
      otp = captureStartEvent.output;
    } else {
      // user changed matches.table, so we need to generate headers, styles, and cells again
      if (captureStartEvent.matches.table !== wholeMatch) {
        tab = preParse(captureStartEvent.matches.table);
        // user passed a malformed table, so we bail
        if (!tab) {
          return wholeMatch;
        }
        headers = tab.rawHeaders;
        styles = tab.rawStyles;
        cells = tab.rawCells;
      }
      let parsedTab = parseTable (headers, styles, cells);
      let attributes = captureStartEvent.attributes;
      otp = buildTableOtp(parsedTab.headers, parsedTab.cells, attributes);
    }

    let beforeHashEvent = new showdown.Event('makehtml.table.onHash', otp);
    beforeHashEvent
      .setOutput(otp)
      ._setGlobals(globals)
      ._setOptions(options);
    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    otp = beforeHashEvent.output;
    return otp;
  }

  /**
   *
   * @param {string[]} headers
   * @param {string[]} cells
   * @param {{}} attributes
   * @returns {string}
   */
  function buildTableOtp (headers, cells, attributes) {
    let otp;
    const colCount = headers.length,
        rowCount = cells.length;

    otp = '<table' + showdown.helper._populateAttributes(attributes) + '>\n<thead>\n<tr>\n';
    for (let i = 0; i < colCount; ++i) {
      otp += headers[i];
    }
    otp += '</tr>\n</thead>\n<tbody>\n';

    for (let i = 0; i < rowCount; ++i) {
      otp += '<tr>\n';
      for (let ii = 0; ii < colCount; ++ii) {
        otp += cells[i][ii];
      }
      otp += '</tr>\n';
    }
    otp += '</tbody>\n</table>\n';
    return otp;
  }

  /**
   * @param {string} rawTable
   * @returns {{rawHeaders: string[], rawStyles: string[], rawCells: *[]}|null}
   */
  function preParse (rawTable) {
    let tableLines = rawTable.split('\n');

    for (let i = 0; i < tableLines.length; ++i) {
      // strip wrong first and last column if wrapped tables are used
      if (/^ {0,3}\|/.test(tableLines[i])) {
        tableLines[i] = tableLines[i].replace(/^ {0,3}\|/, '');
      }
      if (/\|[ \t]*$/.test(tableLines[i])) {
        tableLines[i] = tableLines[i].replace(/\|[ \t]*$/, '');
      }
      // parse code spans first, but we only support one line code spans
      tableLines[i] = showdown.subParser('makehtml.codeSpan')(tableLines[i], options, globals);
    }

    let rawHeaders = tableLines[0].split('|').map(function (s) { return s.trim();}),
        rawStyles = tableLines[1].split('|').map(function (s) { return s.trim();}),
        rawCells = [];

    tableLines.shift();
    tableLines.shift();

    for (let i = 0; i < tableLines.length; ++i) {
      if (tableLines[i].trim() === '') {
        continue;
      }
      rawCells.push(
        tableLines[i]
          .split('|')
          .map(function (s) {
            return s.trim();
          })
      );
    }

    if (rawHeaders.length !== rawStyles.length) {
      return null;
    }

    return {
      rawHeaders: rawHeaders,
      rawStyles: rawStyles,
      rawCells: rawCells
    };
  }

  /**
   *
   * @param {string[]} rawHeaders
   * @param {string[]} rawStyles
   * @param {string[]} rawCells
   * @returns {{headers: *, cells: *}}
   */
  function parseTable (rawHeaders, rawStyles, rawCells) {
    const headers = [],
        cells = [],
        styles = [],
        colCount = rawHeaders.length,
        rowCount = rawCells.length;

    for (let i = 0; i < colCount; ++i) {
      styles.push(parseStyle(rawStyles[i]));
    }

    for (let i = 0; i < colCount; ++i) {
      let header;
      let captureStartEvent = new showdown.Event('makehtml.table.header.onCapture', rawHeaders[i]);
      captureStartEvent
        .setOutput(null)
        ._setGlobals(globals)
        ._setOptions(options)
        .setRegexp(null)
        .setMatches({
          _wholeMatch: rawHeaders[i],
          header: rawHeaders[i]
        })
        .setAttributes(styles[i]);
      captureStartEvent = globals.converter.dispatch(captureStartEvent);
      if (captureStartEvent.output && captureStartEvent.output !== '') {
        // user provided an otp, so we use it
        header = captureStartEvent.output;
      } else {
        header = parseHeader(captureStartEvent.matches.header, styles[i]);
      }
      let beforeHashEvent = new showdown.Event('makehtml.table.header.onHash', header);
      beforeHashEvent
        .setOutput(header)
        ._setGlobals(globals)
        ._setOptions(options);
      beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
      header = beforeHashEvent.output;

      headers.push(header);
    }

    for (let i = 0; i < rowCount; ++i) {
      let row = [];
      for (let ii = 0; ii < colCount; ++ii) {
        let cell = (!showdown.helper.isUndefined(rawCells[i][ii])) ? rawCells[i][ii] : '',
            attributes = (!showdown.helper.isUndefined(styles[ii])) ? styles[ii] : {};

        // since we're reusing attributes, we might need to remove the id that we previously set for headers
        if (attributes.id) {
          attributes.classes = [attributes.id] + '_col';
          delete attributes.id;
        }


        let captureStartEvent = new showdown.Event('makehtml.table.cell.onCapture', cell);
        captureStartEvent
          .setOutput(null)
          ._setGlobals(globals)
          ._setOptions(options)
          .setRegexp(null)
          .setMatches({
            _wholeMatch: cell,
            cell: cell
          })
          .setAttributes(attributes);
        captureStartEvent = globals.converter.dispatch(captureStartEvent);
        if (captureStartEvent.output && captureStartEvent.output !== '') {
          // user provided an otp, so we use it
          cell = captureStartEvent.output;
        } else {
          attributes = captureStartEvent.attributes;
          cell = parseCell(captureStartEvent.matches.cell, attributes);
        }
        let beforeHashEvent = new showdown.Event('makehtml.table.cell.onHash', cell);
        beforeHashEvent
          .setOutput(cell)
          ._setGlobals(globals)
          ._setOptions(options);
        beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
        cell = beforeHashEvent.output;

        row.push(cell);
      }
      cells.push(row);
    }

    return {headers: headers, cells: cells};
  }

  /**
   * @param {string} sLine
   * @returns {{}|{style: string}}
   */
  function parseStyle (sLine) {
    if (/^:[ \t]*-+$/.test(sLine)) {
      return { style: 'text-align:left;' };
    } else if (/^-+[ \t]*:[ \t]*$/.test(sLine)) {
      return { style: 'text-align:right;' };
    } else if (/^:[ \t]*-+[ \t]*:$/.test(sLine)) {
      return { style: 'text-align:center;' };
    } else {
      return {};
    }
  }

  /**
   *
   * @param {string} headerText
   * @param {{id: string}} attributes
   * @returns {string}
   */
  function parseHeader (headerText, attributes) {
    headerText = headerText.trim();

    // Derive the id from the raw header text *before* spanGamut runs. spanGamut hashes any
    // inline HTML/code into ¨-prefixed placeholders; lowercasing one for the id (¨C0C -> ¨c0c)
    // stops unhashHTMLSpans from ever restoring it, so the placeholder would otherwise leak
    // verbatim into the id (and the derived `_col` cell class). This mirrors the pre-refactor
    // ordering where the id came off the untouched header text.
    if (options.tablesHeaderId) {
      attributes.id = headerText.replace(/ /g, '_').toLowerCase();
    }

    headerText = showdown.subParser('makehtml.spanGamut')(headerText, options, globals);
    return '<th' + showdown.helper._populateAttributes(attributes) + '>' + headerText + '</th>\n';
  }

  /**
   *
   * @param {string} cellText
   * @param {{}} attributes
   * @returns {string}
   */
  function parseCell (cellText, attributes) {
    cellText = showdown.subParser('makehtml.spanGamut')(cellText, options, globals);
    return '<td' + showdown.helper._populateAttributes(attributes) + '>' + cellText + '</td>\n';
  }
});

////
// makehtml/taskListItem.js
// Copyright (c) 2024 ShowdownJS
//
// GFM task-list item renderer, shared by both list parsers.
//
// Given the raw text of a single list item, it matches a leading `[ ]`/`[x]`
// marker plus the rest of that line and renders the marker as a disabled
// `<input type="checkbox">`, leaving the line's text in place for the caller to
// parse further. It runs at the same (raw, pre-parse) stage in both
// `makehtml.list` (the default regex parser) and `makehtml.cmList` (the
// commonmark container-block parser), so the events below always expose the
// task item's raw source line on either path.
//
// Events (nested under the `makehtml.list.taskListItem` namespace that the default
// list parser already uses for its item-level events):
//   makehtml.list.taskListItem.checkbox.onCapture - fired on a matched task line.
//     `input` and `_wholeMatch` are the full source line (`[ ] foo *bar*`);
//     `attributes` are the checkbox attributes. Returning output overrides the line.
//   makehtml.list.taskListItem.checkbox.onHash    - fired with the rendered line
//     (`<input ...> foo *bar*`) before it is handed back to the caller.
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.list.taskListItem.checkbox', function (text, options, globals) {
  'use strict';

  if (!options.tasklists) {
    return text;
  }

  // Match the marker and the remainder of its (first) line. The text is captured so
  // the events expose the full line, not just the checkbox; everything after the line
  // is left untouched for the caller's block/span parsing.
  //
  // Per GFM the marker must be followed by at least one space/tab to be a task: a bare
  // `[ ]` (nothing after) or `[ ]x` (no whitespace) is left literal, matching cmark-gfm.
  const taskItemRgx = /^([ \t]*)\[([xX ])](?=[ \t])([^\n]*)/;
  return text.replace(taskItemRgx, function (wm, prefix, checkedRaw, lineText) {
    let checked = checkedRaw.trim() !== '';

    // GFM spec output is a bare `<input disabled type="checkbox">` (checked items add a
    // leading `checked`). Only when `moreStyling` is enabled do we keep the legacy inline
    // style that visually aligns the checkbox.
    let attributes = options.moreStyling ?
      {
        type: 'checkbox',
        disabled: true,
        style: 'margin: 0px 0.35em 0.25em -1.6em; vertical-align: middle;',
        checked: checked
      } :
      (checked ?
        { checked: true, disabled: true, type: 'checkbox' } :
        { disabled: true, type: 'checkbox' });

    let captureStartEvent = new showdown.Event('makehtml.list.taskListItem.checkbox.onCapture', wm);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(taskItemRgx)
      .setMatches({
        _wholeMatch: wm,
        _taskListButton: prefix + '[' + checkedRaw + ']',
        _taskListButtonChecked: checkedRaw,
        _taskListItemText: lineText
      })
      .setAttributes(attributes);
    captureStartEvent = globals.converter.dispatch(captureStartEvent);

    let otp;
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      otp = captureStartEvent.output;
    } else {
      attributes = captureStartEvent.attributes;
      let txt = captureStartEvent.matches._taskListItemText;
      otp = prefix + '<input' + showdown.helper._populateAttributes(attributes) + '>' + txt;
    }

    let beforeHashEvent = new showdown.Event('makehtml.list.taskListItem.checkbox.onHash', otp);
    beforeHashEvent
      .setOutput(otp)
      ._setGlobals(globals)
      ._setOptions(options);
    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    return beforeHashEvent.output;
  });
});

showdown.subParser('makehtml.underline', function (text, options, globals) {
  'use strict';

  if (!options.underline) {
    return text;
  }

  let startEvent = new showdown.Event('makehtml.underline.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  // Resolve an escaped underscore (`\_`) to the escape placeholder (¨E95E, charcode of
  // `_`), consuming the backslash, so it is neither underlined nor left with a stray `\`.
  // Needed because under cmSpec underline runs before backslash escapes are resolved; a
  // no-op in the legacy path, where `\_` is already a placeholder before this runs.
  text = text.replace(/\\_/g, '¨E95E');

  if (options.literalMidWordUnderscores) {

    const rgx1 = /\b___(\S[\s\S]*?)___\b/g;
    text = text.replace(rgx1, function (wm, txt) {
      return parse(rgx1, wm, txt);
    });

    const rgx2 = /\b__(\S[\s\S]*?)__\b/g;
    text = text.replace(rgx2, function (wm, txt) {
      return parse(rgx2, wm, txt);
    });
  } else {

    const rgx3 = /___(\S[\s\S]*?)___/g;
    text = text.replace(rgx3, function (wm, txt) {
      if (!(/\S$/.test(txt))) {
        return wm;
      }
      return parse(rgx3, wm, txt);
    });

    const rgx4 = /__(\S[\s\S]*?)__/g;
    text = text.replace(rgx4, function (wm, txt) {
      if (!(/\S$/.test(txt))) {
        return wm;
      }
      return parse(rgx4, wm, txt);
    });
  }

  // escape remaining underscores to prevent them being parsed by italic and bold
  text = text.replace(/(_)/g, showdown.helper.escapeCharactersCallback);

  let afterEvent = new showdown.Event('makehtml.underline.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;


  function parse (pattern, wholeMatch, txt) {
    let otp;
    let captureStartEvent = new showdown.Event('makehtml.underline.onCapture', txt);
    captureStartEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setRegexp(pattern)
      .setMatches({
        _wholeMatch: wholeMatch,
        strikethrough: txt
      })
      .setAttributes({});
    captureStartEvent = globals.converter.dispatch(captureStartEvent);
    // if something was passed as output, it takes precedence
    // and will be used as output
    if (captureStartEvent.output && captureStartEvent.output !== '') {
      otp = captureStartEvent.output;
    } else {
      otp = '<u' + showdown.helper._populateAttributes(captureStartEvent.attributes) + '>' +
        showdown.subParser('makehtml.hardLineBreaks')(txt, options, globals) +
        '</u>';
    }
    let beforeHashEvent = new showdown.Event('makehtml.underline.onHash', otp);
    beforeHashEvent
      .setOutput(otp)
      ._setGlobals(globals)
      ._setOptions(options);
    beforeHashEvent = globals.converter.dispatch(beforeHashEvent);
    return beforeHashEvent.output;
  }


});

/**
 * Swap back in all the special characters we've hidden.
 */
showdown.subParser('makehtml.unescapeSpecialChars', function (text, options, globals) {
  'use strict';
  let startEvent = new showdown.Event('makehtml.unescapeSpecialChars.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  text = text.replace(/¨E(\d+)E/g, function (wholeMatch, m1) {
    let charCodeToReplace = parseInt(m1);
    return String.fromCharCode(charCodeToReplace);
  });

  let afterEvent = new showdown.Event('makehtml.unescapeSpecialChars.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

////
// makehtml/unhashHTMLSpans.js
// Copyright (c) 2018 ShowdownJS
//
// Unhash HTML spans
//
// ***Author:***
// - Estêvão Soares dos Santos (Tivie) <https://github.com/tivie>
////


showdown.subParser('makehtml.unhashHTMLSpans', function (text, options, globals) {
  'use strict';
  let startEvent = new showdown.Event('makehtml.unhashHTMLSpans.onStart', text);
  startEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  startEvent = globals.converter.dispatch(startEvent);
  text = startEvent.output;

  // Resolve one span placeholder to its stored HTML, expanding any nested placeholders it
  // contains (bounded depth, mirrors the historical "assume 20 as limit for recurse").
  function resolveSpan (num) {
    let repText = globals.gHtmlSpans[num],
        limit = 0;
    while (/¨C(\d+)C/.test(repText)) {
      let n2 = repText.match(/¨C(\d+)C/)[1];
      repText = repText.replace('¨C' + n2 + 'C', globals.gHtmlSpans[n2]);
      if (limit === 10) {
        console.error('maximum nesting of 20 spans reached!!!');
        break;
      }
      ++limit;
    }
    return repText;
  }

  // Single pass over the document (was: one String.replace per span, i.e. O(spans × text) —
  // quadratic when the input produces many spans, e.g. `'a_'.repeat(n)`).
  text = text.replace(/¨C(\d+)C/g, function (whole, num) {
    return resolveSpan(num);
  });

  let afterEvent = new showdown.Event('makehtml.unhashHTMLSpans.onEnd', text);
  afterEvent
    .setOutput(text)
    ._setGlobals(globals)
    ._setOptions(options);
  afterEvent = globals.converter.dispatch(afterEvent);
  return afterEvent.output;
});

showdown.subParser('makeMarkdown.blockquote', function (node, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.blockquote.onStart', node.outerHTML);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    result = (function () {
      var txt = '';
      if (node.hasChildNodes()) {
        var children = node.childNodes,
            childrenLength = children.length;

        for (var i = 0; i < childrenLength; ++i) {
          var innerTxt = showdown.subParser('makeMarkdown.node')(children[i], options, globals);

          if (innerTxt === '') {
            continue;
          }
          txt += innerTxt;
        }
      }
      // cleanup
      txt = txt.trim();
      txt = '> ' + txt.split('\n').join('\n> ');
      return txt;
    })();
  }

  let endEvent = new showdown.Event('makeMarkdown.blockquote.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;
});

showdown.subParser('makeMarkdown.break', function (node, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.break.onStart', node.outerHTML);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    result = '  \n';
  }

  let endEvent = new showdown.Event('makeMarkdown.break.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;
});

showdown.subParser('makeMarkdown.codeBlock', function (node, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.codeBlock.onStart', node.outerHTML);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    let lang = node.getAttribute('language'),
        num  = node.getAttribute('precodenum'),
        code = globals.preList[num];
    if (options.ghCodeBlocks) {
      result = '```' + lang + '\n' + code + '\n```';
    } else {
      // fenced code blocks disabled -> emit raw HTML (re-escape the special chars that
      // substitutePreCodeTags decoded when it stashed the content)
      let escaped = code.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'),
          langClass = lang ? ' class="' + lang + '"' : '';
      result = '<pre><code' + langClass + '>' + escaped + '</code></pre>';
    }
  }

  let endEvent = new showdown.Event('makeMarkdown.codeBlock.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;
});

showdown.subParser('makeMarkdown.codeSpan', function (node, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.codeSpan.onStart', node.outerHTML);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    let code = showdown.helper.unescapeHTMLEntities(node.innerHTML);
    // pick a backtick fence longer than the longest run of backticks inside the content
    let backtickRuns = code.match(/`+/g),
        longestRun = 0;
    if (backtickRuns) {
      for (let b = 0; b < backtickRuns.length; ++b) {
        if (backtickRuns[b].length > longestRun) {
          longestRun = backtickRuns[b].length;
        }
      }
    }
    let fence = new Array(longestRun + 2).join('`'),
        pad = (longestRun > 0) ? ' ' : '';
    result = fence + pad + code + pad + fence;
  }

  let endEvent = new showdown.Event('makeMarkdown.codeSpan.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;
});

showdown.subParser('makeMarkdown.emphasis', function (node, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.emphasis.onStart', node.outerHTML);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    result = (function () {
      let txt = '';
      if (node.hasChildNodes()) {
        txt += '*';
        let children = node.childNodes,
            childrenLength = children.length;
        for (let i = 0; i < childrenLength; ++i) {
          txt += showdown.subParser('makeMarkdown.node')(children[i], options, globals);
        }
        txt += '*';
      }
      return txt;
    })();
  }

  let endEvent = new showdown.Event('makeMarkdown.emphasis.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;
});

// Reverse direction (HTML -> Markdown) for GFM footnotes. Handles the two shapes the
// forward parser (and GitHub) produce:
//   <sup class="footnote-ref"><a href="#fn-ID" ...>N</a></sup>      -> [^ID]
//   <section class="footnotes"><ol><li id="fn-ID">...<a class="footnote-backref">...</a></li></ol></section>
//                                                                   -> [^ID]: ...body...
// Gated by the `footnotes` option in makeMarkdown.node, mirroring makeHtml.
showdown.subParser('makeMarkdown.footnotes', function (node, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.footnotes.onStart', node.outerHTML);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    result = (function () {
      let tagName = node.tagName.toLowerCase();

      if (tagName === 'sup') {
        return renderReference(node);
      }
      if (tagName === 'section') {
        return renderSection(node);
      }
      return '';
    })();
  }

  let endEvent = new showdown.Event('makeMarkdown.footnotes.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;

  // the label lives in the `#fn-<label>` href (percent-encoded by makeHtml); recover it
  function decodeLabel (s) {
    try {
      return decodeURIComponent(s);
    } catch {
      return s;
    }
  }

  function renderReference (sup) {
    let a = sup.querySelector('a');
    if (!a) { return ''; }
    let label = decodeLabel((a.getAttribute('href') || '').replace(/^#fn-/, ''));
    return '[^' + label + ']';
  }

  function renderSection (section) {
    let items = section.querySelectorAll('ol > li');
    if (!items.length) { items = section.querySelectorAll('li'); }
    let defs = [];
    for (let i = 0; i < items.length; ++i) {
      let li = items[i],
          label = decodeLabel((li.getAttribute('id') || '').replace(/^fn-/, ''));

      // drop the back-reference anchors (and the nested <sup> some carry)
      let backrefs = li.querySelectorAll('a.footnote-backref');
      for (let b = 0; b < backrefs.length; ++b) {
        backrefs[b].parentNode.removeChild(backrefs[b]);
      }

      // render the cleaned body
      let body = '';
      for (let c = 0; c < li.childNodes.length; ++c) {
        body += showdown.subParser('makeMarkdown.node')(li.childNodes[c], options, globals);
      }
      body = body
        .replace(/[ \t]+$/gm, '') // trailing space left by a removed backref
        .replace(/\n+$/, '');

      // `[^label]: ` on the first line; continuation lines indented by 4 spaces
      let lines = body.split('\n'),
          def = '[^' + label + ']: ' + (lines[0] || '');
      for (let l = 1; l < lines.length; ++l) {
        def += '\n' + (lines[l] === '' ? '' : '    ' + lines[l]);
      }
      defs.push(def);
    }
    return defs.join('\n\n');
  }
});

showdown.subParser('makeMarkdown.header', function (node, options, globals, headerLevel) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.header.onStart', node.outerHTML);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    result = (function () {
      let headerMark = new Array(headerLevel + 1).join('#'),
          txt = '';

      if (node.hasChildNodes()) {
        txt = headerMark + ' ';
        let children = node.childNodes,
            childrenLength = children.length;

        for (let i = 0; i < childrenLength; ++i) {
          txt += showdown.subParser('makeMarkdown.node')(children[i], options, globals);
        }
      }
      return txt;
    })();
  }

  let endEvent = new showdown.Event('makeMarkdown.header.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;
});

showdown.subParser('makeMarkdown.hr', function (node, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.hr.onStart', node.outerHTML);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    result = '---';
  }

  let endEvent = new showdown.Event('makeMarkdown.hr.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;
});

showdown.subParser('makeMarkdown.image', function (node, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.image.onStart', node.outerHTML);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    result = (function () {
      let txt = '';

      // reverse the `emoji` option: "special" emoji render as an <img> whose src is known.
      // Map that back to its :code:. When emoji is off (or the src isn't an emoji) this falls
      // through to normal image handling, so a disabled feature degrades to plain image markdown.
      if (options.emoji && node.hasAttribute('src')) {
        let emojiImages = showdown.helper.emojiReverse().images,
            src = node.getAttribute('src');
        if (Object.prototype.hasOwnProperty.call(emojiImages, src)) {
          return ':' + emojiImages[src] + ':';
        }
      }

      if (node.hasAttribute('src') && node.getAttribute('src') !== '') {
        let hasDimensions = node.hasAttribute('width') && node.hasAttribute('height');

        // image dimensions are a showdown-specific syntax; when the option is disabled but the
        // image carries dimensions, fall back to raw HTML so the size isn't silently lost
        if (hasDimensions && !options.parseImgDimensions) {
          return node.outerHTML;
        }

        txt += '![' + showdown.helper.escapeMarkdownText(node.getAttribute('alt') || '') + '](';
        txt += '<' + showdown.helper.escapeMarkdownDestination(node.getAttribute('src')) + '>';
        if (hasDimensions) {
          let width = node.getAttribute('width');
          let height = node.getAttribute('height');
          txt += ' =' + (width === 'auto' ? '*' : width) + 'x' + (height === 'auto' ? '*' : height);
        }

        if (node.hasAttribute('title')) {
          txt += ' "' + showdown.helper.escapeMarkdownTitle(node.getAttribute('title')) + '"';
        }
        txt += ')';
      }
      return txt;
    })();
  }

  let endEvent = new showdown.Event('makeMarkdown.image.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;
});

showdown.subParser('makeMarkdown.input', function (node, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.input.onStart', node.outerHTML);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    result = (function () {
      // A checkbox input maps to a `[ ]`/`[x]` task marker only when the `tasklists` option
      // is enabled, the checkbox lives inside a list item, AND it is followed by some content.
      // The list-item context matters: in Markdown a `[ ]`/`[x]` marker is only a task when it
      // leads a list item, so a naked checkbox (top level, or inside a `<p>`/`<div>`) would
      // degrade into meaningless literal bracket text that no longer round-trips back to a
      // checkbox. The following-content check matters for the same reason: a bare
      // `<li><input type="checkbox"></li>` has no task text, and `- [ ]` on its own does not
      // round-trip to a checkbox, so it is kept as the raw `<input>` instead. Detection
      // deliberately keys on the `<li>` ancestry rather than the `task-list-item` class (which
      // `makeHtml` only emits under `moreStyling`), so checkboxes in hand-written or unstyled
      // list HTML are still recognised. Anything that fails these checks passes through as raw
      // HTML. A `checked` attribute (any value, including empty) marks it done; its absence open.
      if (node.getAttribute('type') !== 'checkbox' || !options.tasklists ||
          !isInsideListItem(node) || !hasFollowingContent(node)) {
        return node.outerHTML;
      }
      return (node.getAttribute('checked') !== null) ? '[x]' : '[ ]';
    })();
  }

  let endEvent = new showdown.Event('makeMarkdown.input.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;

  // Walks up the ancestor chain looking for an enclosing `<li>` (covers both tight
  // `<li><input>` items and loose `<li><p><input>` ones).
  function isInsideListItem (n) {
    let parent = n.parentNode;
    while (parent && typeof parent.tagName !== 'undefined') {
      if (parent.tagName.toLowerCase() === 'li') {
        return true;
      }
      parent = parent.parentNode;
    }
    return false;
  }

  // True when the checkbox is followed by actual task text — an element sibling, or a text
  // node that is not just whitespace. A checkbox with nothing meaningful after it is not a
  // task list item (`- [ ]` alone does not round-trip back to a checkbox).
  function hasFollowingContent (n) {
    let sibling = n.nextSibling;
    while (sibling) {
      if (sibling.nodeType === 1) {
        return true;
      }
      if (sibling.nodeType === 3 && sibling.nodeValue.trim() !== '') {
        return true;
      }
      sibling = sibling.nextSibling;
    }
    return false;
  }
});

showdown.subParser('makeMarkdown.links', function (node, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.links.onStart', node.outerHTML);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    result = (function () {
      let txt = '';
      if (!node.hasChildNodes()) {
        return txt;
      }
      let children = node.childNodes,
          childrenLength = children.length;

      // anchors without an href (e.g. named anchors) lose their link semantics but keep their text
      if (!node.hasAttribute('href')) {
        for (let n = 0; n < childrenLength; ++n) {
          txt += showdown.subParser('makeMarkdown.node')(children[n], options, globals);
        }
        return txt;
      }

      // special case for mentions
      // to simplify (and not make stuff really complicated) mentions will only work in this circumstance:
      // <a class="user-mention" href="https://github.com/user">@user</a>
      // that is, if there's a "user-mention" class and option ghMentions is true
      // otherwise is ignored
      let classes = node.getAttribute('class');
      if (options.ghMentions && /(?:^| )user-mention\b/.test(classes)) {
        for (let ii = 0; ii < childrenLength; ++ii) {
          txt += showdown.subParser('makeMarkdown.node')(children[ii], options, globals);
        }
        return txt;
      }

      let innerTxt = '';
      for (let i = 0; i < childrenLength; ++i) {
        innerTxt += showdown.subParser('makeMarkdown.node')(children[i], options, globals);
      }
      let href = node.getAttribute('href');

      // autolink: when the link text is identical to the href and there's no title,
      // emit the compact <href> form instead of [href](<href>)
      if (!node.hasAttribute('title') && innerTxt === href) {
        return '<' + showdown.helper.escapeMarkdownDestination(href) + '>';
      }

      txt = '[' + innerTxt + '](<' + showdown.helper.escapeMarkdownDestination(href) + '>';
      if (node.hasAttribute('title')) {
        txt += ' "' + showdown.helper.escapeMarkdownTitle(node.getAttribute('title')) + '"';
      }
      txt += ')';
      return txt;
    })();
  }

  let endEvent = new showdown.Event('makeMarkdown.links.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;
});

showdown.subParser('makeMarkdown.list', function (node, options, globals, type) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.list.onStart', node.outerHTML);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    result = (function () {
      let txt = '';
      if (!node.hasChildNodes()) {
        return '';
      }
      let listItems       = node.childNodes,
          listItemsLenght = listItems.length,
          listNum = node.getAttribute('start') || 1;

      for (let i = 0; i < listItemsLenght; ++i) {
        if (typeof listItems[i].tagName === 'undefined' || listItems[i].tagName.toLowerCase() !== 'li') {
          continue;
        }

        // define the bullet to use in list
        let bullet;
        if (type === 'ol') {
          bullet = listNum.toString() + '. ';
        } else {
          bullet = '- ';
        }

        // parse list item
        txt += bullet + showdown.subParser('makeMarkdown.listItem')(listItems[i], options, globals);
        ++listNum;
      }

      return txt.trim();
    })();
  }

  let endEvent = new showdown.Event('makeMarkdown.list.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;
});

showdown.subParser('makeMarkdown.listItem', function (node, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.listItem.onStart', node.outerHTML);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    result = (function () {
      let listItemTxt = '';

      let children = node.childNodes,
          childrenLenght = children.length;

      for (let i = 0; i < childrenLenght; ++i) {
        let child = children[i];
        // A nested list must begin on its own line, otherwise the indentation step below
        // glues it to the preceding inline text (e.g. `a<ul>…` would render as `- a- b`
        // instead of `- a` followed by an indented `- b`).
        if (child.nodeType === 1 && /^[ou]l$/i.test(child.tagName) &&
            listItemTxt !== '' && !/\n$/.test(listItemTxt)) {
          listItemTxt += '\n';
        }
        listItemTxt += showdown.subParser('makeMarkdown.node')(child, options, globals);
      }
      // if it's only one liner, we need to add a newline at the end
      if (!/\n$/.test(listItemTxt)) {
        listItemTxt += '\n';
      } else {
        // it's multiparagraph, so we need to indent
        listItemTxt = listItemTxt
          .split('\n')
          .join('\n    ')
          .replace(/^ {4}$/gm, '')
          .replace(/\n\n+/g, '\n\n');
      }

      return listItemTxt;
    })();
  }

  let endEvent = new showdown.Event('makeMarkdown.listItem.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;
});



showdown.subParser('makeMarkdown.node', function (node, options, globals, spansOnly) {
  'use strict';

  spansOnly = spansOnly || false;

  let startEvent = new showdown.Event('makeMarkdown.node.onStart', node.outerHTML || node.nodeValue || '');
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    result = (function () {
      let txt = '';

      // edge case of text without wrapper paragraph
      if (node.nodeType === 3) {
        return showdown.subParser('makeMarkdown.txt')(node, options, globals);
      }

      // HTML comment
      if (node.nodeType === 8) {
        return '<!--' + node.data + '-->\n\n';
      }

      // process only node elements
      if (node.nodeType !== 1) {
        return '';
      }

      let tagName = node.tagName.toLowerCase();

      // Renders an element as raw HTML while still converting its children to markdown.
      // Used for unknown wrapper elements and for feature-gated constructs (strikethrough,
      // underline, tables, ...) when their option is disabled, so the reverse direction stays
      // symmetric with makeHtml: a construct makeHtml wouldn't parse isn't emitted as markdown
      // here either. Embedded/replaced-content and void/empty elements are emitted verbatim.
      function renderRawElement (n, tag) {
        let rawContentTags = ['script', 'style', 'canvas', 'audio', 'video', 'iframe', 'object', 'svg', 'math', 'noscript', 'template', 'picture'];
        let kids = n.childNodes;
        if (kids && kids.length > 0 && rawContentTags.indexOf(tag) === -1) {
          let inner = '';
          for (let k = 0; k < kids.length; ++k) {
            inner += showdown.subParser('makeMarkdown.node')(kids[k], options, globals, spansOnly);
          }
          // a block child terminates itself with a blank line; trim that trailing separator so
          // the wrapper's closing tag stays compact instead of dangling on its own line
          inner = inner.replace(/\n+$/, '');
          // derive the opening tag from outerHTML so attribute serialization is preserved
          // exactly (and is robust against ">" inside attribute values)
          let outer    = n.outerHTML,
              closeTag = '</' + tag + '>',
              openTag  = outer.substring(0, outer.length - n.innerHTML.length - closeTag.length);
          return openTag + inner + closeTag;
        }
        return n.outerHTML;
      }

      switch (tagName) {

        //
        // BLOCKS
        //
        case 'h1':
          if (!spansOnly) { txt = showdown.subParser('makeMarkdown.header')(node, options, globals, 1) + '\n\n'; }
          break;
        case 'h2':
          if (!spansOnly) { txt = showdown.subParser('makeMarkdown.header')(node, options, globals, 2) + '\n\n'; }
          break;
        case 'h3':
          if (!spansOnly) { txt = showdown.subParser('makeMarkdown.header')(node, options, globals, 3) + '\n\n'; }
          break;
        case 'h4':
          if (!spansOnly) { txt = showdown.subParser('makeMarkdown.header')(node, options, globals, 4) + '\n\n'; }
          break;
        case 'h5':
          if (!spansOnly) { txt = showdown.subParser('makeMarkdown.header')(node, options, globals, 5) + '\n\n'; }
          break;
        case 'h6':
          if (!spansOnly) { txt = showdown.subParser('makeMarkdown.header')(node, options, globals, 6) + '\n\n'; }
          break;

        case 'p':
          if (!spansOnly) { txt = showdown.subParser('makeMarkdown.paragraph')(node, options, globals) + '\n\n'; }
          break;

        case 'blockquote':
          if (!spansOnly) { txt = showdown.subParser('makeMarkdown.blockquote')(node, options, globals) + '\n\n'; }
          break;

        case 'hr':
          if (!spansOnly) { txt = showdown.subParser('makeMarkdown.hr')(node, options, globals) + '\n\n'; }
          break;

        case 'ol':
          if (!spansOnly) { txt = showdown.subParser('makeMarkdown.list')(node, options, globals, 'ol') + '\n\n'; }
          break;

        case 'ul':
          if (!spansOnly) { txt = showdown.subParser('makeMarkdown.list')(node, options, globals, 'ul') + '\n\n'; }
          break;

        case 'precode':
          if (!spansOnly) { txt = showdown.subParser('makeMarkdown.codeBlock')(node, options, globals) + '\n\n'; }
          break;

        case 'pre':
          if (!spansOnly) { txt = showdown.subParser('makeMarkdown.pre')(node, options, globals) + '\n\n'; }
          break;

        case 'table':
          if (!spansOnly) {
            // when tables are disabled, emit the table verbatim: recursing into its block-level
            // cells would inject blank lines that break the raw HTML block on re-parse
            txt = (options.tables ?
              showdown.subParser('makeMarkdown.table')(node, options, globals) :
              node.outerHTML) + '\n\n';
          }
          break;

        //
        // SPANS
        //
        case 'code':
          txt = showdown.subParser('makeMarkdown.codeSpan')(node, options, globals);
          break;

        case 'em':
        case 'i':
          txt = showdown.subParser('makeMarkdown.emphasis')(node, options, globals);
          break;

        case 'strong':
        case 'b':
          txt = showdown.subParser('makeMarkdown.strong')(node, options, globals);
          break;

        case 'del':
        case 's':
        case 'strike':
          txt = options.strikethrough ?
            showdown.subParser('makeMarkdown.strikethrough')(node, options, globals) :
            renderRawElement(node, tagName);
          break;

        case 'u':
          txt = options.underline ?
            showdown.subParser('makeMarkdown.underline')(node, options, globals) :
            renderRawElement(node, tagName);
          break;

        case 'a':
          txt = showdown.subParser('makeMarkdown.links')(node, options, globals);
          break;

        case 'img':
          txt = showdown.subParser('makeMarkdown.image')(node, options, globals);
          break;

        case 'br':
          txt = showdown.subParser('makeMarkdown.break')(node, options, globals);
          break;

        case 'input':
          txt = showdown.subParser('makeMarkdown.input')(node, options, globals);
          break;

        case 'sup':
          // GFM footnote reference; otherwise an ordinary inline <sup> kept as raw HTML
          if (options.footnotes && /(?:^| )footnote-ref(?: |$)/.test(node.getAttribute('class') || '')) {
            txt = showdown.subParser('makeMarkdown.footnotes')(node, options, globals);
          } else {
            txt = renderRawElement(node, tagName);
            if (!spansOnly) { txt += '\n\n'; }
          }
          break;

        case 'section':
          // GFM footnotes section; otherwise an ordinary <section> kept as raw HTML
          if (!spansOnly && options.footnotes && /(?:^| )footnotes(?: |$)/.test(node.getAttribute('class') || '')) {
            txt = showdown.subParser('makeMarkdown.footnotes')(node, options, globals) + '\n\n';
          } else {
            txt = renderRawElement(node, tagName);
            if (!spansOnly) { txt += '\n\n'; }
          }
          break;

        default:
          // unknown tag: keep the wrapper as raw HTML but still convert its children
          txt = renderRawElement(node, tagName);
          if (!spansOnly) { txt += '\n\n'; }
      }

      // common normalization
      // TODO eventually

      return txt;
    })();
  }

  let endEvent = new showdown.Event('makeMarkdown.node.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;
});

showdown.subParser('makeMarkdown.paragraph', function (node, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.paragraph.onStart', node.outerHTML);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    result = (function () {
      let txt = '';
      if (node.hasChildNodes()) {
        let children = node.childNodes,
            childrenLength = children.length;
        for (let i = 0; i < childrenLength; ++i) {
          txt += showdown.subParser('makeMarkdown.node')(children[i], options, globals);
        }
      }

      // some text normalization
      txt = txt.trim();

      return txt;
    })();
  }

  let endEvent = new showdown.Event('makeMarkdown.paragraph.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;
});

showdown.subParser('makeMarkdown.pre', function (node, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.pre.onStart', node.outerHTML);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    let num  = node.getAttribute('prenum');
    result = '<pre>' + globals.preList[num] + '</pre>';
  }

  let endEvent = new showdown.Event('makeMarkdown.pre.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;
});

showdown.subParser('makeMarkdown.strikethrough', function (node, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.strikethrough.onStart', node.outerHTML);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    result = (function () {
      let txt = '';
      if (node.hasChildNodes()) {
        txt += '~~';
        let children = node.childNodes,
            childrenLength = children.length;
        for (let i = 0; i < childrenLength; ++i) {
          txt += showdown.subParser('makeMarkdown.node')(children[i], options, globals);
        }
        txt += '~~';
      }
      return txt;
    })();
  }

  let endEvent = new showdown.Event('makeMarkdown.strikethrough.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;
});

showdown.subParser('makeMarkdown.strong', function (node, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.strong.onStart', node.outerHTML);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    result = (function () {
      let txt = '';
      if (node.hasChildNodes()) {
        txt += '**';
        let children = node.childNodes,
            childrenLength = children.length;
        for (let i = 0; i < childrenLength; ++i) {
          txt += showdown.subParser('makeMarkdown.node')(children[i], options, globals);
        }
        txt += '**';
      }
      return txt;
    })();
  }

  let endEvent = new showdown.Event('makeMarkdown.strong.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;
});

showdown.subParser('makeMarkdown.table',
  /**
   *
   * @param {DocumentFragment} node
   * @param {{}} options
   * @param {{}} globals
   * @returns {string}
   */
  function (node, options, globals) {
    'use strict';

    let startEvent = new showdown.Event('makeMarkdown.table.onStart', node.outerHTML);
    startEvent
      .setOutput(null)
      ._setGlobals(globals)
      ._setOptions(options)
      .setMatches({node: node});
    startEvent = globals.converter.dispatch(startEvent);

    let result;
    if (startEvent.output && startEvent.output !== '') {
      result = startEvent.output;
    } else {
      result = (function () {
        let txt = '',
            tableArray = [[], []],
            headings,
            rows = [],
            colCount,
            i,
            ii;

        /**
         * @param {Element} tr
         */
        function iterateRow (tr) {
          let children = tr.childNodes,
              cols = [];
          // we need to iterate by order, since td and th can be used interchangeably and in any order
          // we will ignore malformed stuff, comments and floating text.
          for (let i = 0; i < children.length; ++i) {
            let childName = children[i].nodeName.toUpperCase();
            if (childName === 'TD' || childName === 'TH') {
              cols.push(children[i]);
            }
          }
          return cols;
        }


        // first lets look for <thead>
        // we will ignore thead without <tr> children
        // also, since markdown doesn't support tables with multiple heading rows, only the first one will be transformed
        // the rest will count as regular rows
        if (node.querySelectorAll(':scope>thead').length !== 0 && node.querySelectorAll(':scope>thead>tr').length !== 0) {
          let thead = node.querySelectorAll(':scope>thead>tr');

          // thead>tr can have td and th children
          for (i = 0; i < thead.length; ++i) {
            rows.push(iterateRow(thead[i]));
          }
        }

        // now let's look for tbody
        // we will ignore tbody without <tr> children
        if (node.querySelectorAll(':scope>tbody').length !== 0 && node.querySelectorAll(':scope>tbody>tr').length !== 0) {
          let tbody = node.querySelectorAll(':scope>tbody>tr');
          // tbody>tr can have td and th children, although th are not very screen reader friendly
          for (i = 0; i < tbody.length; ++i) {
            rows.push(iterateRow(tbody[i]));
          }
        }

        // now look for tfoot
        if (node.querySelectorAll(':scope>tfoot').length !== 0 && node.querySelectorAll(':scope>tfoot>tr').length !== 0) {
          let tfoot = node.querySelectorAll(':scope>tfoot>tr');
          // tfoot>tr can have td and th children, although th are not very screen reader friendly
          for (i = 0; i < tfoot.length; ++i) {
            rows.push(iterateRow(tfoot[i]));
          }
        }

        // lastly look for naked tr
        if (node.querySelectorAll(':scope>tr').length !== 0) {

          let tr = node.querySelectorAll(':scope>tr');
          // tfoot>tr can have td and th children, although th are not very screen reader friendly
          for (i = 0; i < tr.length; ++i) {
            rows.push(iterateRow(tr[i]));
          }
        }

        // TODO: implement <caption> in tables https://developer.mozilla.org/pt-BR/docs/Web/HTML/Element/caption
        // note: <colgroup> is ignored, since they are basically styling

        // we need now to account for cases of completely empty tables, like <table></table> or equivalent
        if (rows.length === 0) {
          // table is empty, return empty text
          return txt;
        }

        // count the first row. We need it to trim the table (if table rows have inconsistent number of columns)
        colCount = rows[0].length;

        // let's shift the first row as a heading
        headings = rows.shift();

        for (i = 0; i < headings.length; ++i) {
          let headContent = showdown.subParser('makeMarkdown.tableCell')(headings[i], options, globals),
              align = '---';

          if (headings[i].hasAttribute('style')) {
            let style = headings[i].getAttribute('style').toLowerCase().replace(/\s/g, '');
            switch (style) {
              case 'text-align:left;':
                align = ':---';
                break;
              case 'text-align:right;':
                align = '---:';
                break;
              case 'text-align:center;':
                align = ':---:';
                break;
            }
          }
          // fall back to the deprecated `align` attribute when no inline text-align style matched
          if (align === '---' && headings[i].hasAttribute('align')) {
            switch (headings[i].getAttribute('align').toLowerCase()) {
              case 'left':
                align = ':---';
                break;
              case 'right':
                align = '---:';
                break;
              case 'center':
                align = ':---:';
                break;
            }
          }
          tableArray[0][i] = headContent.trim();
          tableArray[1][i] = align;
        }

        // now iterate through the rows and create the pseudo output (not pretty yet)
        for (i = 0; i < rows.length; ++i) {
          let r = tableArray.push([]) - 1;

          for (ii = 0; ii < colCount; ++ii) {
            let cellContent = ' ';
            if (typeof rows[i][ii] !== 'undefined') {
              // Note: if rows[i][ii] is undefined, it means the row has fewer elements than the header,
              // and empty content will be added
              cellContent = showdown.subParser('makeMarkdown.tableCell')(rows[i][ii], options, globals);
            }
            tableArray[r].push(cellContent);
          }
        }

        // now tidy up the output, aligning cells and stuff
        let cellSpacesCount = 3;
        for (i = 0; i < tableArray.length; ++i) {
          for (ii = 0; ii < tableArray[i].length; ++ii) {
            let strLen = tableArray[i][ii].length;
            if (strLen > cellSpacesCount) {
              cellSpacesCount = strLen;
            }
          }
        }

        for (i = 0; i < tableArray.length; ++i) {
          for (ii = 0; ii < tableArray[i].length; ++ii) {
            if (i === 1) {
              if (tableArray[i][ii].slice(-1) === ':') {
                tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii].slice(0, -1), cellSpacesCount - 1, '-') + ':';
              } else {
                tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii], cellSpacesCount, '-');
              }

            } else {
              tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii], cellSpacesCount);
            }
          }
          txt += '| ' + tableArray[i].join(' | ') + ' |\n';
        }

        return txt.trim();
      })();
    }

    let endEvent = new showdown.Event('makeMarkdown.table.onEnd', result);
    endEvent
      .setOutput(result)
      ._setGlobals(globals)
      ._setOptions(options)
      .setMatches({node: node});
    endEvent = globals.converter.dispatch(endEvent);
    return endEvent.output;
  }
);

showdown.subParser('makeMarkdown.tableCell', function (node, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.tableCell.onStart', node.outerHTML);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    result = (function () {
      let txt = '';
      if (!node.hasChildNodes()) {
        return '';
      }
      let children = node.childNodes,
          childrenLength = children.length;

      for (let i = 0; i < childrenLength; ++i) {
        txt += showdown.subParser('makeMarkdown.node')(children[i], options, globals, true);
      }
      return txt.trim();
    })();
  }

  let endEvent = new showdown.Event('makeMarkdown.tableCell.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;
});

showdown.subParser('makeMarkdown.txt', function (node, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.txt.onStart', node.nodeValue);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    result = (function () {
      let txt = node.nodeValue;

      // multiple spaces are collapsed
      txt = txt.replace(/ +/g, ' ');

      // replace the custom ¨NBSP; with a space
      txt = txt.replace(/¨NBSP;/g, ' ');

      // ", <, > and & should replace escaped html entities
      txt = showdown.helper.unescapeHTMLEntities(txt);

      // reverse the `ellipsis` option: … -> ...  (only when the converter would have produced it)
      if (options.ellipsis) {
        txt = txt.replace(/…/g, '...');
      }

      // reverse the `emoji` option: turn unicode emoji back into their `:code:` form.
      // Done before the magic-char escaping below so an emoji whose value contains a markdown
      // metachar (e.g. asterisk -> *️⃣) becomes :asterisk: instead of an escaped \*.
      // Note: like underline, this is symmetric but opt-in - any literal emoji the source HTML
      // already contained is also rewritten to a code when this option is on.
      if (options.emoji) {
        let emojiReverse = showdown.helper.emojiReverse();
        txt = txt.replace(emojiReverse.regex, function (wholeMatch) {
          return ':' + emojiReverse.unicode[wholeMatch] + ':';
        });
      }

      // escape markdown magic characters
      // emphasis, strong and strikethrough - can appear everywhere
      // we also escape pipe (|) because of tables
      // and escape ` because of code blocks and spans
      txt = txt.replace(/([*_~|`])/g, '\\$1');

      // escape > because of blockquotes
      txt = txt.replace(/^(\s*)>/g, '\\$1>');

      // hash character, only troublesome at the beginning of a line because of headers
      txt = txt.replace(/^#/gm, '\\#');

      // horizontal rules
      txt = txt.replace(/^(\s*)([-=]{3,})(\s*)$/, '$1\\$2$3');

      // dot, because of ordered lists, only troublesome at the beginning of a line when preceded by an integer
      txt = txt.replace(/^( {0,3}\d+)\./gm, '$1\\.');

      // +, * and -, at the beginning of a line becomes a list, so we need to escape them also (asterisk was already escaped)
      txt = txt.replace(/^( {0,3})([+-])/gm, '$1\\$2');

      // images and links, ] followed by ( is problematic, so we escape it
      txt = txt.replace(/](\s*)\(/g, '\\]$1\\(');

      // reference URIs must also be escaped
      txt = txt.replace(/^ {0,3}\[([\S \t]*?)]:/gm, '\\[$1]:');

      return txt;
    })();
  }

  let endEvent = new showdown.Event('makeMarkdown.txt.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;
});

showdown.subParser('makeMarkdown.underline', function (node, options, globals) {
  'use strict';

  let startEvent = new showdown.Event('makeMarkdown.underline.onStart', node.outerHTML);
  startEvent
    .setOutput(null)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  startEvent = globals.converter.dispatch(startEvent);

  let result;
  if (startEvent.output && startEvent.output !== '') {
    result = startEvent.output;
  } else {
    result = (function () {
      // showdown's forward parser emits <u> for the `underline` option (e.g. __text__).
      // We mirror that here so <u> round-trips. Note: __ is standard-Markdown strong, so this
      // only round-trips cleanly through a converter that has the `underline` option enabled.
      let txt = '';
      if (node.hasChildNodes()) {
        txt += '__';
        let children = node.childNodes,
            childrenLength = children.length;
        for (let i = 0; i < childrenLength; ++i) {
          txt += showdown.subParser('makeMarkdown.node')(children[i], options, globals);
        }
        txt += '__';
      }
      return txt;
    })();
  }

  let endEvent = new showdown.Event('makeMarkdown.underline.onEnd', result);
  endEvent
    .setOutput(result)
    ._setGlobals(globals)
    ._setOptions(options)
    .setMatches({node: node});
  endEvent = globals.converter.dispatch(endEvent);
  return endEvent.output;
});

/**
 * Created by Estevao on 31-05-2015.
 */

/**
 * Module scope (shared across all converter instances): warn at most once per process per
 * deprecated extension type, rather than once per extension load.
 * @type {{}}
 */
let deprecatedExtTypeWarned = {};

/**
 * Emit a one-time deprecation warning for a legacy (`lang`/`output`) extension type
 * @param {string} type
 * @param {string} event
 */
function warnDeprecatedExtType (type, event) {
  'use strict';
  if (deprecatedExtTypeWarned[type]) {
    return;
  }
  deprecatedExtTypeWarned[type] = true;
  console.warn('DEPRECATION WARNING: "' + type + '" extensions are deprecated and will be ' +
    'removed in a future version. Use a "listener" extension on the "' + event + '" event instead.');
}

/**
 * Showdown Converter class
 * @class
 * @param {object} [converterOptions]
 * @returns {Converter}
 */
showdown.Converter = function (converterOptions) {
  'use strict';

  let
      /**
       * Options used by this converter
       * @private
       * @type {{}}
       */
      options = {},

      /**
       * Event listeners
       * @private
       * @type {{}}
       */
      listeners = {},

      /**
       * The flavor set in this converter
       */
      setConvFlavor = setFlavor,

      /**
       * Metadata of the document
       * @type {{parsed: {}, raw: string, format: string}}
       */
      metadata = {
        parsed: {},
        raw: '',
        format: ''
      };

  _constructor();

  /**
   * Converter constructor
   * @private
   */
  function _constructor () {
    converterOptions = converterOptions || {};

    for (let gOpt in globalOptions) {
      if (Object.prototype.hasOwnProperty.call(globalOptions, gOpt)) {
        options[gOpt] = globalOptions[gOpt];
      }
    }

    // Merge options
    if (typeof converterOptions === 'object') {
      for (let opt in converterOptions) {
        if (Object.prototype.hasOwnProperty.call(converterOptions, opt)) {
          options[opt] = converterOptions[opt];
        }
      }
    } else {
      throw Error('Converter expects the passed parameter to be an object, but ' + typeof converterOptions +
      ' was passed instead.');
    }

    if (options.extensions) {
      showdown.helper.forEach(options.extensions, _parseExtension);
    }

    options = showdown.helper.validateOptions(options);
  }

  /**
   * Parse extension
   * @param {*} ext
   * @param {string} [name='']
   * @private
   */
  function _parseExtension (ext, name) {

    name = name || null;
    // If it's a string, the extension was previously loaded
    if (showdown.helper.isString(ext)) {
      ext = showdown.helper.stdExtName(ext);
      name = ext;

      if (!showdown.helper.isUndefined(extensions[ext])) {
        ext = extensions[ext];

      } else {
        throw Error('Extension "' + ext + '" could not be loaded. It was either not found or is not a valid extension.');
      }
    }

    if (typeof ext === 'function') {
      ext = ext();
    }

    if (!showdown.helper.isArray(ext)) {
      ext = [ext];
    }

    let validExt = validate(ext, name);
    if (!validExt.valid) {
      throw Error(validExt.error);
    }

    for (let i = 0; i < ext.length; ++i) {
      // `lang` and `output` extensions are sugar over the event system: a `lang`
      // extension is a listener on `makehtml.onPreParse` (runs after escaping, before the
      // subparsers) and an `output` extension a listener on `makehtml.onEnd` (runs on the
      // final HTML). They are deprecated in favor of writing listener extensions directly.
      switch (ext[i].type) {

        case 'lang':
          warnDeprecatedExtType('lang', 'makehtml.onPreParse');
          listen('makehtml.onPreParse', _wrapLegacyExtension(ext[i]));
          break;

        case 'output':
          warnDeprecatedExtType('output', 'makehtml.onEnd');
          listen('makehtml.onEnd', _wrapLegacyExtension(ext[i]));
          break;
      }
      if (Object.prototype.hasOwnProperty.call(ext[i], 'listeners')) {
        for (let ln in ext[i].listeners) {
          if (Object.prototype.hasOwnProperty.call(ext[i].listeners, ln)) {
            listen(ln, ext[i].listeners[ln]);
          }
        }
      }
    }

  }

  /**
   * Adapt a legacy `lang`/`output` extension to an event listener.
   * Returning a string makes `dispatch` update both `event.input` and `event.output`, so
   * several legacy extensions on the same event chain exactly like the old forEach did.
   * @param {{}} ext
   * @returns {function(showdown.Event): string}
   */
  function _wrapLegacyExtension (ext) {
    return function (event) {
      return showdown.subParser('makehtml.runExtension')(ext, event.input, event.options, { converter: event.converter });
    };
  }

  /**
   * Listen to an event
   * @param {string} name
   * @param {function} callback
   */
  function listen (name, callback) {
    if (!showdown.helper.isString(name)) {
      throw Error('Invalid argument in converter.listen() method: name must be a string, but ' + typeof name + ' given');
    }

    if (typeof callback !== 'function') {
      throw Error('Invalid argument in converter.listen() method: callback must be a function, but ' + typeof callback + ' given');
    }
    name = name.toLowerCase();
    if (!Object.prototype.hasOwnProperty.call(listeners, name)) {
      listeners[name] = [];
    }
    listeners[name].push(callback);
  }

  /**
   * Stop listening to an event
   * @param {string} name
   * @param {function} [callback] If omitted, removes every listener for the event
   */
  function unlisten (name, callback) {
    if (!showdown.helper.isString(name)) {
      throw Error('Invalid argument in converter.unlisten() method: name must be a string, but ' + typeof name + ' given');
    }
    name = name.toLowerCase();
    if (!Object.prototype.hasOwnProperty.call(listeners, name)) {
      return;
    }
    // no callback given: remove every listener registered for this event
    if (typeof callback === 'undefined') {
      delete listeners[name];
      return;
    }
    if (typeof callback !== 'function') {
      throw Error('Invalid argument in converter.unlisten() method: callback must be a function, but ' + typeof callback + ' given');
    }
    let idx = listeners[name].indexOf(callback);
    while (idx > -1) {
      listeners[name].splice(idx, 1);
      idx = listeners[name].indexOf(callback);
    }
    if (listeners[name].length === 0) {
      delete listeners[name];
    }
  }

  function rTrimInputText (text) {
    let rsp = text.match(/^\s*/)[0].length,
        rgx = new RegExp('^\\s{0,' + rsp + '}', 'gm');
    return text.replace(rgx, '');
  }

  /**
   *
   * @param {showdown.Event} event
   * @returns showdown.Event
   */
  this.dispatch = function (event) {
    if (!(event instanceof showdown.Event)) {
      throw new TypeError('dispatch only accepts showdown.Event objects as param, but ' + typeof event + ' given');
    }
    event.converter = this;
    if (Object.prototype.hasOwnProperty.call(listeners, event.name)) {
      for (let i = 0; i < listeners[event.name].length; ++i) {
        let listRet = listeners[event.name][i](event);
        if (showdown.helper.isString(listRet)) {
          event.output = listRet;
          event.input = listRet;
        } else if (listRet instanceof showdown.Event && listRet.name === event.name) {
          event = listRet;
        }
      }
    }
    return event;
  };

  /**
   * Listen to an event
   * @param {string} name
   * @param {function} callback
   * @returns {showdown.Converter}
   */
  this.listen = function (name, callback) {
    listen(name, callback);
    return this;
  };

  /**
   * Stop listening to an event
   * @param {string} name
   * @param {function} [callback] If omitted, removes every listener for the event
   * @returns {showdown.Converter}
   */
  this.unlisten = function (name, callback) {
    unlisten(name, callback);
    return this;
  };

  /**
   * Converts a markdown string into HTML string
   * @param {string} text
   * @returns {*}
   */
  this.makeHtml = function (text) {
    //check if text is not falsy
    if (!text) {
      return text;
    }

    let globals = {
      gHtmlBlocks:     [],
      gHtmlRawBlocks:  [],
      gHtmlMdBlocks:   [],
      gHtmlSpans:      [],
      gUrls:           {},
      gTitles:         {},
      gDimensions:     {},
      gListLevel:      0,
      hashLinkCounts:  {},
      converter:       this,
      ghCodeBlocks:    [],
      metadata: {
        parsed: {},
        raw: '',
        format: ''
      }
    };

    // document level onStart event, emitted with the raw markdown before any escaping or
    // normalization. Listeners here see literal `$`/`¨` (unlike onPreParse, which runs after
    // escaping) and can rewrite the source wholesale.
    let startEvent = new showdown.Event('makehtml.onStart', text);
    startEvent
      .setOutput(text)
      ._setGlobals(globals)
      ._setOptions(options);
    startEvent = this.dispatch(startEvent);
    text = startEvent.output;

    // This lets us use ¨ trema as an escape char to avoid md5 hashes
    // The choice of character is arbitrary; anything that isn't
    // magic in Markdown will work.
    text = text.replace(/¨/g, '¨T');

    // Replace $ with ¨D
    // RegExp interprets $ as a special character
    // when it's in a replacement string
    text = text.replace(/\$/g, '¨D');

    // Standardize line endings
    text = text.replace(/\r\n/g, '\n'); // DOS to Unix
    text = text.replace(/\r/g, '\n'); // Mac to Unix

    // Stardardize line spaces
    //text = text.replace(/\u00A0/g, '&nbsp;');

    if (options.smartIndentationFix) {
      text = rTrimInputText(text);
    }

    // Make sure text begins and ends with a couple of newlines:
    text = '\n\n' + text + '\n\n';

    // detab
    //text = showdown.subParser('makehtml.detab')(text, options, globals);
    text = showdown.helper.normalizeLeadingTabs(text);

    /**
     * Strip any lines consisting only of spaces and tabs.
     * This makes subsequent regexs easier to write, because we can
     * match consecutive blank lines with /\n+/ instead of something
     * contorted like /[ \t]*\n+/
     */
    text = text.replace(/^[ \t]+$/mg, '');

    // document level onPreParse event, emitted after escaping/normalization and immediately
    // before the subparsers run. This is where `lang` extensions are invoked (as listeners).
    // Input here contains the `¨D`/`¨T` placeholders for escaped `$`/`¨`.
    let preParseEvent = new showdown.Event('makehtml.onPreParse', text);
    preParseEvent
      .setOutput(text)
      ._setGlobals(globals)
      ._setOptions(options);
    preParseEvent = this.dispatch(preParseEvent);
    text = preParseEvent.output;

    // run the sub parsers
    text = showdown.subParser('makehtml.metadata')(text, options, globals);
    text = showdown.subParser('makehtml.hashPreCodeTags')(text, options, globals);
    if (options.cmSpec) {
      // Container mode parses leaf blocks in document order: an open HTML block (e.g. a
      // `<div>` with no following blank line) absorbs a fence that follows it, so the
      // (fence-aware) HTML-block scan must run before githubCodeBlock. githubCodeBlock then
      // only claims fences at indent 0; indent 1-3 fences nested in list items / block
      // quotes are handled by the container parsers (and a later blockGamut pass for
      // genuinely top-level indented fences).
      if (options.cmSpec) {
        text = showdown.helper.expandCmTabs(text);
      }
      text = showdown.subParser('makehtml.hashHTMLBlocks')(text, options, globals, true);
      text = showdown.subParser('makehtml.githubCodeBlock')(text, options, globals, true);
    } else {
      text = showdown.subParser('makehtml.githubCodeBlock')(text, options, globals);
      // CommonMark tab expansion runs after fenced/pre code is hashed (so their content
      // tabs are protected) and before the block parsers, which key off indentation.
      if (options.cmSpec) {
        text = showdown.helper.expandCmTabs(text);
      }
      text = showdown.subParser('makehtml.hashHTMLBlocks')(text, options, globals, true);
    }
    text = showdown.subParser('makehtml.hashCodeTags')(text, options, globals);
    // Footnotes (GFM): collect `[^id]: ...` definitions and replace `[^id]` references
    // before stripLinkDefinitions (whose scanner would otherwise claim `[^id]:` lines).
    text = showdown.subParser('makehtml.footnotes')(text, options, globals, 'strip');
    text = showdown.subParser('makehtml.stripLinkDefinitions')(text, options, globals);
    text = showdown.subParser('makehtml.blockGamut')(text, options, globals);
    text = showdown.subParser('makehtml.paragraphs')(text, options, globals);
    // Footnotes (GFM): render the referenced footnotes into a <section> and append it,
    // before unhashHTMLSpans so hashed spans inside the rendered footnotes are restored.
    text = showdown.subParser('makehtml.footnotes')(text, options, globals, 'build');
    // decode character references (gated by the decodeEntities option) after inline parsing,
    // while code spans/blocks are still hashed, so decoded chars are not re-parsed
    text = showdown.subParser('makehtml.decodeEntities')(text, options, globals);
    // restore raw CommonMark HTML blocks now, after decodeEntities, so their verbatim
    // content (e.g. `<a href="&ouml;&ouml;.html">`) keeps its entities undecoded
    if (globals.gHtmlRawBlocks.length) {
      text = text.replace(/¨R(\d+)R/g, function (wm, n) {
        return globals.gHtmlRawBlocks[n];
      });
    }
    text = showdown.subParser('makehtml.unhashHTMLSpans')(text, options, globals);
    text = showdown.subParser('makehtml.unescapeSpecialChars')(text, options, globals);
    // GFM disallowed-raw-html tagfilter (opt-in): neutralize a small HTML tag blacklist in
    // the now-restored raw HTML. Runs late so it sees the final tags, not placeholders.
    text = showdown.subParser('makehtml.disallowedHtmlTags')(text, options, globals);

    // attacklab: Restore dollar signs
    text = text.replace(/¨D/g, '$$');

    // attacklab: Restore tremas
    text = text.replace(/¨T/g, '¨');

    // render a complete html document instead of a partial if the option is enabled
    text = showdown.subParser('makehtml.completeHTMLDocument')(text, options, globals);

    // document level onEnd event, emitted with the final HTML. This is where `output`
    // extensions are invoked (as listeners) and where listeners can post-process the output.
    let endEvent = new showdown.Event('makehtml.onEnd', text);
    endEvent
      .setOutput(text)
      ._setGlobals(globals)
      ._setOptions(options);
    endEvent = this.dispatch(endEvent);
    text = endEvent.output;

    // update metadata
    metadata = globals.metadata;
    return text;
  };

  /**
   * Converts an HTML string into a markdown string
   * @param src
   * @returns {string}
   */
  this.makeMarkdown = function (src) {

    // replace \r\n with \n
    src = src.replace(/\r\n/g, '\n');
    src = src.replace(/\r/g, '\n'); // old macs

    // document level onStart event (lets listeners rewrite the raw html before parsing)
    let mdStartEvent = new showdown.Event('makeMarkdown.onStart', src);
    mdStartEvent
      .setOutput(src)
      ._setOptions(options);
    mdStartEvent = this.dispatch(mdStartEvent);
    src = mdStartEvent.output;

    // due to an edge case, we need to find this: > <
    // to prevent removing of non silent white spaces
    // ex: <em>this is</em> <strong>sparta</strong>
    src = src.replace(/>[ \t]+</, '>¨NBSP;<');

    let doc = showdown.helper.parseHTML(src);

    let globals = {
      preList: substitutePreCodeTags(doc),
      converter: this
    };

    // remove all newlines and collapse spaces
    clean(doc);

    // some stuff, like accidental reference links must now be escaped
    // TODO
    // doc.innerHTML = doc.innerHTML.replace(/\[[\S\t ]]/);

    let nodes = doc.childNodes,
        mdDoc = '';

    for (let i = 0; i < nodes.length; i++) {
      mdDoc += showdown.subParser('makeMarkdown.node')(nodes[i], options, globals);
    }

    function clean (node) {
      for (let n = 0; n < node.childNodes.length; ++n) {
        let child = node.childNodes[n];
        if (child.nodeType === 3) {
          if (!/\S/.test(child.nodeValue) && !/^ +$/.test(child.nodeValue)) {
            node.removeChild(child);
            --n;
          } else {
            child.nodeValue = child.nodeValue.split('\n').join(' ');
            child.nodeValue = child.nodeValue.replace(/(\s)+/g, '$1');
          }
        } else if (child.nodeType === 1) {
          clean(child);
        }
      }
    }

    // find all pre tags and replace contents with placeholder
    // we need this so that we can remove all indentation from html
    // to ease up parsing
    function substitutePreCodeTags (doc) {

      let pres = doc.querySelectorAll('pre'),
          presPH = [];

      for (let i = 0; i < pres.length; ++i) {

        if (pres[i].childElementCount === 1 && pres[i].firstChild.tagName.toLowerCase() === 'code') {
          let content = pres[i].firstChild.innerHTML.trim(),
              language = pres[i].firstChild.getAttribute('data-language') || '';

          // if data-language attribute is not defined, then we look for class language-*
          if (language === '') {
            let classes = pres[i].firstChild.className.split(' ');
            for (let c = 0; c < classes.length; ++c) {
              let matches = classes[c].match(/^language-(.+)$/);
              if (matches !== null) {
                language = matches[1];
                break;
              }
            }
          }

          // unescape html entities in content
          content = showdown.helper.unescapeHTMLEntities(content);

          presPH.push(content);
          pres[i].outerHTML = '<precode language="' + language + '" precodenum="' + i.toString() + '"></precode>';
        } else {
          presPH.push(pres[i].innerHTML);
          pres[i].innerHTML = '';
          pres[i].setAttribute('prenum', i.toString());
        }
      }
      return presPH;
    }

    // document level onEnd event (lets listeners post-process the generated markdown)
    let mdEndEvent = new showdown.Event('makeMarkdown.onEnd', mdDoc);
    mdEndEvent
      .setOutput(mdDoc)
      ._setGlobals(globals)
      ._setOptions(options);
    mdEndEvent = this.dispatch(mdEndEvent);
    mdDoc = mdEndEvent.output;

    return mdDoc;
  };

  /**
   * Set an option of this Converter instance
   * @param {string} key
   * @param {*} value
   */
  this.setOption = function (key, value) {
    options[key] = value;
  };

  /**
   * Get the option of this Converter instance
   * @param {string} key
   * @returns {*}
   */
  this.getOption = function (key) {
    return options[key];
  };

  /**
   * Get the options of this Converter instance
   * @returns {{}}
   */
  this.getOptions = function () {
    return options;
  };

  /**
   * Add extension to THIS converter
   * @param {{}} extension
   * @param {string} [name=null]
   */
  this.addExtension = function (extension, name) {
    name = name || null;
    _parseExtension(extension, name);
  };

  /**
   * Use a global registered extension with THIS converter
   * @param {string} extensionName Name of the previously registered extension
   */
  this.useExtension = function (extensionName) {
    _parseExtension(extensionName);
  };

  /**
   * Set the flavor THIS converter should use
   * @param {string} name
   */
  this.setFlavor = function (name) {
    if (!Object.prototype.hasOwnProperty.call(flavor, name)) {
      throw Error(name + ' flavor was not found');
    }
    let preset = flavor[name];
    setConvFlavor = name;
    for (let option in preset) {
      if (Object.prototype.hasOwnProperty.call(preset, option)) {
        options[option] = preset[option];
      }
    }
  };

  /**
   * Get the currently set flavor of this converter
   * @returns {string}
   */
  this.getFlavor = function () {
    return setConvFlavor;
  };

  /**
   * Get the metadata of the previously parsed document
   * @param raw
   * @returns {string|{}}
   */
  this.getMetadata = function (raw) {
    if (raw) {
      return metadata.raw;
    } else {
      return metadata.parsed;
    }
  };

  /**
   * Get the metadata format of the previously parsed document
   * @returns {string}
   */
  this.getMetadataFormat = function () {
    return metadata.format;
  };

  /**
   * Private: set a single key, value metadata pair
   * @param {string} key
   * @param {string} value
   */
  this._setMetadataPair = function (key, value) {
    metadata.parsed[key] = value;
  };

  /**
   * Private: set metadata format
   * @param {string} format
   */
  this._setMetadataFormat = function (format) {
    metadata.format = format;
  };

  /**
   * Private: set metadata raw text
   * @param {string} raw
   */
  this._setMetadataRaw = function (raw) {
    metadata.raw = raw;
  };
};

// noinspection JSUnresolvedReference

let root = this || globalThis;

// AMD Loader
if (typeof define === 'function' && define.amd) {
  define(function () {
    'use strict';
    return showdown;
  });

// CommonJS/nodeJS Loader
} else if (typeof module !== 'undefined' && module.exports) {
  module.exports = showdown;

// Regular Browser loader
} else {
  root.showdown = showdown;
}

}).call(this);
